(function() {
	'use strict';

	angular
	.module('theFoodApp', [
		'ngStorage',
		'ngAnimate',
		'tmh.dynamicLocale',
		'pascalprecht.translate',
		'ngResource',
		'ngCookies',
		'ngAria',
		'ngCacheBuster',
		'ngFileUpload',
		'ui.bootstrap',
		'ui.bootstrap.datetimepicker',
		'ui.router',
		'infinite-scroll',
		// jhipster-needle-angularjs-add-module JHipster will add new module here
		'angular-loading-bar',
		'smoothScroll',
		'duScroll',
		'bsLoadingOverlay',
		'ui-notification',
        'angular-cookie-law',
        'angulartics',
        'angulartics.google.analytics',
        'angulartics.scroll'
	])
	.config(function($sceDelegateProvider, SERVER_URL) {
		$sceDelegateProvider.resourceUrlWhitelist([
			'self',
			SERVER_URL + '**'
		]);
	}).run(run);

	function run(stateHandler, translationHandler, $rootScope, $state, $log, AlertService, bsLoadingOverlayService, SERVER_URL, APP_TITLE) {
		stateHandler.initialize();
		translationHandler.initialize();

		Promise.setScheduler(function(cb) {
			$rootScope.$evalAsync(cb);
		});

		bsLoadingOverlayService.setGlobalConfig({
			templateUrl: 'static/pages/loading-overlay-template.html'
		});

		// Lodash template interpolation settings: Now interpolates {{x}} as template variables.
		_.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
		$rootScope.SERVER_URL = SERVER_URL;
		
		
		window.document.title = APP_TITLE;

		$rootScope.isMobile = function() {
			if (window.cordova) {
				return true;
			} else {
				return false;
			}
		};


	}
})();

(function() {
	'use strict';

	angular
		.module('theFoodApp')
		.factory('DownloadAppToggle', DownloadAppToggle);

	function DownloadAppToggle( $rootScope, $window, $log, MobileAppService ) {
		var vm = this;

		// Interface
		vm.showDownloadAppPage = shouldShowDownloadAppPage;
		vm.notShowDownloadApp = notShowDownloadApp;
		vm.downloadApp = downloadApp;

		// Implementation

		var isWebsiteViewedOnMobileDevices = false;

		function getIsWebsiteViewedOnMobileDevices() {
			
			// Se siamo già sulla app, non visualizzare il banner.
			if ( $rootScope.isMobile() )
				return false; 

			// Il banner è attivo solo su TheFood e per certi OS.
			if ( !MobileAppService.getStoreUrlForDevice() )
				return false;

			// Altrimenti il banner è attivo. 

			// L'utente potrebbe aver già dismissato il banner in precedenza, in quel caso non lo rifacciamo vedere
			if ( $window.localStorage['banner-app'] )
				return false;

			return true;

		}

		function shouldShowDownloadAppPage() {
			return isWebsiteViewedOnMobileDevices;
		}

		function notShowDownloadApp() {
			isWebsiteViewedOnMobileDevices = false;
			$window.localStorage.setItem('banner-app', true);
		}

		function isLocalStorageNameSupported() {
			var localStorageName = 'localStorage';
			try {
				var supported = (localStorageName in window && $window[localStorageName]);
				if (supported) {
					localStorage.setItem("storage", "");
					localStorage.removeItem("storage");
				}

				return true;
			} catch(err) {
				$log.error(err);
				return false;
			}
		}
		
		
		function downloadApp(){
			var url = MobileAppService.getStoreUrlForDevice();
			$window.open( url, '_blank' );
		}

		isWebsiteViewedOnMobileDevices = isLocalStorageNameSupported() && getIsWebsiteViewedOnMobileDevices();

		return vm;
	}

})();

(function() {
	'use strict';

	angular
		.module('theFoodApp')
		.factory('NavBarToggle', NavBarToggle);

	function NavBarToggle( $rootScope, Principal ) {

		var vm = this;

		// Interface

		vm.showNavBar = shouldShowNavBar;

		// Implementation

		var isAdmin;

		function getIsAdmin() {
			isAdmin = false;
			Principal.identity().then( function(identity) {
				isAdmin = identity && identity.authorities && identity.authorities.indexOf('ROLE_ADMIN') !== -1;
			});
		}

		$rootScope.$on('authenticationSuccess', function() {
	        getIsAdmin();
		});
		$rootScope.$on('authenticationLogout', function() {
	        getIsAdmin();
		});

		function shouldShowNavBar() {
			return isAdmin;
		}

		getIsAdmin();

		return vm;

	}

}) ();

(function() {
	'use strict';

	angular
		.module('theFoodApp')
		.factory('MultiInsegnaToggle', MultiInsegnaToggle);

	function MultiInsegnaToggle( APP_NAME ) {
    var vm = this;

    vm.isMultiInsegna = isMultiInsegna;

    function isMultiInsegna() {
      return ('RunnerPizza' !== APP_NAME);
    }

    return vm;
  }

})();

(function () {
    'use strict';
    angular
        .module('theFoodApp')
        .factory('Versione', Versione);

    Versione.$inject = ['$resource', 'SERVER_URL'];

    function Versione($resource, SERVER_URL) {
        var resourceUrl = SERVER_URL + 'api/need-update/:codiceVersion';

        return $resource(resourceUrl, {}, {
            'getNeedUpdate': {
                url: resourceUrl,
                method: 'GET'
            },

        });
    }
})();

(function () {
    'use strict';

    angular
        .module('theFoodApp')
        .factory('User', User);

    User.$inject = ['$resource', 'SERVER_URL'];

    function User ($resource, SERVER_URL) {
        var service = $resource(SERVER_URL + 'api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

( function() {
	'use strict';

	angular
		.module( 'theFoodApp' )
		.factory( 'TrovaZona', TrovaZona );

	TrovaZona.$inject = [ '$resource', 'SERVER_URL' ];

	function TrovaZona( $resource, SERVER_URL ) {
		var resourceUrl = SERVER_URL + 'api/public/v1/trovazona';

		return $resource( resourceUrl, {}, {
			civico: {
				method: 'GET',
				isArray: false,
				url: resourceUrl + '/civico?civico=:civico',
				params: {
					civico: '@civico',
				},
				cache: true
			},
			autocomplete: {
				method: 'GET',
				isArray: true,
				url: resourceUrl + '/autocomplete?query=:query',
				params: {
					query: '@query',
				},
				cache: true
			},
			zona: {
				method: 'GET',
				isArray: false,
				url: resourceUrl + '/zona?stradaId=:stradaId&civico=:civico',
				params: {
					stradaId: '@stradaId',
					civico: '@civico',
				},
				cache: true,
				transformResponse: function( data ) {
					return { id: data };
				}
			}
		} );
	}
} )();

(function() {
	'use strict';

	angular
		.module('theFoodApp')
		.factory('TokenStore', TokenStore);

	var COOKIE_NAME = 'token';
	var COOKIE_EXPIRATION = 12; // In hours.

	function TokenStore($cookies) {

		var vm = this;

		// Interface
		vm.setToken = setToken;
		vm.clearCookie = clearCookie;
		vm.isPresent = isPresent;
		vm.get = clone;

		// Implementation

		var validCookie = false;
		var tokenCookie = null;

		// Low level functions
		function loadCookie() {
			return $cookies.getObject(COOKIE_NAME);
		}

		function saveCookie(cookie) {
			$cookies.putObject(COOKIE_NAME, cookie, {
				expires: new moment().add(COOKIE_EXPIRATION, 'hours').toDate()
			});
		}

		function removeCookie() {
			$cookies.remove(COOKIE_NAME);
		}

		// High level functions
		function setToken(token) {
			validCookie = true;
			tokenCookie = { token: token };
			saveCookie(tokenCookie);
			return clone();
		}

		function loadFromCookie() {
			tokenCookie = loadCookie();
			validCookie = angular.isDefined(tokenCookie);
		}

		function clearCookie() {
			validCookie = false;
			tokenCookie = null;
			removeCookie();
		}

		function isPresent() {
			return validCookie;
		}

		function clone() {
			return _.clone(tokenCookie);
		}

		loadFromCookie();

		return vm;
	}

})();

(function() {
    'use strict';
    angular
        .module('theFoodApp')
        .factory('TipoIndirizzo', TipoIndirizzo);

    TipoIndirizzo.$inject = ['$resource', 'SERVER_URL'];

    function TipoIndirizzo ($resource, SERVER_URL) {
        var resourceUrl =  SERVER_URL + 'api/tipo-indirizzos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();


( function() {
	'use strict';
	angular
		.module( 'theFoodApp' )
		.factory( 'TempUserIdService', TempUserIdService );

	var COOKIE_NAME = 'temp-customer-uuid';
	var COOKIE_EXPIRATION = 24 * 7; // In hours.

	function TempUserIdService( $cookies ) {

		var vm = this;

		// Interface

		vm.init = init;
		vm.get = get;
		vm.clear = remove;

		// Implementation

		var current;

		function get() {
			return current;
		}

		function remove() {
			$cookies.remove( COOKIE_NAME );
			init();
		}

		function init() {
			var value = $cookies.get(COOKIE_NAME) || generateUUID();
			$cookies.put( COOKIE_NAME, value, {
				expires: new moment().add(COOKIE_EXPIRATION, 'hours').toDate()
			} );
			current = value;
			return value;
		}

		/**
		 * Generates a random string.
		 * Taken from: http://stackoverflow.com/a/8809472/90006
		 */
		function generateUUID() {
			var d = new Date().getTime();
			if (angular.isDefined(performance) && angular.isFunction(performance.now)){
				d += performance.now(); //use high-precision timer if available
			}
			return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
				var r = (d + Math.random() * 16) % 16 | 0;
				d = Math.floor(d / 16);
				return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
			});
		}

		init();

		return vm;

	}

} )();

(function() {
    'use strict';
    angular
        .module('theFoodApp')
        .factory('StoricoOrdini', StoricoOrdini);

    StoricoOrdini.$inject = ['$resource', 'SERVER_URL'];

    function StoricoOrdini ($resource, SERVER_URL) {
        var resourceUrl = SERVER_URL + 'api/v1/ordini/storico';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}//,
            // 'get': {
            //     method: 'GET',
            //     transformResponse: function (data) {
            //         if (data) {
            //             data = angular.fromJson(data);
            //         }
            //         return data;
            //     }
            // },
            // 'update': { method:'PUT' }
        });
    }
})();

(function(){
	'use strict';

	angular
		.module('theFoodApp')
		.service('RieffettuaOrdine', RieffettuaOrdine);

	function RieffettuaOrdine(SERVER_URL, $resource, DateUtils){
		var resourceUrl = SERVER_URL + 'api/v1/ordini/rieffettua-ordine';

		return $resource(resourceUrl, {}, {
			'riordina': {
				method: 'POST',
				transformRequest: function(data) {
					var copy = angular.copy(data);
					copy.dataConsegna = DateUtils.convertLocalDateToServer(copy.dataConsegna);
					copy.dataPagamento = DateUtils.convertLocalDateToServer(copy.dataPagamento);
					copy.dataOrdine = DateUtils.convertLocalDateToServer(copy.dataOrdine);
					return angular.toJson(copy);
				}
			}
		});
	}
})();

(function(){
	'use strict';

	angular
		.module('theFoodApp')
		.service("RecuperaPromozioniService", RecuperaPromozioniService);

	function RecuperaPromozioniService($resource, SERVER_URL){
		var resourceUrl = SERVER_URL + 'api/public/v1/promozioni/:insegnaId';

		return $resource(resourceUrl, {}, {
			'get': {
				method: 'GET',
				isArray: true,
				params: {
					isMobile: '@isMobile'
				}
			}
		});
	}
})();
(function() {
	'use strict';
	angular
		.module('theFoodApp')
		.factory('ClienteOrdine', ClienteOrdine);

	function ClienteOrdine($resource, SERVER_URL, DateUtils) {

		var resourceUrl = SERVER_URL + 'api/v1/ordini/ordine-cliente';

		return $resource(resourceUrl, {}, {
			'get': {
				method: 'GET',
				transformResponse: function(data) {
					if (data) {
						data = angular.fromJson(data);
						data.dataOrdine = DateUtils.convertDateTimeFromServer(data.dataOrdine);
						data.dataConsegna = DateUtils.convertLocalDateFromServer(data.dataConsegna);
						data.dataDownload = DateUtils.convertDateTimeFromServer(data.dataDownload);
					}
					return data;
				}
			}
		});
	}
})();

(function() {
    'use strict';
    angular
        .module('theFoodApp')
        .factory('Provincia', Provincia);

    Provincia.$inject = ['$resource', 'SERVER_URL'];

    function Provincia ($resource, SERVER_URL) {
        var resourceUrl =  SERVER_URL + 'api/v1/public/province/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http', 'SERVER_URL'];

    function ProfileService($http, SERVER_URL) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get(SERVER_URL + 'api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href=""><span data-translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</span> <span id="size-info"></span></a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function() {
	'use strict';
	angular
			.module('theFoodApp')
			.factory('Pagamento', Pagamento);

	Pagamento.$inject = ['$resource', 'SERVER_URL'];

	function Pagamento ($resource, SERVER_URL) {
		var resourceUrl =  SERVER_URL + 'api/v1/pagamento/:id';

		return $resource(resourceUrl, {}, {
			get: {
				method: 'GET',
				isArray: false,
				cache: true
			},
			request: {
				method: 'GET',
				isArray: false,
				url: resourceUrl + '/request/:ordineId?issuer=:issuer',
				params: {
					ordineId: '@ordineId',
					issuer: '@issuer'
				},
				cache: false
			},	
			requestWithCouponAndCredit: {
				method: 'GET',
				isArray: false,
				url: resourceUrl + '/request/:ordineId?issuer=:issuer&couponCode=:couponCode&useCredit=:useCredit',
				params: {
					couponCode: '@couponCode',
					useCredit: '@useCredit',
					ordineId: '@ordineId',
					issuer: '@issuer'
				},
				cache: false
			},
			transaction: {
				method: 'GET',
				isArray: false,
				url: resourceUrl + '/transaction/:transactionId',
				params: {
					transactionId: '@transactionId'
				},
				cache: false
			}
		});
	}
})();

(function() {
    'use strict';
    angular
        .module('theFoodApp')
        .factory('OrariConsegna', OrariConsegna);

    OrariConsegna.$inject = ['$resource', 'SERVER_URL'];

    function OrariConsegna($resource, SERVER_URL) {
        var resourceUrl = SERVER_URL + 'api/public/v1/locali/orari-consegna';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: false
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('theFoodApp')
        .factory('MovimentiCredito', MovimentiCredito);

        MovimentiCredito.$inject = ['$resource', 'SERVER_URL'];

    function MovimentiCredito ($resource, SERVER_URL) {
        var resourceUrl = SERVER_URL + 'api/v1/movimento-credito';

        return $resource(resourceUrl, {}, {

            totale: {
				method: 'GET',
				isArray: false,
				url: resourceUrl + '/totale',
				cache: false
            },            
            movimenti: {
				method: 'GET',
				isArray: true,
				url: resourceUrl + '/movimenti',
				cache: false
			}
            //'query': { method: 'GET', isArray: true}//,
            // 'get': {
            //     method: 'GET',
            //     transformResponse: function (data) {
            //         if (data) {
            //             data = angular.fromJson(data);
            //         }
            //         return data;
            //     }
            // },
            // 'update': { method:'PUT' }
        });
    }
})();

/* global MobileDetect console */
( function () {
	
	'use strict';
	angular
		.module( 'theFoodApp' )
		.factory( 'MobileAppService', MobileAppService );

	function MobileAppService( $window, LINK_ANDROID_APP, LINK_IOS_APP ) {
		
		var me = this;

		// Interface
		me.getStoreUrlForDevice = getStoreUrlForDevice;

		// Implementation

		function getStoreUrlForDevice() {
			var md = new MobileDetect( $window.navigator.userAgent );
			if ( md.os() === 'AndroidOS' ) {
				return LINK_ANDROID_APP;
			} else if ( md.os() === 'iOS' ) {
				return LINK_IOS_APP;
			} else {
				return null;
			}
		}

		return me;

	}

} )();


( function() {
	'use strict';
	angular
		.module( 'theFoodApp' )
		.factory( 'Locale', Locale );

	function Locale( $resource, SERVER_URL ) {
		var resourceUrl = SERVER_URL + 'api/public/v1/locali/:localeId';

		return $resource( resourceUrl, {}, {
			get: {
				method: 'GET',
				isArray: false,
				cache: true
			},
			getListino: {
				url: resourceUrl + '/listino',
				isArray: true,
				cache: false
			}
		} );
	}
} )();

(function() {
	'use strict';

	angular
		.module("theFoodApp")
		.factory("InformazioniAperturaOdierna", InformazioniAperturaOdierna);

	function InformazioniAperturaOdierna() {
		var vm = this;

		vm.getInformazioniAperturaOdierna = getInformazioniAperturaOdierna;


		var descrizioneApertura = ['theFoodApp.locale.oggiChiuso', 'theFoodApp.locale.apertoCena', 'theFoodApp.locale.apertoPranzo', 'theFoodApp.locale.oggiAperto'];
		var stiliApertura = ['oggi-chiuso', 'oggi-aperto-cena', 'oggi-aperto-pranzo', 'oggi-aperto oggi-aperto-cena oggi-aperto-pranzo'];
		var giorniSettimana = ['theFoodApp.locale.giorniSettimana.lunedi', 'theFoodApp.locale.giorniSettimana.martedi', 'theFoodApp.locale.giorniSettimana.mercoledi', 'theFoodApp.locale.giorniSettimana.giovedi', 'theFoodApp.locale.giorniSettimana.venerdi', 'theFoodApp.locale.giorniSettimana.sabato', 'theFoodApp.locale.giorniSettimana.domenica'];

		var informazioniAperturaCache = [];

		function getDescrizioneAperturaLocale(statoApertura) {
			return descrizioneApertura[statoApertura];
		}

		function getStileAperturaLocale(statoApertura) {
			return stiliApertura[statoApertura];
		}

		function showProssimaConsegnaUtile(apertoPranzo, apertoCena) {
			return apertoPranzo || apertoCena;
		}

		function calcolaGiornoProssimaConsegna(giornoDelCalendario, dayOfWeek){
			return giornoDelCalendario === dayOfWeek ? null : giorniSettimana[giornoDelCalendario-1]
		}

		function nessunaDataDisponibile(apertoPranzo, apertoCena, statoApertura){
			return !apertoPranzo && !apertoCena && statoApertura === 0
		}

		function getInformazioniAperturaOdierna(locale) {
			var nessunaConsegnaDisponibile = locale.insegna.nessunaConsegnaDisponibile
			var nessunCalendarioDisponibile = locale.insegna.nessunCalendarioDisponibile;
			// var dayOfWeek = moment().day();
			var giornoDelCalendario = null;
			var calendarioRelativoAlGiornoDellaSettimana = null;
			var dayOfWeek = moment().isoWeekday();
			if (informazioniAperturaCache[locale.id] != null) {
				return informazioniAperturaCache[locale.id]
			}

			for(var i = dayOfWeek; i <= (dayOfWeek+6); i++){
				giornoDelCalendario = (i - 1) % 7 + 1;
				calendarioRelativoAlGiornoDellaSettimana = _.find(locale.calendarios, {
					'giornoSettimana': giornoDelCalendario
				});
				if(calendarioRelativoAlGiornoDellaSettimana !== undefined && ((calendarioRelativoAlGiornoDellaSettimana.pranzoApre != null || calendarioRelativoAlGiornoDellaSettimana.cenaApre != null) || nessunCalendarioDisponibile === true) ){
					break;
				}
				if(calendarioRelativoAlGiornoDellaSettimana !== undefined && (calendarioRelativoAlGiornoDellaSettimana.pranzoApre == null || calendarioRelativoAlGiornoDellaSettimana.cenaApre == null)){
					break;
				}
			}
			var apertoPranzo = !!(calendarioRelativoAlGiornoDellaSettimana && calendarioRelativoAlGiornoDellaSettimana.pranzoApre !== null);
			var apertoCena = !!(calendarioRelativoAlGiornoDellaSettimana && calendarioRelativoAlGiornoDellaSettimana.cenaApre !== null);
			var statoApertura = apertoPranzo * 2 + apertoCena;

			informazioniAperturaCache[locale.id] = {
				descrizioneAperturaLocale: getDescrizioneAperturaLocale(giornoDelCalendario !== dayOfWeek || nessunaConsegnaDisponibile ? 0 : statoApertura),
				stileAperturaLocale: getStileAperturaLocale(giornoDelCalendario !== dayOfWeek || nessunaConsegnaDisponibile ? 0 : statoApertura),
				prossimaConsegnaUtile: showProssimaConsegnaUtile(apertoPranzo, apertoCena),
				orarioPrimaConsegna: mostraPrimaConsegna(dayOfWeek, giornoDelCalendario, locale, calendarioRelativoAlGiornoDellaSettimana),
				giornoProssimaConsegna: calcolaGiornoProssimaConsegna(giornoDelCalendario, dayOfWeek),
				nessunaDataDisponibile: nessunaConsegnaDisponibile || nessunaDataDisponibile(apertoPranzo, apertoCena, statoApertura)
			};
			return informazioniAperturaCache[locale.id]
		}

		function mostraPrimaConsegna(dayOfWeek, giornoDelCalendario, locale, calendarioRelativoAlGiornoDellaSettimana){
			if(dayOfWeek !== giornoDelCalendario){
				return calendarioRelativoAlGiornoDellaSettimana.pranzoApre !== null ? calendarioRelativoAlGiornoDellaSettimana.pranzoApre : calendarioRelativoAlGiornoDellaSettimana.cenaApre;
			}

			return locale.orarioPrimaConsegna;
		}

		return vm;
	}

})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .factory('IndirizzoDialogService', IndirizzoDialogService);

    IndirizzoDialogService.$inject = ['$uibModal'];

    function IndirizzoDialogService ($uibModal) {
      var vm = this;

      vm.open = open;
      vm.openDelete = openDelete;

        function open(cliente, indirizzo) {

          if (!indirizzo) {
            indirizzo = {
              clienteId: cliente.id,
              civico: null,
              tipoCivico: null,
              nomeSulCampanello: null,
              sezioneCensimento: null,
              via: null,
              telefono: null,
              telefono2: null,
              piano: null,
              interno: null,
              scala: null,
              note: null,
              id: null
            };
          }

          return $uibModal.open({
             templateUrl: 'app/pages/cliente/indirizzo/indirizzo-dialog.html',
             controller: 'IndirizzoDialogController',
             controllerAs: 'vm',
             backdrop: 'static',
             size: 'lg',
             resolve: { entity: indirizzo }
          }).result;
        }

        function openDelete(indirizzo) {

          return $uibModal.open({
                templateUrl: 'app/pages/cliente/indirizzo/indirizzo-delete-dialog.html',
                controller: 'IndirizzoDeleteController',
                controllerAs: 'vm',
                size: 'md',
                resolve: { entity: indirizzo }
            }).result;

        }

      return vm;
    }
})();

(function() {
	'use strict';

	angular
		.module('theFoodApp')
		.factory('IndirizzoStore', IndirizzoStore);

	var COOKIE_NAME = 'consegna';
	var COOKIE_EXPIRATION = 12; // In hours.

	/*
	 *
	 * addressCookie = {
	 *
	 *	// Se true, è stato specificato una strada e un civico custom;
	 *	// Se false, è stato selezionato uno degli indirizzi esistenti
	 *	new: true,
	 *
	 *	// (new == false) L'id dell'indirizzo scelto
	 *	addressId: null,
	 *
	 *	// (new == true) Oggetto strada e numerico civico inseriti dall'utente
	 *	strada: null,
	 * 	civico: null
	 *
	 *	// The resulting zone identifier
	 *	zone: null
	 *
	 * };
	 *
	 */

	function IndirizzoStore($cookies) {

		var vm = this;

		// Interface

		vm.setFromAddressBook = setFromAddressBook;
		vm.setFromInput = setFromInput;
		vm.clearCookie = clearCookie;
		vm.isPresent = isPresent;
		vm.get = clone;

		// Implementation

		var validCookie = false;
		var addressCookie = null;

		// Low level functions
		function loadCookie() {
			return $cookies.getObject(COOKIE_NAME);
		}

		function saveCookie(cookie) {
			$cookies.putObject(COOKIE_NAME, cookie, {
				expires: new moment().add(COOKIE_EXPIRATION, 'hours').toDate()
			});
		}

		function removeCookie() {
			$cookies.remove(COOKIE_NAME);
		}

		// High level functions
		function setFromAddressBook(address, zone) {
			validCookie = true;
			addressCookie = {
				new: false,
				addressId: address.id,
				strada: address.strada,
				civico: address.civico,
				zone: zone
			};
			saveCookie(addressCookie);
			return clone();
		}

		function setFromInput(strada, civico, zone) {
			validCookie = true;
			addressCookie = {
				new: true,
				strada: strada,
				civico: civico,
				zone: zone
			};
			saveCookie(addressCookie);
		}

		function loadFromCookie() {
			addressCookie = loadCookie();
			validCookie = angular.isDefined(addressCookie);
		}

		function clearCookie() {
			validCookie = false;
			addressCookie = null;
			removeCookie();
		}

		function isPresent() {
			return validCookie;
		}

		function clone() {
			return _.clone(addressCookie);
		}

		loadFromCookie();

		return vm;
	}

})();

(function() {
    'use strict';
    angular
        .module('theFoodApp')
        .factory('Indirizzo', Indirizzo);

    Indirizzo.$inject = ['$resource', 'SERVER_URL'];

    function Indirizzo ($resource, SERVER_URL) {
        var resourceUrl = SERVER_URL + 'api/v1/indirizzi/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('theFoodApp')
        .factory('DatiFatturazione', DatiFatturazione);

    DatiFatturazione.$inject = ['$resource', 'SERVER_URL'];

    function DatiFatturazione ($resource, SERVER_URL) {
        var resourceUrl =  SERVER_URL + 'api/dati-fatturaziones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('theFoodApp')
        .factory('Coupon', Coupon);

        Coupon.$inject = ['$resource', 'SERVER_URL'];

    function Coupon ($resource, SERVER_URL) {
        var resourceUrl = SERVER_URL + '/api/coupon';

        return $resource(resourceUrl, {}, { 

            saveCouponCredito: {
				method: 'GET',
				isArray: false,
                url: resourceUrl + '/aggiungi-credito/:codice',
                params: {
					codice: '@codice'
				},
				cache: false
            },     
            getValueCouponCredito: {
				method: 'GET',
				isArray: false,
                url: resourceUrl + '/valore-credito/:codice',
                params: {
					codice: '@codice'
				},
				cache: false
            }, 
            //'query': { method: 'GET', isArray: true}//,
            // 'get': {
            //     method: 'GET',
            //     transformResponse: function (data) {
            //         if (data) {
            //             data = angular.fromJson(data);
            //         }
            //         return data;
            //     }
            // },
            // 'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('theFoodApp')
        .factory('Register', Register);

    Register.$inject = ['$resource', 'SERVER_URL'];

    function Register ($resource, SERVER_URL) {
        return $resource(SERVER_URL + 'api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource', 'SERVER_URL'];

    function PasswordResetInit($resource, SERVER_URL) {
        var service = $resource(SERVER_URL + 'api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource', 'SERVER_URL'];

    function PasswordResetFinish($resource, SERVER_URL) {
        var service = $resource(SERVER_URL + 'api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .factory('Password', Password);

    Password.$inject = ['$resource', 'SERVER_URL'];

    function Password($resource, SERVER_URL) {
        var service = $resource(SERVER_URL + 'api/account/change_password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .factory('Auth', Auth);

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish, TempUserIdService) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            loginWithToken: loginWithToken,
            logout: logout,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount,
            loginWithGoogle : loginWithGoogle,
            loginWithFacebook: loginWithFacebook,
            loginWithApple: loginWithApple,
            loginWithAppleFromWeb : loginWithAppleFromWeb,
            getRedirectAppleJS: getRedirectAppleJS
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register')) {
                    $state.go('landing');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    /*this.logout();*/
                    return cb(err);
                }.bind(this)).$promise;
        }

        function loginWithToken(jwt) {
            var deferred = $q.defer();

            AuthServerProvider.loginWithToken(jwt)
                .then(loginThen)
                .catch(function (err) {
                    deferred.reject(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    deferred.resolve(data);
                });
                $rootScope.$broadcast('authenticationSuccess');
            }

            return deferred.promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    /*if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }*/
                    deferred.resolve(data);
                });
                $rootScope.$broadcast('authenticationSuccess');
                return cb();
            }

            return deferred.promise;
        }


        function logout () {
            return Promise.resolve( AuthServerProvider.logout() ).finally( function() {
                Principal.authenticate(null);
                TempUserIdService.clear();
                $rootScope.$broadcast('authenticationLogout');
            } );
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }

        function loginWithGoogle(googleUser){
        	var deferred = $q.defer();

            AuthServerProvider.loginWithGoogle(googleUser)
                .then(loginThen)
                .catch(function (err) {
                    deferred.reject(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    deferred.resolve(data);
                });
                $rootScope.$broadcast('authenticationSuccess');
            }

            return deferred.promise;
        }

        function loginWithFacebook(facebookUser){
        	var deferred = $q.defer();

            AuthServerProvider.loginWithFacebook(facebookUser)
                .then(loginThen)
                .catch(function (err) {
                    deferred.reject(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    deferred.resolve(data);
                });
                $rootScope.$broadcast('authenticationSuccess');
            }

            return deferred.promise;
        }

        function getRedirectAppleJS() {
            return AuthServerProvider.getRedirectAppleJS();
        }
        function loginWithApple(appleID){
            var deferred = $q.defer();

            AuthServerProvider.loginWithApple(appleID)
                .then(loginThen)
                .catch(function (err) {
                    deferred.reject(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    deferred.resolve(data);
                });
                $rootScope.$broadcast('authenticationSuccess');
            }

            return deferred.promise;
        }

        function loginWithAppleFromWeb(){
            AuthServerProvider.loginWithAppleFromWeb().then(function (response){

                return deferred.resolve(response);
            });

            return deferred.promise;
        }
    }
})();

(function() {
    /*jshint camelcase: false */
    'use strict';

    angular
        .module('theFoodApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', 'SERVER_URL', '$interpolate','$q', '$localStorage', 'Base64', 'WebStorageUtil', 'TokenStore'];

    function AuthServerProvider ($http, SERVER_URL,$interpolate, $q,$localStorage, Base64, WebStorageUtil, TokenStore) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithToken : loginWithToken,
            logout: logout,
            loginWithGoogle: loginWithGoogle,
            loginWithFacebook: loginWithFacebook,
            loginWithApple : loginWithApple,
            getRedirectAppleJS: getRedirectAppleJS
        };

        return service;

        function getToken () {
            if (WebStorageUtil.isLocalStorageSupported())
                return $localStorage.authenticationToken;
            else
                return TokenStore.isPresent() ? TokenStore.get().token : null
        }

        function login (credentials) {
            var data = 'username=' +  encodeURIComponent(credentials.username) + '&password=' +
                encodeURIComponent(credentials.password) + '&grant_type=password&scope=read%20write&' +
                'client_secret=my-secret-token-to-change-in-production&client_id=TheFoodapp';

            return $http.post(SERVER_URL + 'oauth/token', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Accept': 'application/json',
                    'Authorization': 'Basic ' + Base64.encode('TheFoodapp' + ':' + 'my-secret-token-to-change-in-production')
                }
            }).success(authSucess);

            function authSucess (response) {
                var expiredAt = new Date();
                expiredAt.setSeconds(expiredAt.getSeconds() + response.expires_in);
                response.expires_at = expiredAt.getTime();
                if (WebStorageUtil.isLocalStorageSupported())
                    $localStorage.authenticationToken = response;
                else
                    TokenStore.setToken(response);
                return response;
            }
        }

        function loginWithToken(jwt) {
            var deferred = $q.defer();
            let received_jwt = jwt;
            if (angular.isDefined(received_jwt)) {
                if (received_jwt)
                    jwt = angular.fromJson(received_jwt);
                if (received_jwt.data && !jwt.access_token)
                    jwt = angular.fromJson(received_jwt.data);

                if (jwt) {
                    var expiredAt = new Date();
                    expiredAt.setSeconds(expiredAt.getSeconds() + jwt.expires_in);
                    jwt.expires_at = expiredAt.getTime();
                    if (WebStorageUtil.isLocalStorageSupported())
                        $localStorage.authenticationToken = jwt;
                    else
                        TokenStore.setToken(jwt);
                    deferred.resolve(jwt);
                } else
                    deferred.reject();

            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function logout () {
            return $http.post(SERVER_URL + 'api/logout').then(function() {
                if (WebStorageUtil.isLocalStorageSupported())
                    delete $localStorage.authenticationToken;
                else
                    TokenStore.clearCookie();
            });
        }


        function loginWithGoogle (googleUser) {
        	var deferred = $q.defer();
            $http.post(SERVER_URL + 'social/signin/google',googleUser).then(function(token){
            	loginWithToken(token).then(function(){
            		deferred.resolve(token);
            	},function(){
            		deferred.reject();
            	})
            })
            return deferred.promise;
        }

        function loginWithFacebook (facebookUser) {
        	var deferred = $q.defer();
            $http.post(SERVER_URL + 'social/signin/facebook',facebookUser).then(function(token){
            	loginWithToken(token).then(function(){
            		deferred.resolve(token);
            	},function(){
            		deferred.reject();
            	})
            })
            return deferred.promise;
        }

        function getRedirectAppleJS() {
            let code = window.crypto.getRandomValues(new Int32Array(1)).toString();
            let baseUrl="";
            if(window.location.origin.includes('https://'))
                baseUrl = window.location.origin + '/';
            else
                baseUrl = SERVER_URL;
            let redirecturi = baseUrl + "social/signin/applejsweb";
            var params = {
                url: 'https://appleid.apple.com/auth/authorize',
                client_id: 'it.runnerpizza.ecommerce.client',
                redirect_uri: encodeURIComponent(redirecturi),
                response_type: 'code',
                scope:'name%20email',
                response_mode:'form_post',
                state:code
            };

            let templateInterpolation = "?client_id={{client_id}}&redirect_uri={{redirect_uri}}&response_type={{response_type}}&scope={{scope}}&response_mode={{response_mode}}&state+{{state}}";
            let paramsUrl = $interpolate(templateInterpolation)(params);
            return params.url + paramsUrl;
        }

        function loginWithApple (appleID) {
            var deferred = $q.defer();
            $http.post(SERVER_URL + 'social/signin/apple',appleID).then(function(token){
                loginWithToken(token).then(function(){
                    deferred.resolve(token);
                },function(){
                    deferred.reject();
                })
            })
            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource', 'SERVER_URL'];

    function Activate ($resource, SERVER_URL) {
        var service = $resource(SERVER_URL + 'api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .factory('Account', Account);

    Account.$inject = ['$resource', 'SERVER_URL'];

    function Account ($resource, SERVER_URL) {
        var service = $resource(SERVER_URL + 'api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function() {
	'use strict';
	angular
		.module('theFoodApp')
		.factory('AnnullaPagamento', AnnullaPagamento);

		function AnnullaPagamento ($resource, SERVER_URL) {
			var resourceUrl = SERVER_URL + 'api/v1/ordini/sblocca-ordine';

		return $resource(resourceUrl, {}, {
			'sblocca': {
				method: 'POST',
				params: {
					id: '@id'
				}
			}
		});
	}
})();

(function() {
    'use strict';
    angular.module('theFoodApp').config(stateConfig);
    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('storico', {
            parent: 'app',
            url: '/storico-ordini',
            reloadOnSearch: false,
            data: {
                pageTitle: 'theFoodApp.storico-ordini.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/pages/storico-ordini/storico-ordini.html',
                    controller: 'StoricoOrdiniController',
                    controllerAs: 'vm'
                }
            },
            breadcrumb: {
                title: "{{ 'theFoodApp.storico-ordini.title' | translate }}"
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ordine');
                    $translatePartialLoader.addPart('locale');
                    $translatePartialLoader.addPart('storico')
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
	'use strict';

	angular
		.module('theFoodApp')
		.controller('StoricoOrdiniController', StoricoOrdiniController);

		function StoricoOrdiniController($state, StoricoOrdini, pagingParams, ParseLinks, AlertService, RieffettuaOrdine, IndirizzoStore) {
			var vm = this;

			// Interface
			vm.itemsPerPage = 5;
			vm.loadPage = loadPage;
			vm.transition = transition;
			vm.loadAll = loadAll;
			vm.vediDettaglio = false;
			vm.storicoOrdini = [];
			vm.getIndirizzoCliente = getIndirizzoCliente;
			vm.isTakeaway = isTakeaway;
			vm.getPrezzo = getPrezzo;
			vm.hasSconto = hasSconto;
			vm.getScontoTotale = getScontoTotale;
			vm.getTotale = getTotale;
			// vm.vediOpzioniAggiunte = false;
			vm.showCaret = showCaret;
			vm.riacquista = riacquista;

			var predicate = 'dataOrdine';
			var reverse = false;

			loadAll();

			function loadAll() {
				StoricoOrdini.query({
					page: pagingParams.page - 1,
					size: vm.itemsPerPage,
					sort: sort()// --> eventualmente da popolare con l'ordinamento scelto dall'utente
				}, onSuccess, onError);
				function sort() {
				var result = [predicate + ',' + (reverse ? 'asc' : 'desc')];
				if (predicate !== 'dataOrdine') {
					result.push('dataOrdine');
				}
				return result;
			}


				function onSuccess(data, headers) {
					vm.links = ParseLinks.parse(headers('link'));
					vm.totalItems = headers('X-Total-Count');
					_.forEach(data, function(dettaglio) {
						vm.storicoOrdini.push(JSON.parse(dettaglio.dettaglioOrdine));
					});
					vm.page = pagingParams.page;
				}

				function onError(error) {
					AlertService.error(error.data.message);
				}
			}

			function loadPage(page) {
				vm.page = page;
				vm.transition();
			}

			function transition() {
				$state.transitionTo($state.$current, {
					page: vm.page
				});
			}

			function getIndirizzoCliente(indirizzoCliente){
				var indirizzo = indirizzoCliente.indirizzo.indirizzo + ', ' + indirizzoCliente.indirizzo.civico;

				return indirizzo;
			}

			function showCaret(riga){
				return (riga.dettaglioMenus && riga.dettaglioMenus.length > 0) || (riga.aggiuntas && riga.aggiuntas.length > 0) || (riga.dettaglioVariantes && riga.dettaglioVariantes.length > 0);
			}

			function isTakeaway(ordine){
				if(ordine){
					return ordine.ritiroAlLocale;
				}
			}

			function hasSconto(ordine) {
				return getScontoTotale(ordine) > 0;
			}

			function getScontoTotale(ordine) {
				return ordine.importoOrdineSenzaSconti - ordine.importoOrdine;
			}

			function getTotale(ordine) {
				if(ordine.creditoUtilizzato != null){
					return ordine.importoOrdine + ordine.importoSpedizione + ordine.creditoUtilizzato;
				}
				return ordine.importoOrdine + ordine.importoSpedizione;
			}

			function getPrezzo(prodotto, ordine){
				return isTakeaway(ordine) ? prodotto.prezzoAsporto : prodotto.prezzoDomicilio;
			}

			function riacquista(ordine){
				var riordine = {};
				riordine.righeOrdine = ordine.ordine.righeOrdine;
				riordine.isTakeaway = ordine.ordine.ritiroAlLocale;
				riordine.localeId = ordine.locale.id;
				riordine.insegnaId = ordine.locale.insegnaId;
				riordine.device = ordine.ordine.device;
				riordine.clienteId = ordine.cliente.id;

				if(!isTakeaway(ordine.ordine)){
					riordine.indirizzoClienteId = ordine.cliente.indirizzo.id;
				}

				RieffettuaOrdine.riordina(riordine).$promise
					.then(function(response){
						
						if(!isTakeaway(ordine.ordine)){
							var address = {};
							address.id = ordine.cliente.indirizzo.id;
							address.civico = ordine.cliente.indirizzo.civico;
							address.strada = ordine.cliente.indirizzo.indirizzo;
							IndirizzoStore.setFromAddressBook(address, response.zonaUtente);
						}

						$state.go('locale', {
							t: isTakeaway(ordine.ordine) ? ordine.locale.id : undefined,
							i: response.insegnaId,
							carrelloRiordinato: true
						});

					}).catch(function(error){
					});
			}
		}
})();

(function() {
    'use strict';

    angular
        .module( 'theFoodApp' )
        .config( stateConfig );

        stateConfig.$inject = [ '$stateProvider', 'SERVER_URL' ];

        function stateConfig ( $stateProvider, SERVER_URL ) {
            $stateProvider.state('static-page', {
                abstract: true,
                parent: 'app',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('static-pages');
                        return $translate.refresh();
                    }]
                }
            })
            /* STATI IN COMUNE */
            .state('static-page.chi-siamo', {
                url: '/chi-siamo',
                data: {
                    pageTitle: "theFoodApp.chisiamo"
                },
                views: {
                    'content@': {
                        templateUrl: SERVER_URL + 'static/pages/chi-siamo.html'
                    }
                },
                breadcrumb: {
                    title: "{{ 'theFoodApp.chisiamo' | translate }}"
                }
            })
            .state('static-page.privacy-policy', {
                url: '/privacy-policy',
                data: {
                    pageTitle: "theFoodApp.privacypolicy"
                },
                views: {
                    'content@': {
                        templateUrl: SERVER_URL + 'static/pages/privacy-policy.html'
                    }
                },
                breadcrumb: {
                    title: "{{ 'theFoodApp.privacypolicy' | translate }}"
                }
            })
            /* STATI PER THE FOOD*/
            .state( 'static-page.il-servizio', {
                url: '/il-servizio',
                data: {
                    pageTitle: "theFoodApp.ilservizio"
                },
                views: {
                    'content@': {
                        templateUrl: SERVER_URL + 'static/pages/il-servizio.html'
                    }
                },
                breadcrumb: {
                    title: "{{ 'theFoodApp.ilservizio' | translate }}"
                }
            })
            .state( 'static-page.light-catering', {
                url: '/light-catering',
                data: {
                    pageTitle: "theFoodApp.lightcatering"
                },
                views: {
                    'content@': {
                        templateUrl: SERVER_URL + 'static/pages/light-catering.html'
                    }
                },
                breadcrumb: {
                    title: "{{ 'theFoodApp.lightcatering' | translate }}"
                }
            })
            .state( 'static-page.gallery', {
                url: '/gallery',
                data: {
                    pageTitle: "theFoodApp.gallery"
                },
                views: {
                    'content@': {
                        templateUrl: SERVER_URL + 'static/pages/gallery.html'
                    }
                },
                breadcrumb: {
                    title: "{{ 'theFoodApp.gallery' | translate }}"
                }
            })
            /* STATI PER RUNNER PIZZA */
            .state( 'static-page.info', {
                url: '/info',
                data: {
                    pageTitle: "theFoodApp.info"
                },
                views: {
                    'content@': {
                        templateUrl: SERVER_URL + 'static/pages/info.html'
                    }
                },
                breadcrumb: {
                    title: "{{ 'theFoodApp.info' | translate }}"
                }
            })
            .state( 'static-page.promo', {
                url: '/promo',
                data: {
                    pageTitle: "theFoodApp.promo"
                },
                views: {
                    'content@': {
                        templateUrl: SERVER_URL + 'php/promo.html'
                    }
                },
                breadcrumb: {
                    title: "{{ 'theFoodApp.promo' | translate }}"
                }
            })
            .state( 'static-page.lavora-con-noi', {
                url: '/lavora-con-noi',
                data: {
                    pageTitle: "theFoodApp.lavoraconnoi"
                },
                views: {
                    'content@': {
                        templateUrl: SERVER_URL + 'static/pages/lavora-con-noi.html'
                    }
                },
                breadcrumb: {
                    title: "{{ 'theFoodApp.lavoraconnoi' | translate }}"
                }
            })
            .state( 'static-page.eventi', {
                url: '/eventi',
                data: {
                    pageTitle: "theFoodApp.eventi"
                },
                views: {
                    'content@': {
                        templateUrl: SERVER_URL + 'static/pages/eventi.html'
                    }
                },
                breadcrumb: {
                    title: "{{ 'theFoodApp.eventi' | translate }}"
                }
            })
            .state( 'static-page.allergeni', {
                url: '/allergeni',
                data: {
                    pageTitle: "theFoodApp.allergeni"
                },
                views: {
                    'content@': {
                        templateUrl: SERVER_URL + 'static/pages/allergeni.html'
                    }
                },
                breadcrumb: {
                    title: "{{ 'theFoodApp.allergeni' | translate }}"
                }
            })
            .state( 'static-page.buoni-pasto', {
                url: '/buoni-pasto',
                data: {
                    pageTitle: "theFoodApp.buonipasto"
                },
                views: {
                    'content@': {
                        templateUrl: SERVER_URL + 'static/pages/buoni-pasto.html'
                    }
                },
                breadcrumb: {
                    title: "{{ 'theFoodApp.buonipasto' | translate }}"
                }
            })
            .state( 'static-page.dove-siamo', {
                url: '/dove-siamo',
                data: {
                    pageTitle: "theFoodApp.dovesiamo"
                },
                views: {
                    'content@': {
                        templateUrl: SERVER_URL + 'static/pages/dove-siamo.html'
                    }
                },
                breadcrumb: {
                    title: "{{ 'theFoodApp.dovesiamo' | translate }}"
                }
            })
            // ============ NUOVI STATI AGGIUNTI ================ //
            .state( 'static-page.formcallcenter', {
                url: '/form-call-center',
                data: {
                    pageTitle: "theFoodApp.formcallcenter"
                },
                views: {
                    'content@': {
                        templateUrl: SERVER_URL + 'php/formcallcenter.html'
                    }
                },
                breadcrumb: {
                    title: "{{ 'theFoodApp.formcallcenter' | translate }}"
                }
            })
            .state( 'static-page.formvettori', {
                url: '/form-vettori',
                data: {
                    pageTitle: "theFoodApp.formvettori"
                },
                views: {
                    'content@': {
                        templateUrl: SERVER_URL + 'php/formvettori.html'
                    }
                },
                breadcrumb: {
                    title: "{{ 'theFoodApp.formvettori' | translate }}"
                }
            })
            .state( 'static-page.formpv', {
                url: '/form-pv',
                data: {
                    pageTitle: "theFoodApp.formpv"
                },
                views: {
                    'content@': {
                        templateUrl: SERVER_URL + 'php/formpv.html'
                    }
                },
                breadcrumb: {
                    title: "{{ 'theFoodApp.formpv' | translate }}"
                }
            })
            .state( 'static-page.formcorporate', {
                url: '/form-corporate',
                data: {
                    pageTitle: "theFoodApp.formcorporate"
                },
                views: {
                    'content@': {
                        templateUrl: SERVER_URL + 'php/formcorporate.html'
                    }
                },
                breadcrumb: {
                    title: "{{ 'theFoodApp.formcorporate' | translate }}"
                }
            })
            .state( 'static-page.newsletter', {
                url: '/newsletter',
                data: {
                    pageTitle: "theFoodApp.newsletter"
                },
                views: {
                    'content@': {
                        templateUrl: SERVER_URL + 'static/pages/newsletter.html'
                    }
                },
                breadcrumb: {
                    title: "{{ 'theFoodApp.newsletter' | translate }}"
                }
            })
            .state( 'static-page.lunch', {
                url: '/lunch',
                data: {
                    pageTitle: "theFoodApp.lunch"
                },
                views: {
                    'content@': {
                        templateUrl: SERVER_URL + 'static/pages/lunch.html'
                    }
                },
                breadcrumb: {
                    title: "{{ 'theFoodApp.lunch' | translate }}"
                }
            })
            .state( 'static-page.aiuto', {
                url: '/aiuto',
                data: {
                    pageTitle: "theFoodApp.aiuto"
                },
                views: {
                    'content@': {
                        templateUrl: SERVER_URL + 'static/pages/aiuto.html'
                    }
                }
            })
            .state( 'static-page.menu', {
                url: '/menu',
                data: {
                    pageTitle: "theFoodApp.menu"
                },
                views: {
                    'content@': {
                        templateUrl: SERVER_URL + 'static/pages/menu.html'
                    }
                }
            })
            .state( 'static-page.pizza', {
                url: '/pizza',
                data: {
                    pageTitle: "theFoodApp.pizza"
                },
                views: {
                    'content@': {
                        templateUrl: SERVER_URL + 'static/pages/pizza.html'
                    }
                }
            })
            .state( 'static-page.calzone', {
                url: '/calzone',
                data: {
                    pageTitle: "theFoodApp.calzone"
                },
                views: {
                    'content@': {
                        templateUrl: SERVER_URL + 'static/pages/calzone.html'
                    }
                }
            })
            .state( 'static-page.focaccia-in-piega', {
                url: '/focaccia-in-piega',
                data: {
                    pageTitle: "theFoodApp.focacciaInPiega"
                },
                views: {
                    'content@': {
                        templateUrl: SERVER_URL + 'static/pages/focaccia-in-piega.html'
                    }
                }
            })
            .state( 'static-page.teglia-del-fornaio', {
                url: '/teglia-del-fornaio',
                data: {
                    pageTitle: "theFoodApp.tegliaDelFornaio"
                },
                views: {
                    'content@': {
                        templateUrl: SERVER_URL + 'static/pages/teglia-del-fornaio.html'
                    }
                }
            })
            .state( 'static-page.insalata-carpaccio', {
                url: '/insalata-carpaccio',
                data: {
                    pageTitle: "theFoodApp.insalataCarpaccio"
                },
                views: {
                    'content@': {
                        templateUrl: SERVER_URL + 'static/pages/insalata-carpaccio.html'
                    }
                }
            })
            .state( 'static-page.hamburger', {
                url: '/hamburger',
                data: {
                    pageTitle: "theFoodApp.hamburger"
                },
                views: {
                    'content@': {
                        templateUrl: SERVER_URL + 'static/pages/hamburger.html'
                    }
                }
            })
            .state( 'static-page.sfiziosi', {
                url: '/sfiziosi',
                data: {
                    pageTitle: "theFoodApp.sfiziosi"
                },
                views: {
                    'content@': {
                        templateUrl: SERVER_URL + 'static/pages/sfiziosi.html'
                    }
                }
            })
            .state( 'static-page.secondi-piatti', {
                url: '/secondi-piatti',
                data: {
                    pageTitle: "theFoodApp.secondiPiatti"
                },
                views: {
                    'content@': {
                        templateUrl: SERVER_URL + 'static/pages/secondi-piatti.html'
                    }
                }
            })
            .state( 'static-page.primi-piatti', {
                url: '/primi-piatti',
                data: {
                    pageTitle: "theFoodApp.primiPiatti"
                },
                views: {
                    'content@': {
                        templateUrl: SERVER_URL + 'static/pages/primi-piatti.html'
                    }
                }
            })
            .state( 'static-page.bibite-vino-birra', {
                url: '/bibite-vino-birra',
                data: {
                    pageTitle: "theFoodApp.bibiteVinoBirra"
                },
                views: {
                    'content@': {
                        templateUrl: SERVER_URL + 'static/pages/bibite-vino-birra.html'
                    }
                }
            })
            .state( 'static-page.dolci-gelati', {
                url: '/dolci-gelati',
                data: {
                    pageTitle: "theFoodApp.dolciGelati"
                },
                views: {
                    'content@': {
                        templateUrl: SERVER_URL + 'static/pages/dolci-gelati.html'
                    }
                }
            })
            // ============ FINE NUOVI STATI AGGIUNTI ================ //
            .state( 'static-page.contatti', {
                url: '/contatti',
                data: {
                    pageTitle: "theFoodApp.contatti"
                },
                views: {
                    'content@': {
                        templateUrl: SERVER_URL + 'static/pages/contatti.html'
                    }
                },
                breadcrumb: {
                    title: "{{ 'theFoodApp.contatti' | translate }}"
                }
            })
            .state( 'static-page.home-runnerpizza', {
                url: '/home',
                views: {
                    'content@': {
                        templateUrl:  SERVER_URL + 'static/pages/home-runnerpizza.html'
                    }
                }
            })
        }
})();

( function() {
	'use strict';
	angular
		.module( 'theFoodApp' )
		.factory( 'Takeaway', Takeaway );

	Takeaway.$inject = [ '$resource', 'SERVER_URL' ];

	function Takeaway( $resource, SERVER_URL ) {
		var resourceUrl = SERVER_URL + 'api/public/v1/takeaway/:type';

		return $resource( resourceUrl, {}, {
			insegne: {
				method: 'GET',
				isArray: true,
				params: {
					type: 'insegne'
				},
				cache: true
			},
			comuni: {
				method: 'GET',
				isArray: true,
				params: {
					type: 'comuni'
				},
				cache: true
			},
			tipologieLocali: {
				method: 'GET',
				isArray: true,
				params: {
					type: 'tipologielocali'
				},
				cache: true
			}
		} );
	}
} )();

(function() {
	'use strict';

	angular
		.module('theFoodApp')
		.controller('TakeawayController', TakeawayController);

	function TakeawayController($scope, $state, Takeaway, AlertService, pagingParams, paginationConstants, insegne, comuni) {
		var vm = this;
		var startSMSize = 991;

		vm.insegne = extendInsegne(insegne);
		vm.comuni = comuni;
		vm.tipologieLocali = [];

		vm.loadingTipologie = false;
		vm.loadingInsegne = false;

		vm.selectedComune = $state.params.comune ? parseFloat($state.params.comune) : null;
		vm.selectedTipologie = $state.params.tipologie ? _.map($state.params.tipologie, parseFloat) : [];

		vm.selectComune = selectComune;
		vm.toggleTipologiaLocale = toggleTipologiaLocale;
		vm.isScreenLargeEnough = isScreenLargeEnough;
		vm.setMostraComuni = setMostraComuni;

		function isScreenLargeEnough() {
			if (document.body.offsetWidth > startSMSize) {
				return true;
			}

			return false;

		}

		function setMostraComuni() {
			if (document.body.offsetWidth <= startSMSize) {
				vm.mostraComuni = false;
			}

			vm.mostraComuni = true;
		}

		function activate() {
			loadTipologieLocali(vm.selectedComune);
		}

		function selectComune(comuneId) {
			if (vm.mostraTipologiePerComune === comuneId) {
				vm.mostraTipologiePerComune = !vm.mostraTipologiePerComune;
			} else {
				vm.mostraTipologiePerComune = !vm.mostraTipologiePerComune;
				vm.mostraTipologiePerComune = comuneId;
			}
			vm.descrizioneSelectedComune = _.find(vm.comuni, ['id', comuneId]);

			if (vm.selectedComune === comuneId) {
				return Promise.resolve();
			}

			vm.selectedComune = comuneId;
			$state.go('.', {
				comune: vm.selectedComune,
				tipologie: vm.selectedTipologie
			});
			return Promise.all([
				loadTipologieLocali(vm.selectedComune),
				loadInsegne(vm.selectedComune, vm.selectedTipologie)
			]);

		}

		function toggleTipologiaLocale(e, t) {
			t.selected = !t.selected;

			vm.selectedTipologie = _(vm.tipologieLocali).filter('selected').map('id').value();
			$state.go('.', {
				comune: vm.selectedComune,
				tipologie: vm.selectedTipologie
			}).then(function() {
				loadInsegne(vm.selectedComune, vm.selectedTipologie);
			});

			e.stopPropagation();
			return false;
		}

		function loadTipologieLocali(comuneId) {
			if (!comuneId) {
				vm.selectedTipologie = [];
				return Promise.resolve([]);
			}

			vm.loadingTipologie = true;
			return Takeaway.tipologieLocali({
				comune: comuneId
			}).$promise.then(function(data) {
				vm.tipologieLocali = data;
				_.each(vm.tipologieLocali, function(t) {
					t.selected = _.includes(vm.selectedTipologie, t.id);
				});
				return data;
			}, function(error) {
				AlertService.error(error.data.message);
			}).then(function() {
				vm.loadingTipologie = false;
			});
		}

		function loadInsegne(comuneId, tipologieLocaliId) {
			var params = {
				comune: comuneId,
				tipologieLocali: tipologieLocaliId
			};

			vm.loadingInsegne = true;
			return Takeaway.insegne(params).$promise.then(function(data) {
				vm.queryCount = vm.totalItems;

				// Sostituisci i *contenuti* di vm.insegna senza eseguire un'assegnazione ad un nuovo valore.
				vm.insegne.splice(0, vm.insegne.length);
				vm.insegne.push.apply(vm.insegne, extendInsegne(data));

				return data;
			}, function(error) {
				AlertService.error(error.data.message);
			}).then(function() {
				vm.loadingInsegne = false;
			});
		}

		function extendInsegne(insegne) {
			_.each(insegne, function(insegna) {
				_.each(insegna.locales, function(locale) {
					locale.insegna = insegna;
				});
			});
			return insegne;
		}

		activate();
		setMostraComuni();

		return vm;

	}

})();

( function() {
	'use strict';

	angular
		.module( 'theFoodApp' )
		.config( stateConfig );

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig( $stateProvider ) {

		$stateProvider.state( 'selezione-locale', {
			abstract: true,
			parent: 'selezione-indirizzo',
			resolve: {
				translatePartialLoader: [ '$translate', '$translatePartialLoader', function( $translate, $translatePartialLoader ) {
					$translatePartialLoader.addPart( 'insegna' );
					$translatePartialLoader.addPart( 'global' );
					$translatePartialLoader.addPart( 'selezione-locale' );
					$translatePartialLoader.addPart( 'locale' );
					return $translate.refresh();
				} ]
			}
		});

		$stateProvider.state( 'takeaway', {
			parent: 'selezione-locale',
			url: '^/takeaway?comune&tipologie',
			reloadOnSearch: false,
			data: {
				pageTitle: 'theFoodApp.selezione-locale.title-takeaway'
			},
			views: {
				'content@': {
					templateUrl: 'app/pages/selezione-locale/takeaway/takeaway-list.html',
					controller: 'TakeawayController',
					controllerAs: 'vm'
				},
				'insegne@takeaway': {
					templateUrl: 'app/pages/selezione-locale/selezione-locale.html',
					controller: 'SelezioneLocaleController',
					controllerAs: 'vm'
				}
			},
			params: {
				comune: {
					value: null,
					squash: true
				},
				tipologie: {
					value: null,
					squash: true,
					array: true
				}
			},
			resolve: {
				insegne: function( $state, $stateParams, $translate, Takeaway, AlertService, RouteError, translatePartialLoader ) {

					var selectedComune = null, selectedTipologie = [], filtersSet = false;

					if ( $stateParams.comune ) {
						selectedComune = parseFloat( $stateParams.comune );
						filtersSet = true;
					}

					if ( $stateParams.tipologie ) {
						selectedTipologie = _.map( $stateParams.tipologie, parseFloat );
						filtersSet = true;
					}

					var params = {
						comune: selectedComune,
						tipologieLocali: selectedTipologie
					};

					return Takeaway.insegne(params).$promise.then( function(insegne) {
						if ( insegne && insegne.length > 0 )
							return insegne;

						// Nessuna insegna trovata.

						// Se l'utente ha impostato dei filtri, lo facciamo comunque andare alla pagina, ma con un messaggio di warning che gli indica la mancanza di locali per i filtri specificati..
						if ( filtersSet )
							return [];

						// Altrimenti, se non abbiamo trovato nessuna insegna senza alcun filtro, vuol dire che non esistono locali che fanno takeaway.
						return Promise.reject( new RouteError().translatedErrorMessage( 'theFoodApp.selezione-indirizzo.error.notakeaway' ).redirectTo( 'selezione-indirizzo' ) );
					}, function(err) {
						return Promise.reject( new RouteError().error( err ) );
					} );
				},
				comuni: function( Takeaway ) {
					return Takeaway.comuni().$promise;
				},
				isTakeaway: _.constant( true ),
				pagingParams: [ '$stateParams', 'PaginationUtil', function( $stateParams, PaginationUtil ) {
					return {
						page: PaginationUtil.parsePage( $stateParams.page ),
						search: $stateParams.search
					};
				} ]
			},
			breadcrumb: {
				title: "{{ 'theFoodApp.selezione-locale.title-takeaway' | translate }}"
			}
		} );

		$stateProvider.state( 'consegna', {
			parent: 'selezione-locale',
			url: '^/consegna?tipologie',
			reloadOnSearch: false,
			data: {
				pageTitle: 'theFoodApp.selezione-locale.title-consegna'
			},
			views: {
				'content@': {
					templateUrl: 'app/pages/selezione-locale/consegna/consegna-list.html',
					controller: 'ConsegnaController',
					controllerAs: 'vm'
				},
				'insegne@consegna': {
					templateUrl: 'app/pages/selezione-locale/selezione-locale.html',
					controller: 'SelezioneLocaleController',
					controllerAs: 'vm'
				}
			},
			params: {
				tipologie: {
					value: null,
					squash: true,
					array: true
				}
			},
			resolve: {
				indirizzoSalvato: function( IndirizzoStore, RouteError, translatePartialLoader ) {
					if ( !IndirizzoStore.isPresent() ) {
						return Promise.reject( new RouteError().translatedErrorMessage( 'theFoodApp.selezione-locale.no-indirizzo-consegna' ).redirectTo( 'selezione-indirizzo' ) );
					} else {
						return IndirizzoStore.get();
					}
				},
				zona: function( indirizzoSalvato ) {
					return indirizzoSalvato.zone;
				},
				indirizzoCercato: function(indirizzoSalvato) {
					return indirizzoSalvato.strada.descrizione + ' ' + indirizzoSalvato.civico;
				},
				insegne: function( $state, $stateParams, Consegna, RouteError, zona, MultiInsegnaToggle, translatePartialLoader ) {
					var selectedTipologie = $stateParams.tipologie ? _.map( $stateParams.tipologie, parseFloat ) : [];
					var params = {
						tipologieLocali: selectedTipologie,
						zona: zona
					};

					return Consegna.insegne(params).$promise.then( function(data) {
						if ( !data || data.length === 0 ) {
							return Promise.reject( new RouteError().translatedErrorMessage( 'theFoodApp.selezione-locale.no-locali-zona' ).redirectTo( 'selezione-indirizzo' ) );
						}

						if (MultiInsegnaToggle.isMultiInsegna()) {
							return data;
						} else {
							$state.go( 'locale', { t: undefined, i: data[0].id } );
						}
					}, function(err) {
						if ( err && 'status' in err && err.status === 404 ) {
							return Promise.reject( new RouteError().translatedErrorMessage( 'theFoodApp.selezione-locale.no-locali-zona' ).redirectTo( 'selezione-indirizzo' ) );
						} else {
							return Promise.reject( new RouteError().error( err ) );
						}
					} );
				},
				tipologieLocali: function( $stateParams, Consegna, zona ) {
					return Consegna.tipologieLocali({ zona: zona }).$promise;
				},
				isTakeaway: _.constant( false ),
				pagingParams: [ '$stateParams', 'PaginationUtil', function( $stateParams, PaginationUtil ) {
					return {
						page: PaginationUtil.parsePage( $stateParams.page ),
						search: $stateParams.search
					};
				} ]
			},
			breadcrumb: {
				title: "{{ 'theFoodApp.selezione-locale.title-consegna' | translate }}"
			}
		} );

	}
} )();

(function() {
	'use strict';

	angular.module('theFoodApp').controller('SelezioneLocaleController',
		SelezioneLocaleController);

	function SelezioneLocaleController($state, insegne, isTakeaway, InformazioniAperturaOdierna) {
		var vm = this;

		vm.collapsed = {};
		vm.onInsegnaClicked = onInsegnaClicked;
		vm.insegne = insegne;
		vm.isTakeaway = isTakeaway;
		vm.informazioniAperturaOdierna = informazioniAperturaOdierna;
		vm.mostraStringaProssimaConsegnaUtile = mostraStringaProssimaConsegnaUtile;
		vm.mostraGiornoProssimaConsegna = mostraGiornoProssimaConsegna;
		vm.nessunaDataDisponibile = nessunaDataDisponibile;

		function onInsegnaClicked(insegna) {
			if (insegna.locales.length === 1) {
				$state.go('locale', {
					t: isTakeaway ? insegna.locales[0].id : undefined,
					i: insegna.id
				});
			} else {
				vm.collapsed[insegna.id] = true;
			}
		}

		function mostraStringaProssimaConsegnaUtile(locale) {
			return InformazioniAperturaOdierna.getInformazioniAperturaOdierna(locale).prossimaConsegnaUtile && InformazioniAperturaOdierna.getInformazioniAperturaOdierna(locale).orarioPrimaConsegna;
		}

		function informazioniAperturaOdierna(locale) {
			return InformazioniAperturaOdierna.getInformazioniAperturaOdierna(locale);
		}

		function mostraGiornoProssimaConsegna(locale){
			return InformazioniAperturaOdierna.getInformazioniAperturaOdierna(locale).giornoProssimaConsegna === null ? false : true;
		}

		function nessunaDataDisponibile(locale){
			return InformazioniAperturaOdierna.getInformazioniAperturaOdierna(locale).nessunaDataDisponibile;
		}

		return vm;

	}

})();

(function() {
	'use strict';

	angular
		.module('theFoodApp')
		.directive('locale', locale);

	function locale() {
		var directive = {
			restrict: 'E',
			scope: {
				locale: '=data',
				isTakeaway: '='
			},
			templateUrl: 'app/pages/selezione-locale/locale.directive.html',
			bindToController: true,
			controllerAs: 'vm',
			/* @ngInject */
			controller: function($state, InformazioniAperturaOdierna) {

				var vm = this;

				vm.pranzoApre = (vm.locale.calendarios && vm.locale.calendarios[0]) ? vm.locale.calendarios[0].pranzoApre : null;
				vm.cenaApre = (vm.locale.calendarios && vm.locale.calendarios[0]) ? vm.locale.calendarios[0].cenaApre : null;

				vm.mostraConsegnaUtile = vm.pranzoApre || vm.cenaApre;
				vm.informazioniAperturaOdierna = InformazioniAperturaOdierna.getInformazioniAperturaOdierna(vm.locale);

				return vm;
			}
		};

		return directive;
	}
})();

( function() {
	'use strict';
	angular
		.module( 'theFoodApp' )
		.factory( 'Consegna', Consegna );

	Consegna.$inject = [ '$resource', 'SERVER_URL' ];

	function Consegna( $resource, SERVER_URL ) {
		var resourceUrl = SERVER_URL + 'api/public/v1/consegne/:zona/:type';

		return $resource( resourceUrl, {}, {
			insegne: {
				method: 'GET',
				isArray: true,
				params: {
					type: 'insegne'
				},
				cache: true
			},
			locale : {
				url : resourceUrl+'/:insegnaId',
				method: 'GET',
				isArray: false,
				params: {
					type: 'insegne'
				},
				cache: true
			},
			tipologieLocali: {
				method: 'GET',
				isArray: true,
				params: {
					type: 'tipologielocali'
				},
				cache: true
			}
		} );
	}
} )();

(function() {
	'use strict';

	angular
		.module('theFoodApp')
		.controller('ConsegnaController', ConsegnaController);

	function ConsegnaController($scope, $state, Consegna, AlertService, pagingParams, paginationConstants, zona, indirizzoCercato, insegne, tipologieLocali, $anchorScroll, $location) {
		var vm = this;
		var startSMSize = 991;

		vm.indirizzoCercato = indirizzoCercato;
		vm.insegne = extendInsegne(insegne);
		vm.tipologieLocali = tipologieLocali;
		vm.setMostraTipologie = setMostraTipologie;
		vm.isScreenLargeEnough = isScreenLargeEnough;
		vm.toggleTipologiaLocale = toggleTipologiaLocale;

		vm.loadingInsegne = false;
		vm.selectedTipologie = $state.params.tipologie ? _.map($state.params.tipologie, parseFloat) : [];

		// isScreenLargeEnough();

		function isScreenLargeEnough() {
			if (document.body.offsetWidth > startSMSize) {
				return true;
			}

			return false;

		}

		setMostraTipologie();

		function setMostraTipologie() {
			if (document.body.offsetWidth <= startSMSize) {
				vm.mostraTipologie = false;
			}

			vm.mostraTipologie = true;
		}

		function activate() {
			_.each(vm.tipologieLocali, function(t) {
				t.selected = _.includes(vm.selectedTipologie, t.id);
			});
		}

		function toggleTipologiaLocale(e, t) {
			t.selected = !t.selected;

			vm.selectedTipologie = _(vm.tipologieLocali).filter('selected').map('id').value();
			$state.go('.', {
				tipologie: vm.selectedTipologie
			}).then(function() {
				loadInsegne(vm.selectedTipologie);
			});

			e.stopPropagation();
			if (document.body.offsetWidth <= startSMSize) {
				// $location.hash('primo-locale');
				// $anchorScroll();
				vm.mostraTipologie = true;
			}

			return false;
		}

		function loadInsegne(tipologieLocaliId) {
			var params = {
				zona: zona,
				tipologieLocali: tipologieLocaliId
			};

			vm.loadingInsegne = true;
			return Consegna.insegne(params).$promise.then(function(data) {
				vm.queryCount = vm.totalItems;

				vm.insegne.splice(0, vm.insegne.length);
				vm.insegne.push.apply(vm.insegne, extendInsegne(data));

				return data;
			}, function(error) {
				AlertService.error(error.data.message);
			}).then(function() {
				vm.loadingInsegne = false;
			});
		}

		function extendInsegne(insegne) {
			_.each(insegne, function(insegna) {
				_.each(insegna.locales, function(locale) {
					locale.insegna = insegna;
				});
			});
			return insegne;
		}

		activate();

		return vm;

	}

})();

( function() {
	'use strict';

	angular
		.module( 'theFoodApp' )
		.config( stateConfig );

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig( $stateProvider ) {
		$stateProvider
			.state( 'selezione-indirizzo', {
				parent: 'app',
				url: '/selezione-indirizzo',
				data: {
					pageTitle: 'theFoodApp.selezione-indirizzo.title'
				},
				views: {
					'content@': {
						templateUrl: 'app/pages/selezione-indirizzo/selezione-indirizzo.html',
						controller: 'SelezioneIndirizzoController as vm'
					},
					'rubrica@selezione-indirizzo': {
						templateUrl: 'app/pages/selezione-indirizzo/selezione-indirizzo.rubrica.html',
						controller: 'SelezioneIndirizzoRubricaController',
						controllerAs: 'vm'
					},
					'new@selezione-indirizzo': {
						templateUrl: 'app/pages/selezione-indirizzo/selezione-indirizzo.new.html',
						controller: 'SelezioneIndirizzoNewController',
						controllerAs: 'vm'
					},
					'takeaway@selezione-indirizzo': {
						templateUrl: 'app/pages/selezione-indirizzo/selezione-indirizzo.takeaway.html'
					}
				},
				resolve: {
					newAddress: function(IndirizzoStore) {
						if ( IndirizzoStore.isPresent() ) {
							var indirizzo = IndirizzoStore.get();
							if ( indirizzo.new ) {
								return indirizzo;
							}
						}
						return {};
					},
					addressBook: function(Principal, Indirizzo) {
						return Principal.identity().then( function(identity) {
							return Principal.isAuthenticated() ? Indirizzo.query().$promise : Promise.resolve( [] );
						} );
					},
					translatePartialLoader: [ '$translate', '$translatePartialLoader', function( $translate, $translatePartialLoader ) {
						$translatePartialLoader.addPart( 'selezione-indirizzo' );
						$translatePartialLoader.addPart( 'global' );
						return $translate.refresh();
					} ]
				},
				breadcrumb: {
					title: "{{ 'theFoodApp.selezione-indirizzo.title' | translate }}"
				}
			} );

	}

} )();

(function() {
	'use strict';

	angular
		.module('theFoodApp')
		.controller('SelezioneIndirizzoRubricaController', SelezioneIndirizzoRubricaController);

	SelezioneIndirizzoRubricaController.$inject = [ '$state', 'TrovaZona', 'IndirizzoStore', 'addressBook', 'Consegna' ];

	function SelezioneIndirizzoRubricaController( $state, TrovaZona, IndirizzoStore, addressBook, Consegna ) {

		var addressTemplate = _.template( '{{ indirizzo.strada.descrizioneComune }} - {{ indirizzo.strada.descrizione }} {{ indirizzo.civico }}' );

		//

		var vm = this;

		vm.validZone = true;
		vm.addressBook = addressBook;
		vm.getDescrizione = getDescrizione;
		vm.selezionaIndirizzo = selezionaIndirizzo;

		//

		function getDescrizione( indirizzo ) {
			return addressTemplate( { indirizzo: indirizzo } );
		}

		function selezionaIndirizzo( indirizzo ) {
			vm.validZone = true;
			return TrovaZona.zona({stradaId: indirizzo.strada.id, civico: indirizzo.civico}).$promise.then( function(zona) {
				IndirizzoStore.setFromAddressBook( indirizzo, zona.id );

				$state.go( 'consegna' );

			}, function() {
				vm.validZone = false;
			} );
		}

		return vm;
	}

})();

(function() {
	'use strict';

	angular
		.module('theFoodApp')
		.controller('SelezioneIndirizzoNewController', SelezioneIndirizzoNewController);

	function SelezioneIndirizzoNewController($log, $state, AlertService, IndirizzoStore, TrovaZona, newAddress, Consegna) {
		var vm = this;

		vm.strada = {};
		vm.civico = null;

		vm.validAddress = true;
		vm.validZone = true;
		vm.selectedAddress = true;
		vm.onAddressSelected = onAddressSelected;

		if (newAddress) {
			vm.strada = newAddress.strada;
			vm.civico = newAddress.civico;
		}

		function searchZona(strada, numeroCivico) {

			vm.validAddress = true;
			vm.validZone = true;
			vm.selectedAddress = true;

			if (angular.isUndefined(strada) || angular.isUndefined(numeroCivico)) {
				vm.validAddress = false;
			}
			if (angular.isUndefined(strada.id)) {
				vm.selectedAddress = false;
			}

			if (!vm.selectedAddress || !vm.validAddress)
				return;

			return TrovaZona.zona({
				stradaId: strada.id,
				civico: numeroCivico
			}).$promise.then(function(data) {
				IndirizzoStore.setFromInput(strada, numeroCivico, data.id);

				$state.go('consegna');

			}, function(err) {
				if (err.status === 404) {
					vm.validZone = false;
				} else {
					throw err;
				}
			});
		}

		function onAddressSelected() {
			vm.selectedAddress = true;
		}

		vm.searchZona = searchZona;
		return vm;
	}

})();

(function () {
    'use strict';

    angular
        .module('theFoodApp')
        .controller('SelezioneIndirizzoController', SelezioneIndirizzoController);

    function SelezioneIndirizzoController(addressBook, SERVER_URL, Versione, $uibModal, DownloadAppToggle, $window) {
        var vm = this;

        function onSuccessGetNeedUpdate(data) {

            if (!data.compatible)
                showModalGetNeedUpdate();
        }

        function onErrorGetNeedUpdate() {
            showModalGetNeedUpdate();
        }

        if (window.device !== undefined && (window.device.platform === "Android" || window.device.platform === "iOS")) {

            /* var versionCode;
             $window.cordova.getAppVersion.getVersionCode(function (version) {
                 console.log("version code", version);
                 versionCode = version;
             });*/

            Versione.getNeedUpdate({codiceVersion: "10154"}, onSuccessGetNeedUpdate, onErrorGetNeedUpdate);

        }

        function showModalGetNeedUpdate() {

            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/selezione-indirizzo/modal-update-app/modal-update-app.html',
                controller: 'UpdateAppController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false


            });

            return Promise.resolve(modalInstance.result);
        }


        vm.showAddressBook = addressBook.length > 0;
        vm.getNotePage = getNotePage;
        vm.getInfoCommerciali = getInfoCommerciali;

        function getNotePage() {
            return SERVER_URL + '/static/pages/note.html';
        }

        function getInfoCommerciali() {
            return SERVER_URL + '/static/pages/informazioni-commerciali.html';
        }

        return vm;
    }

})();

(function () {
    'use strict';

    angular
        .module('theFoodApp')
        .controller('UpdateAppController', UpdateAppController);

    function UpdateAppController($scope, $window, $state, $translate, $uibModalInstance, MobileAppService) {
        var vm = this;

        vm.downloadApp = downloadApp;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function downloadApp() {
            var url = MobileAppService.getStoreUrlForDevice();
            $window.open(url, '_blank');
        }

        return vm;
    }


})();

(function() {

	angular
		.module( 'theFoodApp' )
		.factory( 'PromozioniHolder', PromozioniHolder );

	function PromozioniHolder($state) {
		var instance = this;
		instance.visible = false;
		instance.promozioni = [];

		instance.setVisibility = setVisibility;
		instance.isVisible = isVisible;
		instance.getPromozioni = getPromozioni;

		function setVisibility(visible, promozioni) {
			instance.visible = visible;
			if (visible && promozioni && promozioni.length > 0) {
				instance.promozioni = promozioni;
			} else {
				instance.promozioni = [];
			}
		}

		function isVisible() {
			return instance.visible;
		}

		function getPromozioni() {
			return instance.promozioni;
		}

		return instance;
	}
})();
(function(){
	'use strict';

	angular
		.module("theFoodApp")
		.config(stateConfig);

	function stateConfig($stateProvider){
		$stateProvider.state('promozione',{
			parent: 'locale',
			url: '/promozione',
			resolve: {
				promozioni: function($rootScope, $stateParams, RecuperaPromozioniService){
					return RecuperaPromozioniService.get({
						insegnaId: $stateParams.i,
						isMobile: $rootScope.isMobile()
					}).$promise;
				},
				translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('promozioni');
					return $translate.refresh();
				}]
			},
			views: {
				'content@': {
					templateUrl: 'app/pages/promozioni/promozioni.full.html',
					controller: 'PromozioniController',
					controllerAs: 'vm'
				}
			}
		});
	}
})();
(function(){
	'use strict';

	angular
		.module('theFoodApp')
		.controller('PromozioniController', PromozioniController);

	function PromozioniController(promozioni){
		var vm = this;

		//Interface
		vm.promozioni = promozioni;

	}
})();
(function() {
	'use strict';

	angular
		.module('theFoodApp')
		.controller('PaymentOkController', PaymentOkController);

	function PaymentOkController( $state, $stateParams, DateUtils, pagamento, indirizzo ) {
    var vm = this;

		vm.pagamento = pagamento;
		vm.ordine = pagamento.ordine;
		vm.locale = pagamento.ordine.locale;
		vm.indirizzo = indirizzo;

		function getOrariConsegna(orarioConsegna, locale) {
			var d = new Date();
			d.setHours(parseInt(orarioConsegna.split(':')[0]));
			d.setMinutes(parseInt(orarioConsegna.split(':')[1]));

			d.setMinutes(d.getMinutes() + locale.insegna.splitOrariDiConsegna);

			return orarioConsegna + " - " + d.getHours() + ":" + d.getMinutes();
		}

		vm.getOrariConsegna = getOrariConsegna;

		vm.dataOraTransazione = DateUtils.convertDateTimeFromServer(vm.pagamento.dataOraTransazione);
		vm.dataOrdine = DateUtils.convertDateTimeFromServer(vm.ordine.dataOrdine);
		vm.dataConsegna = DateUtils.convertDateTimeFromServer(vm.ordine.dataConsegna);

		return vm;
  }

}) ();
(function() {
	'use strict';

	angular
		.module('theFoodApp')
		.controller('PaymentErrorController', PaymentErrorController);

	function PaymentErrorController( $state, $stateParams ) {
    var vm = this;

		return vm;
  }

}) ();
(function() {
	'use strict';

	angular
		.module('theFoodApp')
		.controller('PaymentCancelController', PaymentCancelController);

	function PaymentCancelController( $state, $stateParams ) {
    var vm = this;

		return vm;
  }

}) ();
( function() {
	'use strict';

	angular
		.module( 'theFoodApp' )
		.config( stateConfig );

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig( $stateProvider ) {
		$stateProvider
			.state( 'paymentOk', {
				parent: 'app',
				url: '/paymentOk/:transactionId',
				data: { pageTitle: 'theFoodApp.payment-ok.title' },
				views: {
					'content@': {
						controller: function($state, pagamento) {
							$state.go('acquisto-concluso', {
								pagamentoId: pagamento.id,
								paymentOk: true,
								t: pagamento.ordine.ritiroAlLocale ? pagamento.ordine.locale.id : undefined,
								i: pagamento.ordine.locale.insegna.id
							})
						}
					}
				},
				resolve: {
					pagamento: function($stateParams, Pagamento) {
						return Pagamento.transaction({ transactionId: $stateParams.transactionId }).$promise;
					}
				},
				breadcrumb: { title: "{{ 'theFoodApp.payment-ok.title' | translate }}" }
			} )
			.state( 'paymentCancel', {
				parent: 'app',
				url: '/paymentCancel/:transactionId',
				data: { pageTitle: 'theFoodApp.payment-cancel.title' },
				views: {
					'content@': {
						controller: function($state, pagamento) {
							$state.go('concludi-acquisto', {
								pagamentoId: pagamento.id,
								paymentCancel: true,
								t: pagamento.ordine.ritiroAlLocale ? pagamento.ordine.locale.id : undefined,
								i: pagamento.ordine.locale.insegna.id
							})
						}
					}
				},
				resolve: {
					pagamento: function($stateParams, Pagamento) {
						return Pagamento.transaction({ transactionId: $stateParams.transactionId }).$promise;
					}
				},
				breadcrumb: { title: "{{ 'theFoodApp.payment-cancel.title' | translate }}" }
			} )
			.state( 'paymentError', {
				parent: 'app',
				url: '/paymentError/:transactionId',
				data: { pageTitle: 'theFoodApp.payment-error.title' },
				views: {
					'content@': {
						controller: function($state, pagamento, AlertService, $translate) {
							if (pagamento) {
								$state.go('concludi-acquisto', {
									pagamentoId: pagamento.id,
									paymentError: true,
									t: pagamento.ordine.ritiroAlLocale ? pagamento.ordine.locale.id : undefined,
									i: pagamento.ordine.locale.insegna.id
								});
							} else {
								AlertService.error($translate.instant('payments.payments-interrupted-error.title'));
								$state.go('landing');
							}
						}
					}
				},
				resolve: {
					pagamento: function($stateParams, Pagamento) {
						return Pagamento.transaction({ transactionId: $stateParams.transactionId }).$promise
							.then(function(pagamento) {
								Promise.resolve(pagamento);
							})
							.catch(function(err) {
								Promise.resolve();
							});
					}
				},
				breadcrumb: { title: "{{ 'theFoodApp.payment-error.title' | translate }}" }
			} );

	}

} )();

( function () {
	'use strict';

	angular
		.module( 'theFoodApp' )
		.config( stateConfig );

	function stateConfig( $stateProvider ) {
		$stateProvider.state( 'mobile-app', {
			parent: 'app',
			url: '/mobile-app',
			resolve: {
				storeUrl: [ 'MobileAppService', function ( MobileAppService ) {
					return MobileAppService.getStoreUrlForDevice();
				}]
			},
			onEnter: function ( $window, $location, $log, $timeout, storeUrl ) {
				$timeout( function () {
					if ( storeUrl && window.localStorage ) {
						localStorage.setItem( 'redirectTo', storeUrl );
						$window.history.replaceState( {}, '', '/' );
					} else {
						$log.error( 'Store URL non disponibile, redirect su homepage' );
						$location.path( '/?from=mobile#/landing' ).replace();
					}
				}, 0 );
			}
		} );
	}

} )();

( function() {
	'use strict';

	angular
		.module( 'theFoodApp' )
		.config( stateConfig );

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig( $stateProvider ) {

		$stateProvider.state( 'locale', {
			parent: 'selezione-locale',
			url: '^/insegna/{i:int}?{t:int}',
			data: {
				pageTitle: '{{ locale.insegna.insegna }}'
			},
			params: {
				carrelloRiordinato: false
			},
			resolve: {

				isTakeaway: function( $stateParams ) {
					return angular.isDefined( $stateParams.t );
				},
				
				isRunnerPizza : function(APP_NAME){
					return ('RunnerPizza' === APP_NAME);
				},

				indirizzoSalvato: function( isTakeaway, IndirizzoStore, RouteError, translatePartialLoader ) {
					if ( isTakeaway )
						return null;
					if ( !IndirizzoStore.isPresent() )
						return Promise.reject( new RouteError().translatedErrorMessage( 'theFoodApp.selezione-locale.no-indirizzo-consegna' ).redirectTo( 'selezione-indirizzo' ) );
					return IndirizzoStore.get();
				},
				zona: function( isTakeaway, indirizzoSalvato ) {
					if ( isTakeaway )
						return null;
					return indirizzoSalvato.zone;
				},

				locale: function( $stateParams, isTakeaway, zona, Locale, Consegna, RouteError, translatePartialLoader ) {

					if ( isTakeaway ) {

						if ( !$stateParams.t ) {
							// Per il takeaway è necessario sapere anche quale locale è stato selezionato.
							return Promise.reject( new RouteError( 'invalid-url' ).redirectTo( 'takeaway' ) );
						}

						return Locale.get( { localeId: $stateParams.t } ).$promise.then( function( locale ) {

							if ( locale.insegna.id !== $stateParams.i ) {
								// Il locale e l'insegna specificata non matchano.
								return Promise.reject( new RouteError().translatedErrorMessage( 'invalid-url' ).redirectTo( 'takeaway' ) );
							}

							return locale;

						}, function( err ) {
							if ( err && 'status' in err && err.status === 404 ) {
								return Promise.reject( new RouteError().translatedErrorMessage( 'invalid-url' ).redirectTo( 'takeaway' ) );
							} else {
								throw err;
							}
						} );
						// TODO: Gestire 404?
					} else {
						return Consegna.locale({ zona : zona, insegnaId : $stateParams.i }).$promise
							.catch( function( err ) {
								if ( err && 'status' in err && err.status === 404 ) {
									return Promise.reject( new RouteError().translatedErrorMessage( 'theFoodApp.selezione-indirizzo.error.no-locale-for-zone' ).redirectTo( 'consegna' ) );
								} else {
									throw err;
								}
							} );
					}

				},

				listino: function( Locale, locale ) {
					return Locale.getListino( { localeId: locale.id } ).$promise;
				},

				carrelloInstance: function( CarrelloInstanceFactory, locale, zona ) {
					return CarrelloInstanceFactory.build( locale, zona );
				},
				promozioni: function($rootScope, RecuperaPromozioniService, locale){
					var isMobile = $rootScope.isMobile();
					return RecuperaPromozioniService.get({
						insegnaId: locale.insegna.id,
						isMobile: isMobile
					}).$promise;
				},

				translatePartialLoader: [ '$translate', '$translatePartialLoader', function( $translate, $translatePartialLoader ) {
					// $translatePartialLoader.addPart( 'selezione-locale' );
					$translatePartialLoader.addPart( 'global' );
					$translatePartialLoader.addPart( 'locale' );
					$translatePartialLoader.addPart( 'ordine' );
					$translatePartialLoader.addPart( 'aggiunte' );
					$translatePartialLoader.addPart( 'varianti' );
					$translatePartialLoader.addPart( 'carrello' );
					return $translate.refresh();
				} ]
			},
			views: {
				'content@': {
					templateUrl: 'app/pages/locale/locale.html',
					controller: 'LocaleController',
					controllerAs: 'vm'
				},
				'listino@locale': {
					templateUrl: 'app/pages/locale/locale.listino.html',
					controller: 'LocaleListinoController',
					controllerAs: 'vm'
				},
				'info@locale': {
					templateUrl: 'app/pages/locale/locale.info.html',
					controller: function( locale ) {
						this.locale = locale;
					},
					controllerAs: 'll'
				},
				'carrello@locale': {
					templateUrl: 'app/pages/carrello/carrello.html',
					controller : 'CarrelloController',
					controllerAs : 'vm'
				}
			},
			breadcrumb: {
				// TODO: Risolvere in qualche modo...
				titleTakeaway: "{{ locale.insegna.insegna }} - {{ locale.indirizzo }}",
				titleConsegna: "{{ locale.insegna.insegna }}",
			}
		} );

	}
} )();

(function() {

	angular
		.module('theFoodApp')
		.controller('LocaleListinoController', LocaleListinoController);

	function LocaleListinoController( $uibModal, $scope, isTakeaway, listino, locale, zona, carrelloInstance, Notification, $translate, CarrelloHolder, DOUBLE_CLICK_TIME, NOTIFICATION_TIME, $timeout, PromozioniHolder, $window ) {

		var vm = this;

		// Interface
		vm.linee = listino;
		vm.locale = locale;
		vm.zona = zona;
		vm.scelteMenu = {};
		vm.showMenuError = -1;

		vm.getPrezzoProdotto = getPrezzoProdotto;
		vm.getImportoCarrello = getImportoCarrello;
		vm.aggiungiProdotto = aggiungiProdotto;
		vm.modificaVarianti = modificaVarianti;
		vm.isDesktop = $window.outerWidth > 812 ? true : false;


		vm.onSceltaMenuChanged = onSceltaMenuChanged;

		CarrelloHolder.setVisibility(true, [carrelloInstance]);

		$scope.$on('$destroy', function() {
			CarrelloHolder.setVisibility(false);
			PromozioniHolder.setVisibility(false);
		});

		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event': 'displayingMenu'
		});

		// Implementation
		var lang = $translate.proposedLanguage() || $translate.use();
		var doubleClickGuard = false;

		function aggiungiProdotto(articolo){
			var scelteMenu = [],
				hasError = false;
			if (articolo.menus.length > 0) {
				var ids = _.map(articolo.menus, 'id').map(_.toString);
				var scelteIds = _.pick(vm.scelteMenu, ids);

				_.each(articolo.menus, function(menu) {
					var scelta = scelteIds[menu.id];
					if (!scelta) {
						if (!menu.opzionale) {
							hasError = true;
						}
						return;
					}

					scelteMenu.push({
						menuItemId: menu.id,
						productId: scelta
					});
				});
			}

			if (!hasError) {
				if(doubleClickGuard)
					return Promise.resolve();

				doubleClickGuard = true;
				$timeout(function(){
					doubleClickGuard = false;
				}, DOUBLE_CLICK_TIME);

				return carrelloInstance.aggiungiProdotto(articolo, scelteMenu).then(function(response) {
					Notification.success({
						message: lang == 'it' ? articolo.descrizioneIt : articolo.descrizioneEn,
						title: $translate.instant('theFoodApp.locale.articoloAggiunto'),
						delay: NOTIFICATION_TIME
					}).then(function(){
						vm.modificaVarianti(response.ordine);
					}).then(function() {
						window.dataLayer = window.dataLayer || [];
						window.dataLayer.push({
							'event': 'addProductOnCart'
						});
					});
				}, function() {
					Notification.error({
						message: lang == 'it' ? articolo.descrizioneIt : articolo.descrizioneEn,
						title: $translate.instant('theFoodApp.locale.articoloNonAggiunto'),
						delay: NOTIFICATION_TIME
					});
				});
			} else {
				vm.showMenuError = articolo.id;
				return Promise.reject(new Error('Invalid menu choices'));
			}
		}

		function getPrezzoProdotto(prodotto) {
			return isTakeaway ? prodotto.prezzoAsporto : prodotto.prezzoDomicilio;
		}

		function onSceltaMenuChanged(scelta) {
			vm.showMenuError = false;
		}

		function getImportoCarrello() {
			return carrelloInstance.getImportoArticoli();
		}


		function modificaVarianti(ordine) {

			if (vm.isDesktop){
				return false;
			}

			var sceltaMenu = null;
			var rigaOrdine = _.maxBy(ordine.rigaOrdines, 'id');

			if (rigaOrdine.dettaglioMenus.length){
					var menus = rigaOrdine.dettaglioMenus;
					var articoloMenuConVariante = _.find(menus, function(menu) {
							if (menu.dettaglioVariantes.length){
								return menu;
							}
					})
					sceltaMenu = articoloMenuConVariante ? articoloMenuConVariante : rigaOrdine;
					if (
							(!articoloMenuConVariante.dettaglioVariantes || !articoloMenuConVariante.dettaglioVariantes.length) &&
							(!articoloMenuConVariante.prodotto.aggiunteDisponibili)
						)
						return false;
			}else{
				if (
					(!rigaOrdine.dettaglioVariantes || !rigaOrdine.dettaglioVariantes.length) &&
					(!rigaOrdine.prodotto.aggiunteDisponibili)
				)
				return false;
			}

			var modal = $uibModal.open({
				controller : 'VariantiController as vm',
				templateUrl : 'app/pages/carrello/articolo.varianti.dialog.html',
				backdrop: 'static',
				resolve : {
					carrelloInstance : function() {
						return carrelloInstance;
					},
					rigaOrdine : function() {
						return rigaOrdine;
					},
					sceltaMenu : function() {
						return sceltaMenu;
					},
					varianti : function() {
						return carrelloInstance.getVarianti( rigaOrdine.id, sceltaMenu ? sceltaMenu.id : null );
					},
					aggiunte : function() {
						return carrelloInstance.getAggiunte( rigaOrdine.id, sceltaMenu ? sceltaMenu.id : null );
					},
					translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('varianti');
						$translatePartialLoader.addPart('aggiunte');
						return $translate.refresh();
					} ]
				}
			});

			return modal.result;

		}


		return vm;

	}

})();

(function() {
	'use strict';

	angular
		.module('theFoodApp')
		.controller('LocaleController', LocaleController);

	function LocaleController($window, $stateParams, $state, locale, isTakeaway,isRunnerPizza, listino, InformazioniAperturaOdierna, promozioni, PromozioniHolder) {

		var vm = this;
		vm.isDesktop = $window.outerWidth > 812 ? true : false;
		vm.mostraLinee = vm.mostraLinee ? vm.mostraLinee : ( vm.isDesktop ? true : false);
		vm.locale = locale;
		vm.linee = listino;
		vm.promozioni = promozioni;
		vm.isTakeaway = isTakeaway; // vero sse siamo in modalità takeaway.
		vm.informazioniAperturaOdierna = InformazioniAperturaOdierna.getInformazioniAperturaOdierna(locale);
		vm.isRunnerPizza = isRunnerPizza;
		vm.showAlertProductModified = $stateParams.carrelloRiordinato;

		PromozioniHolder.setVisibility(promozioni.length > 0, [promozioni]);

		mostraStringaProssimaConsegnaUtile(locale);

		function mostraStringaProssimaConsegnaUtile(locale) {
			vm.mostraPrimaConsegnaUtile = vm.informazioniAperturaOdierna.prossimaConsegnaUtile && vm.informazioniAperturaOdierna.orarioPrimaConsegna;
		}

	}

})();

( function() {
	'use strict';

	angular
		.module( 'theFoodApp' )
		.directive( 'calendario', calendario );

	function calendario() {
		var directive = {
			restrict: 'E',
			scope: {
				calendario: '=data'
			},
			templateUrl: 'app/pages/locale/calendario.directive.html',
			/* @ngInject */
			controller: function( $scope, $state, $translate, $translatePartialLoader ) {
				$translatePartialLoader.addPart( 'locale' );
				$translate.refresh();

				$scope.calendarioOrdinato = _.orderBy( $scope.calendario, [ 'giornoSettimana' ], [ 'asc' ] );

				$scope.days = [ 0, 1, 2, 3, 4, 5, 6 ];

				$scope.getDayOfTheWeek = function( giornoSettimana ) {
					var lang = $translate.proposedLanguage() || $translate.use();
					return moment().locale( lang ).day( giornoSettimana + 1 ).format( 'ddd' );
				};

				$scope.isOpenAtLunch = function( giornoSettimana ) {
					return $scope.calendarioOrdinato[ giornoSettimana ] && $scope.calendarioOrdinato[ giornoSettimana ].pranzoApre !== null;
				};

				$scope.isOpenAtDinner = function( giornoSettimana ) {
					return $scope.calendarioOrdinato[ giornoSettimana ] && $scope.calendarioOrdinato[ giornoSettimana ].cenaApre !== null;
				};

			},
			controllerAs: 'ctrl'
		};

		return directive;
	}
} )();

(function(){
    'use strict';

    angular
		.module( 'theFoodApp' )
		.controller( 'ConfirmCouponCreditoController', ConfirmCouponCreditoController );

		function ConfirmCouponCreditoController(couponCode, $uibModalInstance,$scope){
			$scope.couponCode = couponCode;
			$scope.modal = $uibModalInstance;

			return $scope.modal.result;
		}
})();

( function() {
	'use strict';

	angular
		.module( 'theFoodApp' )
		.controller( 'PaymentsController', PaymentsController );

	function PaymentsController($scope, $window, $state, $translate, $uibModalInstance, SERVER_URL, Pagamento, ordine,useCredit, totalWithUseCredit, bsLoadingOverlayService, $uibModal ) {
		var vm = this;
		vm.allPayments = [
			{
				imgUrl: SERVER_URL + 'static/images/payments/paypal.jpg',
				imgAlt: $translate.instant( 'theFoodApp.concludi.payments.paypal' ),
				issuer: 'PayPal'
			}
			, {
				imgUrl: SERVER_URL + 'static/images/payments/gestpay.png',
				imgAlt: $translate.instant( 'theFoodApp.concludi.payments.gestpay' ),
				issuer: 'BancaSella'
			}
			, {
				imgUrl: SERVER_URL + 'static/images/payments/cashOnDelivery.jpeg',
				imgAlt: $translate.instant( 'theFoodApp.concludi.payments.cashOnDelivery' ),
				issuer: 'CashOnDelivery'
			}
		];

		vm.pickUpPayments = [
			{
				imgUrl: SERVER_URL + 'static/images/payments/paypal.jpg',
				imgAlt: $translate.instant( 'theFoodApp.concludi.payments.paypal' ),
				issuer: 'PayPal'
			}
			, {
				imgUrl: SERVER_URL + 'static/images/payments/gestpay.png',
				imgAlt: $translate.instant( 'theFoodApp.concludi.payments.gestpay' ),
				issuer: 'BancaSella'
			}
		];

		vm.payments = ordine.ritiroAlLocale ? vm.pickUpPayments : vm.allPayments;
		vm.cancel = cancel;
		vm.selectIssuer = selectIssuer;
		vm.totalWithUseCredit = totalWithUseCredit;
		vm.useCredit = useCredit;

		var isSafari = false;
		var ua = navigator.userAgent.toLowerCase();
		if (ua.indexOf('safari') != -1 && ua.indexOf('chrome') <= -1) {
			isSafari = true;
		}

		function selectIssuer( issuer ) {

			var params = {
				ordineId: ordine.id,
				issuer: issuer,
				couponCode : ordine.codiceCoupon,
				useCredit : useCredit,
        device: $scope.isMobile() ? 'ANDROID' : 'WEB'
			};

			bsLoadingOverlayService.start( { referenceId: 'body' } );

			Pagamento.requestWithCouponAndCredit( params ).$promise
				.then( function( result ) {
					if( result.error === true){
						bsLoadingOverlayService.stop( { referenceId: 'body' } );
						cancel(result.errorCode);
					} else {
						if ( $scope.isMobile() ) {
							var ref = cordova.InAppBrowser.open( result.redirectUrl, '_blank', 'location=no' );
							var shouldReload = true;
							ref.addEventListener( 'loadstart', function( event ) {
								if ( event.url.match( "#/paymentOk/|#/paymentError/|#/paymentCancel/" ) ) {
									var newURL = event.url.substring( event.url.indexOf( '#' ) );
									$window.location.hash = newURL;
									$window.location.reload( true );
									shouldReload = false;
									ref.close();
								}
							} );
							ref.addEventListener('exit',function(){
								if(shouldReload){
									$window.location.reload( true );
								}
	
							});
						} else {
							$window.location.href = result.redirectUrl;
						}
					}
				} )
				.catch( function( err ) {
					bsLoadingOverlayService.stop( { referenceId: 'body' } );
					cancel();
					if (err.data.message === 'error.frozenCart') {
						openAnnullaOrdineModal(ordine);
					}
				} )
				.finally(function(){
					cancel();
					if(isSafari || $scope.isMobile()){
					    // Issue #109: Premendo back su safari o da app rimane il loading overlay attivo.
						bsLoadingOverlayService.stop( { referenceId: 'body' } );
					}
				});
		}

		function cancel(error) {
			if(error){
				$uibModalInstance.dismiss( error );
			} else {
				$uibModalInstance.dismiss( 'cancel' );
			}
		}

		function openAnnullaOrdineModal(ordine) {
			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'app/pages/carrello/annulla-pagamento.html',
				backdrop: 'static',
				keyboard: false,
				controller: 'AnnullaPagamentoController',
				controllerAs: 'vm',
				resolve: {
					ordine: ordine,
					translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('carrello');
						return $translate.refresh();
					}]
				}
			});
			return Promise.resolve(modalInstance.result).then(function() {
				$state.reload();
			});
		}
	}

} )();

(function() {
	'use strict';

	angular
		.module('theFoodApp')
		.factory('IndirizziRubricaDialogService', IndirizziRubricaDialogService);

	function IndirizziRubricaDialogService ($uibModal) {
		var vm = this;

		vm.open = open;

		function open(indirizziRubrica) {
			var modalInstance = $uibModal.open({
				templateUrl: 'app/pages/concludi-acquisto/indirizzi/indirizzi-rubrica-dialog.html',
				controller: 'IndirizziRubricaDialogController',
				controllerAs: 'vm',
				backdrop: 'static',
				resolve: {
				indirizziRubrica: function () {
					return indirizziRubrica;
				}
			 }
			});

			return Promise.resolve(modalInstance.result);
		}

		return vm;
	}

})();
(function() {
	'use strict';

	angular
		.module('theFoodApp')
		.controller('IndirizziRubricaDialogController', IndirizziRubricaDialogController);


	function IndirizziRubricaDialogController($uibModalInstance, indirizziRubrica) {
		var vm = this;

		vm.indirizziRubrica = indirizziRubrica;

		vm.selezionaIndirizzo = selezionaIndirizzo;
		vm.clear = clear;

		function selezionaIndirizzo(indirizzo) {
			$uibModalInstance.close(indirizzo);
		}

		function clear () {
			$uibModalInstance.dismiss('cancel');
		}

		return vm;
	}

})();
(function() {
	'use strict';

	angular
		.module('theFoodApp')
		.config(stateConfig);

	stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {

		$stateProvider.state('concludi-acquisto', {
				parent: 'locale',
				url: '/concludi-acquisto',
				reloadOnSearch: false,
				data: {
					authorities: ['ROLE_USER'],
					pageTitle: 'theFoodApp.concludi.title'
				},
				params: {
					pagamentoId: undefined,
					paymentOk: false,
					paymentError: false,
					paymentCancel: false
				},
				views: {
					'content@': {
						templateUrl: 'app/pages/concludi-acquisto/concludi-acquisto.html',
						controller: 'ConcludiAcquistoController',
						controllerAs: 'vm'
					}
				},
				resolve: {
					orariConsegna: function(locale, OrariConsegna) {
						return OrariConsegna.query({
							localeId: locale.id
						}).$promise;
					},
					carrello: function(Carrello, locale, zona, carrelloInstance) {
						return carrelloInstance.$promise.tap(function(carrello) {
							return carrello.refresh();
						});
					},
					cliente: function(Cliente) {
						return Cliente.get().$promise;
					},
					indirizzo: function(IndirizzoStore, Indirizzo, RouteError, isTakeaway, ordine, translatePartialLoader) {
						// Se sono in takeaway non ho indirizzo
						if (isTakeaway) {
							return null;
						}

						if (!IndirizzoStore.isPresent()) {
							return Promise.reject(new RouteError().translatedErrorMessage('theFoodApp.selezione-locale.no-indirizzo-consegna').redirectTo('selezione-indirizzo'));
						}

						var indirizzo = IndirizzoStore.get();

						// Se è un indirizzo digitato, lo restituisco poi il cliente completerà i campi
						if (indirizzo.new) {
							return indirizzo;
						}
						// Altrimenti restituisco quello presente in rubrica
						return indirizzo = Indirizzo.get({
							id: indirizzo.addressId
						}).$promise;
					},
					indirizziRubrica: function(Principal, Indirizzo, isTakeaway, indirizzo, locale, ordine) {

						if (!isTakeaway && indirizzo && indirizzo.new) {
							return Principal.identity().then(function(identity) {
								return Principal.isAuthenticated() ? Indirizzo.query({ idZona: indirizzo.zone }).$promise : Promise.resolve([]);
							});
						} else {
							return Promise.resolve([]);
						}
					},
					// SERVE ?
					addressBook: function(Principal, Indirizzo) {
						return Principal.identity().then(function(identity) {
							return Principal.isAuthenticated() ? Indirizzo.query().$promise : Promise.resolve([]);
						});
					},
					datiFatturazione: function(DatiFatturazione) {
						return DatiFatturazione.query();
					},
					ordine: function(ClienteOrdine, locale, $stateParams) {
						return !$stateParams.paymentOk ? ClienteOrdine.get({ localeId: locale.id }).$promise : null;
					},
					translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('concludiAcquisto');
						$translatePartialLoader.addPart('indirizzo');
						$translatePartialLoader.addPart('locale');
						$translatePartialLoader.addPart('cliente');
						$translatePartialLoader.addPart('payment');
						$translatePartialLoader.addPart('global');
						$translatePartialLoader.addPart('datiFatturazione');

						return $translate.refresh();
					}]
				},
				breadcrumb: {
					title: "{{ 'theFoodApp.concludi.title' | translate }}"
				}
			})
			.state('acquisto-concluso', {
				parent: 'concludi-acquisto',
				url: '/acquisto-concluso',
				params: {
					pagamentoId: undefined
				},
				views: {
					'content@': {
						templateUrl: 'app/pages/concludi-acquisto/acquisto-concluso.html',
						controller: 'AcquistoConclusoController as vm'
					}
				},
				resolve: {
					pagamento: function($stateParams, Pagamento) {
						return Pagamento.get({ id: $stateParams.pagamentoId}).$promise;
					},
					indirizzo: function(Indirizzo, pagamento) {
						return !pagamento.ordine.ritiroAlLocale ? Indirizzo.get({ id: pagamento.ordine.indirizzoId }).$promise : null;
					},
					translatePartialLoader: [ '$translate', '$translatePartialLoader', function( $translate, $translatePartialLoader ) {
						$translatePartialLoader.addPart( 'payment' );
						return $translate.refresh();
					} ]
				},
				breadcrumb: { title: "{{ 'theFoodApp.payment.title' | translate }}" }
			});

	}
})();

(function () {
    'use strict';

    angular
        .module('theFoodApp')
        .controller('ConcludiAcquistoController', ConcludiAcquistoController);

    function ConcludiAcquistoController(Pagamento, Coupon, $window, DateUtils, MovimentiCredito, bsLoadingOverlayService, $state, $scope, $stateParams, $anchorScroll, orariConsegna, $translate, $uibModal, carrello, cliente, Cliente, addressBook, indirizzo, indirizziRubrica, TipoIndirizzo, locale, isTakeaway, Indirizzo, Ordine, translationStorageProvider, datiFatturazione, ordine, IndirizzoStore, AlertService, DatiFatturazioneDialogService, IndirizziRubricaDialogService, Notification, NOTIFICATION_TIME, $timeout) {
        var vm = this;

        vm.pagamentoId = $stateParams.pagamentoId;
        vm.paymentError = $stateParams.paymentError;
        vm.paymentCancel = $stateParams.paymentCancel;
        var today = moment().format('YYYY-MM-DD');

        // Interface
        vm.checkCodiceLotteria = false;
        vm.emettiFattura = false;
        vm.checkEmettiFattura = false;
        vm.orariConsegna = orariConsegna;
        vm.isTakeaway = isTakeaway;
        vm.addressBook = addressBook;
        vm.indirizzo = indirizzo;
        // vm.indirizziRubrica = indirizziRubrica;
        vm.dataOraConfirmed = false;
        vm.calcolaCostiOrdine = calcolaCostiOrdine;
        vm.cliente = cliente;
        vm.codiceLotteria = vm.cliente.codiceLotteria;

        vm.datiFatturazione = datiFatturazione;
        vm.ordine = carrello.getOrdine(); // ordine;
        vm.localeEmetteFattura = localeEmetteFattura;

        vm.datePossibiliDiConsegna = [];
        vm.oraConsegnaSelezionata = null;
        vm.dataConsegnaSelezionata = null;
        vm.idFatturazione = null;
        vm.getOrariConsegna = _.memoize(getOrariConsegna);
        vm.showAlertDataOraNotConfirmed = false;

        vm.getImportoArticoliSenzaSconti = carrello.getImportoArticoliSenzaSconti;
        vm.getImportoArticoli = carrello.getImportoArticoli;
        vm.getCostoSpedizione = getCostoSpedizione;
        vm.hasCostoSpedizione = hasCostoSpedizione;
        vm.getScontoTotale = getScontoTotale;

        vm.dataConsegnaFormattata = getDataConsegnaFormattata;
        vm.getOrarioFormattato = getOrarioFormattato;
        vm.concludiAcquisto = concludiAcquisto;
        vm.getLocale = getLocale;
        vm.selezionaIndirizzo = selezionaIndirizzo;
        vm.datiFatturazioneDialog = datiFatturazioneDialog;
        vm.totaleConCredito = totaleConCredito;

        vm.hasSconto = hasSconto;
        vm.totaleCarrello = totaleCarrello;

        vm.indirizzoCliente = null;
        vm.civico = null;

        vm.tipoindirizzo = TipoIndirizzo.query();

        vm.onDataChanged = onDataChanged;
        vm.onOraChanged = onOraChanged;
        vm.dataOraLoading = false;
        vm.modifyOrderCondition = false;

        //COUPON
        vm.codiceCouponInserito = "";
        vm.coupon_code = "";
        vm.saveFailed1 = false;
        vm.saveFailed2 = false;
        vm.saveFailed3 = false;
        vm.saveFailed4 = false;
        vm.saveFailed5 = false;
        vm.saveFailed6 = false;
        vm.saved1 = false;
        vm.saved2 = false;

        //PAYPAL REDIRECT
        vm.isPaymentError = false;
        //RICALCOLO ORDINE
        //vm.recalcOrdine = recalcOrdine;
        // IS MOBILE
        vm.mobile = false;
        //CREDITO
        vm.getTotaleCredito = getTotaleCredito;
        vm.totaleCredito = 0;
        vm.debito = 0;
        vm.utilizzaCredito = true;
        // Implementation

        var lang = $translate.proposedLanguage() || $translate.use();
        if ($window.innerWidth < 760) { // 768px portrait
            vm.mobile = true;
        }


        function activate() {
            // Forzo il ritorno alla pagina precedente se l'importo dell'ordine
            // non ha raggiunto l'importo minimo. Possibile arrivo per URL Injection
            if (ordine.importoOrdineSenzaSconti < locale.insegna.importoMinimoConsegna) {
                AlertService.error($translate.instant('theFoodApp.concludi.error.importo-minimo-non-raggiunto', {
                    importoMinimo: locale.insegna.importoMinimoConsegna + '€'
                }));
                $state.go('locale');
                return false;
            }

            // Forzo il ritorno alla pagina precedente se
            // il carrello è vuoto. Possibile arrivo per URL Injection
            if (carrello.isVuoto()) {
                AlertService.error($translate.instant('theFoodApp.concludi.error.carrelloVuoto'));
                $state.go('locale');
                return false;
            }

            // Al refresh della pagina carica i dati di fatturazione
            if (vm.ordine.datiFatturazioneId !== null) {
                vm.emettiFattura = true;
                vm.checkEmettiFattura = true;
                vm.idFatturazione = vm.ordine.datiFatturazioneId;
            }

            // Calcola le date possibili di consegna.
            vm.datePossibiliDiConsegna = _(orariConsegna).keys()
                .filter(function (chiavi) {
                    return chiavi[0] !== '$';
                })
                .filter(isValidDay)
                .sortBy()
                .value();

            // Se non ci sono date possibili di consegna,
            // torno alla pagina precedente. Non permetto
            // all'utente di entrare su concludi-acquisto
            if (vm.datePossibiliDiConsegna.length === 0) {
                AlertService.error($translate.instant('theFoodApp.concludi.error.noDateConsegna'))
                $state.go('locale');
                return false;
            }

            if (today === moment(vm.datePossibiliDiConsegna[0]).format('YYYY-MM-DD')) {
                vm.dataConsegnaSelezionata = vm.datePossibiliDiConsegna[0];
            }

            /*var data = moment(vm.ordine.dataConsegna).format('YYYY-MM-DD')
            for (var i = 0; i < vm.datePossibiliDiConsegna.length; i++) {
                if (vm.datePossibiliDiConsegna[i] === data) {
                    vm.dataConsegnaSelezionata = vm.datePossibiliDiConsegna[i];
                    break;
                }
            }*/

            if (indirizzo && indirizzo.new && indirizziRubrica && indirizziRubrica.length > 0) {
                setTimeout(function () {
                    IndirizziRubricaDialogService.open(indirizziRubrica).then(function (i) {
                        vm.indirizzo = i;
                        vm.indirizzo.new = false;
                    });
                }, 500);
            }

            if (vm.dataConsegnaSelezionata) {
                autoSelectOrarioConsegna();
            }

            if (!isTakeaway) {
                vm.indirizzo.telefono = vm.indirizzo.telefono ? vm.indirizzo.telefono : vm.cliente.telefono;
            }
            getTotaleCredito();
        }

        function autoSelectOrarioConsegna() {

            var orariConsegna = getOrariConsegna(vm.dataConsegnaSelezionata);

            // Se esiste il prima possibile lo metto come default
            if (!orariConsegna[0].group) {
                vm.oraConsegnaSelezionata = orariConsegna[0];
            }

            // Popolata con l'ora presente sull'ordine sul DB.
            for (var i = 0; i < orariConsegna.length; i++) {
                var labelEstremoSx = _.split(orariConsegna[i].label, '-', 1);
                if (vm.ordine.orarioConsegna === moment(labelEstremoSx[0], 'HH:mm').locale(lang).format('HH:mm')) {
                    vm.oraConsegnaSelezionata = orariConsegna[i];
                    controllaSeAncoraValido(_.split(vm.oraConsegnaSelezionata.label, '-'), orariConsegna[i])
                    break;
                }
            }

            if (vm.oraConsegnaSelezionata) {
                calcolaCostiOrdine();
            }

        }

        function selezionaIndirizzo(indirizzo) {
            vm.indirizzo = indirizzo;
        }

        function getScontoTotale() {
            return vm.ordine.importoOrdineSenzaSconti - vm.ordine.importoOrdine;
        }

        function hasSconto() {
            return getScontoTotale() > 0;
        }


        function totaleCarrello() {
            if (vm.utilizzaCredito) {
                if ((vm.ordine.importoOrdine + getCostoSpedizione() + vm.debito) - vm.ordine.scontoCoupon - vm.totaleCredito < 0) {
                    return 0;
                } else {
                    return (vm.ordine.importoOrdine + getCostoSpedizione() + vm.debito) - vm.ordine.scontoCoupon - vm.totaleCredito;
                }
            } else {
                return (vm.ordine.importoOrdine + getCostoSpedizione() + vm.debito) - vm.ordine.scontoCoupon;
            }
        }

        function totaleConCredito() {
            var totaleSenzaCredito = ((vm.ordine.importoOrdine + getCostoSpedizione()) - vm.ordine.scontoCoupon);
            if (vm.totaleCredito >= totaleSenzaCredito) {
                return totaleSenzaCredito;
            } else {
                return vm.totaleCredito;
            }
        }

        function datiFatturazioneDialog() {
            return DatiFatturazioneDialogService.open(cliente)
                .then(function (datiFatturazione) {
                    vm.datiFatturazione.push(datiFatturazione);
                });
        }

        function isValidDay(d) {
            return orariConsegna[d].orariConsegnaPranzo.length +
                orariConsegna[d].orariConsegnaCena.length +
                orariConsegna[d].consegnaPrimaPossibilePranzo +
                orariConsegna[d].consegnaPrimaPossibileCena;
        }

        function getOrariConsegna(data) {
            if (!data)
                return [];

            var orari = orariConsegna[data];
            if (!orari)
                return [];

            var costoConsegnaPranzo = isTakeaway ? 0 : locale.insegna.costoConsegnaPranzo;
            var costoConsegnaCena = isTakeaway ? 0 : locale.insegna.costoConsegnaCena;

            var result = [];
            // result.push( vm.orarioConsegnaPlaceholder );
            if (orari.consegnaPrimaPossibilePranzo)
                result.push({
                    value: 'PrimaPossibile',
                    label: $translate.instant('theFoodApp.concludi.labelPrimaPossibile', {
                        attesa: locale.attesaPrnz
                    }),
                    costoConsegna: costoConsegnaPranzo
                });
            if (orari.consegnaPrimaPossibileCena)
                result.push({
                    value: 'PrimaPossibile',
                    label: $translate.instant('theFoodApp.concludi.labelPrimaPossibile', {
                        attesa: locale.attesaCena
                    }),
                    costoConsegna: costoConsegnaCena
                });
            _.each(orari.orariConsegnaPranzo, function (o, i) {
                result.push({
                    value: 'p' + i,
                    label: getOrarioFormattato(o),
                    costoConsegna: costoConsegnaPranzo,
                    group: $translate.instant('theFoodApp.concludi.labelOrariConsegnaPranzo'),
                    disabled: o.tipoFasciaBloccata === 'BLOCCATA'
                });
            });
            _.each(orari.orariConsegnaCena, function (o, i) {
                result.push({
                    value: 'c' + i,
                    label: getOrarioFormattato(o),
                    costoConsegna: costoConsegnaCena,
                    group: $translate.instant('theFoodApp.concludi.labelOrariConsegnaCena'),
                    disabled: o.tipoFasciaBloccata === 'BLOCCATA'
                });
            });

            return result;
        }

        function controllaSeAncoraValido(label, result) {
            var dataConsegnaMoment = new moment(vm.ordine.dataConsegna, 'YYYY-MM-DD');
            var labelDx = moment(label[1], 'HH:mm');
            var current = moment();

            if (moment(current.format('YYYY-MM-DD')).isSame(dataConsegnaMoment.format('YYYY-MM-DD')) && !current.isBefore(labelDx)) {
                vm.showAlertOrario = true;
                vm.oraConsegnaSelezionata = null;
            }
        }

        function getDataConsegnaFormattata(date) {
            if (!date)
                return '';

            var momentDate = new moment(date, 'YYYY-MM-DD');
            if (momentDate.startOf('day').isSame(new Date(), "day"))
                return $translate.instant('theFoodApp.concludi.oggi');

            return momentDate.locale(lang).format('dddd D MMMM YYYY');
        }

        function getOrarioFormattato(orario) {
            if (!orario)
                return '';

            var inizio = new moment(orario.oraInizio, 'HH:mm:ss').locale(lang).format('HH:mm');
            var fine = new moment(orario.oraFine, 'HH:mm:ss').locale(lang).format('HH:mm');
            var extra = orario.tipoFasciaBloccata === 'CRITICA' ? ' - Fascia critica' : '';
            return inizio + ' - ' + fine + extra;
        }

        function hasCostoSpedizione() {
            return isTakeaway || (vm.dataConsegnaSelezionata && vm.oraConsegnaSelezionata);
        }

        function getCostoSpedizione() {
            //return isTakeaway ? 0 : vm.oraConsegnaSelezionata.costoConsegna;
            return vm.ordine.importoSpedizione ? vm.ordine.importoSpedizione : 0;
        }

        function concludiAcquisto() {
            vm.paymentError = false;
            vm.paymentCancel = false;
            vm.coupon_code = "";
            vm.showAlertOraMissing = false;
            vm.showAlertIndFatturazione = false;

            if (!vm.dataOraConfirmed) {
                vm.showAlertDataOraNotConfirmed = true;
                $anchorScroll();
                return;
            }
            if (vm.oraConsegnaSelezionata === null) {
                vm.showAlertOraMissing = true;
                $anchorScroll();
                return;
            }
            if (vm.checkEmettiFattura && vm.idFatturazione === null) {
                vm.showAlertIndFatturazione = true;
                $anchorScroll();
                return;
            }
            if ($scope.editForm.$invalid) {
                return;
            }

            vm.isSaving = true;
            return Promise.resolve().then(function () {
                if (isTakeaway) {
                    return;
                }

                // Se entro con un nuovo indirizzo, lo salvo nel db.
                if (vm.indirizzo.new) {
                    vm.indirizzo.clienteId = cliente.id;
                    return Indirizzo.save(vm.indirizzo).$promise
                        .then(function (result) {
                            vm.ordine.indirizzoId = result.id;
                            vm.indirizzo.new = false;
                            vm.indirizzo.id = result.id;
                            return result;
                        });
                }

                // altrimenti faccio l'update nel caso avessi fatto delle modifiche
                return Indirizzo.update(vm.indirizzo).$promise.then(function () {
                    vm.ordine.indirizzoId = vm.indirizzo.id;
                });
            }).then(function () {
                if (isTakeaway) {
                    return;
                }
                IndirizzoStore.setFromAddressBook(vm.indirizzo, IndirizzoStore.get().zone);
                return Promise.resolve();
            }).then(function () {
                return salvaOrdine();
            }).then(function (ordine) {
                if (vm.utilizzaCredito === true) {
                    var totaleDaPagareSenzaCredito = (vm.ordine.importoOrdine + getCostoSpedizione() + vm.debito) - vm.ordine.scontoCoupon; // è una fix
                    if (vm.totaleCredito > totaleDaPagareSenzaCredito) { // sto pagando l'ordine interamente con il credito. Il credito residuo sarà >= 0
                        payWithoutPayments();
                        return null;
                    }
                }
                openPaymentsModal(vm.ordine);
            }).catch(function (error) {
                Notification.error({
                    message: $translate.instant('theFoodApp.concludi.error.salvataggioOrdine'),
                    delay: NOTIFICATION_TIME
                });
                vm.oraConsegnaSelezionata = null;
            }).finally(function () {
                vm.isSaving = false;
            });
        }

        function getLocale() {
            return translationStorageProvider.getCurrent();
        }


        function salvaOrdine() {
            // Prendo l'estremo sinistro dell'intervallo
            var oraConsegna = _.split(vm.oraConsegnaSelezionata.label, '-', 1);
            if (vm.oraConsegnaSelezionata.value === 'PrimaPossibile') {
                vm.ordine.orarioConsegna = null;
            } else {
                vm.ordine.orarioConsegna = _.trim(oraConsegna[0]);
            }

            vm.ordine.dataConsegna = vm.dataConsegnaSelezionata;
            //vm.ordine.importoSpedizione = getCostoSpedizione();
            if (!isTakeaway) {
                vm.ordine.zona = IndirizzoStore.get().zone;
            }
            vm.ordine.datiFatturazioneId = vm.emettiFattura ? vm.idFatturazione : null;
            vm.ordine.tipoOrarioConsegna = vm.oraConsegnaSelezionata.value === 'PrimaPossibile' ? 'PRIMA_POSSIBILE' : 'STANDARD';

            // Aggiorno il codice lotteria sul cliente
            if (vm.codiceLotteria !== vm.cliente.codiceLotteria) {
                vm.cliente.codiceLotteria = vm.codiceLotteria;
                Cliente.update(vm.cliente);
            }

            // check se posso salvare il codiceLotteria su ordine altrimenti aggiorno l'ordine eliminando il codice
            if (vm.checkCodiceLotteria && vm.codiceLotteria !== null && _.trim(vm.codiceLotteria) !== '' && _.trim(vm.codiceLotteria).length === 8) {
                vm.ordine.codiceLotteria = _.trim(vm.codiceLotteria);
            } else {
                vm.ordine.codiceLotteria = null;
            }

            if (vm.coupon_code || vm.codiceCouponInserito) {
                if (vm.coupon_code.length > 0) {
                    vm.ordine.codiceCoupon = vm.coupon_code;
                } else {
                    vm.ordine.codiceCoupon = vm.codiceCouponInserito;
                }
                return Ordine.updateWithCouponCode(vm.ordine).$promise.catch(function (e) {
                }).then(function (res) {
                    if (res.status === "SUCCESS") {
                        if (vm.codiceCouponInserito.length === 0) {
                            if (res.code === 0) {
                                vm.saved1 = true;
                                vm.codiceCouponInserito = vm.coupon_code;
                            } else if (res.code === 7) {
                                Coupon.getValueCouponCredito({
                                    codice: vm.coupon_code
                                }, onSuccess, onError);

                                function onSuccess(data1, headers) {
                                    if (data1.status === "SUCCESS") {
                                        var modalInstance = $uibModal.open({
                                            animation: true,
                                            templateUrl: 'app/pages/confirm-coupon-credito/confirm-coupon-credito.html',
                                            controller: 'ConfirmCouponCreditoController',
                                            controllerAs: 'vm',
                                            backdrop: 'static',
                                            keyboard: false,
                                            resolve: {
                                                couponCode: function () {
                                                    return data1.value;
                                                }
                                            }
                                        });
                                        modalInstance.result.then(function (parameter) {
                                            if (parameter !== 'cancel') {
                                                Coupon.saveCouponCredito({
                                                    codice: vm.coupon_code
                                                }, onSuccess, onError);

                                                function onSuccess(data2, headers) {
                                                    if (data2.status === "SUCCESS") {
                                                        vm.saved2 = true;
                                                        vm.coupon_code = '';
                                                        getTotaleCredito();
                                                    } else {
                                                        checkErrors(data2.status, data2.code)
                                                        return vm.ordine;
                                                    }
                                                }

                                                function onError(error) {
                                                    AlertService.error(error.data2.message);
                                                }
                                            }
                                        });
                                    } else {
                                        checkErrors(data1.status, data1.code)
                                        return vm.ordine;
                                    }
                                }

                                function onError(error) {
                                    AlertService.error(error.data1.message);
                                }
                            }
                            $timeout(function () {
                                vm.saved1 = false;
                                vm.saved2 = false;
                            }, 3000);
                            return res.value;
                        }
                    } else if (res.status === "ERROR") {
                        checkErrors(res.status, res.code)
                        return vm.ordine;
                    }
                });
            } else {
                return Ordine.update(vm.ordine).$promise;
            }
        }


        function onDataChanged() {
            vm.modifyOrderCondition = true;
            vm.dataOraConfirmed = false;
            vm.oraConsegnaSelezionata = null;
        }

        function onOraChanged() {
            vm.dataOraConfirmed = false;
            vm.showAlertDataOraNotConfirmed = false;

            if (vm.oraConsegnaSelezionata) {
                calcolaCostiOrdine();
            }
        }

        function calcolaCostiOrdine() {
            vm.dataOraLoading = true;
            return Promise.all([
                salvaOrdine(),
                Promise.delay(1250)
            ]).spread(function (ordine) {
                vm.dataOraConfirmed = true;
                vm.ordine = ordine;
            }).catch(function (e) {
                Notification.error({
                    title: $translate.instant('theFoodApp.concludi.error.calcolaCostiOrdine'),
                    delay: NOTIFICATION_TIME
                });
            }).finally(function () {
                vm.dataOraLoading = false;
            });
        }

        function localeEmetteFattura() {
            return locale.emetteFattura;
        }

        function openPaymentsModal(ordine) {
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/concludi-acquisto/payments/payments.html',
                controller: 'PaymentsController',
                controllerAs: 'vm',
                resolve: {
                    ordine: ordine,
                    useCredit: vm.utilizzaCredito,
                    totalWithUseCredit: totaleCarrello(),
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('concludiAcquisto');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(function (parameter) {
            }, function (parameter) {
                if (parameter !== 'cancel') {
                    checkErrors(parameter, Number(parameter));
                }
            });
            return Promise.resolve(modalInstance.result);
        }

        function checkErrors(status, code) {

            if (code === 1) {
                vm.saveFailed1 = true;
            }
            if (code === 2) {
                vm.saveFailed2 = true;
            }
            if (code === 3) {
                vm.saveFailed3 = true;
            }
            if (code === 4) {
                vm.saveFailed4 = true;
            }
            if (code === 5) {
                vm.saveFailed5 = true;
            }
            if (code === 6) {
                vm.saveFailed6 = true;
            }
            if (code === undefined) {
                if (status === 'INV-URL' || 'ERROR') {
                    vm.isPaymentError = true;
                }
            }
            $timeout(function () {
                vm.saveFailed1 = false;
                vm.saveFailed2 = false;
                vm.saveFailed3 = false;
                vm.saveFailed4 = false;
                vm.saveFailed5 = false;
                vm.saveFailed6 = false;
                vm.isPaymentError = false;
            }, 4000);
        }


        activate();

        return vm;


        function getTotaleCredito() {
            MovimentiCredito.totale({}, onSuccess, onError);

            function onSuccess(data, headers) {
                //_.forEach(data, function(movimento) {
                if (data.totale > 0) {
                    vm.totaleCredito = data.totale;
                    vm.debito = 0;
                    vm.utilizzaCredito = true;
                } else {
                    vm.totaleCredito = 0;
                    vm.debito = (data.totale) * (-1);
                    vm.utilizzaCredito = false;
                }
                //});
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function payWithoutPayments() {
            var params = {
                ordineId: vm.ordine.id,
                issuer: 'Credit',
                couponCode: vm.codiceCouponInserito,
                useCredit: 'true',
                device: $scope.isMobile() ? 'ANDROID' : 'WEB'
            };

            bsLoadingOverlayService.start({referenceId: 'body'});
            Pagamento.request(params).$promise
                .then(function (result) {
                    if ($scope.isMobile()) {
                        var ref = cordova.InAppBrowser.open(result.redirectUrl, '_self', 'location=no');
                        var shouldReload = true;
                        ref.addEventListener('loadstart', function (event) {
                            if (event.url.match("#/paymentOk/|#/paymentError/|#/paymentCancel/")) {
                                var newURL = event.url.substring(event.url.indexOf('#'));
                                $window.location.hash = newURL;
                                $window.location.reload(true);
                                shouldReload = false;
                                ref.close();
                            }
                        });
                        ref.addEventListener('exit', function () {
                            if (shouldReload) {
                                $window.location.reload(true);
                            }

                        });
                    } else {
                        $window.location.href = result.redirectUrl;
                    }
                })
                .catch(function (err) {
                    bsLoadingOverlayService.stop({referenceId: 'body'});
                })
                .finally(function () {
                    cancel();
                    if (isSafari || $scope.isMobile()) {
                        // Issue #109: Premendo back su safari o da app rimane il loading overlay attivo.
                        bsLoadingOverlayService.stop({referenceId: 'body'});
                    }
                });
        }

    }
})();

(function() {
	'use strict';

	angular
		.module('theFoodApp')
		.controller('AcquistoConclusoController', AcquistoConclusoController);

	function AcquistoConclusoController( $state, $stateParams, $translate, DateUtils, pagamento, indirizzo ) {
    var vm = this;

		vm.pagamento = pagamento;
		vm.ordine = pagamento.ordine;
		vm.locale = pagamento.ordine.locale;
		vm.indirizzo = indirizzo;
		vm.getScontoTotale = getScontoTotale;
		vm.hasSconto = hasSconto;

		// Interface
		vm.getOrarioConsegnaDa = getOrarioConsegnaDa;
		vm.getOrarioConsegnaA = getOrarioConsegnaA;
		vm.goToHome = goToHome;
		vm.goToStoricoOrdini = goToStoricoOrdini;

		if (vm.ordine.ritiroAlLocale) {
			vm.paymentLabel = vm.ordine.orarioConsegna ? 'payments.payments-ok.takeaway' : 'payments.payments-ok.prima-possibile-takeaway';
			vm.indirizzoText = vm.locale.insegna.insegna + " - " + vm.locale.indirizzo + ","
			vm.indirizzoText += vm.locale.civico + (vm.locale.rosso ? $translate.instant('theFoodApp.locale.civicoRosso') : '');
			vm.indirizzoText += " " + vm.locale.comune;
		} else {
			vm.paymentLabel = vm.ordine.orarioConsegna ? 'payments.payments-ok.consegna' : 'payments.payments-ok.prima-possibile-consegna';
			vm.indirizzoText = vm.indirizzo.indirizzoAsText + " " + vm.indirizzo.strada.descrizioneComune;
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'purchaseCompleted'
        });

		// if (vm.ordine.orarioConsegna && vm.ordine.ritiroAlLocale) {
		// 	// ORARIO TAKEAWAY
		// 	vm.paymentLabel = 'payments.payments-ok.takeaway';
		// 	vm.indirizzoText = vm.locale.insegna.insegna + " - " + vm.locale.indirizzo + ","
		// 	vm.indirizzoText += vm.locale.civico + (vm.locale.rosso ? $translate.instant('theFoodApp.locale.civicoRosso') : '');
		// 	vm.indirizzoText += " " + vm.locale.comune;
		// } else if(!vm.ordine.orarioConsegna && !vm.ordine.ritiroAlLocale){
		// 	//PRIMA POSSIBILE NO TAKEAWAY
		// 	vm.paymentLabel = 'payments.payments-ok.prima-possibile-consegna';
		// 	vm.indirizzoText = vm.indirizzo.indirizzoAsText + " " + vm.indirizzo.strada.descrizioneComune;
		// } else if(!vm.ordine.orarioConsegna && vm.ordine.ritiroAlLocale){
		// 	//PRIMA POSSIBILE TAKEAWAY
		// 	vm.paymentLabel = 'payments.payments-ok.prima-possibile-takeaway';
		// 	vm.indirizzoText = vm.locale.insegna.insegna + " - " + vm.locale.indirizzo + ","
		// 	vm.indirizzoText += vm.locale.civico + (vm.locale.rosso ? $translate.instant('theFoodApp.locale.civicoRosso') : '');
		// 	vm.indirizzoText += " " + vm.locale.comune;
		// } else {
		// 	//ORARIO
		// 	vm.paymentLabel = 'payments.payments-ok.consegna';
		// 	vm.indirizzoText = vm.indirizzo.indirizzoAsText + " " + vm.indirizzo.strada.descrizioneComune;
		// }

		function getOrarioConsegnaDa(orarioConsegna) {
			if(orarioConsegna){
				return orarioConsegna;
			}
		}

		function getOrarioConsegnaA(orarioConsegna, locale) {
			if(orarioConsegna){
				var d = new Date();
				d.setHours(parseInt(orarioConsegna.split(':')[0]));
				d.setMinutes(parseInt(orarioConsegna.split(':')[1]));
				d.setMinutes(d.getMinutes() + locale.insegna.splitOrariDiConsegna);

				return moment(d).format('HH:mm');
			}
		}

		function getScontoTotale(){
		/*	if(vm.ordine.creditoUtilizzato){
				return vm.ordine.importoOrdineSenzaSconti  + vm.ordine.importoSpedizione - vm.ordine.importoOrdine + vm.ordine.creditoUtilizzato;
			}*/
			return vm.ordine.importoOrdineSenzaSconti - vm.ordine.importoOrdine;
		}

		function hasSconto(){
			return getScontoTotale() > 0;
		}

		function goToHome() {
			$state.go('landing');
		}

		function goToStoricoOrdini() {
			$state.go('storico');
		}


		vm.dataOraTransazione = DateUtils.convertDateTimeFromServer(vm.pagamento.dataOraTransazione);
		vm.dataOrdine = DateUtils.convertDateTimeFromServer(vm.ordine.dataOrdine);
		vm.dataConsegna = DateUtils.convertDateTimeFromServer(vm.ordine.dataConsegna);

		return vm;
  }

}) ();
(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .controller('IndirizzoDialogController', IndirizzoDialogController);

    IndirizzoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'translationStorageProvider', 'Indirizzo', 'TipoIndirizzo'];

    function IndirizzoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, translationStorageProvider, Indirizzo, TipoIndirizzo) {
        var vm = this;

        vm.indirizzo = entity;
        vm.selectedAddress = true;
        vm.clear = clear;
        vm.save = save;
        vm.tipoindirizzos = TipoIndirizzo.query();

		vm.getLocale = getLocale;
        vm.onAddressSelected = onAddressSelected;

		function getLocale() {
			return translationStorageProvider.getCurrent();
		}

        function onAddressSelected() {
			vm.selectedAddress = true;
		}

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            if (angular.isUndefined(vm.indirizzo.strada) || angular.isUndefined(vm.indirizzo.strada.id)) {
                vm.selectedAddress = false;
                return;
            }

            vm.isSaving = true;
            if (vm.indirizzo.id !== null) {
                Indirizzo.update(vm.indirizzo, onSaveSuccess, onSaveError);
            } else {
                Indirizzo.save(vm.indirizzo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .controller('IndirizzoDeleteController',IndirizzoDeleteController);

    IndirizzoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Indirizzo'];

    function IndirizzoDeleteController($uibModalInstance, entity, Indirizzo) {
        var vm = this;

        vm.indirizzo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Indirizzo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .factory('DatiFatturazioneDialogService', DatiFatturazioneDialogService);

    DatiFatturazioneDialogService.$inject = ['$uibModal'];

    function DatiFatturazioneDialogService ($uibModal) {
      var vm = this;

      vm.open = open;
      vm.openDelete = openDelete;

        function open(cliente, datiFatturazione) {

            if (!datiFatturazione) {
                datiFatturazione = {
                    clienteId: cliente.id,
                    ragioneSociale: null,
                    ragioneSociale2: null,
                    pIva: null,
                    codFisc: null,
                    indirizzo: null,
                    citta: null,
                    provincia: null,
                    cap: null,
                    telefono: null,
                    id: null,
                    pec: null,
                    sdi: null
                };
            }

            return $uibModal.open({
                templateUrl: 'app/pages/cliente/dati-fatturazione/dati-fatturazione-dialog.html',
                controller: 'DatiFatturazioneDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: { entity: datiFatturazione }
            }).result;
        }

        function openDelete(datiFatturazione) {

            return $uibModal.open({
                templateUrl: 'app/pages/cliente/dati-fatturazione/dati-fatturazione-delete-dialog.html',
                controller: 'DatiFatturazioneDeleteController',
                controllerAs: 'vm',
                size: 'md',
                resolve: { entity: datiFatturazione }
            }).result;

        }

      return vm;
    }
})();

(function() {
	'use strict';

	angular.module('theFoodApp').controller('DatiFatturazioneDialogController',
			DatiFatturazioneDialogController);

	DatiFatturazioneDialogController.$inject = [ '$timeout', '$scope',
			'$stateParams', '$uibModalInstance', 'entity', 'DatiFatturazione', 'Provincia' ];

	function DatiFatturazioneDialogController($timeout, $scope, $stateParams,
			$uibModalInstance, entity, DatiFatturazione, Provincia) {
		var vm = this;

		vm.datiFatturazione = entity;
		vm.clear = clear;
		vm.save = save;
		vm.province = Provincia.query({sort: 'descrizione'});

		vm.cap = /^([0-9]{5})+$/

		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		function save() {
			vm.isSaving = true;
			if (vm.datiFatturazione.id !== null) {
				DatiFatturazione.update(vm.datiFatturazione, onSaveSuccess,
						onSaveError);
			} else {
				DatiFatturazione.save(vm.datiFatturazione, onSaveSuccess,
						onSaveError);
			}
		}

		function onSaveSuccess(result) {
			$scope.$emit('theFoodApp:datiFatturazioneUpdate', result);
			$uibModalInstance.close(result);
			vm.isSaving = false;
		}

		function onSaveError() {
			vm.isSaving = false;
		}

	}
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .controller('DatiFatturazioneDetailController', DatiFatturazioneDetailController);

    DatiFatturazioneDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'DatiFatturazione', 'Cliente'];

    function DatiFatturazioneDetailController($scope, $rootScope, $stateParams, previousState, entity, DatiFatturazione, Cliente) {
        var vm = this;

        vm.datiFatturazione = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('theFoodApp:datiFatturazioneUpdate', function(event, result) {
            vm.datiFatturazione = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .controller('DatiFatturazioneDeleteController',DatiFatturazioneDeleteController);

    DatiFatturazioneDeleteController.$inject = ['$uibModalInstance', 'entity', 'DatiFatturazione'];

    function DatiFatturazioneDeleteController($uibModalInstance, entity, DatiFatturazione) {
        var vm = this;

        vm.datiFatturazione = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            DatiFatturazione.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('dati-fatturazione', {
            parent: 'entity',
            url: '/dati-fatturazione',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'theFoodApp.datiFatturazione.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dati-fatturazione/dati-fatturaziones.html',
                    controller: 'DatiFatturazioneController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('datiFatturazione');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('dati-fatturazione-detail', {
            parent: 'entity',
            url: '/dati-fatturazione/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'theFoodApp.datiFatturazione.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dati-fatturazione/dati-fatturazione-detail.html',
                    controller: 'DatiFatturazioneDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('datiFatturazione');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'DatiFatturazione', function($stateParams, DatiFatturazione) {
                    return DatiFatturazione.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'dati-fatturazione',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('dati-fatturazione-detail.edit', {
            parent: 'dati-fatturazione-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dati-fatturazione/dati-fatturazione-dialog.html',
                    controller: 'DatiFatturazioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DatiFatturazione', function(DatiFatturazione) {
                            return DatiFatturazione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dati-fatturazione.new', {
            parent: 'dati-fatturazione',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dati-fatturazione/dati-fatturazione-dialog.html',
                    controller: 'DatiFatturazioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                clienteId: null,
                                ragioneSociale: null,
                                ragioneSociale2: null,
                                pIva: null,
                                codFisc: null,
                                indirizzo: null,
                                citta: null,
                                provincia: null,
                                cap: null,
                                telefono: null,
                                pec: null,
                                sdi: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('dati-fatturazione', null, { reload: 'dati-fatturazione' });
                }, function() {
                    $state.go('dati-fatturazione');
                });
            }]
        })
        .state('dati-fatturazione.edit', {
            parent: 'dati-fatturazione',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dati-fatturazione/dati-fatturazione-dialog.html',
                    controller: 'DatiFatturazioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DatiFatturazione', function(DatiFatturazione) {
                            return DatiFatturazione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dati-fatturazione', null, { reload: 'dati-fatturazione' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dati-fatturazione.delete', {
            parent: 'dati-fatturazione',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dati-fatturazione/dati-fatturazione-delete-dialog.html',
                    controller: 'DatiFatturazioneDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DatiFatturazione', function(DatiFatturazione) {
                            return DatiFatturazione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dati-fatturazione', null, { reload: 'dati-fatturazione' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .factory('DatiFatturazioneSearch', DatiFatturazioneSearch);

    DatiFatturazioneSearch.$inject = ['$resource', 'SERVER_URL'];

    function DatiFatturazioneSearch($resource, SERVER_URL) {
        var resourceUrl =  SERVER_URL + 'api/_search/dati-fatturaziones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .controller('DatiFatturazioneController', DatiFatturazioneController);

    DatiFatturazioneController.$inject = ['$scope', '$state', 'DatiFatturazione', 'DatiFatturazioneSearch'];

    function DatiFatturazioneController ($scope, $state, DatiFatturazione, DatiFatturazioneSearch) {
        var vm = this;
        
        vm.datiFatturaziones = [];
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            DatiFatturazione.query(function(result) {
                vm.datiFatturaziones = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            DatiFatturazioneSearch.query({query: vm.searchQuery}, function(result) {
                vm.datiFatturaziones = result;
            });
        }    }
})();

(function() {
    'use strict';

    angular.module('theFoodApp').controller('ClienteDetailController',
        ClienteDetailController);

    function ClienteDetailController($state, $anchorScroll, translationStorageProvider, cliente, indirizzi, datiFatturazione, Cliente, $translate, DatiFatturazioneDialogService, IndirizzoDialogService) {
        var vm = this;
        // Interfaccia
        vm.cliente = cliente;
        vm.indirizzi = indirizzi;
        vm.datiFatturazione = datiFatturazione;
        vm.getLocale = getLocale;

        vm.datiFatturazioneDialog = datiFatturazioneDialog;

        vm.aggiungiIndirizzo = aggiungiIndirizzo;
        vm.modificaIndirizzo = modificaIndirizzo;
        vm.cancellaIndirizzo = cancellaIndirizzo;
        vm.goPrivacyPolicy = goPrivacyPolicy;

        vm.aggiungiDatiFatturazione = aggiungiDatiFatturazione;
        vm.modificaDatiFatturazione = modificaDatiFatturazione;
        vm.cancellaDatiFatturazione = cancellaDatiFatturazione;

        vm.isSaving = false;
        vm.saved = false;

        vm.clear = clear;
        vm.save = save;

        vm.genderList = [{
                "id": "M",
                "value": 'global.form.genderMale'
            },
            {
                "id": "F",
                "value": 'global.form.genderFemale'
            }
        ];

        vm.datepickerOptions = {
            showWeeks: false,
            maxDate: new Date()
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dataDiNascita = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        // Implementazione

        var clienteData = _.cloneDeep(cliente);

        function goPrivacyPolicy(){
            $state.go('static-page.privacy-policy');
        }

        function datiFatturazioneDialog(){
            DatiFatturazioneDialogService.open(cliente,vm.datiFatturazione);
        }

        function aggiungiDatiFatturazione() {
            return DatiFatturazioneDialogService.open(cliente)
                .then(function(datiFatturazione) {
                    vm.datiFatturazione.push(datiFatturazione);
                });
        }

        function modificaDatiFatturazione(datiFatturazione) {
            return DatiFatturazioneDialogService.open(cliente, datiFatturazione);
        }

        function cancellaDatiFatturazione(datiFatturazione) {
            return DatiFatturazioneDialogService.openDelete(datiFatturazione)
                .then(function() {
                    vm.datiFatturazione = _.filter(vm.datiFatturazione, function(df) {
                        return df.id !== datiFatturazione.id;
                    });
                });
        }

        function aggiungiIndirizzo() {
            return IndirizzoDialogService.open(cliente)
                .then(function(indirizzo) {
                    vm.indirizzi.push(indirizzo);
                });
        }

        function modificaIndirizzo(indirizzo) {
            return IndirizzoDialogService.open(cliente, indirizzo);
        }

        function cancellaIndirizzo(indirizzo) {
            return IndirizzoDialogService.openDelete(indirizzo)
                .then(function() {
                    vm.indirizzi = _.filter(vm.indirizzi, function(i) {
                        return i.id !== indirizzo.id;
                    });
                });
        }

        function getLocale() {
            return translationStorageProvider.getCurrent();
        }

        function clear() {
            vm.cliente = _.cloneDeep(clienteData);
        }

        function save() {
            if(vm.cliente.consensoCondizioni === false){
                vm.saveFailed = true;
                $anchorScroll();
                return;
            }
            vm.saved = false;
            vm.saveFailed = false;
            vm.isSaving = true;
            Cliente.update(vm.cliente, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            vm.saved = true;
            $anchorScroll();
        }

        function onSaveError(err) {
            vm.isSaving = false;
            vm.saveFailed = true;
            $anchorScroll();
        }

    }
})();

(function() {
	'use strict';

	angular
	.module('theFoodApp')
	.config(stateConfig);

	stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider
		.state('cliente', {
			parent: 'app',
			url: '/cliente',
			data: {
				authorities: ['ROLE_USER'],
				pageTitle: 'theFoodApp.cliente.detail.title'
			},
			views: {
				'content@': {
					templateUrl: 'app/pages/cliente/cliente-detail.html',
					controller: 'ClienteDetailController',
					controllerAs: 'vm'
				}
			},
			resolve: {
				translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('cliente');
					$translatePartialLoader.addPart('indirizzo');
					$translatePartialLoader.addPart('datiFatturazione');
					$translatePartialLoader.addPart('indirizzo');


					return $translate.refresh();
				}],
				cliente: function($stateParams, Cliente) {
					return Cliente.get({id : $stateParams.id}).$promise;
				},
				indirizzi: function(Indirizzo) {
					return Indirizzo.query();
				},
				datiFatturazione: function(DatiFatturazione) {
					return DatiFatturazione.query();
				}
			},
			breadcrumb: {
				title: "{{ 'theFoodApp.cliente.detail.title' | translate }}"
			}
		})
	}

})();

(function() {
    'use strict';
    angular
        .module('theFoodApp')
        .factory('Cliente', Cliente);

    Cliente.$inject = ['$resource', 'SERVER_URL', 'DateUtils'];

    function Cliente ($resource, SERVER_URL, DateUtils) {
        var resourceUrl = SERVER_URL + 'api/clientes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dataCreazione = DateUtils.convertDateTimeFromServer(data.dataCreazione);
                        data.dataDiNascita = DateUtils.convertDateTimeFromServer(data.dataDiNascita);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();


( function() {

	angular
		.module( 'theFoodApp' )
		.factory( 'CarrelloHolder', CarrelloHolder );

	function CarrelloHolder($state) {
    var instance = this;
    instance.visible = false;
    instance.carrelli = [];

    instance.setVisibility = setVisibility;
    instance.isVisible = isVisible;
    instance.getCarrelli = getCarrelli;
    instance.getImportoCarrello = getImportoCarrello;

    function setVisibility(visible, carrelli) {
      instance.visible = visible;
      if (visible && carrelli && carrelli.length > 0) {
        instance.carrelli = carrelli;
      } else {
        instance.carrelli = [];
      }
    }

    function isVisible() {
      return instance.visible;
    }

    function getCarrelli() {
      return instance.carrelli;
    }

    function getImportoCarrello() {
      if (instance.carrelli && instance.carrelli.length > 0) {
			  return instance.carrelli[0].getImportoArticoliExcludeScontoConsegna();
      } else {
        return null;
      }
		}

    return instance;
  }

})();

(function() {
	'use strict';

	angular.module('theFoodApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig($stateProvider) {

		$stateProvider.state('carrello', {
			parent: 'locale',
			url : '/carrello',
			reloadOnSearch : false,
			data : {
				pageTitle : 'theFoodApp.ordine.detail.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/pages/carrello/carrello.full.html',
				},
				'carrello@carrello' : {
					templateUrl : 'app/pages/carrello/carrello.html',
					controller : 'CarrelloController',
					controllerAs : 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('ordine');
					$translatePartialLoader.addPart('aggiunte');
					$translatePartialLoader.addPart('varianti');
					$translatePartialLoader.addPart('carrello');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				} ]
			},
			breadcrumb: {
				title: "{{ 'theFoodApp.ordine.detail.title' | translate }}"
			}
		});
	}
})();

(function() {
	'use strict';

	angular
		.module('theFoodApp')
		.factory('Carrello', Carrello);

	function Carrello($resource, SERVER_URL) {

		var resourceUrl = SERVER_URL + 'api/public/v1/carrello/:localeId',
			rigaCarrelloUrl = resourceUrl + '/articoli/:rigaId';

		return $resource(resourceUrl, {}, {

			get : {
				// Parametri necessari: localeId, zonaId, clienteId
				url: resourceUrl,
				method : 'GET'
			},

			aggiungiProdotto : {
				// Parameteri necessari: localeId, zonaId, clienteId
				// Body:
				//   productId: prodotto selezionato [obbligatorio]
				//   menuProducts: [ { productId, menuItemId } ]
				url: rigaCarrelloUrl,
				method: 'POST'
			},
			rimuoviArticolo : {
				// Parameteri necessari: localeId, rigaId, zonaId, clienteId
				url: rigaCarrelloUrl,
				method: 'DELETE'
			},

			svuotaCarrello : {
				url: resourceUrl + '/svuota-carrello',
				method: 'DELETE'
			},

			varianti: {
				// Parametri necessari: localeId, rigaId, clienteId
				// Parametri opzionali: dettaglioMenuId
				url: rigaCarrelloUrl + '/varianti',
				method : 'GET',
				isArray: true
			},
			salvaVarianti: {
				// Parametri necessari: localeId, rigaId, zonaId, clienteId
				// Parametri opzionali: dettaglioMenuId
				// Body:
				//   [ { varianteId, dettaglioVarianteId } ]
				url: rigaCarrelloUrl + '/varianti',
				method : 'PUT'
			},

			aggiunte: {
				// Parametri necessari: localeId, rigaId, clienteId
				// Parametri opzionali: dettaglioMenuId
				url: rigaCarrelloUrl + '/aggiunte',
				method : 'GET',
				isArray: true
			},
			salvaAggiunte: {
				// Parametri necessari: localeId, rigaId, zonaId, clienteId
				// Parametri opzionali: dettaglioMenuId
				// Body:
				//   [ aggiuntaId ]
				url: rigaCarrelloUrl + '/aggiunte',
				method : 'PUT'
			},
			salvaVariantiAggiunte: {
				url: rigaCarrelloUrl + '/variantiAggiunte',
				method : 'PUT'
			}

		});

	}
})();

(function() {

	angular
		.module('theFoodApp')
		.factory('CarrelloInstanceFactory', CarrelloInstanceFactory);

	function CarrelloInstanceFactory($rootScope, Carrello, TempUserIdService, $translate, ThrottlerInstanceFactory, $uibModal) {

		function CarrelloInstance(locale, zona) {

			var instance = this;
			// Implementation
			var lang = $translate.proposedLanguage() || $translate.use();

			// Interface
			this.locale = locale;
			this.zona = zona;

			this.refresh = refresh;
			this.getArticoli = getArticoli;
			this.aggiungiProdotto = aggiungiProdotto;
			this.rimuoviArticolo = rimuoviArticolo;
			this.svuotaCarrello = svuotaCarrello;
			this.getAggiunte = getAggiunte;
			this.salvaAggiunte = salvaAggiunte;
			this.salvaVariantiAggiunte = salvaVariantiAggiunte;
			this.getPrezzoProdotto = getPrezzoProdotto;
			this.getTotaleArticoli = getTotaleArticoli;
			this.getImportoArticoli = getImportoArticoli;
			this.getImportoArticoliSenzaSconti = getImportoArticoliSenzaSconti;
            this.getImportoArticoliExcludeScontoConsegna = getImportoArticoliExcludeScontoConsegna;
            this.isTipoConsegnaGratis=isTipoConsegnaGratis;
			this.getImportoSpedizione = getImportoSpedizione;
			this.getVarianti = getVarianti;
			this.salvaVarianti = salvaVarianti;
			this.isVuoto = isVuoto;
			this.isImportoMinimoRaggiunto = isImportoMinimoRaggiunto;
			this.getScontiOrdine =  getScontiOrdine;
			this.getOrdine = getOrdine;
			this.getMessaggiPromozione = getMessaggiPromozione;
			this.$promise = Promise.resolve();

			// Implementation

			var ordine = {},
				articoli = [],
				isTakeaway = zona === null,
				throttler = ThrottlerInstanceFactory.build(1, 0),
				annullaOrdineModalOpen = false;

			function parameters(args) {

				var device = 'WEB';
				if ( $rootScope.isMobile() ) {
					if ( window.device !== undefined && window.device.platform === "iOS" ) {
						device = 'IOS';
					} else if ( window.device !== undefined && window.device.platform === "Android" ) {
						device = 'ANDROID';
					} else {
						device = 'MOBILE';
					}
				}

				return _.extend( {}, args, {
					device: device,
					localeId: locale.id,
					zonaId: zona,
					clienteId: TempUserIdService.get()
				} );
			}

            function isTipoConsegnaGratis(scontoPromozione) {
                let dettaglio = getDettaglioPromozione(scontoPromozione);
                let tipoDettaglio = angular.fromJson(dettaglio);
                return tipoDettaglio.effetto.tipo === "SCONTO_CONSEGNA_GRATIS"
            }

            function getDettaglioPromozione(scontoPromozione) {
                return scontoPromozione.promozione.dettaglio;
            }

            function refresh() {
				return Carrello.get( parameters() ).$promise.then( onDataUpdated )
			}

			function activate() {
				instance.$promise = Promise.resolve( refresh() ).return( instance );
				return instance.$promise;
			}

			function onDataUpdated( data ) {
				ordine = data.ordine;
				articoli = ordine.rigaOrdines;
				$rootScope.$broadcast( 'carrello-updated', this );

				if(ordine.ordineCongelato){
					openAnnullaOrdineModal(ordine);
				}
				return data;
			}

			function getArticoli() {
				return articoli;
			}

			function getTotaleArticoli() {
				return articoli.length;
			}

            function getImportoArticoliExcludeScontoConsegna() {
                if (ordine.scontoPromoziones) {
                    let scontoPromoziones = ordine.scontoPromoziones
                    let totaleScontato = ordine.importoOrdine;

                    /* ISSUE 283*/
                    for (let index in scontoPromoziones) {
                        let sconto = scontoPromoziones[index];
                        if (isTipoConsegnaGratis(sconto)) {
                            totaleScontato += sconto.valoreSconto;
                        }
                    }
                    return totaleScontato;
                }
                return ordine.importoOrdine;
            }


            function getImportoArticoliSenzaSconti() {
				return ordine.importoOrdineSenzaSconti;
			}

			function getImportoArticoli() {
				return ordine.importoOrdine;
			}

			function getImportoSpedizione() {
				return ordine.importoSpedizione;
			}

			function handleError(err) {
				if (err.data.message === 'error.frozenCart') {
					openAnnullaOrdineModal(ordine);
				}

				return Promise.reject(err);
			}

			/**
			 * Aggiunge un prodotto a questo carrello.
			 * @param prodotto : Il prodotto da aggiungere
			 * @param menu[] : La lista di scelte fatte per il menu, se il prodotto è un menu. Ogni oggetto della lista dovrà contentenere una proprietà 'menuItemId' che è l'identificativo della scelta di menu fatta, e una proprietà 'productId' che indica qual'è il prodotto associato alla scelta.
			 */
			function aggiungiProdotto(prodotto, menu) {
				return throttler.throttle(function() {
					return Carrello.aggiungiProdotto(parameters(), {
						productId: prodotto.id,
						menuProducts: menu
					}).$promise.then(onDataUpdated, handleError);
				});
			}

			function rimuoviArticolo(riga) {
				return throttler.throttle(function() {
					return Carrello.rimuoviArticolo(parameters({
						rigaId: riga.id
					})).$promise.then(onDataUpdated, handleError);
				});
			}

			function svuotaCarrello() {
				return throttler.throttle(function() {
					return Carrello.svuotaCarrello(parameters())
						.$promise.then(onDataUpdated, handleError);
				});
			}

			function getAggiunte(rigaId, menuId) {
				return Carrello.aggiunte(parameters({
					rigaId: rigaId,
					dettaglioMenuId: menuId
				})).$promise;
			}

			function salvaAggiunte(rigaId, menuId, aggiunte) {
				return throttler.throttle(function() {
					return Carrello.salvaAggiunte(parameters({
						rigaId: rigaId,
						dettaglioMenuId: menuId
					}), aggiunte).$promise.then(onDataUpdated, handleError);
				});
			}

			function getVarianti(rigaId, menuId) {
				return Carrello.varianti(parameters({
					rigaId: rigaId,
					dettaglioMenuId: menuId
				})).$promise;
			}

			function salvaVarianti(rigaId, menuId, varianti) {
				return throttler.throttle(function() {
					return Carrello.salvaVarianti(parameters({
						rigaId: rigaId,
						dettaglioMenuId: menuId
					}), varianti).$promise.then(onDataUpdated, handleError);
				});
			}

			function salvaVariantiAggiunte(rigaId, menuId, varianti, aggiunte, isAggiunteToUpdate) {
				return throttler.throttle(function() {
					return Carrello.salvaVariantiAggiunte(parameters({
						rigaId: rigaId,
						dettaglioMenuId: menuId,
						aggiunte: aggiunte,
						isAggiunteToUpdate: isAggiunteToUpdate
					}), varianti).$promise.then(onDataUpdated, handleError);
				});
			}

			function getPrezzoProdotto(prodotto) {
				return isTakeaway ? prodotto.prezzoAsporto : prodotto.prezzoDomicilio;
			}

			function isVuoto() {
				return getTotaleArticoli() === 0;
			}

			function isImportoMinimoRaggiunto() {
				return !locale.insegna.importoMinimoConsegna || locale.insegna.importoMinimoConsegna <= getImportoArticoli();
			}

			function openAnnullaOrdineModal(ordine) {
				if ( annullaOrdineModalOpen )
					return;
				annullaOrdineModalOpen = true;
				var modalInstance = $uibModal.open({
					animation: true,
					templateUrl: 'app/pages/carrello/annulla-pagamento.html',
					backdrop: 'static',
					keyboard: false,
					controller: 'AnnullaPagamentoController',
					controllerAs: 'vm',
					resolve: {
						ordine: ordine,
						translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
							$translatePartialLoader.addPart('carrello');
							return $translate.refresh();
						}]
					}
				});
				return modalInstance.result.then( function() {
					annullaOrdineModalOpen = false;
					return refresh();
				}, function(e) {
					annullaOrdineModalOpen = false;
					return openAnnullaOrdineModal( ordine );
				});
			}

			// Restituisce gli sconti relativi all'ordine.
			function getScontiOrdine(){
				return ordine.scontoPromoziones;
			}

			function getOrdine(){
				return ordine;
			}

			function getMessaggiPromozione(){
				return ordine.messaggi;
			}

			activate();

			return instance;

		}

		return {
			build: function( locale, zona, isTakeaway ) {
				return new CarrelloInstance( locale, zona, isTakeaway );
			}
		};
	}

}) ();

(function() {
	'use strict';

	angular
		.module('theFoodApp')
		.controller('CarrelloController', CarrelloController);

	function CarrelloController($scope, $state, $translate, carrelloInstance, locale, isTakeaway, Principal, LoginService, ConfirmationYesnoDialogService) {

		var vm = this;

		// Interface
		vm.carrello = carrelloInstance;
		vm.canCheckout = canCheckout;
		vm.checkout = checkout;
		vm.svuotaCarrello = svuotaCarrello;
		vm.getImportoMinimoConsegna = getImportoMinimoConsegna;
		vm.showEmptyCartError = false;
		vm.showAmountTooLowError = false;
		vm.showBannerAmountTooLowInfo = true;
		vm.showAmountTooLowInfo = showAmountTooLowInfo;
		vm.visualizzaMessaggioPromo = visualizzaMessaggioPromo;
		vm.isTipoConsegnaGratis= isTipoConsegnaGratis;

		// Implementation

		function visualizzaMessaggioPromo(){
			return carrelloInstance.getMessaggiPromozione();
		}

        function isTipoConsegnaGratis(scontoPromozione) {
            return carrelloInstance.isTipoConsegnaGratis(scontoPromozione)
        }

		function showAmountTooLowInfo(){
			return vm.showAmountTooLowError ? false : vm.showBannerAmountTooLowInfo && !vm.carrello.isImportoMinimoRaggiunto();
		}

		function getImportoMinimoConsegna() {
			return isTakeaway ? 0 : locale.insegna.importoMinimoConsegna;
		}

		function canCheckout() {
			return !vm.carrello.isVuoto() && vm.carrello.isImportoMinimoRaggiunto();
		}

		function checkout() {

			vm.showEmptyCartError = false;
			vm.showAmountTooLowError = false;

			return Principal.identity(true).then( function(identity) {

				if ( identity === null ) {
					var loginBanner = {
						message: 'global.messages.info.login-to-complete-order',
						type: 'info'
					};
					LoginService.open( loginBanner ).then( vm.carrello.refresh ).then( checkout );
					return false;
				}

				if (vm.carrello.isVuoto()) {
					vm.showEmptyCartError = true;
					return false;
				}

				if (!vm.carrello.isImportoMinimoRaggiunto()) {
					vm.showAmountTooLowError = true;
					vm.showBannerAmountTooLowInfo = false;
					return false;
				}

				$state.go('concludi-acquisto');

			} );

		}

		function svuotaCarrello() {
			var data = {
				title: $translate.instant('theFoodApp.carrello.confirm.svuotaCarrelloTitle'),
				body: $translate.instant('theFoodApp.carrello.confirm.svuotaCarrelloBody'),
			};

			return ConfirmationYesnoDialogService.open(data).then(function() {
				return carrelloInstance.svuotaCarrello().then(function() {
					Notification.success({
						title: $translate.instant('theFoodApp.carrello.carrelloSvuotato'),
						delay: NOTIFICATION_TIME
					});
				}, function() {
					Notification.error({
						title: $translate.instant('theFoodApp.carrello.carrelloNonSvuotato'),
						delay: NOTIFICATION_TIME
					});
				});
			});
		}

		function onCarrelloUpdated() {
			vm.showEmptyCartError = false;
		}

		$scope.$on('carrello-updated', onCarrelloUpdated);

		return vm;

	}

})();

(function() {
	'use strict';

	angular
		.module('theFoodApp')
		.controller( 'VariantiController', VariantiController );

	function VariantiController( $window, $uibModalInstance, currencyFilter, languageSwitchFilter, carrelloInstance, rigaOrdine, sceltaMenu, varianti, aggiunte ) {

		var vm = this;

		// Interface

		//Aggiunte
		vm.aggiunte = _.clone( aggiunte );
		vm.toggleAggiunta = toggleAggiunta;
		vm.getTotaleAggiunte = getTotaleAggiunte;
		vm.getCostoAggiunte = getCostoAggiunte;
		vm.getPrezzoAggiunta = getPrezzoAggiunta;
		vm.getAggiunteDisponibili = getAggiunteDisponibili;
		vm.canClear = _.constant( true );
		vm.canSave = canSave;
		vm.clear = clear;
		vm.isDesktop = $window.outerWidth > 812 ? true : false;
		vm.mostraAggiunte = vm.mostraAggiunte ? vm.mostraAggiunte : ( vm.isDesktop ? true : false);

		var riga = sceltaMenu || rigaOrdine,
		articolo = riga.prodotto;


		//Varianti
		vm.varianti = [];
		vm.variantiSelezionate = [];

		vm.isSaving = false;
		// vm.canSave = _.constant( true );
		vm.save = save;

		vm.abort = abort;

		vm.getCostoVarianti = getCostoVarianti;
		vm.getVarianteLabel = getVarianteLabel;

		// Implementation

		var riga = sceltaMenu || rigaOrdine;

		function activate() {
			vm.varianti = initVarianti( _.clone( varianti ) );
			vm.variantiSelezionate = _( riga.dettaglioVariantes )
				.keyBy( 'varianteId' )
				.value( );
			var current = _.map( riga.aggiuntas, 'id' );
				_.each( vm.aggiunte, function(a) {
					a.selected = _.includes( current , a.id );
				});
		}

		function extendDettaglioVariante( dettaglio ) {
			dettaglio.dettaglioVarianteId = dettaglio.id;
			return dettaglio;
		}

		function initVarianti( varianti ) {
			return _.orderBy( varianti, 'sortOrder' );
		}

		function getVarianteLabel( variante ) {
			var name = languageSwitchFilter( variante, 'descrizioneIt', 'descrizioneEn' ),
				priceLabel = ( variante.price === 0 ? '' : ' - ' + currencyFilter( variante.price, '€' ) );
			return name + priceLabel;
		}

		function getCostoVarianti() {
			return _.reduce( vm.variantiSelezionate, function(totale, vs) {
				return totale + vs.price;
			}, 0 );
		}

		function save() {
			var payload = _( vm.variantiSelezionate )
				.map( extendDettaglioVariante )
				.values();

				// return carrelloInstance.salvaVarianti( rigaOrdine.id, sceltaMenu ? sceltaMenu.id : null, payload )
				// 	.then( $uibModalInstance.close );
				var isAggiunteToUpdate = vm.aggiunte.length ? true : false;
				return carrelloInstance.salvaVariantiAggiunte( rigaOrdine.id, sceltaMenu ? sceltaMenu.id : null, payload, getAggiunteSelezionate(), isAggiunteToUpdate )
					.then( $uibModalInstance.close );
			}

		function abort() {
			$uibModalInstance.dismiss();
		}


		//Aggiunte
		function toggleAggiunta(evt, aggiunta) {
			aggiunta.selected = !aggiunta.selected;

			evt.stopPropagation();
			return false;
		}
		function clear() {
			_.each( vm.aggiunte, function(a) {
				a.selected = false;
			} );
		}

		function getAggiunteSelezionate() {
				return _( vm.aggiunte ).filter( 'selected' ).map( 'id' ).value();
		}

		function getTotaleAggiunte() {
			return _( vm.aggiunte ).filter( 'selected' ).value().length;
		}

		function getPrezzoAggiunta( aggiunta ) {
			return carrelloInstance.getPrezzoProdotto( aggiunta );
		}

		function getCostoAggiunte() {
			return _( vm.aggiunte ).filter( 'selected' ).reduce( function(v, a) {
				return v + ( a.selected ? getPrezzoAggiunta( a ) : 0 );
			}, 0 );
		}

		function getAggiunteDisponibili() {
			return articolo.aggiunteDisponibili;
		}

		function clear() {
			_.each( vm.aggiunte, function(a) {
				a.selected = false;
			} );
		}

		function canSave() {
			if (vm.aggiunte.length){
				return getAggiunteDisponibili() && getTotaleAggiunte() <= getAggiunteDisponibili();
			}else{
				return true;
			}
		}

		activate();

		return vm;

	}

})();


( function() {
	'use strict';

	angular
		.module( 'theFoodApp' )
		.directive( 'articolo', articolo );

	function articolo() {

		var directive = {
			restrict: 'E',
			scope: {
				rigaOrdine: '=',
				sceltaMenu: '=',
				carrelloInstance: '=carrello'
			},
			templateUrl: 'app/pages/carrello/articolo.directive.html',
			bindToController: true,
			controllerAs: 'vm',
			controller: ArticoloController
		};

		return directive;

	}

	/* @ngInject */
	function ArticoloController($uibModal, $scope, $translate, $timeout, Notification, DOUBLE_CLICK_TIME, NOTIFICATION_TIME) {

		var vm = this;
		var lang = $translate.proposedLanguage() || $translate.use();
		// Interface

		vm.articolo = vm.sceltaMenu || vm.rigaOrdine;
		vm.modificaAggiunte = modificaAggiunte;
		vm.modificaVarianti = modificaVarianti;
		vm.rimuoviArticolo = rimuoviArticolo;

		vm.getPrezzoProdotto = vm.carrelloInstance.getPrezzoProdotto;
		var doubleClickGuard = false;

		// Implementation

		function rimuoviArticolo(articolo){
			if(doubleClickGuard)
				return Promise.resolve();

			doubleClickGuard = true;
			$timeout(function(){
				doubleClickGuard = false;
			}, DOUBLE_CLICK_TIME);

			vm.carrelloInstance.rimuoviArticolo(articolo).then(function() {
				Notification.success({
					message: lang == 'it' ? articolo.prodotto.descrizioneIt : articolo.prodotto.descrizioneEn,
					title: $translate.instant('theFoodApp.locale.articoloRimosso'),
					delay: NOTIFICATION_TIME
                });

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'removedProductFromCart'
                });
			}, function() {
				Notification.error({
					message: lang == 'it' ? articolo.prodotto.descrizioneIt : articolo.prodotto.descrizioneEn,
					title: $translate.instant('theFoodApp.locale.articoloNonRimosso'),
					delay: NOTIFICATION_TIME
				});
			});
		}

		function modificaAggiunte() {

			if ( !vm.articolo.prodotto.aggiunteDisponibili )
				return false;

			var modal = $uibModal.open({
				controller : 'AggiunteController as vm',
				templateUrl : 'app/pages/carrello/articolo.aggiunte.dialog.html',
				backdrop: 'static',
				resolve : {
					carrelloInstance : function() {
						return vm.carrelloInstance;
					},
					rigaOrdine : function() {
						return vm.rigaOrdine;
					},
					sceltaMenu : function() {
						return vm.sceltaMenu;
					},
					aggiunte : function() {
						return vm.carrelloInstance.getAggiunte( vm.rigaOrdine.id, vm.sceltaMenu ? vm.sceltaMenu.id : null );
					},
					translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('aggiunte');
						$translatePartialLoader.addPart('carrello');
						return $translate.refresh();
					} ]
				}
			});

			return modal.result;

		}

		function modificaVarianti( riga ) {

			if (
					(!vm.articolo.dettaglioVariantes || !vm.articolo.dettaglioVariantes.length) &&
					(!vm.articolo.prodotto.aggiunteDisponibili)
				)
				return false;

			var modal = $uibModal.open({
				controller : 'VariantiController as vm',
				templateUrl : 'app/pages/carrello/articolo.varianti.dialog.html',
				backdrop: 'static',
				resolve : {
					carrelloInstance : function() {
						return vm.carrelloInstance;
					},
					rigaOrdine : function() {
						return vm.rigaOrdine;
					},
					sceltaMenu : function() {
						return vm.sceltaMenu;
					},
					varianti : function() {
						return vm.carrelloInstance.getVarianti( vm.rigaOrdine.id, vm.sceltaMenu ? vm.sceltaMenu.id : null );
					},
					aggiunte : function() {
						return vm.carrelloInstance.getAggiunte( vm.rigaOrdine.id, vm.sceltaMenu ? vm.sceltaMenu.id : null );
					},
					translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('varianti');
						$translatePartialLoader.addPart('aggiunte');
						return $translate.refresh();
					} ]
				}
			});

			return modal.result;

		}

	}

} )();

(function() {
	'use strict';

	angular
		.module('theFoodApp')
		.controller( 'AggiunteController', AggiunteController );

	function AggiunteController( $uibModalInstance, carrelloInstance, rigaOrdine, sceltaMenu, aggiunte ) {

		var vm = this;

		// Interface

		vm.aggiunte = _.clone( aggiunte );

		vm.isSaving = false;
		vm.canSave = canSave;
		vm.save = save;

		vm.canClear = _.constant( true );
		vm.clear = clear;

		vm.abort = abort;

		vm.toggleAggiunta = toggleAggiunta;
		vm.getTotaleAggiunte = getTotaleAggiunte;
		vm.getCostoAggiunte = getCostoAggiunte;
		vm.getPrezzoAggiunta = getPrezzoAggiunta;
		vm.getAggiunteDisponibili = getAggiunteDisponibili;

		// Implementation

		var riga = sceltaMenu || rigaOrdine,
			articolo = riga.prodotto;

		function activate() {
			var current = _.map( riga.aggiuntas, 'id' );
			_.each( vm.aggiunte, function(a) {
				a.selected = _.includes( current , a.id );
			});
			console.info( articolo, riga.aggiuntas, current );
		}

		function clear() {
			_.each( vm.aggiunte, function(a) {
				a.selected = false;
			} );
		}

		function getAggiunteSelezionate() {
			return _( vm.aggiunte ).filter( 'selected' ).map( 'id' ).value();
		}

		function getTotaleAggiunte() {
			return _( vm.aggiunte ).filter( 'selected' ).value().length;
		}

		function getPrezzoAggiunta( aggiunta ) {
			return carrelloInstance.getPrezzoProdotto( aggiunta );
		}

		function getCostoAggiunte() {
			return _( vm.aggiunte ).filter( 'selected' ).reduce( function(v, a) {
				return v + ( a.selected ? getPrezzoAggiunta( a ) : 0 );
			}, 0 );
		}

		function getAggiunteDisponibili() {
			return articolo.aggiunteDisponibili;
		}

		function canSave() {
			return getAggiunteDisponibili() && getTotaleAggiunte() <= getAggiunteDisponibili();
		}

		function save() {
			return carrelloInstance.salvaAggiunte( rigaOrdine.id, sceltaMenu ? sceltaMenu.id : null, getAggiunteSelezionate() )
				.then( $uibModalInstance.close );
		}

		function abort() {
			$uibModalInstance.dismiss();
		}

		function toggleAggiunta(evt, aggiunta) {
			aggiunta.selected = !aggiunta.selected;

			evt.stopPropagation();
			return false;
		}

		activate();

		return vm;

	}

})();

(function(){
    'use strict';

    angular
		.module( 'theFoodApp' )
		.controller( 'AnnullaPagamentoController', AnnullaPagamentoController );

		function AnnullaPagamentoController(ordine, $uibModalInstance, AnnullaPagamento, $state){
			var vm = this;

			// Interface
			vm.annullaPagamento = annullaPagamento;

			function annullaPagamento() {
				return AnnullaPagamento.sblocca({id: ordine.id}).$promise.then(function(){
					$uibModalInstance.close();
					$state.reload();
				});
			}


			return vm;
		}
})();

(function() {
    'use strict';
    angular.module('theFoodApp').config(stateConfig);
    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('areaPersonale', {
            parent: 'app',
            url: '/area-personale',
            reloadOnSearch: false,
            data: {
				authorities: ['ROLE_USER'],
                pageTitle: 'theFoodApp.area-personale.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/pages/area-personale/area-personale.html',
                    controller: 'AreaPersonaleController',
                    controllerAs: 'vm'
                }
            },
            breadcrumb: {
                title: "{{ 'theFoodApp.area-personale.title' | translate }}"
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('cliente');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
	'use strict';

	angular
		.module('theFoodApp')
		.controller('AreaPersonaleController', AreaPersonaleController);

	function AreaPersonaleController($scope, Coupon, $state,$uibModal,$window, pagingParams, ParseLinks, AlertService, MovimentiCredito, translationStorageProvider, $timeout) {
		var vm = this;


		vm.movimentiCredito = [];
		vm.itemsPerPage = 5;
		vm.totaleCredito = 0;
		vm.loadTotale = loadTotale;
		vm.mostraMov = false;
		vm.transition = transition;
		vm.mobile = false;
		vm.coupon_code = "";
		vm.saveCoupon = saveCoupon;
		var predicate = 'dataOrdine';
		var reverse = false;
		vm.saved = false;
		vm.saveFailed1 = false;
		vm.saveFailed2 = false;
		vm.saveFailed3 = false;
		vm.saveFailed4 = false;


		loadAll();

		//Carica i movimenti credito
		function loadAll() {
			if ($window.innerWidth <= 460) { // 768px portrait
				vm.mobile = true;
			}
			MovimentiCredito.movimenti({
				page: pagingParams.page - 1,
				size: vm.itemsPerPage,
				//sort: sort()// --> eventualmente da popolare con l'ordinamento scelto dall'utente
			}, onSuccess, onError);


			function sort() {
				var result = [predicate + ',' + (reverse ? 'asc' : 'desc')];
				if (predicate !== 'dataOrdine') {
					result.push('dataOrdine');
				}
				return result;
			}


			function onSuccess(data, headers) {
				loadTotale();
				vm.links = ParseLinks.parse(headers('link'));
				vm.totalItems = headers('X-Total-Count');
				//_.forEach(data, function(movimento) {
				vm.movimentiCredito = data;
				//});
				vm.page = pagingParams.page;
			}

			function onError(error) {
				AlertService.error(error.data.message);
			}
		}



		function loadTotale() {
			MovimentiCredito.totale({}, onSuccess, onError);

			function onSuccess(data, headers) {
				//_.forEach(data, function(movimento) {
				vm.totaleCredito = data.totale;
				//});
			}

			function onError(error) {
				AlertService.error(error.data.message);
			}
		}

		function transition() {
			$state.transitionTo($state.$current, {
				page: vm.page
			});
		}


		function saveCoupon() {
			Coupon.getValueCouponCredito({
				codice: vm.coupon_code
			}, onSuccess, onError);
			function onSuccess(data1, headers) {
				if (data1.status === "SUCCESS") {
					var modalInstance = $uibModal.open({
						animation: true,
						templateUrl: 'app/pages/confirm-coupon-credito/confirm-coupon-credito.html',
						controller: 'ConfirmCouponCreditoController',
						controllerAs: 'vm',
						backdrop: 'static',
						keyboard: false,
						resolve: {
							couponCode :  function() {
								return data1.value;
							  }
						}
					});
					modalInstance.result.then(function (parameter) {
						if (parameter !== 'cancel') {
							Coupon.saveCouponCredito({
								codice: vm.coupon_code
							}, onSuccess, onError);
							function onSuccess(data, headers) {
								showError(data);
							}		
							function onError(error) {
								AlertService.error(error.data.message);
							}
						}
					});
				} else {
					showError(data1);
				}
			}
			function onError(error) {
				AlertService.error(error.data1.message);
			}
			


		}

		function showError(data) {
			if (data.status === "SUCCESS") {
				vm.saved = true;
				$timeout(function () {
					vm.saved = false;
				}, 3000);
				loadAll();
			} else if (data.status === "ERROR") {
				if (data.code === 1) {
					vm.saveFailed1 = true;
				}
				if (data.code === 2) {
					vm.saveFailed2 = true;
				}
				if (data.code === 3) {
					vm.saveFailed3 = true;
				}
				if (data.code === 4) {
					vm.saveFailed4 = true;
				}
				$timeout(function () {
					vm.saveFailed1 = false;
					vm.saveFailed2 = false;
					vm.saveFailed3 = false;
					vm.saveFailed4 = false;
				}, 4000);
			}
				
		}
	}

})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('landing');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .directive('activeLink', activeLink);

    function activeLink() {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var clazz = attrs.activeLink;
            var path = attrs.href;
            path = path.substring(1); //hack because path does bot return including hashbang
            scope.location = location;
            scope.$watch('location.path()', function(newPath) {
                if (path === newPath) {
                    element.addClass(clazz);
                } else {
                    element.removeClass(clazz);
                }
            });
        }
    }
})();

(function() {
	'use strict';

	angular
		.module('theFoodApp')
		.controller('HeaderController', HeaderController);

	function HeaderController($scope, $document, $state, $translate, $window, Auth, Principal, ProfileService, LoginService, tmhDynamicLocale, CarrelloHolder, PromozioniHolder) {
		var vm = this;

		vm.isAuthenticated = Principal.isAuthenticated;

		vm.login = login;
		vm.logout = logout;
		vm.goToHome = goToHome;
		vm.changeLanguage = changeLanguage;
		vm.carrelloHolder = CarrelloHolder;
		vm.promozioniHolder = PromozioniHolder;
		vm.toggleMyAccount = toggleMyAccount;
		vm.goToHomePage = goToHomePage;
		vm.open = false;
		vm.isIosX = isIosX;
		vm.goToHelp = goToHelp;

		function isIosX() {
			if ( 	window.device !== undefined && window.device.platform == "iOS" &&	(window.device.model == "iPhone10,6" || window.device.model == "iPhone10,3")) {
				return true;
			}else{
				return false;
			}
		}

		function goToHelp() {
				$state.go('static-page.aiuto');
		}

		function login() {
			LoginService.open().then(function() {
				$state.reload();
			});
		}

		function logout() {
			Auth.logout().then(function() {
				return $state.go('landing');
			}).then(function() {
				$state.reload();
			});
		}

		function goToHome() {
			$state.go('cliente');
		}

		function changeLanguage(languageKey) {
			$translate.use(languageKey);
			tmhDynamicLocale.set(languageKey);
		}

		function toggleMyAccount(event) {
			event.stopPropagation();
			vm.open = !vm.open;
			return vm.open;
		}

		function goToHomePage() {
			$state.go('landing');
		}

		// Aggiunto listener sul document per chiudere tendina con i link
		// per gli utenti loggati

		$document.click(function() {
			$scope.$apply(function() {
				vm.open = false;
			});
		});
	}
})();

(function() {
    'use strict';

    angular
    .module('theFoodApp')
    .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('error', {
            parent: 'app',
            url: '/error',
            data: {
                authorities: [],
                pageTitle: 'error.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/layouts/error/error.html'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    return $translate.refresh();
                }]
            },
            breadcrumb: {
                title: "{{ 'error.title' | translate }}"
            }
        })
        .state('accessdenied', {
            parent: 'app',
            url: '/accessdenied',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/layouts/error/accessdenied.html'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    return $translate.refresh();
                }]
            },
            breadcrumb: {
                title: "{{ 'error.title' | translate }}"
            }
        });
    }
})();

( function() {
	'use strict';

	angular
		.module( 'theFoodApp' )
		.controller( 'BreadcrumbController', BreadcrumbController );

	function BreadcrumbController( $scope, $state, $interpolate, $log ) {
		var vm = this;

		var updateBreadcrumbsArray = function() {
			var links = [],
				current = $state.$current;

			while ( current ) {

				if ( current.breadcrumb ) {

					var link = {
						sref: current.breadcrumb.state || current.name, // Allow overriding the breadcrumb link with the special property state.
						isIcon: false,
						description: '--',
						icon: '--'
					};

					if ( current.breadcrumb.title ) {
						var interpolationContext = angular.isDefined( current.locals ) ? current.locals.globals : current;
						link.description = $interpolate( current.breadcrumb.title )( interpolationContext );
					} else if ( current.breadcrumb.icon ) {
						link.icon = 'glyphicon glyphicon-' + current.breadcrumb.icon;
						link.isIcon = true;
					} else {
						$log.error( 'Invalid breadcrumb definition for state: ' + current.name );
						link = null;
					}

					if ( link )
						links.push( link );

				} else if ( current.name && !current.abstract ) {
					$log.warn( 'No breadcrumb defined for state: ' + current.name );
				}

				current = current.parent;
			}

			vm.links = _.reverse( links );
		};

		$scope.$on( '$stateChangeSuccess', function() {
			updateBreadcrumbsArray();
		} );
		$scope.$root.$on( '$translateChangeEnd', function() {
			updateBreadcrumbsArray();
		} );

		updateBreadcrumbsArray();

	}
} )();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .controller('OrdineDialogController', OrdineDialogController);

    OrdineDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Ordine', 'Feedback', 'RigaOrdine', 'Cliente', 'Locale', 'Indirizzo', 'DatiFatturazione', 'ScontoPromozione', 'Pagamento'];

    function OrdineDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Ordine, Feedback, RigaOrdine, Cliente, Locale, Indirizzo, DatiFatturazione, ScontoPromozione, Pagamento) {
        var vm = this;

        vm.ordine = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.feedbacks = Feedback.query({filter: 'ordine-is-null'});
        $q.all([vm.ordine.$promise, vm.feedbacks.$promise]).then(function() {
            if (!vm.ordine.feedbackId) {
                return $q.reject();
            }
            return Feedback.get({id : vm.ordine.feedbackId}).$promise;
        }).then(function(feedback) {
            vm.feedbacks.push(feedback);
        });
        vm.rigaordines = RigaOrdine.query();
        vm.clientes = Cliente.query();
        vm.locales = Locale.query();
        vm.indirizzos = Indirizzo.query();
        vm.datifatturaziones = DatiFatturazione.query();
        vm.scontopromoziones = ScontoPromozione.query();
        vm.pagamentos = Pagamento.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.ordine.id !== null) {
                Ordine.update(vm.ordine, onSaveSuccess, onSaveError);
            } else {
                Ordine.save(vm.ordine, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('theFoodApp:ordineUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dataOrdine = false;
        vm.datePickerOpenStatus.dataConsegna = false;
        vm.datePickerOpenStatus.dataDownload = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .controller('OrdineDetailController', OrdineDetailController);

    OrdineDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Ordine', 'Feedback', 'RigaOrdine', 'Cliente', 'Locale', 'Indirizzo', 'DatiFatturazione', 'ScontoPromozione', 'Pagamento'];

    function OrdineDetailController($scope, $rootScope, $stateParams, previousState, entity, Ordine, Feedback, RigaOrdine, Cliente, Locale, Indirizzo, DatiFatturazione, ScontoPromozione, Pagamento) {
        var vm = this;

        vm.ordine = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('theFoodApp:ordineUpdate', function(event, result) {
            vm.ordine = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .controller('OrdineDeleteController',OrdineDeleteController);

    OrdineDeleteController.$inject = ['$uibModalInstance', 'entity', 'Ordine'];

    function OrdineDeleteController($uibModalInstance, entity, Ordine) {
        var vm = this;

        vm.ordine = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Ordine.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ordine', {
            parent: 'entity',
            url: '/ordine',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'theFoodApp.ordine.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ordine/ordines.html',
                    controller: 'OrdineController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ordine');
                    $translatePartialLoader.addPart('tipoOrdine');
                    $translatePartialLoader.addPart('statoOrdine');
                    $translatePartialLoader.addPart('tipoOrarioConsegna');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('ordine-detail', {
            parent: 'entity',
            url: '/ordine/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'theFoodApp.ordine.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ordine/ordine-detail.html',
                    controller: 'OrdineDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ordine');
                    $translatePartialLoader.addPart('tipoOrdine');
                    $translatePartialLoader.addPart('statoOrdine');
                    $translatePartialLoader.addPart('tipoOrarioConsegna');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Ordine', function($stateParams, Ordine) {
                    return Ordine.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ordine',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ordine-detail.edit', {
            parent: 'ordine-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ordine/ordine-dialog.html',
                    controller: 'OrdineDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ordine', function(Ordine) {
                            return Ordine.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ordine.new', {
            parent: 'ordine',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ordine/ordine-dialog.html',
                    controller: 'OrdineDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                tipoOrdine: null,
                                statoOrdine: null,
                                dataOrdine: null,
                                totaleOrdine: null,
                                dataConsegna: null,
                                tipoOrarioConsegna: null,
                                orarioConsegna: null,
                                ritiroAlLocale: false,
                                dataDownload: null,
                                tempCustomerUUID: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ordine', null, { reload: 'ordine' });
                }, function() {
                    $state.go('ordine');
                });
            }]
        })
        .state('ordine.edit', {
            parent: 'ordine',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ordine/ordine-dialog.html',
                    controller: 'OrdineDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ordine', function(Ordine) {
                            return Ordine.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ordine', null, { reload: 'ordine' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ordine.delete', {
            parent: 'ordine',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ordine/ordine-delete-dialog.html',
                    controller: 'OrdineDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Ordine', function(Ordine) {
                            return Ordine.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ordine', null, { reload: 'ordine' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
	'use strict';
	angular
		.module('theFoodApp')
		.factory('Ordine', Ordine);

    Ordine.$inject = ['$resource', 'SERVER_URL', 'DateUtils'];

    function Ordine ($resource, SERVER_URL, DateUtils) {
        var resourceUrl = SERVER_URL + 'api/v1/ordini/:id';

		return $resource(resourceUrl, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
			'get': {
				method: 'GET',
				transformResponse: function(data) {
					if (data) {
						data = angular.fromJson(data);
						data.dataOrdine = DateUtils.convertDateTimeFromServer(data.dataOrdine);
						data.dataConsegna = DateUtils.convertLocalDateFromServer(data.dataConsegna);
						data.dataDownload = DateUtils.convertDateTimeFromServer(data.dataDownload);
					}
					return data;
				}
			},
			'update': {
				method: 'PUT',
				transformRequest: function(data) {
					var copy = angular.copy(data);
					copy.dataConsegna = DateUtils.convertLocalDateToServer(copy.dataConsegna);
					return angular.toJson(copy);
				}
			},
			'save': {
				method: 'POST',
				transformRequest: function(data) {
					var copy = angular.copy(data);
					copy.dataConsegna = DateUtils.convertLocalDateToServer(copy.dataConsegna);
					return angular.toJson(copy);
				}
			},
			'updateWithCouponCode': {
				method: 'PUT',
				url: SERVER_URL + 'api/v1/ordini/coupon'
			},
		});
	}
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .factory('OrdineSearch', OrdineSearch);

    OrdineSearch.$inject = ['$resource', 'SERVER_URL'];

    function OrdineSearch($resource, SERVER_URL) {
        var resourceUrl =  SERVER_URL + 'api/_search/ordines/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .controller('OrdineController', OrdineController);

    OrdineController.$inject = ['$scope', '$state', 'Ordine', 'OrdineSearch', 'ParseLinks', 'AlertService'];

    function OrdineController ($scope, $state, Ordine, OrdineSearch, ParseLinks, AlertService) {
        var vm = this;
        
        vm.ordines = [];
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            Ordine.query(function(result) {
                vm.ordines = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            OrdineSearch.query({query: vm.searchQuery}, function(result) {
                vm.ordines = result;
            });
        }    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .controller('InsegnaDialogController', InsegnaDialogController);

    InsegnaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Insegna', 'Locale', 'TipologiaLocale'];

    function InsegnaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Insegna, Locale, TipologiaLocale) {
        var vm = this;

        vm.insegna = entity;
        vm.clear = clear;
        vm.save = save;
        vm.locales = Locale.query();
        vm.tipologialocales = TipologiaLocale.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.insegna.id !== null) {
                Insegna.update(vm.insegna, onSaveSuccess, onSaveError);
            } else {
                Insegna.save(vm.insegna, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('theFoodApp:insegnaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .controller('InsegnaDetailController', InsegnaDetailController);

    InsegnaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Insegna', 'Locale', 'TipologiaLocale'];

    function InsegnaDetailController($scope, $rootScope, $stateParams, previousState, entity, Insegna, Locale, TipologiaLocale) {
        var vm = this;

        vm.insegna = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('theFoodApp:insegnaUpdate', function(event, result) {
            vm.insegna = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .controller('InsegnaDeleteController',InsegnaDeleteController);

    InsegnaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Insegna'];

    function InsegnaDeleteController($uibModalInstance, entity, Insegna) {
        var vm = this;

        vm.insegna = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Insegna.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('insegna', {
            parent: 'entity',
            url: '/insegna?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'theFoodApp.insegna.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/insegna/insegnas.html',
                    controller: 'InsegnaController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('insegna');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('insegna-detail', {
            parent: 'entity',
            url: '/insegna/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'theFoodApp.insegna.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/insegna/insegna-detail.html',
                    controller: 'InsegnaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('insegna');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Insegna', function($stateParams, Insegna) {
                    return Insegna.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'insegna',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('insegna-detail.edit', {
            parent: 'insegna-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/insegna/insegna-dialog.html',
                    controller: 'InsegnaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Insegna', function(Insegna) {
                            return Insegna.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('insegna.new', {
            parent: 'insegna',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/insegna/insegna-dialog.html',
                    controller: 'InsegnaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                insegna: null,
                                descrizioneIt: null,
                                descrizioneEn: null,
                                sortOrder: null,
                                consGratisOltreSoglia: false,
                                sogliaConsGratis: null,
                                cosConsPrnzZona1: null,
                                cosConsCenaZona1: null,
                                impMinConsZona1: null,
                                cosConsPrnzZona2: null,
                                cosConsCenaZona2: null,
                                impMinConsZona2: null,
                                tipoConsegna: null,
                                ordiniBanco: null,
                                stato: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('insegna', null, { reload: 'insegna' });
                }, function() {
                    $state.go('insegna');
                });
            }]
        })
        .state('insegna.edit', {
            parent: 'insegna',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/insegna/insegna-dialog.html',
                    controller: 'InsegnaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Insegna', function(Insegna) {
                            return Insegna.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('insegna', null, { reload: 'insegna' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('insegna.delete', {
            parent: 'insegna',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/insegna/insegna-delete-dialog.html',
                    controller: 'InsegnaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Insegna', function(Insegna) {
                            return Insegna.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('insegna', null, { reload: 'insegna' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('theFoodApp')
        .factory('Insegna', Insegna);

    Insegna.$inject = ['$resource', 'SERVER_URL'];

    function Insegna ($resource, SERVER_URL) {
        var resourceUrl =  SERVER_URL + 'api/insegnas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .factory('InsegnaSearch', InsegnaSearch);

    InsegnaSearch.$inject = ['$resource', 'SERVER_URL'];

    function InsegnaSearch($resource, SERVER_URL) {
        var resourceUrl =  SERVER_URL + 'api/_search/insegnas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .controller('InsegnaController', InsegnaController);

    InsegnaController.$inject = ['$scope', '$state', 'Insegna', 'InsegnaSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function InsegnaController ($scope, $state, Insegna, InsegnaSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                InsegnaSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Insegna.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.insegnas = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function () {

  angular
    .module('theFoodApp')
    .factory('WebStorageUtil', WebStorageUtil);

  function WebStorageUtil() {
    var instance = this;

    instance.isLocalStorageSupported = isLocalStorageSupported;
    instance.isSessionStorageSupported = isSessionStorageSupported;

    function isLocalStorageSupported() {
      return isWebStorageSupported('localStorage');
    }

    function isSessionStorageSupported() {
      return isWebStorageSupported('sessionStorage');
    }

    function isWebStorageSupported(webStorageName) {
			try {
				var supported = (webStorageName in window && window[webStorageName]);
				if (supported) {
					 window[webStorageName].setItem("storage", "");
					 window[webStorageName].removeItem("storage");
				}

				return true;
			} catch(err) {
				console.log(err)
				return false;
			}
    }

    return instance;
  }

})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .filter('characters', characters);
        
    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .filter('translateEnv', translateEnv);

    translateEnv.$inject = ['$translate', 'APP_NAME'];

    function translateEnv ($translate, APP_NAME) {
        function translate(input) {
            var translation = $translate.instant(input + '-' + APP_NAME);

            if (translation.indexOf(input) > -1) {
                translation = $translate.instant(input);
            }

            return translation;
        }

        translate.$stateful = true;
        return translate;
    }

})();

(function () {

  angular
    .module('theFoodApp')
    .factory('ThrottlerInstanceFactory', ThrottlerInstanceFactory);

  function ThrottlerInstanceFactory() {

    function ThrottlerInstance(slotCount, slotCooldown) {
      if (!_.isFinite(slotCount)) {
        throw new Error('No or invalid slotCount parameter given');
      }

      if (!_.isFinite(slotCooldown)) {
        throw new Error('No or invalid slotCooldown parameter given');
      }

      var instance = this;

      this._slotCount = Math.max(slotCount, 1);
      this._slotCooldown = Math.max(slotCooldown, 0);
      this._availableSlots = _.map(_.times(this._slotCount, function () { return 0; }),
        function (v, i) { return Date.now() + i * this._slotCooldown / this._slotCount; });
      this._waitingRequests = [];

      this._awaitSlot = _awaitSlot;
      this._releaseSlot = _releaseSlot;
      this.throttle = throttle;

      function _awaitSlot() {
        if (instance._availableSlots.length > 0) {
          var slot = instance._availableSlots.shift(),
            now = Date.now(),
            promise = Promise.resolve(slot);
          if (slot > now) {
            promise = promise.delay(slot - now);
          }
          return promise;
        } else {
          // Semaphore implementation using promises.
          var release;
          var promise = new Promise(function () {
            release = arguments[0];
          });
          instance._waitingRequests.push({ release: release });
          return promise.then(function () { return instance._awaitSlot() });
        }
      }

      function _releaseSlot() {
        instance._availableSlots.push(Date.now() + instance._slotCooldown);
        if (instance._waitingRequests.length > 0) instance._waitingRequests.shift().release();
      }

      function throttle(fn) {
        if (!_.isFunction(fn))
          return Promise.reject(new Error('No or invalid function given.'));

        return instance._awaitSlot()
          .then(function(slot) { return fn(); })
          .finally(function () {
            instance._releaseSlot();
          });
      }

      return instance;
    }

    return {
      build: function (slotCount, slotCooldown) {
        return new ThrottlerInstance(slotCount, slotCooldown);
      }
    };
  }

})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('theFoodApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('theFoodApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('theFoodApp')
        .component('jhiItemCount', jhiItemCount);
})();


/**
 * La direttiva imposta la larghezza di un elemento HTML in base alla larghezza di un suo contenitore con la classe outer-affix.
 * Questo serve ad escludere dei bruschi salti di dimensione quando si passa da un elemento in-flow (es, position: static) ad uno out-of-flow (es, position: fixed).
 * L'uso primario della direttiva è quello di rendere liscia la transizione fra un componente in modalità affix e la relativa modalità ancorata.
 */

( function() {
	'use strict';

	angular
		.module( 'theFoodApp' )
		.directive( 'innerAffix', innerAffix );

	function innerAffix( $window, $timeout, $log ) {

		var directive = {
			restrict: 'C',
			link: function(scope, element) {

				var parent = element.parent( '.outer-affix' ),
					timeout;

				if ( parent.length === 0 ) {
					$log.warn( 'No outer-affix parent found for ' + element[0] );
					return;
				}

				function recalculateWidth() {
					element.width( parent.width() );
				}

				angular.element( $window ).bind( 'resize', function() {
					$timeout.cancel( timeout );
					timeout = $timeout( recalculateWidth, 50 );
				} );

				recalculateWidth();

			}
		};

		return directive;
	}

})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            dateformat : dateformat
        };

        return service;

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('theFoodApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();


( function() {
	'use strict';

	angular
		.module( 'theFoodApp' )
		.directive( 'affix', affix );

	function affix( $window, $timeout, $log ) {

		var directive = {
			restrict: 'A',
			link: function(scope, element) {

				var elementEl = element[0],
					wasActive = false,
					// offset = 20,
					offset = 120,
					cls = 'active';

				function handleScroll() {
					var pos = elementEl.getBoundingClientRect(),
						active = pos.top < offset;

					if ( active !== wasActive ) {
						element.toggleClass( cls, active );
						wasActive = active;
					}
				}

				angular.element( window )
					.on( 'scroll', handleScroll )
					.on( 'resize', handleScroll )
					.triggerHandler( 'scroll' );

			}
		};

		return directive;
	}

})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .factory('LoginService', LoginService);

    function LoginService ($uibModal, $resource, SERVER_URL) {


        var service = {
            open: open,
            getResources: getResources
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open ( banner ) {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    banner: _.constant( banner ),
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            return Promise.resolve( modalInstance.result ).finally( resetModal );
        }

        function getResources(){
            var resourceUrl = 'http://localhost:8080/social/signin/jwtApple';

            return $resource(resourceUrl, {}, {
                getJwtApple : {
                    url: resourceUrl,
                    method : 'GET'
                }});
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('theFoodApp')
        .controller('LoginController', LoginController);

    function LoginController($rootScope, $state, $timeout, $window, Auth, banner, $uibModalInstance) {
        var vm = this;


        vm.isMobile = $rootScope.isMobile();

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;
        vm.banner = banner;
        vm.callGoogle = callGoogle;
        vm.callApple = callApple;
        vm.callFacebook = callFacebook;
        vm.signAppleFromWeb = signAppleFromWeb;
        vm.isAvailableAppleSignIn = function () {
            if (window.device !== undefined && window.device.platform === "iOS" && window.device.version >= "13") {
                return true;
            } else return false;
        }

        vm.isAndroid = function () {
            if (window.device !== undefined && window.device.platform === "Android") {
                return true;
            } else return false;
        }

        /*===========================================================*/

        function callFacebook() {
            var facebookUser = {};
            var fbLoginSuccess = function (userData) {
                console.log("UserInfo: ", userData);
                facebookConnectPlugin.getAccessToken(function (token) {
                    console.log("Token: " + token);
                    facebookConnectPlugin.api("/me?fields=birthday,email,first_name,last_name,id,link,picture%7Burl%7D,name", ['public_profile', 'email'],
                        function onSuccess(result) {
                            facebookUser.birthday = result.birthday;
                            facebookUser.firstName = result.first_name;
                            facebookUser.lastName = result.last_name;
                            facebookUser.profileUrl = result.link;
                            //facebookUser.userId = result.id;
                            facebookUser.email = result.email;
                            facebookUser.imageUrl = result.picture.data.url;
                            facebookUser.displayName = result.name;
                            facebookUser.accessToken = userData.authResponse.accessToken;
                            facebookUser.userId = userData.authResponse.userID;
                            facebookUser.expiresIn = userData.authResponse.expiresIn;
                            console.log("Result: ", facebookUser);
                            Auth.loginWithFacebook(facebookUser).then(function () {
                                vm.authenticationError = false;
                                $uibModalInstance.close();
                            }).catch(function () {
                                vm.authenticationError = true;
                                vm.banner = null;
                            });
                        }, function onError(error) {
                            console.log("Failed: ", error);
                        }
                    );
                });
            }

            facebookConnectPlugin.login(["public_profile"], fbLoginSuccess,
                function (error) {
                    console.error(error)
                }
            );
        }

        function callGoogle() {
            window.plugins.googleplus.login(
                {
                    'scopes': 'https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email',
                    'webClientId': '632217101407-uj6okaf8ajtccbhh9r5l27ejd47k1qhh.apps.googleusercontent.com',
                    'offline': true
                },
                function (obj) {
                    vm.authenticationError = false;
                    Auth.loginWithGoogle(obj).then(function () {
                        vm.authenticationError = false;
                        $uibModalInstance.close();
                    }).catch(function () {
                        vm.authenticationError = true;
                        vm.banner = null;
                    });

                },
                function (msg) {
                    alert('error: ' + msg);
                }
            );
        }

        function isAvailableAppleSignIn() {
            return true;
        }

        function callApple() {
            let userCancelRequestCode = "1001";
            /*requestedScopes is an array of requested scopes.
            0: FullName
            1: Email*/
            if (window.cordova) {
                if (window.cordova.plugins && window.cordova.plugins.SignInWithApple) {
                    window.cordova.plugins.SignInWithApple.signin(
                        {requestedScopes: [0, 1]},
                        function (obj) {
                            vm.authenticationError = false;
                            Auth.loginWithApple(obj).then(function () {
                                vm.authenticationError = false;
                                $uibModalInstance.close();
                            }).catch(function () {
                                vm.authenticationError = true;
                                vm.banner = null;
                            });
                        },
                        function (err) {
                            if (err.code !== userCancelRequestCode)
                                alert('error: ' + err.localizedDescription);
                        }
                    );
                }
            }
        }

        function signAppleFromWeb() {
            let appleJSRedirect = Auth.getRedirectAppleJS();
            let mode = '_blank';
            if ($rootScope.isMobile()) {
                var ref = window.cordova.InAppBrowser.open(appleJSRedirect, mode, 'location=no');
                var shouldReload = true;
                ref.addEventListener('loadstart', function (event) {
                    if (event.url.match("#/social-apple/")) {
                        var newURL = event.url.substring(event.url.indexOf('#'));
                        $window.location.hash = newURL;
                        $window.location.reload(true);
                        shouldReload = false;
                        ref.close();
                    }
                });
                ref.addEventListener('exit', function () {
                    if (shouldReload) {
                        $window.location.reload(true);
                    }
                });
            } else {
                $window.location.href = appleJSRedirect;
            }
        }

        function cancel() {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login(event) {
            vm.authenticationError = false;
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('landing');
                }

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is succesful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
                vm.banner = null;
            });
        }

        function register() {
            $uibModalInstance.dismiss('cancel');

            $state.go('register', {
                redirectUrl: location.href
            });
        }

        function requestResetPassword() {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

( function() {
	'use strict';

	angular
		.module( 'theFoodApp' )
		.filter( 'languageSwitch', languageSwitch );

	function languageSwitch( translationStorageProvider ) {

		return function( obj, keyIta, keyEng ) {
			var key = translationStorageProvider.getCurrent() === 'it' ? keyIta : keyEng;
			return obj[ key ];
		};

	}

} )();

(function () {
    'use strict';

    angular
        .module('theFoodApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('theFoodApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'it',
            'en'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function(){
	'use strict';

	angular
		.module('theFoodApp')
		.directive('telefono', telefono);

	function telefono(){

		var directive = {
			restrict: 'A',
			template: '<input ng-pattern="tl.patternTelefono"/>',
			replace: true,
			controller: controller,
			controllerAs: 'tl'
		};

		function controller(AlertService) {
			'ngInject';

			this.patternTelefono = /^[0-9]+$/;

			return this;

		}

		return directive;

	}

})();

(function() {
	'use strict';

	angular
		.module('theFoodApp')
		.directive('strada', strada);

	function strada() {

		var indirizzoTemplate = _.template("{{ strada.descrizioneComune }}, {{ strada.descrizione }}");

		var directive = {
			restrict: 'A',
			template: '<input uib-typeahead="indirizzo as ss.componiIndirizzo(indirizzo) for indirizzo in ss.searchStrada($viewValue)" typeahead-wait-ms="600" typeahead-input-formatter="ss.componiIndirizzo($model, indirizzo)" autocomplete="off" typeahead-min-length="3" />',
			replace: true,
			controller: controller,
			controllerAs: 'ss'
		};

		function controller(TrovaZona, AlertService) {
			'ngInject';

			this.searchStrada = function(strada) {
				return TrovaZona.autocomplete({
					query: strada
				}).$promise.catch(function(error) {
					AlertService.error(error.data.message);
				});

			};

			this.componiIndirizzo = function(strada) {
				return strada ? capitalize(indirizzoTemplate({
					strada: strada
				})) : null;
			};

			function capitalize(str) {
				return _(str).split(' ').map(function (w) {
					if (w){
						return w[0].toUpperCase() + w.substring(1).toLowerCase()
					}
				} ).join(' ');
			}

			return this;

		}

		return directive;

	}

})();

(function() {
	'use strict';

	angular
		.module('theFoodApp')
		.directive('showValidation', showValidation);

	function showValidation() {
		var directive = {
			restrict: 'A',
			require: 'form',
			link: linkFunc
		};

		return directive;



		function linkFunc(scope, element, attrs, formCtrl) {

			scope.length = function() {
				// console.info('length');;
			}
			scope.$watch(function() {
				return element.find('.form-group:not(.validation)').length;
			}, function() {
				refreshFormGroups();
			});

			function refreshFormGroups() {
				element.find('.form-group:not(.validation)').each(function() {
					var $formGroup = angular.element(this);
					var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');
					$formGroup.addClass('validation');

					if ($inputs.length > 0) {
						$inputs.each(function() {
							var $input = angular.element(this);
							var inputName = $input.attr('name');
							scope.$watch(function() {
								return (formCtrl[inputName].$invalid && (formCtrl[inputName].$dirty || formCtrl.$submitted));
							}, function(isInvalid) {
								$formGroup.toggleClass('has-error', isInvalid);
							});
						});
					}
				});
			}
		}
	}
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .directive('partitaIva', partitaIva);

    function partitaIva () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.partitaIva = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || checkPartitaIva(modelValue);
            };
        }

		function checkPartitaIva(pi) {
			if (pi === '') {
				return true;
			}

			if (!/^[0-9]{11}$/.test(pi)) {
				return false;
			}

			var s = 0, i;
			for (i = 0; i <= 9; i += 2)
				s += pi.charCodeAt(i) - '0'.charCodeAt(0);
			for (i = 1; i <= 9; i += 2) {
				var c = 2 * (pi.charCodeAt(i) - '0'.charCodeAt(0));
				if (c > 9)
					c = c - 9;
				s += c;
			}
			var atteso = (10 - s % 10) % 10;
			if (atteso !== pi.charCodeAt(10) - '0'.charCodeAt(0)) {
				return false;
			}

			return true;
		}
    }

})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .directive('codiceFiscalePartitaIva', codiceFiscalePartitaIva);

    function codiceFiscalePartitaIva () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.codiceFiscale = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || checkCodiceFiscale(modelValue) || checkPartitaIva(modelValue);
            };
        }

		function checkCodiceFiscale(cf) {
			cf = cf.toUpperCase();
			if (cf === '') {
				return true;
			}
			if (!/^[0-9A-Z]{16}$/.test(cf)) {
				return false;
			}
			var map = [ 1, 0, 5, 7, 9, 13, 15, 17, 19, 21, 1, 0, 5, 7, 9, 13,
					15, 17, 19, 21, 2, 4, 18, 20, 11, 3, 6, 8, 12, 14, 16, 10,
					22, 25, 24, 23 ];
			var s = 0;
			for (var i = 0; i < 15; i++) {
				var c = cf.charCodeAt(i);
				if (c < 65)
					c = c - 48;
				else
					c = c - 55;
				if (i % 2 === 0)
					s += map[c];
				else
					s += c < 10 ? c : c - 10;
			}
			var atteso = String.fromCharCode(65 + s % 26);
			if (atteso !== cf.charAt(15)) {
				return false;
			}
			return true;
		}

		function checkPartitaIva(pi) {
			if (pi === '') {
				return true;
			}

			if (!/^[0-9]{11}$/.test(pi)) {
				return false;
			}

			var s = 0, i;
			for (i = 0; i <= 9; i += 2)
				s += pi.charCodeAt(i) - '0'.charCodeAt(0);
			for (i = 1; i <= 9; i += 2) {
				var c = 2 * (pi.charCodeAt(i) - '0'.charCodeAt(0));
				if (c > 9)
					c = c - 9;
				s += c;
			}
			var atteso = (10 - s % 10) % 10;
			if (atteso !== pi.charCodeAt(10) - '0'.charCodeAt(0)) {
				return false;
			}

			return true;
		}
    }

})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .directive('codiceFiscale', codiceFiscale);

    function codiceFiscale () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.codiceFiscale = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || checkCodiceFiscale(modelValue);
            };
        }

		function checkCodiceFiscale(cf) {
			cf = cf.toUpperCase();
			if (cf === '') {
				return true;
			}
			if (!/^[0-9A-Z]{16}$/.test(cf)) {
				return false;
			}
			var map = [ 1, 0, 5, 7, 9, 13, 15, 17, 19, 21, 1, 0, 5, 7, 9, 13,
					15, 17, 19, 21, 2, 4, 18, 20, 11, 3, 6, 8, 12, 14, 16, 10,
					22, 25, 24, 23 ];
			var s = 0;
			for (var i = 0; i < 15; i++) {
				var c = cf.charCodeAt(i);
				if (c < 65)
					c = c - 48;
				else
					c = c - 55;
				if (i % 2 === 0)
					s += map[c];
				else
					s += c < 10 ? c : c - 10;
			}
			var atteso = String.fromCharCode(65 + s % 26);
			if (atteso !== cf.charAt(15)) {
				return false;
			}
			return true;
		}
    }

})();

(function(){
	'use strict';

	angular
		.module('theFoodApp')
		.directive('civico', civico);

	function civico(){

		var directive = {
			restrict: 'A',
			template: '<input ng-pattern="cc.patternNumeroCivico"  />',
			replace: true,
			controller: controller,
			controllerAs: 'cc'
		};

		function controller(TrovaZona, AlertService) {
			'ngInject';

			this.patternNumeroCivico = /^([1-9][0-9]*)([\s\/]?(rosso|[a-z]|[1-9])|)$/i;
			return this;

		}

		return directive;

	}

})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .factory('ConfirmationYesnoDialogService', ConfirmationYesnoDialogService);

    function ConfirmationYesnoDialogService($uibModal) {
      var vm = this;

      vm.open = open;

      function open(data) {

          return $uibModal.open({
              templateUrl: 'app/components/dialog/confirmation-yesno-dialog.html',
              controller: 'ConfirmationYesnoDialogController',
              controllerAs: 'vm',
              size: 'md',
              resolve: { data: data }
          }).result;
      }

      return vm;
    }
})();
(function() {
	'use strict';

	angular.module('theFoodApp').controller('ConfirmationYesnoDialogController', ConfirmationYesnoDialogController);

	function ConfirmationYesnoDialogController($uibModalInstance, data) {
		var vm = this;

    vm.title = data.title;
    vm.body = data.body;

    vm.ok = ok;
    vm.cancel = cancel;

    function ok() {
      $uibModalInstance.close();
    }

    function cancel() {
			$uibModalInstance.dismiss();
    }

  }

})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('theFoodApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('theFoodApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            if  (httpResponse.data && httpResponse.data.ignore) {
                return;
            }

            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var errorHeader = httpResponse.headers('X-theFoodApp-error');
                var entityKey = httpResponse.headers('X-theFoodApp-params');
                if (errorHeader) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('theFoodApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><div ng-bind-html="alert.msg"></div></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('theFoodApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function(){
	'use strict';

	angular
		.module('theFoodApp')
		.constant('NOTIFICATION_TIME', 2000)
		.constant('DOUBLE_CLICK_TIME', 250);
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var alertKey = response.headers('X-theFoodApp-alert');
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers('X-theFoodApp-params')});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('api/account') > -1 )))) {
                $rootScope.$emit('theFoodApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);


    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage', 'WebStorageUtil', 'TokenStore'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage, WebStorageUtil, TokenStore) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                if (WebStorageUtil.isLocalStorageSupported()) {
                    delete $localStorage.authenticationToken;
                    delete $sessionStorage.authenticationToken;
                } else {
                    TokenStore.clearCookie();
                }

                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage', 'WebStorageUtil', 'TokenStore'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage, WebStorageUtil, TokenStore) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = '';
            if (WebStorageUtil.isLocalStorageSupported())
                token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            else
                token = TokenStore.isPresent() ? TokenStore.get().token : null;

            if (token && token.expires_at && token.expires_at > new Date().getTime()) {
                config.headers.Authorization = 'Bearer ' + token.access_token;
            }

            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
//            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
//                updateTitle();
//            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precendence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                
                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
                
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                //translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('theFoodApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {

        var current = null;
        
        return {
            getCurrent: getCurrent,
            get: get,
            put: put
        };

        function getCurrent() {
            if ( !current )
                current = get('NG_TRANSLATE_LANG_KEY');
            return current;
        }

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to prefered language "it"');
                $cookies.putObject(name, 'it');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            if ( name === 'NG_TRANSLATE_LANG_KEY' )
                current = value;
            $cookies.putObject(name, value);
        } 
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('it');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);
        
        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            data: {
                pageTitle: 'Home'
            },
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                },
                'breadcrumb@': {
                    templateUrl: 'app/layouts/breadcrumb/breadcrumb.html',
                    controller: 'BreadcrumbController as bc'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
					$translatePartialLoader.addPart('payment');
                    $translatePartialLoader.addPart( 'selezione-locale' );
                    $translatePartialLoader.addPart('social');
                    return $translate.refresh();
                }]
            },
            breadcrumb: {
                icon: 'home',
                state: 'home'
            }
        });
		$stateProvider.state('landing', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            onEnter: function( $location, $timeout, HOME_PAGE ) {
                $timeout( function() {
                    if ( window.localStorage && window.localStorage.getItem( 'redirectTo' ) ) {
                        var redirectTo = window.localStorage.getItem( 'redirectTo' );
                        localStorage.removeItem( 'redirectTo' );
                        window.location.href = redirectTo;
                    } else {
                        $location.path( '/' + HOME_PAGE ).replace();
                    }
                }, 0 );
            }
        });
	}
})();

(function() {

	angular
		.module('theFoodApp')
		.factory('RouteError', RouteErrorFactory)
		.run(setupStateChangeHandlers);

	function RouteErrorFactory($translate) {

		// var handlingRouteChangeError = false;

		function RouteError(message, newState) {
			this.name = 'RouteError';
			this.stack = (new Error()).stack;
			this._errorMessage = message;
			this._redirectTo = newState;
		}
		RouteError.prototype = Object.create(Error.prototype);
		RouteError.prototype.constructor = RouteError;

		RouteError.prototype.redirectTo = function(newState) {
			this._redirectTo = newState;
			return this;
		};
		RouteError.prototype.errorMessage = function(message) {
			this._errorMessage = message;
			return this;
		};
		RouteError.prototype.error = function(err) {
			this.stack = err.stack;
			return this;
		};
		RouteError.prototype.translatedErrorMessage = function(messageCode, messageParameters) {
			this._errorMessage = $translate.instant(messageCode, messageParameters);
			return this;
		};
		RouteError.prototype.getErrorMessage = function() {
			return this._errorMessage;
		};
		RouteError.prototype.getRedirectTo = function() {
			return this._redirectTo;
		};

		return RouteError;
	}

	function setupStateChangeHandlers($rootScope, $state, $log, $document, $location, AlertService, RouteError, HOME_PAGE) {

		// eslint-disable-next-line angular/on-watch
		$rootScope.$on('$stateChangeError', function(evt, newState, newStateParams, oldState, oldStateParams, error) {

			var message = 'Error when trying to reach ' + newState.name;
			if (oldState && oldState.name !== '') message += ' from ' + oldState.name;
			message += ':';
			console.warn(message, error);

			if (error instanceof RouteError) {
				error._from = oldState;
				error._to = newState;

				if (error.getErrorMessage()) {
					AlertService.error(error.getErrorMessage());
				}
				if (error.getRedirectTo()) {
					$state.go(error.getRedirectTo());
				}
			}

		});

		// eslint-disable-next-line angular/on-watch
		$rootScope.$on('$stateChangeSuccess', function() {
			$document[0].body.scrollTop = $document[0].documentElement.scrollTop = 0;
		});

	}

})();

(function () {
        'use strict';

        angular
            .module('theFoodApp')
            .controller('AppController', AppController);

        function AppController($scope, $timeout, $window, $document, $uibModalStack, NavBarToggle, DownloadAppToggle, SERVER_URL, Versione) {

            var vm = this;


            vm.headerView = function () {
                return SERVER_URL + 'static/layouts/header.html';
            };
            vm.footerView = function () {
                return SERVER_URL + 'static/layouts/footer.html';
            };
            vm.bannerView = function () {
                return SERVER_URL + 'static/pages/download-app.html';
            }

            // Interaface

            vm.showNavBar = NavBarToggle.showNavBar;
            vm.showDownloadApp = DownloadAppToggle.showDownloadAppPage;
            vm.notShowDownloadApp = DownloadAppToggle.notShowDownloadApp;
            vm.getBodyClasses = getBodyClasses;
            vm.dismissAllModals = dismissAllModals;
            vm.downloadApp = DownloadAppToggle.downloadApp;
            vm.isIosX = isIosX;

            // Implementation

            function isIosX() {
                if (window.device !== undefined && window.device.platform == "iOS" && (window.device.model == "iPhone10,3" || window.device.model == "iPhone10,6")) {
                    return true;
                } else {
                    return false;
                }
            }

            function getBodyClasses() {
                var classes = [];
                classes.push('no-breadcrumb');
                if (DownloadAppToggle.showDownloadAppPage()) {
                    classes.push('modal-open');
                }

                // Applica una classe apposta per iOS >= 7.0
                if (window.device !== undefined && window.device.platform == "iOS" && parseFloat(window.device.version) >= 7.0) {
                    classes.push('ios7-app');
                }
                return _.join(classes, ' ');
            }

            function dismissAllModals() {
                $uibModalStack.dismissAll();
            }

            // Possibile soluzione per il tasto back di Android. Probabilmente doppione di locationChangeStart.
            // document.addEventListener("backbutton", dismissAllModals, false);

            $scope.$on('$locationChangeStart', function (e) {

                // Se si sta andando indietro tramite browser con una modale aperta,
                // Chiudi la modale e impedisci il redirect.
                if ($uibModalStack.getTop()) {
                    $uibModalStack.dismissAll();
                    e.preventDefault();
                    return false;
                }

            });

            var timeout = null;
            $window.onresize = function () {
                $timeout.cancel(timeout);
                timeout = $timeout(_.bind($scope.$apply, $scope), 350);
            };

            return vm;
        }
    }

)();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('theFoodApp')
        .constant('APP_NAME', "RunnerPizza")
        .constant('APP_TITLE', "Runner Pizza")
        .constant('HOME_PAGE', "selezione-indirizzo")
        .constant('SERVER_URL', "")
        .constant('LINK_ANDROID_APP', "https://play.google.com/store/apps/details?id=it.sviluppopg.runnerpizza.ecommerce")
        .constant('LINK_IOS_APP', "https://itunes.apple.com/us/app/runnerpizza/id1353328805?l=it&ls=1&mt=8")
        .constant('VERSION', "1.1.66")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController ($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'userManagement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]

            },
            breadcrumb: {
                title: "{{ 'userManagement.home.title' | translate }}"
            }        })
        .state('user-management-detail', {
            parent: 'admin',
            url: '/user/:login',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management.new', {
            parent: 'user-management',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            parent: 'user-management',
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management.delete', {
            parent: 'user-management',
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            //hide anonymous user from user management: it's a required user for Spring Security
            var hiddenUsersSize = 0;
            for (var i in data) {
                if (data[i]['login'] === 'anonymoususer') {
                    data.splice(i, 1);
                    hiddenUsersSize++;
                }
            }
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count') - hiddenUsersSize;
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            },
            breadcrumb: {
                title: "{{ 'metrics.title' | translate }}"
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/jhipster/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            vm.cachesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
                if (key.indexOf('net.sf.ehcache.Cache') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    vm.cachesStats[newKey] = {
                        'name': newKey,
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            },
            breadcrumb: {
                title: "{{ 'logs.title' | translate }}"
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource', 'SERVER_URL'];

    function LogsService ($resource, SERVER_URL) {
        var service = $resource('management/jhipster/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            },
            breadcrumb: {
                title: "{{ 'health.title' | translate }}"
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('theFoodApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('theFoodApp')
        .controller('ElasticsearchReindexDialogController', ElasticsearchReindexDialogController);

    ElasticsearchReindexDialogController.$inject = ['$uibModalInstance', 'ElasticsearchReindex'];

    function ElasticsearchReindexDialogController($uibModalInstance, ElasticsearchReindex) {
        var vm = this;

        vm.clear = clear;
        vm.confirmReindex = confirmReindex;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmReindex() {
            ElasticsearchReindex.reindex(
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('theFoodApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('elasticsearch-reindex', {
            parent: 'admin',
            url: '/elasticsearch-reindex',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'elasticsearch.reindex.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/elasticsearch-reindex//elasticsearch-reindex.html',
                    controller: 'ElasticsearchReindexController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('elasticsearch-reindex');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            },
            breadcrumb: {
                title: "{{ 'elasticsearch.reindex.title' | translate }}"
            }
        }).state('elasticsearch-reindex.dialog', {
            parent: 'elasticsearch-reindex',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/elasticsearch-reindex//elasticsearch-reindex-dialog.html',
                    controller: 'ElasticsearchReindexDialogController',
                    controllerAs: 'vm',
                    size: 'sm'
                }).result.finally(function () {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('theFoodApp')
        .factory('ElasticsearchReindex', ElasticsearchReindex);

    ElasticsearchReindex.$inject = ['$resource', 'SERVER_URL', 'SERVER_URL'];

    function ElasticsearchReindex($resource, SERVER_URL) {
        var service = $resource(SERVER_URL+'api/elasticsearch/index', {}, {
            'reindex': {method: 'POST'}
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('theFoodApp')
        .controller('ElasticsearchReindexController', ElasticsearchReindexController);

    ElasticsearchReindexController.$inject = [];

    function ElasticsearchReindexController() {
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            },
            breadcrumb: {
                title: "{{ 'global.menu.admin.apidocs' | translate }}"
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            },
            breadcrumb: {
                title: "{{ 'configuration.title' | translate }}"
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            },
            breadcrumb: {
                title: "{{ 'audits.title' | translate }}"
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource', 'SERVER_URL'];

    function AuditsService ($resource, SERVER_URL) {
        var service = $resource('management/jhipster/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('theFoodApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .controller('SocialRegisterController', SocialRegisterController);

    SocialRegisterController.$inject = ['$filter', '$stateParams'];

    function SocialRegisterController ($filter, $stateParams) {
        var vm = this;

        vm.success = $stateParams.success;
        vm.error = !vm.success;
        vm.provider = $stateParams.provider;
        vm.providerLabel = $filter('capitalize')(vm.provider);
        vm.success = $stateParams.success;
    }
})();

(function () {
    'use strict';

    angular
        .module('theFoodApp')
        .controller('SocialAuthController', SocialAuthController);

    SocialAuthController.$inject = ['$state', '$cookies', 'Auth'];

    function SocialAuthController($state, $cookies, Auth) {
        var token = $cookies.get('social-authentication');
        
        Auth.loginWithToken(token).then(function () {
            $cookies.remove('social-authentication');
            Auth.authorize(true);
            var redirect = $cookies.getObject('social-redirect');
            if (angular.isDefined(redirect)){
            	$cookies.remove('social-redirect');
            	location.href =redirect;
            }else{
            	 $state.go('home');
            }
            $cookies.putObject('social-redirect', $state.current);
        }, function () {
            $state.go('social-register', {'success': 'false'});
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('theFoodApp')
        .controller('SocialAppleController', SocialAppleController);

    SocialAppleController.$inject = ['$filter', '$stateParams', 'Auth', '$state'];

    function SocialAppleController($filter, $stateParams, Auth, $state) {
        var vm = this;
        vm.success = $stateParams.success;
        if (vm.success === 'true') {
            vm.token = $stateParams.token;
            let dto = {
                identityToken: vm.token
            }
            Auth.loginWithApple(dto).then(function () {
                return $state.go('landing');
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('social-register', {
            parent: 'account',
            url: '/social-register/:provider?{success:boolean}',
            data: {
                authorities: [],
                pageTitle: 'social.register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/social/social-register.html',
                    controller: 'SocialRegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('social');
                    return $translate.refresh();
                }]
            }
        })
        .state('social-auth', {
            parent: 'account',
            url: '/social-auth',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    controller: 'SocialAuthController'
                }
            }
        }).state('social-apple',{
            parent: 'account',
            url: '/social-apple/?{success:string}&{token:string}',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/social/social-apple.html',
                    controller: 'SocialAppleController',
                    controllerAs: 'vm'
                }
            }
        })
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .factory('SocialService', SocialService);

    SocialService.$inject = ['$http', '$cookies'];

    function SocialService ($http, $cookies) {
        var socialService = {
            getProviderSetting: getProviderSetting,
            getProviderURL: getProviderURL,
            getCSRF: getCSRF
        };

        return socialService;

        function getProviderSetting (provider) {
            switch(provider) {
            case 'google': return 'https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email';
            case 'facebook': return 'public_profile,email';
            case 'twitter': return '';
                // jhipster-needle-add-social-button
            default: return 'Provider setting not defined';
            }
        }

        function getProviderURL (provider) {
            return 'signin/' + provider;
        }

        function getCSRF () {
            return $cookies.get($http.defaults.xsrfCookieName);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .directive('jhSocial', jhSocial);

    jhSocial.$inject = ['$translatePartialLoader', '$translate', '$filter', 'SocialService','$cookies','$location'];

    function jhSocial($translatePartialLoader, $translate, $filter, SocialService,$cookies,$location) {
        var directive = {
            restrict: 'E',
            scope: {
                provider: '@ngProvider'
            },
            templateUrl: 'app/account/social/directive/social.html',
            link: linkFunc
        };

        return directive;

        /* private helper methods */

        function linkFunc(scope) {
            
            $translatePartialLoader.addPart('social');
            $translate.refresh();
            
            scope.saveState = function(){
            	if (!($location.$$absUrl.indexOf('social-register')>-1 && $cookies.get('social-redirect')!=null)){
            		$cookies.putObject('social-redirect', $location.$$absUrl);
            	}
            	
            };
            
            scope.label = $filter('capitalize')(scope.provider);
            scope.providerSetting = SocialService.getProviderSetting(scope.provider);
            scope.providerURL = SocialService.getProviderURL(scope.provider);
            scope.csrf = SocialService.getCSRF();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            },
            breadcrumb: {
                title: "{{ 'reset.request.title' | translate }}"
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            },
            breadcrumb: {
                title: "{{ 'reset.finish.title' | translate }}"
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            params: {
                redirectUrl: ''
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    $translatePartialLoader.addPart('cliente');
                    return $translate.refresh();
                }]
            },
            breadcrumb: {
                title: "{{ 'register.title' | translate }}"
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .controller('RegisterController', RegisterController);

    function RegisterController($translate, $timeout, Auth, LoginService, $state, $stateParams, $anchorScroll) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;
        vm.goPrivacyPolicy = goPrivacyPolicy;

        //garante della privacy
        // vm.registerAccount.consensoCondizioni = vm.registerAccount.consensoCondizioni ? vm.registerAccount.consensoCondizioni : true;
        // vm.registerAccount.consensoProfilazione = vm.registerAccount.consensoProfilazione ? vm.registerAccount.consensoProfilazione : true;;
        // vm.registerAccount.consensoCommerciale = vm.registerAccount.consensoCommerciale ? vm.registerAccount.consensoCommerciale : true;;

        vm.genderList = [{
                "id": "M",
                "value": 'global.form.genderMale'
            },
            {
                "id": "F",
                "value": 'global.form.genderFemale'
            }
        ];

        vm.datepickerOptions = {
            showWeeks: false,
            maxDate: new Date()
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dataDiNascita = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function register() {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
                $anchorScroll();
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;
                vm.errorPhoneExists = null;
                vm.registerAccount.login = vm.registerAccount.email;
                Auth.createAccount(vm.registerAccount).then(function() {
                    vm.success = 'OK';
                }).then(function() {
                    /**
                     * Quando la registrazione è completata,
                     * pusho l'evento.
                     */
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'registrationComplete'
                    });
                }).then(function() {
                    return autoLoginAndRedirect();
                }).catch(function(response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                        $anchorScroll();
                    } else if (response.status === 400 && response.data === 'e-mail address already in use') {
                        vm.errorEmailExists = 'ERROR';
                        $anchorScroll();
                    } else if (response.status === 400 && response.data === 'phone number already in use') {
                        vm.errorPhoneExists = 'ERROR';
                        $anchorScroll();
                    } else {
                        vm.error = 'ERROR';
                        $anchorScroll();
                    }
                });
            }
        }

        function goPrivacyPolicy(){
            $state.go('static-page.privacy-policy');
        }

        // Login automatico dopo registrazione e redirect diretto sulla
        // pagina di concludi-acquisto se registrazione effettuata in fase di ordinazione
        function autoLoginAndRedirect() {
            return Auth.login({
                username: vm.registerAccount.email,
                password: vm.registerAccount.password,
                rememberMe: true
            }).then(function() {
                location.href = $stateParams.redirectUrl;
            });
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small data-translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar" style="padding:0">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    if ( !p || !p.length )
                        return 0;

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penality (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penality (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 0) {
                        idx = 0;
                    }
                    else if (s <= 10) {
                        idx = 1;
                    }
                    else if (s <= 20) {
                        idx = 2;
                    }
                    else if (s <= 30) {
                        idx = 3;
                    }
                    else if (s <= 40) {
                        idx = 4;
                    }
                    else {
                        idx = 5;
                    }

                    return { idx: idx, col: this.colors[idx - 1] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                var c = strength.getColor(strength.mesureStrength(password));
                iElement.removeClass('ng-hide');
                iElement.find('ul').children('li')
                    .css({ 'background-color': '#DDD' })
                    .slice(0, c.idx)
                    .css({ 'background-color': c.col });
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            },
            breadcrumb: {
                title: "{{ 'activate.title' | translate }}"
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('theFoodApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('theFoodApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/account/register/register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><div class="alert alert-success" ng-show="vm.success"><div data-translate="register.messages.success"></div><a ui-sref="landing" data-translate="go.home">Clicca qui per tornare alla home.</a></div><div class="alert alert-danger" ng-show="vm.error" data-translate="register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists" data-translate="register.messages.error.userexists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists" data-translate="register.messages.error.emailexists"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorPhoneExists" data-translate="register.messages.error.phoneexists"><strong>Phone number is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div></div><div class="col-md-10 col-md-offset-1"><form ng-show="!vm.success" name="form" role="form" ng-submit="vm.register()" show-validation><div class="row"><div class="form-group col-md-6"><label class="control-label" for="name" data-translate="global.form.name">Name</label><input type="text" class="form-control" id="name" name="name" placeholder="{{\'global.form.name.placeholder\' | translate}}" ng-model="vm.registerAccount.firstName" ng-maxlength="50" ng-pattern="/^[A-Za-z\\s\xE8\xE9\xF2\xE0\xF9\xEC]*$/" required><div ng-show="form.name.$dirty && form.name.$invalid"><p class="help-block" ng-show="form.name.$error.required" data-translate="register.messages.validate.name.required">Your name is required.</p><p class="help-block" ng-show="form.name.$error.maxlength" data-translate="register.messages.validate.name.maxlength">Your name cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.name.$error.pattern" data-translate="register.messages.validate.name.pattern">Your name can only contain letters.</p></div></div><div class="form-group col-md-6"><label class="control-label" for="surname" data-translate="global.form.surname">Surname</label><input type="text" class="form-control" id="surname" name="surname" placeholder="{{\'global.form.surname.placeholder\' | translate}}" ng-model="vm.registerAccount.lastName" ng-maxlength="50" ng-pattern="/^[A-Za-z\'\\s\xE8\xE9\xF2\xE0\xF9\xEC]*$/" required><div ng-show="form.surname.$dirty && form.surname.$invalid"><p class="help-block" ng-show="form.surname.$error.required" data-translate="register.messages.validate.surname.required">Your surname is required.</p><p class="help-block" ng-show="form.surname.$error.maxlength" data-translate="register.messages.validate.surname.maxlength">Your surname cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.surname.$error.pattern" data-translate="register.messages.validate.surname.pattern">Your surname can only contain letters.</p></div></div></div><div class="row"><div class="form-group col-md-6"><label class="control-label" for="field_dataDiNascita" data-translate="global.form.dateOfBirth">Data di nascita</label><div class="input-group"><input type="text" class="form-control" id="field_dataDiNascita" name="dataDiNascita" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.registerAccount.dataDiNascita" is-open="vm.datePickerOpenStatus.dataDiNascita" placeholder="{{\'global.form.dateOfBirth.placeholder\' | translate}}" show-button-bar="false" datepicker-options="vm.datepickerOptions" ng-pattern="/^(?:(?:(?:0[1-9]|1\\d|2[0-8])\\/(?:0[1-9]|1[0-2])|(?:29|30)\\/(?:0[13-9]|1[0-2])|31\\/(?:0[13578]|1[02]))\\/[1-9]\\d{3}|29\\/02\\/(?:[1-9]\\d(?:0[48]|[2468][048]|[13579][26])|(?:[2468][048]|[13579][26])00))$/"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dataDiNascita\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="form.dataDiNascita.$invalid"><p class="help-block" ng-show="form.dataDiNascita.$error" data-translate="global.form.dateOfBirth.pattern">Data di nascita non valida.</p></div></div><div class="col-md-6"><label class="control-label" for="gender" data-translate="global.form.gender">Sesso</label><select class="form-control" id="gender" name="gender" ng-model="vm.registerAccount.sesso"><option ng-repeat="gender in vm.genderList" value="{{gender.id}}">{{gender.value | translate}}</option></select></div></div><div class="row"><!--<div class="form-group col-md-6">\n                        <label class="control-label" for="login" data-translate="global.form.username">Username</label>\n                        <input type="text" class="form-control" id="login" name="login" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.registerAccount.login" ng-minlength=1 ng-maxlength=50 ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required>\n                        <div ng-show="form.login.$dirty && form.login.$invalid">\n                            <p class="help-block" ng-show="form.login.$error.required" data-translate="register.messages.validate.login.required">\n                                Your username is required.\n                            </p>\n                            <p class="help-block" ng-show="form.login.$error.minlength" data-translate="register.messages.validate.login.minlength">\n                                Your username is required to be at least 1 character.\n                            </p>\n                            <p class="help-block" ng-show="form.login.$error.maxlength" data-translate="register.messages.validate.login.maxlength">\n                                Your username cannot be longer than 50 characters.\n                            </p>\n                            <p class="help-block" ng-show="form.login.$error.pattern" data-translate="register.messages.validate.login.pattern">\n                                Your username can only contain lower-case letters and digits.\n                            </p>\n                        </div>\n                    </div>--><div class="form-group col-md-6"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" pattern="^.+@.+\\..+$" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email || form.email.$error.pattern" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group col-md-6"><label class="control-label" for="telefono" data-translate="global.form.telefono">E-mail</label><input type="text" class="form-control" id="telefono" name="telefono" placeholder="{{\'global.form.telefono.placeholder\' | translate}}" ng-model="vm.registerAccount.telefono" ng-minlength="5" ng-maxlength="50" telefono><div ng-show="form.telefono.$dirty && form.telefono.$invalid"><p class="help-block" ng-show="form.telefono.$error.required" data-translate="global.messages.validate.telefono.required">Your phone number is required.</p><p class="help-block" ng-show="form.telefono.$error.telefono || form.telefono.$error.pattern" data-translate="global.messages.validate.telefono.invalid">Your phone number is invalid.</p><p class="help-block" ng-show="form.telefono.$error.minlength" data-translate="global.messages.validate.telefono.minlength">Your phone number is required to be at least 5 characters.</p><p class="help-block" ng-show="form.telefono.$error.maxlength" data-translate="global.messages.validate.telefono.maxlength">Your phone number cannot be longer than 50 characters.</p></div></div><!--<div class="form-group col-md-6">\n                        <label class="control-label" for="password" data-translate="global.form.newpassword">New password</label>\n                        <input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.registerAccount.password" ng-minlength=4 ng-maxlength=50 required ng-model-options="{ debounce: 250 }">\n                        <div ng-show="form.password.$dirty && form.password.$invalid">\n                            <p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">\n                                Your password is required.\n                            </p>\n                            <p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">\n                                Your password is required to be at least 4 characters.\n                            </p>\n                            <p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">\n                                Your password cannot be longer than 50 characters.\n                            </p>\n                        </div>\n                    </div>--></div><div class="row"><!--<div class="form-group col-md-6">\n                        <label class="control-label" for="password" data-translate="global.form.newpassword">New password</label>\n                        <input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.registerAccount.password" ng-minlength=4 ng-maxlength=50 required ng-model-options="{ debounce: 250 }">\n                        <div ng-show="form.password.$dirty && form.password.$invalid">\n                            <p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">\n                                Your password is required.\n                            </p>\n                            <p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">\n                                Your password is required to be at least 4 characters.\n                            </p>\n                            <p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">\n                                Your password cannot be longer than 50 characters.\n                            </p>\n                        </div>\n                    </div>--><div class="form-group col-md-6"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required ng-model-options="{ debounce: 250 }"><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div></div><div class="form-group col-md-6"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div></div><div class="row text-center" style="margin:10px 0"><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="row text-center"><div class="form-group col-sm-4"><input type="checkbox" class="checkbox form-control" name="consensoCondizioni" id="field_consensoCondizioni" ng-model="vm.registerAccount.consensoCondizioni" required><label class="control-label" for="field_consensoCondizioni"><a target="_blank" ng-click="vm.goPrivacyPolicy()"><span class="control-label" data-translate="theFoodApp.cliente.consensoCondizioni">Consenso Condizioni </span></a><span class="control-label" data-translate="theFoodApp.cliente.e">e </span><a target="_blank" href="http://www.iubenda.com/privacy-policy/58074298"><span class="control-label" data-translate="theFoodApp.cliente.consensoPrivacyPolicy">Privacy Policy</span></a></label><div ng-show="form.consensoCondizioni.$error.required && form.consensoCondizioni.$dirty"><p class="help-block" data-translate="theFoodApp.cliente.consensoCondizioniRichiesto"></p></div></div><div class="form-group col-sm-4"><input type="checkbox" class="checkbox" name="consensoProfilazione" id="field_consensoProfilazione" ng-model="vm.registerAccount.consensoProfilazione"><label class="control-label" for="field_consensoProfilazione" data-translate="theFoodApp.cliente.consensoProfilazione">Consenso Profilazione</label><p class="messaggio-consenso" data-translate="theFoodApp.cliente.consensoProfilazioneMessaggio"></p></div><div class="form-group col-sm-4"><input type="checkbox" class="checkbox" name="consensoCommerciale" id="field_consensoCommerciale" ng-model="vm.registerAccount.consensoCommerciale" ng-false-value="\'false\'"><label class="control-label" for="field_consensoCommerciale" data-translate="theFoodApp.cliente.consensoCommerciale">Consenso Commerciale</label><p class="messaggio-consenso" data-translate="theFoodApp.cliente.consensoCommercialeMessaggio"></p></div></div><br><div class="row text-center"><button type="submit" ng-class="{\'disabled\' : form.$invalid}" class="elementor-button-primary lg search-btn" data-translate="register.form.button">Register</button></div></form></div></div></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><div class="alert alert-success" ng-show="vm.success" data-translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="elementor-button-primary lg" data-translate="password.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" data-translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label for="langKey" data-translate="settings.form.language">Language</label><select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="settings.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/social/social-apple.html','<div class="alert alert-success" ng-show="vm.success === \'true\'" data-translate="social.login.success">Sign In completed</div><div class="alert alert-danger" ng-show="vm.success === \'false\'" data-translate="social.login.error">Signin Failed</div>');
$templateCache.put('app/account/social/social-register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 ng-show="success" data-translate="social.register.title" translate-values="{ label: vm.providerLabel }">Registration with</h1><h1 ng-show="error" data-translate="social.register.errorTitle">Registration</h1><div class="alert alert-success" ng-show="vm.success" data-translate="social.register.messages.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="social.register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><jh-social ng-if="vm.success" ng-provider="{{ vm.provider }}"></jh-social></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><div class="row"><div class="col-md-5"><h4 data-translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" data-translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" data-translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span data-translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span data-translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span data-translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span data-translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span data-translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" style="background-color:white"></iframe>');
$templateCache.put('app/admin/configuration/configuration.html','<div><span data-translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span data-translate="configuration.table.prefix">Prefix</span></th><th data-translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/elasticsearch-reindex/elasticsearch-reindex-dialog.html','<form name="reindexForm" ng-submit="vm.confirmReindex()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="elasticsearch.reindex.dialog.title">Confirm reindex operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="elasticsearch.reindex.dialog.question">Are you sure you want to reindex Elasticsearch? This could take a while!</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span data-translate="elasticsearch.reindex.dialog.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-exclamation-sign"></span>&nbsp; <span data-translate="elasticsearch.reindex.dialog.confirm">Reindex</span></button></div></form>');
$templateCache.put('app/admin/elasticsearch-reindex/elasticsearch-reindex.html','<div class="clearfix"><jhi-alert></jhi-alert><p data-translate="elasticsearch.reindex.instructions1">This will send a request to reindex all data from your primary datasource into Elasticsearch. This will fix missing data and mapping issues, however you will lose any ES data and mapping that was defined outside of your application. This request will return immediately and the reindexing will run in the background. You will see "Elasticsearch: Successfully performed reindexing" in your logs when this is complete.</p><p data-translate="elasticsearch.reindex.instructions2">This can take a long time and is susceptible to concurrency issues so it should be performed when the number of users is low.</p><br><p class="text-center"><button type="button" class="btn btn-primary" ui-sref="elasticsearch-reindex.dialog"><span class="glyphicon glyphicon-exclamation-sign"></span> <span data-translate="elasticsearch.reindex.go">Go</span></button></p></div>');
$templateCache.put('app/admin/health/health.html','<div><p class="text-center"><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" data-translate="health.table.service">Service Name</th><th class="col-md-2 text-center" data-translate="health.table.status">Status</th><th class="col-md-2 text-center" data-translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 data-translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" data-translate="health.details.name">Name</th><th class="col-md-6 text-left" data-translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 data-translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span data-translate="userManagement.detail.title">User</span> "{{vm.user.login}}"</h2><dl class="dl-horizontal"><dt><span data-translate="userManagement.login">Login</span></dt><dd><span>{{vm.user.login}}</span></dd><dt><span data-translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span data-translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span data-translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span data-translate="userManagement.activated">Activated</span></dt><dd>{{vm.user.activated}}</dd><dt><span data-translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span data-translate="userManagement.createdBy">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span data-translate="userManagement.createdDate">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span data-translate="userManagement.lastModifiedBy">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span data-translate="userManagement.profiles">Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span>{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="userManagement.home.createOrEditLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label data-translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="userManagement.login">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" ng-required="vm.user.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.firstName">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label data-translate="userManagement.lastName">Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.email">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span data-translate="userManagement.activated">Activated</span></label></div><div class="form-group"><label data-translate="userManagement.langKey">Lang Key</label><select class="form-control" name="langKey" ng-model="vm.user.langKey" ng-options="language as language for language in vm.languages track by language"></select></div><div class="form-group"><label data-translate="userManagement.profiles">Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><jhi-alert></jhi-alert><div class="text-center"><button class="btn btn-primary" ui-sref="user-management.new"><span class="glyphicon glyphicon-flash"></span> <span data-translate="userManagement.home.createLabel">Create a new User</span></button></div><div class="table-responsive"><table class="table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span data-translate="userManagement.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="userManagement.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th jh-sort-by="langKey"><span data-translate="userManagement.langKey">Lang Key</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="userManagement.profiles">Profiles</span></th><th jh-sort-by="createdDate"><span data-translate="userManagement.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span data-translate="userManagement.lastModifiedBy">Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><span class="label label-danger" ng-click="vm.setActive(user, true)" ng-show="!user.activated" data-translate="userManagement.deactivated" style="cursor: pointer">Deactivated</span> <span class="label label-success" ng-click="vm.setActive(user, false)" ng-show="user.activated" data-translate="userManagement.activated" style="cursor: pointer">Activated</span></td><td>{{user.langKey}}</td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login==user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><p data-translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span data-translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span data-translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span data-translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><p class="text-center"><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="metrics.refresh.button">Refresh</span></button></p><h3 data-translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b data-translate="metrics.jvm.memory.title">Memory</b><p><span data-translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span data-translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" data-translate="metrics.updating">Updating...</div><h3 data-translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span data-translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span data-translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.jvm.http.table.code">Code</th><th data-translate="metrics.jvm.http.table.count">Count</th><th class="text-right" data-translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td data-translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" data-translate="metrics.servicesstats.table.count">Count</th><th class="text-right" data-translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" data-translate="metrics.servicesstats.table.min">Min</th><th class="text-right" data-translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" data-translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" data-translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" data-translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" data-translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 data-translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span data-translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" data-translate="metrics.datasource.count">Count</th><th class="text-right" data-translate="metrics.datasource.mean">Mean</th><th class="text-right" data-translate="metrics.datasource.min">Min</th><th class="text-right" data-translate="metrics.datasource.p50">p50</th><th class="text-right" data-translate="metrics.datasource.p75">p75</th><th class="text-right" data-translate="metrics.datasource.p95">p95</th><th class="text-right" data-translate="metrics.datasource.p99">p99</th><th class="text-right" data-translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" data-translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" data-translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th data-translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/entities/insegna/insegna-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.insegna.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="theFoodApp.insegna.delete.question" translate-values="{id: \'{{vm.insegna.id}}\'}">Are you sure you want to delete this Insegna?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/insegna/insegna-detail.html','<div><h2><span data-translate="theFoodApp.insegna.detail.title">Insegna</span> {{vm.insegna.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="theFoodApp.insegna.insegna">Insegna</span></dt><dd><span>{{vm.insegna.insegna}}</span></dd><dt><span data-translate="theFoodApp.insegna.descrizioneIt">Descrizione It</span></dt><dd><span>{{vm.insegna.descrizioneIt}}</span></dd><dt><span data-translate="theFoodApp.insegna.descrizioneEn">Descrizione En</span></dt><dd><span>{{vm.insegna.descrizioneEn}}</span></dd><dt><span data-translate="theFoodApp.insegna.sortOrder">Sort Order</span></dt><dd><span>{{vm.insegna.sortOrder}}</span></dd><dt><span data-translate="theFoodApp.insegna.consGratisOltreSoglia">Cons Gratis Oltre Soglia</span></dt><dd><span>{{vm.insegna.consGratisOltreSoglia}}</span></dd><dt><span data-translate="theFoodApp.insegna.sogliaConsGratis">Soglia Cons Gratis</span></dt><dd><span>{{vm.insegna.sogliaConsGratis}}</span></dd><dt><span data-translate="theFoodApp.insegna.cosConsPrnzZona1">Cos Cons Prnz Zona 1</span></dt><dd><span>{{vm.insegna.cosConsPrnzZona1}}</span></dd><dt><span data-translate="theFoodApp.insegna.cosConsCenaZona1">Cos Cons Cena Zona 1</span></dt><dd><span>{{vm.insegna.cosConsCenaZona1}}</span></dd><dt><span data-translate="theFoodApp.insegna.impMinConsZona1">Imp Min Cons Zona 1</span></dt><dd><span>{{vm.insegna.impMinConsZona1}}</span></dd><dt><span data-translate="theFoodApp.insegna.cosConsPrnzZona2">Cos Cons Prnz Zona 2</span></dt><dd><span>{{vm.insegna.cosConsPrnzZona2}}</span></dd><dt><span data-translate="theFoodApp.insegna.cosConsCenaZona2">Cos Cons Cena Zona 2</span></dt><dd><span>{{vm.insegna.cosConsCenaZona2}}</span></dd><dt><span data-translate="theFoodApp.insegna.impMinConsZona2">Imp Min Cons Zona 2</span></dt><dd><span>{{vm.insegna.impMinConsZona2}}</span></dd><dt><span data-translate="theFoodApp.insegna.tipoConsegna">Tipo Consegna</span></dt><dd><span>{{vm.insegna.tipoConsegna}}</span></dd><dt><span data-translate="theFoodApp.insegna.ordiniBanco">Ordini Banco</span></dt><dd><span>{{vm.insegna.ordiniBanco}}</span></dd><dt><span data-translate="theFoodApp.insegna.stato">Stato</span></dt><dd><span>{{vm.insegna.stato}}</span></dd><dt><span data-translate="theFoodApp.insegna.tipologiaLocale">Tipologia Locale</span></dt><dd><span ng-repeat="tipologiaLocale in vm.insegna.tipologiaLocales"><a ui-sref="tipologia-locale-detail({id: tipologiaLocale.id})">{{tipologiaLocale.id}}</a>{{$last ? \'\' : \', \'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="insegna-detail.edit({id:vm.insegna.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/insegna/insegna-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myInsegnaLabel" data-translate="theFoodApp.insegna.home.createOrEditLabel">Create or edit a Insegna</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.insegna.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.insegna.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="theFoodApp.insegna.insegna" for="field_insegna">Insegna</label><input type="text" class="form-control" name="insegna" id="field_insegna" ng-model="vm.insegna.insegna" required><div ng-show="editForm.insegna.$invalid"><p class="help-block" ng-show="editForm.insegna.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="theFoodApp.insegna.descrizioneIt" for="field_descrizioneIt">Descrizione It</label><input type="text" class="form-control" name="descrizioneIt" id="field_descrizioneIt" ng-model="vm.insegna.descrizioneIt"></div><div class="form-group"><label class="control-label" data-translate="theFoodApp.insegna.descrizioneEn" for="field_descrizioneEn">Descrizione En</label><input type="text" class="form-control" name="descrizioneEn" id="field_descrizioneEn" ng-model="vm.insegna.descrizioneEn"></div><div class="form-group"><label class="control-label" data-translate="theFoodApp.insegna.sortOrder" for="field_sortOrder">Sort Order</label><input type="number" class="form-control" name="sortOrder" id="field_sortOrder" ng-model="vm.insegna.sortOrder"></div><div class="form-group"><label class="control-label" data-translate="theFoodApp.insegna.consGratisOltreSoglia" for="field_consGratisOltreSoglia">Cons Gratis Oltre Soglia</label><input type="checkbox" class="form-control" name="consGratisOltreSoglia" id="field_consGratisOltreSoglia" ng-model="vm.insegna.consGratisOltreSoglia"><div ng-show="editForm.consGratisOltreSoglia.$invalid"><p class="help-block" ng-show="editForm.consGratisOltreSoglia.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="theFoodApp.insegna.sogliaConsGratis" for="field_sogliaConsGratis">Soglia Cons Gratis</label><input type="number" class="form-control" name="sogliaConsGratis" id="field_sogliaConsGratis" ng-model="vm.insegna.sogliaConsGratis"></div><div class="form-group"><label class="control-label" data-translate="theFoodApp.insegna.cosConsPrnzZona1" for="field_cosConsPrnzZona1">Cos Cons Prnz Zona 1</label><input type="number" class="form-control" name="cosConsPrnzZona1" id="field_cosConsPrnzZona1" ng-model="vm.insegna.cosConsPrnzZona1"></div><div class="form-group"><label class="control-label" data-translate="theFoodApp.insegna.cosConsCenaZona1" for="field_cosConsCenaZona1">Cos Cons Cena Zona 1</label><input type="number" class="form-control" name="cosConsCenaZona1" id="field_cosConsCenaZona1" ng-model="vm.insegna.cosConsCenaZona1"></div><div class="form-group"><label class="control-label" data-translate="theFoodApp.insegna.impMinConsZona1" for="field_impMinConsZona1">Imp Min Cons Zona 1</label><input type="number" class="form-control" name="impMinConsZona1" id="field_impMinConsZona1" ng-model="vm.insegna.impMinConsZona1"></div><div class="form-group"><label class="control-label" data-translate="theFoodApp.insegna.cosConsPrnzZona2" for="field_cosConsPrnzZona2">Cos Cons Prnz Zona 2</label><input type="number" class="form-control" name="cosConsPrnzZona2" id="field_cosConsPrnzZona2" ng-model="vm.insegna.cosConsPrnzZona2"></div><div class="form-group"><label class="control-label" data-translate="theFoodApp.insegna.cosConsCenaZona2" for="field_cosConsCenaZona2">Cos Cons Cena Zona 2</label><input type="number" class="form-control" name="cosConsCenaZona2" id="field_cosConsCenaZona2" ng-model="vm.insegna.cosConsCenaZona2"></div><div class="form-group"><label class="control-label" data-translate="theFoodApp.insegna.impMinConsZona2" for="field_impMinConsZona2">Imp Min Cons Zona 2</label><input type="number" class="form-control" name="impMinConsZona2" id="field_impMinConsZona2" ng-model="vm.insegna.impMinConsZona2"></div><div class="form-group"><label class="control-label" data-translate="theFoodApp.insegna.tipoConsegna" for="field_tipoConsegna">Tipo Consegna</label><input type="text" class="form-control" name="tipoConsegna" id="field_tipoConsegna" ng-model="vm.insegna.tipoConsegna" ng-maxlength="1"><div ng-show="editForm.tipoConsegna.$invalid"><p class="help-block" ng-show="editForm.tipoConsegna.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="1">This field cannot be longer than 1 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="theFoodApp.insegna.ordiniBanco" for="field_ordiniBanco">Ordini Banco</label><input type="text" class="form-control" name="ordiniBanco" id="field_ordiniBanco" ng-model="vm.insegna.ordiniBanco" ng-maxlength="1"><div ng-show="editForm.ordiniBanco.$invalid"><p class="help-block" ng-show="editForm.ordiniBanco.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="1">This field cannot be longer than 1 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="theFoodApp.insegna.stato" for="field_stato">Stato</label><input type="text" class="form-control" name="stato" id="field_stato" ng-model="vm.insegna.stato" ng-maxlength="1"><div ng-show="editForm.stato.$invalid"><p class="help-block" ng-show="editForm.stato.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="1">This field cannot be longer than 1 characters.</p></div></div><div class="form-group"><label data-translate="theFoodApp.insegna.tipologiaLocale" for="field_tipologiaLocale">Tipologia Locale</label><select class="form-control" id="field_tipologiaLocale" multiple="multiple" name="tipologiaLocale" ng-model="vm.insegna.tipologiaLocales" ng-options="tipologiaLocale as tipologiaLocale.id for tipologiaLocale in vm.tipologialocales track by tipologiaLocale.id"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/insegna/insegnas.html','<div><h2 data-translate="theFoodApp.insegna.home.title">Insegnas</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="insegna.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" data-translate="theFoodApp.insegna.home.createLabel">Create new Insegna</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'theFoodApp.insegna.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="insegna"><span data-translate="theFoodApp.insegna.insegna">Insegna</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descrizioneIt"><span data-translate="theFoodApp.insegna.descrizioneIt">Descrizione It</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descrizioneEn"><span data-translate="theFoodApp.insegna.descrizioneEn">Descrizione En</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="sortOrder"><span data-translate="theFoodApp.insegna.sortOrder">Sort Order</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="consGratisOltreSoglia"><span data-translate="theFoodApp.insegna.consGratisOltreSoglia">Cons Gratis Oltre Soglia</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="sogliaConsGratis"><span data-translate="theFoodApp.insegna.sogliaConsGratis">Soglia Cons Gratis</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cosConsPrnzZona1"><span data-translate="theFoodApp.insegna.cosConsPrnzZona1">Cos Cons Prnz Zona 1</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cosConsCenaZona1"><span data-translate="theFoodApp.insegna.cosConsCenaZona1">Cos Cons Cena Zona 1</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="impMinConsZona1"><span data-translate="theFoodApp.insegna.impMinConsZona1">Imp Min Cons Zona 1</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cosConsPrnzZona2"><span data-translate="theFoodApp.insegna.cosConsPrnzZona2">Cos Cons Prnz Zona 2</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cosConsCenaZona2"><span data-translate="theFoodApp.insegna.cosConsCenaZona2">Cos Cons Cena Zona 2</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="impMinConsZona2"><span data-translate="theFoodApp.insegna.impMinConsZona2">Imp Min Cons Zona 2</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipoConsegna"><span data-translate="theFoodApp.insegna.tipoConsegna">Tipo Consegna</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="ordiniBanco"><span data-translate="theFoodApp.insegna.ordiniBanco">Ordini Banco</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="stato"><span data-translate="theFoodApp.insegna.stato">Stato</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="insegna in vm.insegnas track by insegna.id"><td><a ui-sref="insegna-detail({id:insegna.id})">{{insegna.id}}</a></td><td>{{insegna.insegna}}</td><td>{{insegna.descrizioneIt}}</td><td>{{insegna.descrizioneEn}}</td><td>{{insegna.sortOrder}}</td><td>{{insegna.consGratisOltreSoglia}}</td><td>{{insegna.sogliaConsGratis}}</td><td>{{insegna.cosConsPrnzZona1}}</td><td>{{insegna.cosConsCenaZona1}}</td><td>{{insegna.impMinConsZona1}}</td><td>{{insegna.cosConsPrnzZona2}}</td><td>{{insegna.cosConsCenaZona2}}</td><td>{{insegna.impMinConsZona2}}</td><td>{{insegna.tipoConsegna}}</td><td>{{insegna.ordiniBanco}}</td><td>{{insegna.stato}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="insegna-detail({id:insegna.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="insegna.edit({id:insegna.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="insegna.delete({id:insegna.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/ordine/ordine-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.ordine.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="theFoodApp.ordine.delete.question" translate-values="{id: \'{{vm.ordine.id}}\'}">Are you sure you want to delete this Ordine?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/ordine/ordine-detail.html','<div><h2><span data-translate="theFoodApp.ordine.detail.title">Ordine</span> {{vm.ordine.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="theFoodApp.ordine.tipoOrdine">Tipo Ordine</span></dt><dd><span data-translate="{{\'theFoodApp.TipoOrdine.\' + vm.ordine.tipoOrdine}}">{{vm.ordine.tipoOrdine}}</span></dd><dt><span data-translate="theFoodApp.ordine.statoOrdine">Stato Ordine</span></dt><dd><span data-translate="{{\'theFoodApp.StatoOrdine.\' + vm.ordine.statoOrdine}}">{{vm.ordine.statoOrdine}}</span></dd><dt><span data-translate="theFoodApp.ordine.dataOrdine">Data Ordine</span></dt><dd><span>{{vm.ordine.dataOrdine | date:\'medium\'}}</span></dd><dt><span data-translate="theFoodApp.ordine.totaleOrdine">Totale Ordine</span></dt><dd><span>{{vm.ordine.totaleOrdine}}</span></dd><dt><span data-translate="theFoodApp.ordine.dataConsegna">Data Consegna</span></dt><dd><span>{{vm.ordine.dataConsegna | date:\'mediumDate\'}}</span></dd><dt><span data-translate="theFoodApp.ordine.tipoOrarioConsegna">Tipo Orario Consegna</span></dt><dd><span data-translate="{{\'theFoodApp.TipoOrarioConsegna.\' + vm.ordine.tipoOrarioConsegna}}">{{vm.ordine.tipoOrarioConsegna}}</span></dd><dt><span data-translate="theFoodApp.ordine.orarioConsegna">Orario Consegna</span></dt><dd><span>{{vm.ordine.orarioConsegna}}</span></dd><dt><span data-translate="theFoodApp.ordine.ritiroAlLocale">Ritiro Al Locale</span></dt><dd><span>{{vm.ordine.ritiroAlLocale}}</span></dd><dt><span data-translate="theFoodApp.ordine.dataDownload">Data Download</span></dt><dd><span>{{vm.ordine.dataDownload | date:\'medium\'}}</span></dd><dt><span data-translate="theFoodApp.ordine.tempCustomerUUID">Temp Customer UUID</span></dt><dd><span>{{vm.ordine.tempCustomerUUID}}</span></dd><dt><span data-translate="theFoodApp.ordine.feedback">Feedback</span></dt><dd><a ui-sref="feedback-detail({id:vm.ordine.feedbackId})">{{vm.ordine.feedbackId}}</a></dd><dt><span data-translate="theFoodApp.ordine.cliente">Cliente</span></dt><dd><a ui-sref="cliente-detail({id:vm.ordine.clienteId})">{{vm.ordine.clienteId}}</a></dd><dt><span data-translate="theFoodApp.ordine.locale">Locale</span></dt><dd><a ui-sref="locale-detail({id:vm.ordine.localeId})">{{vm.ordine.localeId}}</a></dd><dt><span data-translate="theFoodApp.ordine.indirizzo">Indirizzo</span></dt><dd><a ui-sref="indirizzo-detail({id:vm.ordine.indirizzoId})">{{vm.ordine.indirizzoId}}</a></dd><dt><span data-translate="theFoodApp.ordine.datiFatturazione">Dati Fatturazione</span></dt><dd><a ui-sref="dati-fatturazione-detail({id:vm.ordine.datiFatturazioneId})">{{vm.ordine.datiFatturazioneId}}</a></dd><dt><span data-translate="theFoodApp.ordine.scontoPromozione">Sconto Promozione</span></dt><dd><span ng-repeat="scontoPromozione in vm.ordine.scontoPromoziones"><a ui-sref="sconto-promozione-detail({id: scontoPromozione.id})">{{scontoPromozione.id}}</a>{{$last ? \'\' : \', \'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="ordine-detail.edit({id:vm.ordine.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/ordine/ordine-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myOrdineLabel" data-translate="theFoodApp.ordine.home.createOrEditLabel">Create or edit a Ordine</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.ordine.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.ordine.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="theFoodApp.ordine.tipoOrdine" for="field_tipoOrdine">Tipo Ordine</label><select class="form-control" name="tipoOrdine" ng-model="vm.ordine.tipoOrdine" id="field_tipoOrdine" required><option value="CARRELLO" data-translate="theFoodApp.TipoOrdine.CARRELLO">CARRELLO</option><option value="ORDINE" data-translate="theFoodApp.TipoOrdine.ORDINE">ORDINE</option></select><div ng-show="editForm.tipoOrdine.$invalid"><p class="help-block" ng-show="editForm.tipoOrdine.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="theFoodApp.ordine.statoOrdine" for="field_statoOrdine">Stato Ordine</label><select class="form-control" name="statoOrdine" ng-model="vm.ordine.statoOrdine" id="field_statoOrdine"><option value="RICEVUTO" data-translate="theFoodApp.StatoOrdine.RICEVUTO">RICEVUTO</option><option value="APPROVATO" data-translate="theFoodApp.StatoOrdine.APPROVATO">APPROVATO</option><option value="PREPARAZIONE" data-translate="theFoodApp.StatoOrdine.PREPARAZIONE">PREPARAZIONE</option><option value="TRASPORTO" data-translate="theFoodApp.StatoOrdine.TRASPORTO">TRASPORTO</option><option value="CONSEGNATO" data-translate="theFoodApp.StatoOrdine.CONSEGNATO">CONSEGNATO</option></select></div><div class="form-group"><label class="control-label" data-translate="theFoodApp.ordine.dataOrdine" for="field_dataOrdine">Data Ordine</label><div class="input-group"><input id="field_dataOrdine" type="text" class="form-control" name="dataOrdine" datetime-picker="{{dateformat}}" ng-model="vm.ordine.dataOrdine" is-open="vm.datePickerOpenStatus.dataOrdine" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dataOrdine\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.dataOrdine.$invalid"><p class="help-block" ng-show="editForm.dataOrdine.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.dataOrdine.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div></div><div class="form-group"><label class="control-label" data-translate="theFoodApp.ordine.totaleOrdine" for="field_totaleOrdine">Totale Ordine</label><input type="number" class="form-control" name="totaleOrdine" id="field_totaleOrdine" ng-model="vm.ordine.totaleOrdine" required><div ng-show="editForm.totaleOrdine.$invalid"><p class="help-block" ng-show="editForm.totaleOrdine.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.totaleOrdine.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="theFoodApp.ordine.dataConsegna" for="field_dataConsegna">Data Consegna</label><div class="input-group"><input id="field_dataConsegna" type="text" class="form-control" name="dataConsegna" uib-datepicker-popup="{{dateformat}}" ng-model="vm.ordine.dataConsegna" is-open="vm.datePickerOpenStatus.dataConsegna"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dataConsegna\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="theFoodApp.ordine.tipoOrarioConsegna" for="field_tipoOrarioConsegna">Tipo Orario Consegna</label><select class="form-control" name="tipoOrarioConsegna" ng-model="vm.ordine.tipoOrarioConsegna" id="field_tipoOrarioConsegna"><option value="STANDARD" data-translate="theFoodApp.TipoOrarioConsegna.STANDARD">STANDARD</option><option value="NON_PRIMA" data-translate="theFoodApp.TipoOrarioConsegna.NON_PRIMA">NON_PRIMA</option><option value="PRIMA_POSSIBILE" data-translate="theFoodApp.TipoOrarioConsegna.PRIMA_POSSIBILE">PRIMA_POSSIBILE</option></select></div><div class="form-group"><label class="control-label" data-translate="theFoodApp.ordine.orarioConsegna" for="field_orarioConsegna">Orario Consegna</label><input type="text" class="form-control" name="orarioConsegna" id="field_orarioConsegna" ng-model="vm.ordine.orarioConsegna"></div><div class="form-group"><label class="control-label" data-translate="theFoodApp.ordine.ritiroAlLocale" for="field_ritiroAlLocale">Ritiro Al Locale</label><input type="checkbox" class="form-control" name="ritiroAlLocale" id="field_ritiroAlLocale" ng-model="vm.ordine.ritiroAlLocale"><div ng-show="editForm.ritiroAlLocale.$invalid"><p class="help-block" ng-show="editForm.ritiroAlLocale.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="theFoodApp.ordine.dataDownload" for="field_dataDownload">Data Download</label><div class="input-group"><input id="field_dataDownload" type="text" class="form-control" name="dataDownload" datetime-picker="{{dateformat}}" ng-model="vm.ordine.dataDownload" is-open="vm.datePickerOpenStatus.dataDownload"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dataDownload\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="theFoodApp.ordine.tempCustomerUUID" for="field_tempCustomerUUID">Temp Customer UUID</label><input type="text" class="form-control" name="tempCustomerUUID" id="field_tempCustomerUUID" ng-model="vm.ordine.tempCustomerUUID"></div><div class="form-group"><label data-translate="theFoodApp.ordine.feedback" for="field_feedback">Feedback</label><select class="form-control" id="field_feedback" name="feedback" ng-model="vm.ordine.feedbackId" ng-options="feedback.id as feedback.id for feedback in vm.feedbacks | orderBy:\'id\'"><option value=""></option></select></div><div class="form-group"><label data-translate="theFoodApp.ordine.cliente" for="field_cliente">Cliente</label><select class="form-control" id="field_cliente" name="cliente" ng-model="vm.ordine.clienteId" ng-options="cliente.id as cliente.id for cliente in vm.clientes"><option value=""></option></select></div><div class="form-group"><label data-translate="theFoodApp.ordine.locale" for="field_locale">Locale</label><select class="form-control" id="field_locale" name="locale" ng-model="vm.ordine.localeId" ng-options="locale.id as locale.id for locale in vm.locales"><option value=""></option></select></div><div class="form-group"><label data-translate="theFoodApp.ordine.indirizzo" for="field_indirizzo">Indirizzo</label><select class="form-control" id="field_indirizzo" name="indirizzo" ng-model="vm.ordine.indirizzoId" ng-options="indirizzo.id as indirizzo.id for indirizzo in vm.indirizzos"><option value=""></option></select></div><div class="form-group"><label data-translate="theFoodApp.ordine.datiFatturazione" for="field_datiFatturazione">Dati Fatturazione</label><select class="form-control" id="field_datiFatturazione" name="datiFatturazione" ng-model="vm.ordine.datiFatturazioneId" ng-options="datiFatturazione.id as datiFatturazione.id for datiFatturazione in vm.datifatturaziones"><option value=""></option></select></div><div class="form-group"><label data-translate="theFoodApp.ordine.scontoPromozione" for="field_scontoPromozione">Sconto Promozione</label><select class="form-control" id="field_scontoPromozione" multiple="multiple" name="scontoPromozione" ng-model="vm.ordine.scontoPromoziones" ng-options="scontoPromozione as scontoPromozione.id for scontoPromozione in vm.scontopromoziones track by scontoPromozione.id"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/ordine/ordines.html','<div><h2 data-translate="theFoodApp.ordine.home.title">Ordines</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="ordine.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" data-translate="theFoodApp.ordine.home.createLabel">Create new Ordine</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'theFoodApp.ordine.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipoOrdine"><span data-translate="theFoodApp.ordine.tipoOrdine">Tipo Ordine</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="statoOrdine"><span data-translate="theFoodApp.ordine.statoOrdine">Stato Ordine</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dataOrdine"><span data-translate="theFoodApp.ordine.dataOrdine">Data Ordine</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="totaleOrdine"><span data-translate="theFoodApp.ordine.totaleOrdine">Totale Ordine</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dataConsegna"><span data-translate="theFoodApp.ordine.dataConsegna">Data Consegna</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipoOrarioConsegna"><span data-translate="theFoodApp.ordine.tipoOrarioConsegna">Tipo Orario Consegna</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="orarioConsegna"><span data-translate="theFoodApp.ordine.orarioConsegna">Orario Consegna</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="ritiroAlLocale"><span data-translate="theFoodApp.ordine.ritiroAlLocale">Ritiro Al Locale</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dataDownload"><span data-translate="theFoodApp.ordine.dataDownload">Data Download</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tempCustomerUUID"><span data-translate="theFoodApp.ordine.tempCustomerUUID">Temp Customer UUID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="feedbackId"><span data-translate="theFoodApp.ordine.feedback">Feedback</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="clienteId"><span data-translate="theFoodApp.ordine.cliente">Cliente</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="localeId"><span data-translate="theFoodApp.ordine.locale">Locale</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="indirizzoId"><span data-translate="theFoodApp.ordine.indirizzo">Indirizzo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datiFatturazioneId"><span data-translate="theFoodApp.ordine.datiFatturazione">Dati Fatturazione</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="ordine in vm.ordines track by ordine.id"><td><a ui-sref="ordine-detail({id:ordine.id})">{{ordine.id}}</a></td><td data-translate="{{\'theFoodApp.TipoOrdine.\' + ordine.tipoOrdine}}">{{ordine.tipoOrdine}}</td><td data-translate="{{\'theFoodApp.StatoOrdine.\' + ordine.statoOrdine}}">{{ordine.statoOrdine}}</td><td>{{ordine.dataOrdine | date:\'medium\'}}</td><td>{{ordine.totaleOrdine}}</td><td>{{ordine.dataConsegna | date:\'mediumDate\'}}</td><td data-translate="{{\'theFoodApp.TipoOrarioConsegna.\' + ordine.tipoOrarioConsegna}}">{{ordine.tipoOrarioConsegna}}</td><td>{{ordine.orarioConsegna}}</td><td>{{ordine.ritiroAlLocale}}</td><td>{{ordine.dataDownload | date:\'medium\'}}</td><td>{{ordine.tempCustomerUUID}}</td><td><a ui-sref="feedback-detail({id:ordine.feedbackId})">{{ordine.feedbackId}}</a></td><td><a ui-sref="cliente-detail({id:ordine.clienteId})">{{ordine.clienteId}}</a></td><td><a ui-sref="locale-detail({id:ordine.localeId})">{{ordine.localeId}}</a></td><td><a ui-sref="indirizzo-detail({id:ordine.indirizzoId})">{{ordine.indirizzoId}}</a></td><td><a ui-sref="dati-fatturazione-detail({id:ordine.datiFatturazioneId})">{{ordine.datiFatturazioneId}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="ordine-detail({id:ordine.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="ordine.edit({id:ordine.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="ordine.delete({id:ordine.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/components/dialog/confirmation-yesno-dialog.html','<div class="modal-header"><h3 class="modal-title" id="modal-title">{{ vm.title }}</h3></div><div class="modal-body" id="modal-body">{{ vm.body }}</div><div class="modal-footer"><button class="btn btn-default" type="button" ng-click="vm.cancel()">{{ "global.buttons.no" | translate }}</button> <button class="btn btn-primary" type="button" ng-click="vm.ok()">{{ "global.buttons.yes" | translate }}</button></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" data-translate="error.403">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/breadcrumb/breadcrumb.html','<div class="well" z-ng-if="bc.links.length > 1"><ul class="breadcrumbs"><li ng-repeat="link in bc.links"><a ui-sref="{{ link.sref }}"><span ng-if="link.isIcon" class="{{ link.icon }}"></span> <span ng-if="!link.isIcon">{{ link.description }}</span></a></li></ul></div>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="login.title">Sign in</h4></div><div class="modal-body"><div class="row"><div class="col-md-12" ng-show="vm.banner"><div class="alert alert-{{ vm.banner.type }}" data-translate="{{ vm.banner.message }}"></div></div><div class="col-md-12"><div class="alert alert-danger" ng-if="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-12"><form class="form" role="form" ng-submit="vm.login($event)"><div class="row"><div class="form-group col-md-6"><label for="username">{{\'global.form.username\' | translate }}/{{\'global.form.email\' | translate }}</label><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group col-md-6"><label for="password" data-translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div></div><div class="row" style="margin-top:10px"><div class="form-group col-md-12 text-center"><button type="submit" class="elementor-button-primary lg" data-translate="login.form.button">Sign in</button></div></div><div class="row text-center" style="margin-top:10px"><a class="alert-link" href="" ng-click="vm.requestResetPassword()" data-translate="login.forgot-password">Did you forget your password?</a><br><a class="alert-link" href="" ng-click="vm.register()" data-translate="login.register">Register a new account</a></div></form><div ng-if="vm.isMobile" class="col-md-8 col-md-offset-2"><button ng-click="vm.callGoogle()" class="btn btn-block jh-btn-social jh-btn-google"><span data-translate="social.btnLabel" translate-values="{ label: \'Google\' }">Accedi con Google</span></button> <button ng-click="vm.callFacebook()" class="btn btn-block jh-btn-social jh-btn-facebook"><span data-translate="social.btnLabel" translate-values="{ label: \'Facebook\' }">Accedi con Facebook</span></button> <button ng-if="vm.isAvailableAppleSignIn()" ng-click="vm.callApple()" class="btn btn-block jh-btn-social jh-btn-apple"><span data-translate="social.btnLabel" translate-values="{ label: \'Apple\' }">Accedi con Apple</span></button></div><div class="col-md-12"><jh-social ng-if="!vm.isMobile" ng-provider="google"></jh-social><jh-social ng-if="!vm.isMobile" ng-provider="facebook"></jh-social><div ng-if="!vm.isAndroid() && !vm.isAvailableAppleSignIn()" ng-click="vm.signAppleFromWeb()" class="btn btn-block jh-btn-social jh-btn-apple"><button><span data-translate="social.btnLabel" translate-values="{ label: \'Apple\' }">Accedi con Apple</span></button></div></div></div></div></div>');
$templateCache.put('app/pages/area-personale/area-personale.html','<div ng-cloak class="container-fluid areaPersonale"><div class="row text-center"><span class="h2" data-translate="theFoodApp.cliente.areaPersonale.areaPersonale">Area Crediti</span></div><hr><form name="editForm" role="form" novalidate show-validation ng-submit="vm.saveCoupon()"><div class="form-group"><div class="row"><h3 class="title-input-coupon-area-personale" ng-class="{\'center\' : vm.mobile === true }" data-translate="theFoodApp.cliente.areaPersonale.inserisciCouponTipoCredito"></h3><div class="col-md-6 col-input-code"><input type="text" class="form-control" id="field_coupon" name="coupon" ng-model="vm.coupon_code" required></div><div class="col-md-2"><div class="col-md-2 button-div-mov" ng-class="{\'center\' : vm.mobile === true }"><!--<button ng-class="{\'disabled\' : editForm.coupon.$invalid  }" type="submit" class="btn btn-primary btn-mostra-mov">--> <button type="submit" class="btn btn-primary btn-mostra-mov"><span data-translate="theFoodApp.cliente.areaPersonale.inserisci">Inserisci</span></button></div></div></div></div></form><hr><hr><div class="col-md-8 col-md-offset-2"><!--SUCCESS--><div class="alert alert-success" ng-show="vm.saved === true"><p data-translate="theFoodApp.cliente.areaPersonale.inserimentoCouponSuccess">Coupon inserito con successo.</p></div><!--ERRORI--><div class="alert alert-danger" ng-show="vm.saveFailed1 === true"><p data-translate="theFoodApp.cliente.areaPersonale.inserimentoCouponError1">Il coupon inserito non \xE8 corretto.</p></div><div class="alert alert-danger" ng-show="vm.saveFailed2 === true"><p data-translate="theFoodApp.cliente.areaPersonale.inserimentoCouponError2">Il coupon inserito non \xE8 corretto.</p></div><div class="alert alert-danger" ng-show="vm.saveFailed3 === true"><p data-translate="theFoodApp.cliente.areaPersonale.inserimentoCouponError3">Il coupon inserito non \xE8 corretto.</p></div><div class="alert alert-danger" ng-show="vm.saveFailed4 === true"><p data-translate="theFoodApp.cliente.areaPersonale.inserimentoCouponError4">Il coupon inserito non \xE8 corretto.</p></div></div><div class="row totaleCredito"><div class="col-md-6 col-title-total" ng-class="{\'center\' : vm.mobile === true }"><span class="title-total" data-translate="theFoodApp.cliente.areaPersonale.totaleCredito">Totale Credito:</span> &nbsp; <span class="title-total">{{vm.totaleCredito | currency:\'\u20AC\'}}</span></div><div class="col-md-2 button-div-mov" ng-class="{\'center\' : vm.mobile === true }"><button title="Movimenti" type="button" class="btn btn-primary btn-mostra-mov" ng-click="vm.mostraMov = !vm.mostraMov"><span ng-if="vm.mostraMov === true " data-translate="theFoodApp.cliente.areaPersonale.mostraMovimenti">Mostra movimenti</span> <span ng-if="vm.mostraMov=== false " data-translate="theFoodApp.cliente.areaPersonale.chiudiMovimenti">Nascondi Movimenti</span><!--<span ng-if="vm.mobile === true && vm.mostraMov=== true" class="glyphicon glyphicon-plus"></span>\n                <span ng-if="vm.mobile === true && vm.mostraMov=== false" class="glyphicon glyphicon-minus"></span>--></button></div></div><div uib-collapse="vm.mostraMov === true"><div class="row" ng-repeat="movimento in vm.movimentiCredito"><div class="riga-movimento"><div class="col-10" ng-class="{\'center\' : vm.mobile === true }"><span><span class="title-movimento-riga" data-translate="theFoodApp.cliente.areaPersonale.data">Data : </span>{{movimento.data | date:\'dd-MM-yyyy HH:mm:ss\'}}<br></span><div ng-if="movimento.tipoMovimento.id === 1"><span><span class="title-movimento-riga" data-translate="theFoodApp.cliente.areaPersonale.ordine">Ordine: </span>{{movimento.riferimento}}<br></span></div><div ng-if="movimento.tipoMovimento.id === 2"><span><span class="title-movimento-riga" data-translate="theFoodApp.cliente.areaPersonale.operatore">Operatore: </span>{{movimento.riferimento}}<br></span></div><div ng-if="movimento.tipoMovimento.id === 3"><span><span class="title-movimento-riga" data-translate="theFoodApp.cliente.areaPersonale.coupon">Coupon: </span>{{movimento.riferimento}}<br></span></div><span><span class="title-movimento-riga" data-translate="theFoodApp.cliente.areaPersonale.tipoMovimento">Tipo Movimento : </span>{{movimento.tipoMovimento.descIt}}<br></span><span ng-if="movimento.importo > 0 "><span class="title-movimento-riga" data-translate="theFoodApp.cliente.areaPersonale.importo">Importo : </span><span class="positivo">+{{movimento.importo | currency:\'\u20AC\' }}</span><br></span><span ng-if="movimento.importo < 0 "><span class="title-movimento-riga" data-translate="theFoodApp.cliente.areaPersonale.importo">Importo :</span> <span class="negativo">{{movimento.importo | currency:\'\u20AC\' }}</span><br></span></div></div></div><div class="text-center pagination-thefood" ng-if="vm.totalItems > vm.itemsPerPage"><uib-pagination class="pagination pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="\n            vm.page" ng-change="vm.transition()" boundary-link-numbers="true"></uib-pagination></div></div><!-- <div class="row ">\n         <div class="col col-text-insert" ng-class="{\'center\' : vm.mobile === true }">\n             <span class="desc-ins-code" data-translate="theFoodApp.cliente.areaPersonale.inserisciCouponText">Inserisci un codice coupon valido solo per aggiunta credito.</span>\n         </div>\n     </div>--></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-default" role="navigation"><div class="container"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand logo" href="#/" ng-click="vm.collapseNavbar()"><span data-translate="global.title">TheFood</span> <span class="navbar-version">v{{VERSION}}</span></a></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><li ui-sref-active="active"><a ui-sref="landing" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-home"></span> <span class="hidden-sm" data-translate="global.menu.home">Home</span></a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-class="{active: vm.$state.includes(\'entity\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu"><span><span class="glyphicon glyphicon-th-list"></span> <span class="hidden-sm" data-translate="global.menu.entities.main">Entities </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="cliente" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.cliente">Cliente</span></a></li><li ui-sref-active="active"><a ui-sref="ordine" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.ordine">Ordine</span></a></li><li ui-sref-active="active"><a ui-sref="indirizzo" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.indirizzo">Indirizzo</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm" data-translate="global.menu.account.main">Account </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="settings" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-wrench"></span>&nbsp; <span data-translate="global.menu.account.settings">Settings</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span data-translate="global.menu.account.password">Password</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span data-translate="global.menu.account.logout">Sign out</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span data-translate="global.menu.account.login">Sign in</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a ui-sref="register" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-plus-sign"></span>&nbsp; <span data-translate="global.menu.account.register">Register</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm" data-translate="global.menu.admin.main">Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.menu.admin.userManagement">User management</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span data-translate="global.menu.admin.metrics">Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span data-translate="global.menu.admin.health">Health</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span data-translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span data-translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span data-translate="global.menu.admin.logs">Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span data-translate="global.menu.admin.apidocs">API</span></a></li><li ui-sref-active="active"><a ui-sref="elasticsearch-reindex" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-exclamation-sign"></span>&nbsp; <span data-translate="global.menu.admin.elasticsearch-reindex">Elasticsearch Reindex</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li><li ui-sref-active="active" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm"><a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1"><span><span class="glyphicon glyphicon-flag"></span> <span class="hidden-sm" data-translate="global.menu.language">Language</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1"><li active-menu="{{language}}" ng-repeat="language in languageVm.languages"><a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a></li></ul></li></ul></div></div></nav>');
$templateCache.put('app/pages/carrello/annulla-pagamento.html','<div class="modal-header"><h4 class="modal-title" data-translate="theFoodApp.carrello.attenzione">Attenzione!</h4></div><div class="modal-body"><div class="row"><div class="col-md-12 messaggio-utente" data-translate="theFoodApp.carrello.messaggio-utente">Per questo ordine ci risulta un pagamento in corso.<br>Per continuare con l\'ordine si prega di annullare il pagamento.</div></div><div class="row"><div class="list-group text-center annulla-pagamento-label"><a class="list-group-item" ng-click="vm.annullaPagamento()" data-translate="theFoodApp.carrello.annulla-e-continua">Annulla pagamento e continua il tuo ordine</a></div></div></div>');
$templateCache.put('app/pages/carrello/articolo.aggiunte.dialog.html','<form name="aggiunteForm" role="form" novalidate class="aggiunte-modal"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.abort()">&times;</button><h4 class="modal-title" data-translate="theFoodApp.aggiunte.title">Aggiunte</h4></div><div class="modal-body"><div class="aggiunte-container"><div class="aggiunta" ng-repeat="aggiunta in vm.aggiunte"><div class="prodotto-main"><div class="prodotto-descrizione"><input type="checkbox" class="checkbox" id="aggiunta-{{ aggiunta.id }}" ng-checked="aggiunta.selected" ng-click="vm.toggleAggiunta($event, aggiunta)"><label for="aggiunta-{{ aggiunta.id }}" class="control-label no-label-appearence">{{ aggiunta | languageSwitch:\'descrizioneIt\':\'descrizioneEn\'}}<div class="prodotto-descrizione-estesa">{{ aggiunta | languageSwitch:\'descrizioneEstesaIt\':\'descrizioneEstesaEn\' }}</div></label></div><div class="prodotto-prezzo">{{ vm.getPrezzoAggiunta(aggiunta) | currency:\'\u20AC\' }}</div></div></div></div></div><div class="modal-footer"><div class="clearfix"><div class="col-xs-12 col-sm-6 col-sm-offset-6"><div class="row" ng-if="vm.getAggiunteDisponibili()"><div class="col-xs-9" data-translate="theFoodApp.aggiunte.available">Aggiunte disponibili:</div><div>{{ vm.getAggiunteDisponibili() }}</div></div><div class="row"><div class="col-xs-9" data-translate="theFoodApp.aggiunte.selected">Aggiunte selezionate:</div><div>{{ vm.getTotaleAggiunte() }}</div></div><div class="row" ng-if="vm.getCostoAggiunte()"><div class="col-xs-9" data-translate="theFoodApp.aggiunte.total">Costo aggiunte:</div><div>{{ vm.getCostoAggiunte() | currency:\'\u20AC\' }}</div></div></div></div><div class="modal-buttons"><button type="button" class="btn btn-sm btn-default" ng-disabled="!vm.canClear()" ng-click="vm.clear()" data-translate="theFoodApp.aggiunte.action.clear">Pulisci</button> <button type="button" class="btn btn-sm btn-primary" ng-disabled="!vm.canSave()" ng-click="vm.save()" data-translate="theFoodApp.aggiunte.action.save">Salva</button></div></div></form>');
$templateCache.put('app/pages/carrello/articolo.directive.html','<div class="articolo"><!-- ARTICOLO --><div class="articolo-main-row"><div ng-if="!vm.sceltaMenu"><button type="button" class="btn btn-sm btn-round btn-primary btn-removal" ng-click="vm.rimuoviArticolo(vm.articolo)"><span class="glyphicon glyphicon-minus"></span></button></div><div class="articolo-descrizione">{{ vm.articolo.prodotto | languageSwitch:\'descrizioneIt\':\'descrizioneEn\' }}</div><div ng-if="!vm.sceltaMenu" class="articolo-prezzo price">{{ vm.getPrezzoProdotto(vm.articolo.prodotto) | currency:\'\u20AC\' }}</div></div><!-- SCONTI --><div class="articolo-main-row" ng-if="vm.articolo.scontoPromoziones" ng-repeat="sconto in vm.articolo.scontoPromoziones"><div class="articolo-descrizione sconto-descrizione">{{sconto | languageSwitch: \'messaggioIt\' : \'messaggioEn\'}}</div><div class="articolo-prezzo price">{{- sconto.valoreSconto | currency: \'\u20AC\'}}</div></div><div class="articolo-dettagli"><div class="articolo-varianti articolo-subsection" ng-if="vm.articolo.dettaglioVariantes.length > 0"><div class="articolo-subtitle" ng-if="vm.articolo.composizioneMenu"><a class="variante-label" ng-click="vm.modificaVarianti()" data-translate="theFoodApp.varianti.label">Varianti:</a></div><div class="articolo-subtitle" ng-if="!vm.articolo.composizioneMenu"><!-- <a class="variante-label" ng-click="vm.modificaVarianti()" data-translate="theFoodApp.varianti.label">Varianti:</a> --><!-- <span class="variante-label" data-translate="theFoodApp.varianti.label">Varianti:</span> --> <span data-translate="theFoodApp.varianti.label">Varianti:</span></div><div class="variante articolo-sub-row" ng-repeat="variante in vm.articolo.dettaglioVariantes"><div class="variante-dettaglio"><span class="variante-etichetta">{{ variante | languageSwitch:\'varianteLabelIt\':\'varianteLabelEn\'}}: </span><span class="variante-descrizione"><!-- <a ng-click="vm.modificaVarianti()">{{ variante | languageSwitch:\'descrizioneIt\':\'descrizioneEn\'}}</a> --> {{ variante | languageSwitch:\'descrizioneIt\':\'descrizioneEn\'}}</span></div><div class="variante-prezzo price" ng-show="variante.price && variante.price > 0">{{ variante.price | currency:\'\u20AC\' }}</div></div></div><div class="articolo-aggiunte articolo-subsection" ng-if="vm.articolo.prodotto.aggiunteDisponibili || vm.articolo.dettaglioVariantes.length > 0"><div class="articolo-subtitle" ng-if="vm.articolo.aggiuntas.length > 0">{{\'theFoodApp.aggiunte.aggiunte\' | translate}}</div><div class="aggiunta articolo-sub-row" ng-repeat="aggiunta in vm.articolo.aggiuntas"><div class="aggiunta-descrizione section-title"><!-- <a ng-click="vm.modificaAggiunte()">{{ aggiunta | languageSwitch:\'descrizioneIt\':\'descrizioneEn\'}}</a> --> <span>{{ aggiunta | languageSwitch:\'descrizioneIt\':\'descrizioneEn\'}}</span></div><div class="aggiunta-prezzo price">{{ vm.getPrezzoProdotto(aggiunta) | currency:\'\u20AC\' }}</div></div><div class="articolo-subsection-link"><!-- <a ng-click="vm.modificaAggiunte()">{{\'theFoodApp.carrello.aggiungi-ingrediente\' | translate}}</a> --> <a ng-click="vm.modificaVarianti()">{{\'theFoodApp.carrello.modify\' | translate}}</a></div></div><div class="menu articolo-subsection" ng-if="vm.articolo.dettaglioMenus.length"><articolo riga-ordine="vm.articolo" scelta-menu="dettaglioMenu" carrello="vm.carrelloInstance" ng-repeat="dettaglioMenu in vm.articolo.dettaglioMenus"></div></div></div>');
$templateCache.put('app/pages/carrello/articolo.varianti.dialog.html','<form name="variantiForm" role="form" novalidate class="varianti-modal"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.abort()">&times;</button><h4 class="modal-title varianti-title" data-translate="theFoodApp.varianti.title">Varianti</h4></div><div class="modal-body modal-body-padding-sm sm"><div class="varianti-container"><div class="variante" ng-repeat="variante in vm.varianti"><div class="form-group"><label class="control-label" for="variante-{{ variante.dettaglioVarianteId }}">{{ variante | languageSwitch:\'descrizioneIt\':\'descrizioneEn\' }}</label><div class=""><select class="form-control input-sm varianti-select" id="variante-{{ variante.dettaglioVarianteId }}" ng-model="vm.variantiSelezionate[variante.id]" ng-options="opt as vm.getVarianteLabel(opt) for opt in variante.dettaglioVariantes track by opt.id"></select></div></div></div></div></div><div ng-if="vm.aggiunte.length && !vm.isDesktop" class="modal-body modal-body-padding-sm section-aggiunte" ng-click="vm.mostraAggiunte = !vm.mostraAggiunte"><span data-translate="theFoodApp.carrello.aggiungi-ingrediente">Aggiungi ingrediente: </span>&nbsp<span class="caret-runnerpizza" ng-class="{\'caret-runnerpizza-up\':vm.mostraAggiunte}"></span></div><div ng-if="vm.aggiunte.length && vm.isDesktop" class="modal-body modal-body-padding-sm"><span data-translate="theFoodApp.carrello.aggiungi-ingrediente">Aggiungi ingrediente:</span></div><div class="modal-body modal-body-padding-sm modal-body-sm" ng-if="vm.aggiunte.length && (vm.mostraAggiunte || vm.isDesktop)"><div><div class="aggiunta" ng-repeat="aggiunta in vm.aggiunte"><div class="prodotto-main"><div class="prodotto-descrizione"><input type="checkbox" class="checkbox" id="aggiunta-{{ aggiunta.id }}" ng-checked="aggiunta.selected" ng-click="vm.toggleAggiunta($event, aggiunta)"><label for="aggiunta-{{ aggiunta.id }}" class="control-label no-label-appearence">{{ aggiunta | languageSwitch:\'descrizioneIt\':\'descrizioneEn\'}}<div class="prodotto-descrizione-estesa">{{ aggiunta | languageSwitch:\'descrizioneEstesaIt\':\'descrizioneEstesaEn\' }}</div></label></div><div class="prodotto-prezzo">{{ vm.getPrezzoAggiunta(aggiunta) | currency:\'\u20AC\' }}</div></div></div></div></div><div class="modal-footer" ng-hide><div class="clearfix"><div class="col-xs-12 col-sm-6 col-sm-offset-6"><div class="row" ng-if="vm.getCostoVarianti()"><div class="col-xs-9" data-translate="theFoodApp.varianti.total">Costo varianti:</div><div>{{ vm.getCostoVarianti() | currency:\'\u20AC\' }}</div></div></div></div><div class="clearfix" ng-if="vm.aggiunte.length"><div class="col-xs-12 col-sm-6 col-sm-offset-6"><div class="row" ng-if="vm.getAggiunteDisponibili()"><div class="col-xs-9" data-translate="theFoodApp.aggiunte.available">Aggiunte disponibili:</div><div>{{ vm.getAggiunteDisponibili() }}</div></div><div class="row"><div class="col-xs-9" data-translate="theFoodApp.aggiunte.selected">Aggiunte selezionate:</div><div>{{ vm.getTotaleAggiunte() }}</div></div><div class="row" ng-if="vm.getCostoAggiunte()"><div class="col-xs-9" data-translate="theFoodApp.aggiunte.total">Costo aggiunte:</div><div>{{ vm.getCostoAggiunte() | currency:\'\u20AC\' }}</div></div></div></div><div class="modal-buttons"><button ng-if="vm.aggiunte.length" type="button" class="btn btn-default" ng-disabled="!vm.canClear()" ng-click="vm.clear()" data-translate="theFoodApp.aggiunte.action.clear">Pulisci</button> <button type="button" class="btn btn-primary" ng-disabled="!vm.canSave()" ng-click="vm.save()" data-translate="theFoodApp.varianti.action.save">Salva</button></div></div></form>');
$templateCache.put('app/pages/carrello/carrello.full.html','<div class="carrello-full"><a ui-sref="^" data-translate="theFoodApp.carrello.modify-cart">&lt; Modifica il tuo ordine</a><div class="cart-header text-center"><i><!-- Icon Placeholder --></i> <span data-translate="theFoodApp.carrello.header">Riepilogo acquisti</span></div><div ui-view="carrello"></div></div>');
$templateCache.put('app/pages/carrello/carrello.html','<div class="carrello"><div class="hidden-lg hidden-md hidden-sm"><div class="clearfix"><div class="row"><div class="col-md-12 text-center"><button type="button" class="elementor-button-primary lg disabled" ng-click="vm.checkout()" ng-show="!vm.canCheckout()" data-translate="theFoodApp.carrello.checkout" disabled="disabled">Ordina</button> <button type="button" class="elementor-button-primary lg" ng-click="vm.checkout()" ng-show="vm.canCheckout()" data-translate="theFoodApp.carrello.checkout">Ordina</button></div></div></div><div class="text-center svuota-carrello"><u ng-click="vm.svuotaCarrello()" data-translate="theFoodApp.carrello.svuota"></u></div><br></div><div class="alert alert-info alert-dismissable visible-xs" ng-if="vm.showAmountTooLowInfo()"><a class="close" data-dismiss="alert" aria-label="close">&times;</a> <span data-translate="theFoodApp.carrello.amount-too-low-error" data-translate-values="{ amount: vm.getImportoMinimoConsegna() }">L\'importo del carrello risulta inferiore all\'importo minimo di consegna di questo punto vendita.</span></div><div class="alert alert-danger alert-dismissable" ng-if="vm.showEmptyCartError"><a class="close" data-dismiss="alert" aria-label="close" ng-click="vm.showEmptyCartError = false">&times;</a> <span data-translate="theFoodApp.carrello.empty-cart-error">Il tuo carrello \xE8 attualmente vuoto.</span></div><div class="alert alert-danger alert-dismissable" ng-if="vm.showAmountTooLowError"><a class="close" data-dismiss="alert" aria-label="close" ng-click="vm.showAmountTooLowError = false">&times;</a> <span data-translate="theFoodApp.carrello.amount-too-low-error" data-translate-values="{ amount: vm.getImportoMinimoConsegna() }">L\'importo del carrello risulta inferiore all\'importo minimo di consegna di questo punto vendita.</span></div><div class="articoli-container clearfix"><articolo riga-ordine="riga" carrello="vm.carrello" ng-repeat="riga in vm.carrello.getArticoli()"></div><hr ng-if="vm.carrello.getTotaleArticoli() > 0"><div class="totale-container clearfix"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 promozioni-attive" ng-repeat="messaggioPromo in vm.visualizzaMessaggioPromo()"><span class="moltiplicatore">{{messaggioPromo.count}} x &nbsp</span> {{messaggioPromo | languageSwitch: \'messaggioIt\' : \'messaggioEn\'}}</div></div><hr ng-show="vm.visualizzaMessaggioPromo().length > 0"><div class="row"><div class="col-xs-8 col-sm-12 col-md-8 text-sm-center" data-translate="theFoodApp.carrello.total-count">Totale articoli:</div><div class="col-xs-4 col-sm-12 col-md-4 text-right text-sm-center">{{ vm.carrello.getTotaleArticoli() }}</div></div><!-- SCONTI ORDINE --><div class="row" ng-repeat="scontoOrdine in vm.carrello.getScontiOrdine()"><div ng-show="!vm.isTipoConsegnaGratis(scontoOrdine)" class="col-xs-8 col-sm-12 col-md-8 text-sm-center">{{scontoOrdine | languageSwitch: \'messaggioIt\' : \'messaggioEn\'}}</div><div ng-show="!vm.isTipoConsegnaGratis(scontoOrdine)" class="col-xs-4 col-sm-12 col-md-4 text-right text-sm-center">{{- scontoOrdine.valoreSconto | currency:\'\u20AC\' }}</div></div><div class="row"><div class="col-xs-8 col-sm-12 col-md-8 text-sm-center" data-translate="theFoodApp.carrello.total-amount">Importo carrello:</div><div class="col-xs-4 col-sm-12 col-md-4 text-right text-sm-center">{{ vm.carrello.getImportoArticoliExcludeScontoConsegna() | currency:\'\u20AC\' }}</div></div></div><hr><div class="hidden-xs"><div class="clearfix"><div class="row"><div class="col-md-12 text-center"><button type="button" class="elementor-button-primary lg disabled" ng-click="vm.checkout()" ng-show="!vm.canCheckout()" data-translate="theFoodApp.carrello.checkout" disabled="disabled">Ordina</button> <button type="button" class="elementor-button-primary lg" ng-click="vm.checkout()" ng-show="vm.canCheckout()" data-translate="theFoodApp.carrello.checkout">Ordina</button></div></div></div><div class="hidden-xs" ng-if="!vm.isTakeaway && vm.getImportoMinimoConsegna()"><div class="importo-minimo text-center text-sm-center">{{ \'theFoodApp.locale.listino.ordineMinimo\' | translate }} {{vm.getImportoMinimoConsegna() | currency: \'\u20AC\'}}</div></div><div class="text-center svuota-carrello"><u ng-click="vm.svuotaCarrello()" data-translate="theFoodApp.carrello.svuota"></u></div></div></div>');
$templateCache.put('app/pages/concludi-acquisto/acquisto-concluso.html','<div class="payment-result-container"><!--<jhi-alert-error></jhi-alert-error>--><div class="col-sm-12"><div class="alert alert-success"><h4 ng-if="vm.pagamento.issuer!==\'CashOnDelivery\'" data-translate="payments.payments-ok.title">Payment successfully made</h4><h4 ng-if="vm.pagamento.issuer===\'CashOnDelivery\'" data-translate="payments.payments-ok.titleCashOnDelivery">Order correctly taken in charge</h4><!--<div ng-if="vm.ordine.ritiroAlLocale">\n                <h4 data-translate="payments.payments-ok.takeaway"></h4>\n            </div>\n            <div ng-if="!vm.ordine.ritiroAlLocale">\n                <h4 data-translate="payments.payments-ok.consegna"></h4>\n            </div>\n            <div class="row">\n                <div class="col-sm-12">{{vm.indirizzoText}}</div>\n                <div class="col-sm-12">{{"payments.payments-ok.orario-consegna" | translate}}: {{vm.getOrariConsegna(vm.ordine.orarioConsegna, vm.locale)}}</div>\n                <div class="col-sm-12">{{"payments.payments-ok.data-consegna" | translate}}: {{vm.dataOrdine | date:\'shortDate\'}}</div>\n            </div>--><h4 data-translate="{{vm.paymentLabel}}" translate-values="{indirizzo: \'{{vm.indirizzoText}}\', orarioDa: \'{{vm.getOrarioConsegnaDa(vm.ordine.orarioConsegna)}}\', orarioA: \'{{vm.getOrarioConsegnaA(vm.ordine.orarioConsegna, vm.locale)}}\', giorno: \'{{vm.dataConsegna | date:\'dd/MM/yyyy\'}}\' }"></h4><!-- <h4 ng-if="!(vm.ordine.orarioConsegna === null) && !vm.ordine.ritiroAlLocale" data-translate="{{vm.paymentLabel}}" translate-values="{indirizzo: \'{{vm.indirizzoText}}\', orarioDa: \'{{vm.getOrarioConsegnaDa(vm.ordine.orarioConsegna)}}\', orarioA: \'{{vm.getOrarioConsegnaA(vm.ordine.orarioConsegna, vm.locale)}}\', giorno: \'{{vm.dataConsegna | date:\'shortDate\'}}\' }"></h4>\n            <h4 ng-if="vm.ordine.orarioConsegna && vm.ordine.ritiroAlLocale" data-translate="{{vm.paymentLabel}}" translate-values="{indirizzo: \'{{vm.indirizzoText}}\', orarioDa: \'{{vm.getOrarioConsegnaDa(vm.ordine.orarioConsegna)}}\', orarioA: \'{{vm.getOrarioConsegnaA(vm.ordine.orarioConsegna, vm.locale)}}\', giorno: \'{{vm.dataConsegna | date:\'shortDate\'}}\' }"></h4>\n            <h4 ng-if="vm.ordine.orarioConsegna === null" data-translate="{{vm.paymentLabel}}" translate-values="{indirizzo: \'{{vm.indirizzoText}}\'}"></h4> --></div></div><div class="col-sm-12 col-md-8"><div class="panel"><div class="panel-body"><div class="row payment-info"><div class="col-sm-4 payment-title" data-translate="payments.payments-ok.issuer"></div><div class="col-sm-6 payment-value">{{vm.pagamento.issuer}}</div></div><div class="row payment-info"><div class="col-sm-4 payment-title" data-translate="payments.payments-ok.data-ora-transazione"></div><div class="col-sm-6 payment-value">{{vm.dataOraTransazione | date:\'dd/MM/yyyy\'}} {{vm.dataOraTransazione | date:\'HH:mm:ss\'}}</div></div><div class="row payment-info"><div class="col-sm-4 payment-title" data-translate="payments.payments-ok.transaction-id"></div><div class="col-sm-6 payment-value">{{vm.pagamento.transactionId}}</div></div><div class="row payment-info"><div class="col-sm-4 payment-title" data-translate="payments.payments-ok.ordine-id"></div><div class="col-sm-6 payment-value">{{vm.ordine.id}}</div></div><div class="row payment-info"><div class="col-sm-4 payment-title" data-translate="payments.payments-ok.data-consegna"></div><div class="col-sm-6 payment-value">{{vm.dataConsegna | date:\'dd/MM/yyyy\'}}</div></div><div class="row payment-info"><div class="col-sm-4 payment-title" data-translate="payments.payments-ok.orario-consegna"></div><div class="col-sm-6 payment-value">{{vm.getOrarioConsegnaDa(vm.ordine.orarioConsegna)}} - {{vm.getOrarioConsegnaA(vm.ordine.orarioConsegna, vm.locale)}}</div></div></div></div></div><div class="col-sm-12 col-md-4"><div class="panel"><div class="panel-body"><div class="row payment-info"><div class="col-xs-6 col-sm-3 col-md-6 payment-title" data-translate="payments.payments-ok.importo-ordine"></div><div class="col-sm-2 col-md-6 text-right">{{vm.ordine.importoOrdineSenzaSconti | currency:\'\u20AC\'}}</div></div><div class="row payment-info"><div class="col-xs-6 col-sm-3 col-md-6 payment-title" data-translate="payments.payments-ok.importo-spedizione"></div><div class="col-sm-2 col-md-6 text-right">{{vm.ordine.importoSpedizione | currency:\'\u20AC\'}}</div></div><div class="row payment-info" ng-if="vm.hasSconto() > 0 "><div class="col-xs-6 col-sm-3 col-md-6 payment-title" data-translate="payments.payments-ok.importo-sconti"></div><div class="col-sm-2 col-md-6 text-right">-{{vm.getScontoTotale() | currency:\'\u20AC\'}}</div></div><div class="row payment-info" ng-if="vm.pagamento.issuer === \'Credit\'"><div class="col-xs-6 col-sm-3 col-md-6 payment-title" data-translate="payments.payments-ok.credito-utilizzato"></div><div class="col-sm-2 col-md-6 text-right">- {{vm.ordine.importoOrdine + vm.ordine.importoSpedizione | currency:\'\u20AC\'}}</div></div><div class="row payment-info" ng-if="vm.ordine.creditoUtilizzato && !vm.pagamento.issuer === \'Credit\'"><div class="col-xs-6 col-sm-3 col-md-6 payment-title" data-translate="payments.payments-ok.credito-utilizzato"></div><div class="col-sm-2 col-md-6 text-right">{{vm.ordine.creditoUtilizzato| currency:\'\u20AC\'}}</div></div><div class="row payment-info"><div class="col-xs-6 col-sm-3 col-md-6 payment-title" data-translate="payments.payments-ok.importo-totale"></div><div class="col-sm-2 col-md-6 text-right" ng-if="vm.pagamento.issuer !== \'Credit\'">{{vm.ordine.importoOrdine + vm.ordine.importoSpedizione | currency:\'\u20AC\'}}</div><div class="col-sm-2 col-md-6 text-right" ng-if="vm.pagamento.issuer === \'Credit\'">{{ 0| currency:\'\u20AC\'}}</div></div></div></div></div><div class="col-xs-12 text-center"><button class="btn btn-primary" data-translate="payments.payments-ok.home" ng-click="vm.goToHome()"></button> <button class="btn btn-primary" data-translate="payments.payments-ok.tuoi-ordini" ng-click="vm.goToStoricoOrdini()"></button></div></div>');
$templateCache.put('app/pages/concludi-acquisto/concludi-acquisto.html','<!-- PULSANTE TORNA INDIETRO --><div style="padding-left: 5%; padding-right: 5%"><div class="go-back">&lt; <a ui-sref="locale" ui-sref-opts="{reload: true}" data-translate="theFoodApp.concludi.listino">&lt; Listino locale</a></div><!-- ALERT MESSAGE --><div class="alert alert-danger alert-dismissable" ng-if="vm.showAlertOrario"><a class="close" data-dismiss="alert" aria-label="close" ng-click="vm.showAlertOrario = false">&times;</a> <span data-translate="theFoodApp.concludi.error.orarioNonDisponibile"></span> <span>{{vm.ordine.orarioConsegna}}</span></div><div class="alert alert-danger alert-dismissable" ng-if="vm.showAlertIndFatturazione"><a class="close" data-dismiss="alert" aria-label="close" ng-click="vm.showAlertIndFatturazione = false">&times;</a> <span data-translate="theFoodApp.concludi.error.noIndirizzoFatturazione"></span></div><div class="alert alert-danger alert-dismissable" ng-if="vm.showAlertOraMissing"><a class="close" data-dismiss="alert" aria-label="close" ng-click="vm.showAlertOraMissing = false">&times;</a> <span data-translate="theFoodApp.concludi.error.oraMissing"></span></div><div class="alert alert-danger alert-dismissable" ng-if="vm.showAlertDataOraNotConfirmed"><a class="close" data-dismiss="alert" aria-label="close" ng-click="vm.showAlertDataOraNotConfirmed = false">&times;</a> <span data-translate="theFoodApp.concludi.error.dataOraNotConfirmed"></span></div><div class="alert alert-info alert-dismissable" ng-if="vm.modifyOrderCondition"><a class="close" data-dismiss="alert" aria-label="close" ng-click="vm.modifyOrderCondition = false">&times;</a> <span data-translate="theFoodApp.concludi.cambio-condizioni"></span></div><!--<div class="alert alert-danger alert-dismissable" ng-if="vm.paymentError">\n        <a class="close" data-dismiss="alert" aria-label="close" ng-click="vm.paymentError = false">&times;</a>\n        <span data-translate="payments.payments-error.title"></span>\n    </div>\n    <div class="alert alert-danger alert-dismissable" ng-if="vm.paymentCancel">\n        <a class="close" data-dismiss="alert" aria-label="close" ng-click="vm.paymentCancel = false">&times;</a>\n        <span data-translate="payments.payments-cancel.title"></span>\n    </div>--><div class="alert alert-danger alert-dismissable" ng-if="vm.paymentCancel || vm.paymentError"><a class="close" data-dismiss="alert" aria-label="close" ng-click="vm.paymentCancel = false; vm.paymentError = false;">&times;</a> <span data-translate="payments.payments-error.title"></span></div><form class="concludi-acquisto" name="editForm" role="form" show-validation novalidate ng-submit="vm.concludiAcquisto()"><!-- SCELTA DATA E ORA CONSEGNA --><div class="form-inline text-left selezione-data-ora"><div class="form-group"><select ng-change="vm.onDataChanged()" name="dataConsegna" required class="form-control data-consegna" ng-model="vm.dataConsegnaSelezionata" ng-options="dataConsegna as vm.dataConsegnaFormattata(dataConsegna) for dataConsegna in vm.datePossibiliDiConsegna"><option value="" selected="selected" disabled="disabled">{{ \'theFoodApp.concludi.selezionaDataPlaceholder\' | translate }}</option></select></div><div class="form-group"><select ng-change="vm.onOraChanged()" ng-disabled="vm.dataConsegnaSelezionata === null" name="oraConsegna" required class="form-control ora-consegna" ng-model="vm.oraConsegnaSelezionata" ng-options="oraConsegna as oraConsegna.label group by oraConsegna.group disable when oraConsegna.disabled for oraConsegna in vm.getOrariConsegna(vm.dataConsegnaSelezionata) track by oraConsegna.value"><option value="" selected="selected" disabled="disabled">{{ \'theFoodApp.concludi.selezionaOrarioPlaceholder\' | translate }}</option></select></div></div><div class="div-coupon" ng-if="vm.oraConsegnaSelezionata"><div class="row row-inserimento-coupon"><div class="col" ng-class="{\'center\' : vm.mobile === true }" ng-if="vm.codiceCouponInserito === \'\'"><h2 class="titile-ins-coupon" data-translate="theFoodApp.concludi.inserisciCoupon">Hai un codice coupon?</h2></div></div><!--   <div class="row ">\n                <div class="col col-text-insert" ng-class="{\'center\' : vm.mobile === true }">\n                    <span class="desc-ins-code" data-translate="theFoodApp.concludi.inserisciCouponText">Inserisci un\n                        codice coupon valido solo per offerta sul\n                        prodotto.</span>\n                </div>\n            </div>--><div><div class="row row-ins-coupon-inp"><div class="col-md-6 col-input-code" ng-if="vm.codiceCouponInserito === \'\'"><input type="text" class="form-control" id="field_coupon" name="coupon" ng-model="vm.coupon_code"></div><div class="col-md-2" ng-if="vm.codiceCouponInserito === \'\' "><div class="col-md-2 button-div-mov" ng-class="{\'center\' : vm.mobile === true }"><!--<button ng-class="{\'disabled\' : vm.coupon_code.length > 16 ||  vm.coupon_code.length < 8 }" type="button" class="btn btn-primary btn-mostra-mov"\n                                ng-click="vm.calcolaCostiOrdine()">--> <button type="button" class="btn btn-primary btn-mostra-mov" ng-click="vm.calcolaCostiOrdine()"><span data-translate="theFoodApp.concludi.inserisci">Inserisci</span></button></div></div><div class="col-md-9" ng-if="vm.codiceCouponInserito.length > 0 " ng-class="{\'center\' : vm.mobile === true }"><h3 class="couponInserito" data-translate="theFoodApp.concludi.codiceCouponInserito">Codice coupon inserito</h3></div><div class="credit-section col-md-3" ng-class="{\'middle\' : vm.mobile === true }" ng-if="vm.totaleCredito > 0 && vm.dataOraConfirmed"><div><div class="box-right" ng-class="{ \'loading-dots\': vm.dataOraLoading }"><div ng-if="!vm.dataOraLoading"><span>{{ \'theFoodApp.concludi.ilTuoCredito\' | translate }} &nbsp;&nbsp; <span ng-if="vm.dataOraConfirmed">{{ vm.totaleCredito | currency:\'\u20AC\' }} </span><span ng-if="!vm.dataOraConfirmed">--</span></span></div></div><div ng-if="vm.totaleCredito > 0 && vm.dataOraConfirmed "><div class="text-usa"><div class="checkbox checkbox-credit"><label><input type="checkbox" ng-model="vm.utilizzaCredito" ng-change="!vm.utilizzaCredito" checked="checked">{{ \'theFoodApp.concludi.utilizzaCredito\' | translate }}</label></div></div></div></div></div></div></div></div><div class="col-md-12 col-result"><!--SUCCESSI--><div class="alert alert-success" ng-show="vm.saved1 === true"><p data-translate="theFoodApp.concludi.inserimentoCouponSuccess1">Coupon inserito con successo.</p></div><div class="alert alert-success" ng-show="vm.saved2 === true"><p data-translate="theFoodApp.concludi.inserimentoCouponSuccess2">Coupon inserito con successo.</p></div><!--ERRORI--><div class="alert alert-danger" ng-show="vm.saveFailed1 === true"><p data-translate="theFoodApp.concludi.inserimentoCouponError1">Il coupon inserito non \xE8 corretto.</p></div><div class="alert alert-danger" ng-show="vm.saveFailed2 === true"><p data-translate="theFoodApp.concludi.inserimentoCouponError2">Il coupon inserito non \xE8 corretto.</p></div><div class="alert alert-danger" ng-show="vm.saveFailed3 === true"><p data-translate="theFoodApp.concludi.inserimentoCouponError3">Il coupon inserito non \xE8 corretto.</p></div><div class="alert alert-danger" ng-show="vm.saveFailed4 === true"><p data-translate="theFoodApp.concludi.inserimentoCouponError4">Il coupon inserito non \xE8 corretto.</p></div><div class="alert alert-danger" ng-show="vm.saveFailed5 === true"><p data-translate="theFoodApp.concludi.inserimentoCouponError5">Il coupon inserito non \xE8 corretto.</p></div><div class="alert alert-danger" ng-show="vm.saveFailed6 === true"><p data-translate="theFoodApp.concludi.inserimentoCouponError6">Il coupon inserito non \xE8 corretto.</p></div><div class="alert alert-danger" ng-show="vm.isPaymentError === true"><p data-translate="theFoodApp.concludi.paymentUnreachable">Non \xE8 stato possibile contattare il fornitore del servizio di pagament, si prega di riprovare</p></div></div><!-- RIEPILOGO COSTI NEL CARRELLO --><div><table class="riepilogo-costi-table"><tr><th>{{ \'theFoodApp.concludi.totaleProdotti\' | translate }}</th><td class="text-right">{{ vm.getImportoArticoliSenzaSconti() | currency:\'\u20AC\' }}</td></tr><tr><th>{{ \'theFoodApp.concludi.costoConsegna\' | translate }}</th><td class="text-right" ng-class="{ \'loading-dots\': vm.dataOraLoading }"><div ng-if="!vm.dataOraLoading"><div ng-if="vm.dataOraConfirmed && vm.hasCostoSpedizione()">{{ vm.getCostoSpedizione() | currency:\'\u20AC\' }}</div><div ng-if="!vm.dataOraConfirmed || !vm.hasCostoSpedizione()">--</div></div></td></tr><tr ng-if="vm.hasSconto()"><th>{{ \'theFoodApp.concludi.totaleSconti\' | translate }}</th><td class="text-right" ng-class="{ \'loading-dots\': vm.dataOraLoading }"><div ng-if="!vm.dataOraLoading"><div ng-if="vm.dataOraConfirmed">-{{ vm.getScontoTotale() | currency:\'\u20AC\' }}</div><div ng-if="!vm.dataOraConfirmed">--</div></div></td></tr><tr ng-if="vm.dataOraConfirmed && vm.codiceCouponInserito.length > 0"><th>{{ \'theFoodApp.concludi.coupon\' | translate }}</th><td class="text-right" ng-class="{ \'loading-dots\': vm.dataOraLoading }"><div ng-if="!vm.dataOraLoading"><div ng-if="vm.dataOraConfirmed">-{{ vm.ordine.scontoCoupon | currency:\'\u20AC\' }}</div><div ng-if="!vm.dataOraConfirmed && vm.codiceCouponInserito.length > 0">--</div></div></td></tr><tr ng-if="vm.dataOraConfirmed && vm.utilizzaCredito"><th>{{ \'theFoodApp.concludi.credito\' | translate }}</th><td class="text-right" ng-class="{ \'loading-dots\': vm.dataOraLoading }"><div ng-if="!vm.dataOraLoading"><div ng-if="vm.dataOraConfirmed">-{{ vm.totaleConCredito() | currency:\'\u20AC\' }}</div><div ng-if="!vm.dataOraConfirmed && vm.codiceCouponInserito.length > 0">--</div></div></td></tr><tr ng-if="vm.dataOraConfirmed && (vm.debito > 0)"><th>{{ \'theFoodApp.concludi.debito\' | translate }}</th><td class="text-right" ng-class="{ \'loading-dots\': vm.dataOraLoading }"><div ng-if="!vm.dataOraLoading"><div ng-if="vm.dataOraConfirmed">{{ vm.debito | currency:\'\u20AC\' }}</div><div ng-if="!vm.dataOraConfirmed">--</div></div></td></tr><tr><th>{{ \'theFoodApp.concludi.totaleOrdine\' | translate }}</th><td class="text-right" ng-class="{ \'loading-dots\': vm.dataOraLoading }"><div ng-if="!vm.dataOraLoading"><div ng-if="vm.dataOraConfirmed">{{ vm.totaleCarrello() | currency:\'\u20AC\' }}</div><div ng-if="!vm.dataOraConfirmed">--</div></div></td></tr></table></div><!-- SEZIONE INDIRIZZO DI CONSEGNA --><div ng-if="!vm.isTakeaway"><hr><div class="row"><div class="form-group col-sm-8"><label class="control-label" data-translate="theFoodApp.concludi.indirizzo" for="field_indirizzo">Indirizzo</label><span>*</span> <input type="text" class="form-control" name="indirizzo" id="field_indirizzo" ng-model="vm.indirizzo.strada.descrizione" readonly="readonly"></div><div class="form-group col-sm-4"><label class="control-label" data-translate="theFoodApp.concludi.civico" for="field_civico">Civico</label><span>*</span> <input type="text" class="form-control" name="civico" id="field_civico" ng-model="vm.indirizzo.civico" readonly="readonly"></div></div><div class="row"><div class="form-group col-sm-3"><label class="control-label" for="field_tipoIndirizzo" data-translate="theFoodApp.concludi.tipoIndirizzo">Tipo Indirizzo</label><span>*</span><select class="form-control" id="field_tipoIndirizzo" name="tipoIndirizzo" ng-model="vm.indirizzo.tipoIndirizzo.id" ng-options="tipoIndirizzo.id as (vm.getLocale() == \'it\' ? tipoIndirizzo.descrizioneIta : tipoIndirizzo.descrizioneEng) for tipoIndirizzo in vm.tipoindirizzo" required></select><p class="help-block error-block" ng-show="editForm.tipoIndirizzo.$error.required" data-translate="entity.validation.required">Questo campo \xE8 obbligatorio</p></div><div class="form-group col-sm-9"><label class="control-label" data-translate="theFoodApp.concludi.nomeSulCampanello" for="field_nomeSulCampanello">Nome Sul Campanello</label><span>*</span> <input type="text" class="form-control" name="nomeSulCampanello" id="field_nomeSulCampanello" ng-model="vm.indirizzo.nomeSulCampanello" required><p class="help-block error-block" ng-show="editForm.nomeSulCampanello.$error.required" data-translate="entity.validation.required">Questo campo \xE8 obbligatorio</p></div></div><!-- RECAPITI --><div class="row"><div class="form-group col-sm-6"><label class="control-label" data-translate="theFoodApp.concludi.telefono" for="field_telefono">Telefono</label><span>*</span> <input type="text" class="form-control" name="telefono" id="field_telefono" ng-model="vm.indirizzo.telefono" telefono required uib-popover="{{\'theFoodApp.indirizzo.informativa\' | translate}}" data-popover-title="{{\'theFoodApp.indirizzo.informativa-title\' | translate}}" data-popover-placement="top" data-popover-append-to-body="true" data-popover-trigger="focus"><p class="help-block error-block" ng-show="editForm.telefono.$error.required" data-translate="entity.validation.required">Questo campo \xE8 obbligatorio</p></div><div class="form-group col-sm-6"><label class="control-label" data-translate="theFoodApp.concludi.telefono2" for="field_telefono2">Telefono 2</label><input type="text" class="form-control" name="telefono2" id="field_telefono2" ng-model="vm.indirizzo.telefono2" telefono></div></div><!-- INFORMAZIONI INTERNO APPARTAMENTO --><div class="row"><div class="form-group col-sm-4"><label class="control-label" data-translate="theFoodApp.concludi.piano" for="field_piano">Piano</label><span>*</span> <input type="text" class="form-control" name="piano" id="field_piano" ng-model="vm.indirizzo.piano" autocomplete="off" required><p class="help-block error-block" ng-show="editForm.piano.$error.required" data-translate="entity.validation.required">Questo campo \xE8 obbligatorio</p></div><div class="form-group col-sm-4"><label class="control-label" data-translate="theFoodApp.concludi.scala" for="field_scala">Scala</label><input type="text" class="form-control" name="scala" id="field_scala" ng-model="vm.indirizzo.scala" autocomplete="off"></div><div class="form-group col-sm-4"><label class="control-label" data-translate="theFoodApp.concludi.interno" for="field_interno">Interno</label><input type="text" class="form-control" name="interno" id="field_interno" ng-model="vm.indirizzo.interno" autocomplete="off"></div></div><div class="form-group"><label class="control-label" data-translate="theFoodApp.concludi.note" for="field_note">Note</label><input type="text" class="form-control" name="note" id="field_note" ng-model="vm.indirizzo.note" autocomplete="off"></div><div class="row"><div class="form-group col-sm-4"><label class="control-label" data-translate="theFoodApp.concludi.codiceLotteria" for="field_codiceLotteria">Scala</label><input type="text" class="form-control" name="codiceLotteria" id="field_codiceLotteria" ng-model="vm.codiceLotteria" minlength="8" maxlength="8" autocomplete="off"></div><div class="form-group col-sm-8"><label class="control-label" onclick="event.preventDefault();">&nbsp;</label><br><div class="checkbox"><label><input type="checkbox" ng-model="vm.checkCodiceLotteria" ng-change="!vm.checkCodiceLotteria" name="checkCodiceLotteria"> Usa il codice lotteria per questo ordine</label></div></div></div><div class="row"><div class="form-group col-sm-12"><p>Il codice lotteria sar\xE0 valido solamente se il pagamento avviene alla consegna con metodo elettronico</p></div></div></div><!-- SEZIONE INDIRIZZO FATTURAZIONE --><div class="row" ng-if="vm.localeEmetteFattura()"><hr><div class="col-sm-12"><input type="checkbox" class="checkbox" name="emettiFattura" id="field_emettiFattura" ng-click="vm.emettiFattura = !vm.emettiFattura" ng-model="vm.checkEmettiFattura"><label class="control-label" for="field_emettiFattura" data-translate="theFoodApp.concludi.fatturazione">Indirizzo di fatturazione</label></div></div><div class="panel panel-default" uib-collapse="!vm.emettiFattura"><div class="panel-heading" data-translate="theFoodApp.datiFatturazione.detail.title">Dati fatturazione</div><div class="panel-body"><div class="well well-sm text-center" ng-if="vm.datiFatturazione.length === 0" data-translate="theFoodApp.cliente.datiFatturazione.nodata">Nessun dato di fatturazione presente.</div><div class="list-group" ng-if="vm.datiFatturazione.length > 0"><div class="dati-fatturazione" ng-repeat="datofatturazione in vm.datiFatturazione"><input type="radio" class="radio" ng-model="vm.idFatturazione" ng-value="{{datofatturazione.id}}" style="margin-right: 20px" id="datofatt_{{ $index }}"><label class="list-group-item" for="datofatt_{{ $index }}"><span>{{ datofatturazione.ragioneSociale}}</span><br><span style="margin-left: 20px">{{datofatturazione.indirizzo}}</span></label></div></div><div class="text-center"><button type="button" class="elementor-button-primary lg" ng-click="vm.datiFatturazioneDialog()"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" data-translate="theFoodApp.cliente.datiFatturazione.nuovo">Nuovo Indirizzo</span></button></div></div></div><!-- BOTTONE PER LO STEP SUCCESSIVO --><hr><div class="row text-center"><div class="col-sm-12"><button ng-show="!vm.dataOraConfirmed || editForm.$invalid || vm.isSaving" type="submit" class="elementor-button-primary lg disabled"><!-- <span class="glyphicon glyphicon-ban-circle"></span>\n                        &nbsp; --> <span>{{ \'theFoodApp.concludi.confermaOrdineBtn\' | translate }}</span></button> <button ng-show="vm.dataOraConfirmed && !editForm.$invalid && !vm.isSaving" type="submit" class="elementor-button-primary lg"><span class="glyphicon glyphicon-ok"></span> &nbsp; <span>{{ \'theFoodApp.concludi.confermaOrdineBtn\' | translate }}</span></button></div></div></form></div>');
$templateCache.put('app/pages/cliente/cliente-detail.html','<div><div class="go-back">&lt; <a ui-sref="landing" data-translate="theFoodApp.cliente.homepage">&lt; Home Page</a></div><!-- NOTIFICHE UTENTE --><div class="col-md-8 col-md-offset-2"><div class="alert alert-success" ng-show="vm.saved"><p data-translate="theFoodApp.cliente.messages.saved">Dati salvati con successo.</p></div><div class="alert alert-danger" ng-show="vm.saveFailed"><p data-translate="theFoodApp.cliente.messages.saveFailed">Non \xE8 stato possibile salvare le modifiche apportate.</p></div></div><form name="editForm" role="form" novalidate show-validation ng-submit="vm.save()"><!-- DATI UTENTE --><div class="row"><div class="form-group col-sm-6"><label class="control-label" data-translate="theFoodApp.cliente.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.cliente.nome" required autocomplete="given-name" ng-pattern="/^[A-Za-z\\s\xE8\xE9\xF2\xE0\xF9\xEC]*$/" ng-maxlength="50"><div ng-show="editForm.nome.$invalid && editForm.nome.$dirty"><p class="help-block" ng-show="editForm.nome.$error.required" data-translate="entity.validation.required">Campo nome obbligatorio.</p><p class="help-block" ng-show="editForm.nome.$error.maxlength" data-translate="theFoodApp.cliente.messages.maxlength">Il nome non pu\xF2 essere pi\xF9 lungo di 50 caratteri.</p><p class="help-block" ng-show="editForm.nome.$error.pattern" data-translate="theFoodApp.cliente.messages.pattern">Il nome pu\xF2 contenere solamente lettere.</p></div></div><div class="form-group col-sm-6"><label class="control-label" data-translate="theFoodApp.cliente.cognome" for="field_cognome">Cognome</label><input type="text" class="form-control" name="cognome" id="field_cognome" ng-model="vm.cliente.cognome" required autocomplete="family-name" ng-pattern="/^[A-Za-z\'\\s\xE8\xE9\xF2\xE0\xF9\xEC]*$/" ng-maxlength="50"><div ng-show="editForm.cognome.$invalid && editForm.cognome.$dirty"><p class="help-block" ng-show="editForm.cognome.$error.required" data-translate="entity.validation.required">Campo cognome obbligatorio.</p><p class="help-block" ng-show="editForm.cognome.$error.maxlength" data-translate="theFoodApp.cliente.messages.maxlength">Il cognome non pu\xF2 essere pi\xF9 lungo di 50 caratteri.</p><p class="help-block" ng-show="editForm.cognome.$error.pattern" data-translate="theFoodApp.cliente.messages.pattern">Il cognome pu\xF2 contenere solamente lettere.</p></div></div></div><div class="row"><div class="form-group col-sm-6"><label class="control-label" for="field_dataDiNascita" data-translate="global.form.dateOfBirth">Data di nascita</label><div class="input-group"><input type="text" class="form-control" id="field_dataDiNascita" name="dataDiNascita" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.cliente.dataDiNascita" is-open="vm.datePickerOpenStatus.dataDiNascita" placeholder="{{\'global.form.dateOfBirth.placeholder\' | translate}}" show-button-bar="false" datepicker-options="vm.datepickerOptions" ng-pattern="/^(?:(?:(?:0[1-9]|1\\d|2[0-8])\\/(?:0[1-9]|1[0-2])|(?:29|30)\\/(?:0[13-9]|1[0-2])|31\\/(?:0[13578]|1[02]))\\/[1-9]\\d{3}|29\\/02\\/(?:[1-9]\\d(?:0[48]|[2468][048]|[13579][26])|(?:[2468][048]|[13579][26])00))$/" ng-model-options="{timezone:\'UTC/GMT\'}"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dataDiNascita\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.dataDiNascita.$invalid"><p class="help-block" ng-show="editForm.dataDiNascita.$error" data-translate="global.form.dateOfBirth.pattern">Data di nascita non valida.</p></div></div><div class="form-group col-sm-6"><label class="control-label" for="field_gender" data-translate="global.form.gender">Sesso</label><select class="form-control" id="field_gender" name="gender" ng-model="vm.cliente.sesso"><option ng-repeat="gender in vm.genderList" value="{{gender.id}}">{{gender.value | translate}}</option></select></div></div><div class="row"><div class="form-group col-sm-6"><label class="control-label" data-translate="theFoodApp.cliente.email" for="field_email">Email</label><input ng-readonly="vm.cliente.socialUser" type="text" class="form-control" name="email" id="field_email" ng-model="vm.cliente.user.email" required autocomplete="email"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group col-sm-6"><label class="control-label" data-translate="theFoodApp.cliente.telefono" for="field_telefono">Email</label><input type="text" class="form-control" name="telefono" id="field_telefono" ng-model="vm.cliente.telefono" ng-minlength="5" ng-maxlength="50" telefono><div ng-show="editForm.telefono.$dirty && editForm.telefono.$invalid"><p class="help-block" ng-show="editForm.telefono.$error.required" data-translate="global.messages.validate.telefono.required">Your phone number is required.</p><p class="help-block" ng-show="editForm.telefono.$error.telefono || editForm.telefono.$error.pattern" data-translate="global.messages.validate.telefono.invalid">Your phone number is invalid.</p><p class="help-block" ng-show="editForm.telefono.$error.minlength" data-translate="global.messages.validate.telefono.minlength">Your phone number is required to be at least 5 characters.</p><p class="help-block" ng-show="editForm.telefono.$error.maxlength" data-translate="global.messages.validate.telefono.maxlength">Your phone number cannot be longer than 50 characters.</p></div></div></div><div class="row"><div class="form-group col-sm-12"><label class="control-label" data-translate="theFoodApp.cliente.note" for="field_note">Note</label><textarea class="form-control" name="note" id="field_note" ng-model="vm.cliente.note" ng-maxlength="1024"> </textarea></div></div><!-- CONSENSI --><div class="row text-center"><div class="form-group col-sm-4"><input type="checkbox" class="checkbox" name="consensoCondizioni" id="field_consensoCondizioni" ng-model="vm.cliente.consensoCondizioni" required><label class="control-label consenso-condizioni" for="field_consensoCondizioni"><a target="_blank" ng-click="vm.goPrivacyPolicy()"><span class="control-label" data-translate="theFoodApp.cliente.consensoCondizioni">Consenso Profilazione </span></a><span class="control-label" data-translate="theFoodApp.cliente.e">e </span><a target="_blank" href="http://www.iubenda.com/privacy-policy/58074298"><span class="control-label" data-translate="theFoodApp.cliente.consensoPrivacyPolicy">Privacy Policy</span></a></label><div ng-show="editForm.consensoCondizioni.$error.required && editForm.consensoCondizioni.$dirty"><p class="help-block" data-translate="theFoodApp.cliente.consensoCondizioniRichiesto"></p></div></div><div class="form-group col-sm-4"><input type="checkbox" class="checkbox" name="consensoProfilazione" id="field_consensoProfilazione" ng-model="vm.cliente.consensoProfilazione"><label class="control-label" for="field_consensoProfilazione" data-translate="theFoodApp.cliente.consensoProfilazione">Consenso Profilazione</label><p class="messaggio-consenso" data-translate="theFoodApp.cliente.consensoProfilazioneMessaggio"></p></div><div class="form-group col-sm-4"><input type="checkbox" class="checkbox" name="consensoCommerciale" id="field_consensoCommerciale" ng-model="vm.cliente.consensoCommerciale"><label class="control-label" for="field_consensoCommerciale" data-translate="theFoodApp.cliente.consensoCommerciale">Consenso Commerciale</label><p class="messaggio-consenso" data-translate="theFoodApp.cliente.consensoCommercialeMessaggio"></p></div></div><!-- INDIRIZZI DI CONSEGNA --><div class="panel panel-default"><div class="panel-heading" data-translate="theFoodApp.cliente.indirizzi.title">Indirizzi</div><div class="panel-body"><div class="table-responsive" ng-if="vm.indirizzi.length > 0"><table class="jh-table table table-striped"><thead><tr><th class="visible-xs"></th><th class="hidden-xs"><span data-translate="theFoodApp.indirizzo.tipoIndirizzo">Tipo Indirizzo</span></th><th><span data-translate="theFoodApp.indirizzo.detail.title">Indirizzo</span></th><th><span data-translate="theFoodApp.indirizzo.comune">Comune</span></th><th class="hidden-xs"><span data-translate="theFoodApp.indirizzo.telefono">Telefono</span></th><th class="hidden-xs"></th></tr></thead><tbody><tr ng-repeat="indirizzo in vm.indirizzi track by indirizzo.id"><td class="visible-xs"><div><button type="button" ng-click="vm.modificaIndirizzo(indirizzo)" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="button" ng-click="vm.cancellaIndirizzo(indirizzo)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td><td class="hidden-xs">{{ vm.getLocale() == \'it\' ? indirizzo.tipoIndirizzo.descrizioneIta : indirizzo.tipoIndirizzo.descrizioneEng }}</td><td>{{indirizzo.strada.descrizione}}</td><td>{{indirizzo.strada.descrizioneComune | capitalize}}</td><td class="hidden-xs">{{indirizzo.telefono}}</td><td class="hidden-xs text-right"><div><button type="button" ng-click="vm.modificaIndirizzo(indirizzo)" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="button" ng-click="vm.cancellaIndirizzo(indirizzo)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="well well-sm text-center" ng-if="vm.indirizzi.length === 0" data-translate="theFoodApp.cliente.indirizzi.nodata">Nessun indirizzo presente.</div><div class="text-center"><button type="button" class="elementor-button-primary lg" ng-click="vm.aggiungiIndirizzo()"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" data-translate="theFoodApp.cliente.indirizzi.nuovo">Nuovo Indirizzo</span></button></div></div></div><!-- DATI DI FATTURAZIONE --><div class="panel panel-default"><div class="panel-heading" data-translate="theFoodApp.datiFatturazione.detail.title">Dati fatturazione</div><div class="panel-body"><div class="table-responsive" ng-if="vm.datiFatturazione.length > 0"><table class="jh-table table table-striped"><thead><tr><th class="visible-xs"></th><th><span data-translate="theFoodApp.datiFatturazione.ragioneSociale">Ragione Sociale</span></th><th class="hidden-xs"><span data-translate="theFoodApp.datiFatturazione.pIva">P.Iva</span></th><th class="hidden-xs"><span data-translate="theFoodApp.datiFatturazione.indirizzo">Indirizzo</span></th><th class="hidden-xs"><span data-translate="theFoodApp.datiFatturazione.citta">Citta</span></th><th class="hidden-xs"><span data-translate="theFoodApp.datiFatturazione.telefono">Telefono</span></th><th class="hidden-xs"><span data-translate="theFoodApp.datiFatturazione.pec">Pec</span></th><th class="hidden-xs"><span data-translate="theFoodApp.datiFatturazione.sdi">Sdi</span></th><th class="hidden-xs"></th></tr></thead><tbody><tr ng-repeat="datoFatturazione in vm.datiFatturazione track by datoFatturazione.id"><td class="visible-xs"><div><button type="button" ng-click="vm.modificaDatiFatturazione(datoFatturazione)" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="button" ng-click="vm.cancellaDatiFatturazione(datoFatturazione)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td><td>{{datoFatturazione.ragioneSociale}}</td><td class="hidden-xs">{{datoFatturazione.pIva}}</td><td class="hidden-xs">{{datoFatturazione.indirizzo | capitalize}}</td><td class="hidden-xs">{{datoFatturazione.citta | capitalize}}</td><td class="hidden-xs">{{datoFatturazione.telefono}}</td><td class="hidden-xs">{{datoFatturazione.pec}}</td><td class="hidden-xs">{{datoFatturazione.sdi}}</td><td class="hidden-xs text-right"><div><button type="button" ng-click="vm.modificaDatiFatturazione(datoFatturazione)" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="button" ng-click="vm.cancellaDatiFatturazione(datoFatturazione)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="well well-sm text-center" ng-if="vm.datiFatturazione.length === 0" data-translate="theFoodApp.cliente.datiFatturazione.nodata">Nessun dato di fatturazione presente.</div><div class="text-center"><button type="button" class="elementor-button-primary lg" ng-click="vm.aggiungiDatiFatturazione()"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" data-translate="theFoodApp.cliente.datiFatturazione.nuovo">Nuovo Indirizzo di fatturazione</span></button></div></div></div><!-- BOTTONE SALVATAGGIO --><div class="text-right"><button type="submit" ng-class="{\'disabled\' : editForm.$invalid || vm.isSaving}" class="elementor-button-primary lg"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form></div>');
$templateCache.put('app/pages/confirm-coupon-credito/confirm-coupon-credito.html','<div class="modal-header"><h4 class="modal-title" data-translate="theFoodApp.cliente.confirmCouponCredito.attenzione">Attenzione!</h4></div><div class="modal-body"><div class="row"><div class="col-md-12 messaggio-utente"><span data-translate="theFoodApp.cliente.confirmCouponCredito.text1"></span> <span>{{couponCode}}</span> <span data-translate="theFoodApp.cliente.confirmCouponCredito.text2"></span></div></div><div class="row"><div class="col-md-12" style="text-align: center; margin-top: 2%"><button type="submit" class="btn btn-primary" ng-click="modal.close(\'confirm\')"><span data-translate="theFoodApp.cliente.confirmCouponCredito.conferma">confirm</span></button> <button type="submit" class="btn btn-primary" ng-click="modal.close(\'cancel\')"><span data-translate="theFoodApp.cliente.confirmCouponCredito.annulla">cancel</span></button></div></div></div>');
$templateCache.put('app/pages/locale/calendario.directive.html','<table class="calendario-locale"><thead><tr align="center"><th colspan="2"></th><th ng-repeat="day in days">{{getDayOfTheWeek(day)}}</th></tr></thead><tbody><tr align="center"><th colspan="2" data-translate="theFoodApp.locale.pranzo">Pranzo</th><td ng-repeat="day in days" align="center"><span ng-if="isOpenAtLunch(day)"><span class="glyphicon glyphicon-ok icona-locale-aperto" uib-tooltip="{{ calendarioOrdinato[day].pranzoApre }} - {{ calendarioOrdinato[day].pranzoChiude }}"></span> </span><span ng-if="!isOpenAtLunch(day)"><span class="glyphicon glyphicon-remove icona-locale-chiuso" uib-tooltip="{{ \'theFoodApp.locale.chiuso\' | translate }}"></span></span></td></tr><tr align="center"><th colspan="2" data-translate="theFoodApp.locale.cena">Cena</th><td ng-repeat="day in days" align="center"><span ng-if="isOpenAtDinner(day)"><span class="glyphicon glyphicon-ok icona-locale-aperto" uib-tooltip="{{ calendarioOrdinato[day].cenaApre }} - {{ calendarioOrdinato[day].cenaChiude }}"></span> </span><span ng-if="!isOpenAtDinner(day)"><span class="glyphicon glyphicon-remove icona-locale-chiuso" uib-tooltip="{{ \'theFoodApp.locale.chiuso\' | translate }}"></span></span></td></tr></tbody></table>');
$templateCache.put('app/pages/locale/locale.html','<div class="go-back">&lt; <a ng-if="!vm.isTakeaway && !vm.isRunnerPizza" ui-sref="consegna" data-translate="theFoodApp.locale.elencoLocali">&lt; Elenco locali</a> <a ng-if="vm.isTakeaway && !vm.isRunnerPizza" ui-sref="takeaway" data-translate="theFoodApp.locale.elencoLocali">&lt; Elenco locali</a> <a ng-if="vm.isRunnerPizza" ui-sref="selezione-indirizzo" data-translate="theFoodApp.selezione-locale.indietro">&lt; Indietro</a></div><div class="locale-container"><div class="alert alert-info alert-dismissable" ng-if="vm.showAlertProductModified"><a class="close" data-dismiss="alert" aria-label="close">&times;</a> <span data-translate="theFoodApp.locale.articolo-modificato">Alcuni prodotti potrebbero aver subito una variazione di prezzo o non essere pi\xF9 disponibili.</span></div><jhi-alert></jhi-alert><!-- INFORMAZIONI APERTURA/CHIUSURA ODIERNA DEL LOCALE --><div class="apertura-locale"><p class="text-center {{ vm.informazioniAperturaOdierna.stileAperturaLocale }}"><span class="apertura-locale-descrizione">{{ vm.informazioniAperturaOdierna.descrizioneAperturaLocale | translate }} </span><span ng-show="vm.mostraPrimaConsegnaUtile">- {{ \'theFoodApp.locale.primaConsegnaUtile\' | translate }} {{ vm.informazioniAperturaOdierna.orarioPrimaConsegna }} </span><span ng-show="vm.informazioniAperturaOdierna.giornoProssimaConsegna">{{\'theFoodApp.locale.di\' | translate}} {{vm.informazioniAperturaOdierna.giornoProssimaConsegna | translate}} </span><!-- <span ng-show="vm.informazioniAperturaOdierna.nessunaDataDisponibile">\n\t\t\t\t- {{\'theFoodApp.locale.nessunaDataDisponibile\' | translate}}\n\t\t\t</span> --></p></div><div class="clearfix"><div class="locale-info-container outer-affix" affix><div class="inner-affix"><div class="locale-informazioni" ui-view="info"></div></div></div><div class="locale-listino-container"><div class="apertura-locale-placeholder">&nbsp;</div><div ui-view="listino"></div></div><div class="locale-carrello-container outer-affix" affix><div class="inner-affix"><div class="cart-header text-center"><i><!-- Icon Placeholder --></i> <span data-translate="theFoodApp.carrello.header">Riepilogo acquisti</span></div><div ui-view="carrello"></div></div></div></div></div>');
$templateCache.put('app/pages/locale/locale.info.html','<div class="locale altezza-informazioni-locale"><div class="locale-section"><div class="row locale-insegna"><div class="col-xs-6 col-sm-4 col-md-12"><div class="insegna-image text-xs-left text-sm-center"><img ng-src="{{SERVER_URL}}/static/images/insegne/{{ ll.locale.insegna.id }}.jpg" class="insegna-logo"></div></div><div class="col-xs-6 insegna-title-xs visibile-xs hidden-md hidden-sm hidden-lg"><span>{{ ll.locale.insegna.insegna }}</span></div><div class="col-xs-12 col-sm-7 visible-sm text-xs-center insegna-title-container"><div class="insegna-title"><span>{{ ll.locale.insegna.insegna }}</span></div><div class="">{{ ll.locale.indirizzo }}, {{ll.locale.civico}}{{ll.locale.rosso ? (\'theFoodApp.locale.civicoRosso\' | translate) : \'\' }}</div><div class="">{{ ll.locale.comune }}</div><!-- <div class="insegna-importo-min visible-sm" ng-if="!vm.isTakeaway">\n                    <div class="section-content">\n                        {{ \'theFoodApp.locale.listino.ordineMinimo\' | translate }} {{ll.locale.insegna.importoMinimoConsegna | currency: \'\u20AC\'}}\n                    </div>\n                </div> --><!-- <div class="insegna-orario visible-sm">\n                    <div class="section-title dropdown">\n                        <span class="orario dropdown-toggle" data-toggle="dropdown" data-translate="theFoodApp.locale.listino.orario" ng-click="vm.mostraOrario = !vm.mostraOrario">\n                            Orario\n                        </span>&nbsp<span class="caret-the-food" ng-class="{\'caret-the-food-up\':vm.mostraOrario}"></span>\n                    </div>\n                    <div class="section-content" uib-collapse="!vm.mostraOrario">\n                        <calendario data="ll.locale.calendarios"></calendario>\n                    </div>\n                </div> --></div></div></div><div ng-show="vm.promozioni.length > 0" class="locale-section hidden-xs"><div class="section-title text-xs-center text-sm-center" ng-click="vm.mostraPromozioni = !vm.mostraPromozioni"><span class="promozioni" data-translate="theFoodApp.locale.promozioni">Promozioni attive: </span>&nbsp<span class="caret-the-food" ng-class="{\'caret-the-food-up\':vm.mostraPromozioni}"></span></div><div uib-collapse="!vm.mostraPromozioni" class="categorie-group" ng-repeat="promozione in vm.promozioni"><li class="list-group-item" ng-if="!promozione.promozioneApp"><b>- {{promozione | languageSwitch: \'nomePromozioneIt\':\'nomePromozioneEn\'}}</b><br>&nbsp {{promozione | languageSwitch: \'descrizioneIt\':\'descrizioneEn\'}}</li></div></div><div class="locale-section"><div class="section-title text-xs-center text-sm-center" ng-click="vm.mostraLinee = !vm.mostraLinee"><span class="categorie" data-translate="theFoodApp.locale.listino.categorie">Tipologie prodotti: </span>&nbsp<span class="caret-the-food" ng-class="{\'caret-the-food-up\':vm.mostraLinee}"></span></div><div uib-collapse="!vm.mostraLinee" class="list-group categorie-group lista-categorie"><a ng-repeat="l in vm.linee" class="list-group-item categorie-group-item" offset="120" du-scrollspy="linea-{{ l.id }}" du-smooth-scroll="linea-{{ l.id }}">{{l | languageSwitch: \'descrizioneIt\':\'descrizioneEn\'}} ({{l.prodottos.length}})</a></div></div><!-- <div class="locale-section hidden-sm">\n        <div role="button" class="section-title text-xs-center text-sm-center" ng-click="vm.mostraOrario = !vm.mostraOrario">\n            <span class="orario" data-translate="theFoodApp.locale.listino.orario">\n\t\t\t\tOrario\n\t\t\t</span>&nbsp<span class="caret-the-food" ng-class="{\'caret-the-food-up\':vm.mostraOrario}"></span>\n        </div>\n        <div class="section-content" uib-collapse="!vm.mostraOrario">\n            <calendario data="ll.locale.calendarios"></calendario>\n        </div>\n    </div> --><div class="locale-section visibile-xs hidden-sm hidden-md hidden-lg" ng-if="!vm.isTakeaway"><div class="section-content text-xs-center text-sm-center">{{ \'theFoodApp.locale.listino.ordineMinimo\' | translate }} {{ll.locale.insegna.importoMinimoConsegna | currency: \'\u20AC\'}}</div></div><div class="locale-section"><div class="section-title insegna-title hidden-xs hidden-sm insegna-collapse" ng-click="vm.mostraDescrizione = !vm.mostraDescrizione"><span>{{ ll.locale.insegna.insegna }}</span>&nbsp<span class="caret-the-food" ng-class="{\'caret-the-food-up\':vm.mostraDescrizione}"></span></div><div class="section-content insegna-description" uib-collapse="!vm.mostraDescrizione"><span style="white-space:pre-wrap">{{ ll.locale.insegna | languageSwitch:\'descrizioneIt\':\'descrizioneEn\' }}</span></div></div><div class="locale-section" uib-collapse="!vm.mostraDescrizione"><div class="section-content"><div class="hidden-xs hidden-sm">{{ ll.locale.indirizzo }}, {{ll.locale.civico}}{{ll.locale.rosso ? (\'theFoodApp.locale.civicoRosso\' | translate) : \'\' }}</div><div class="hidden-xs hidden-sm">{{ ll.locale.comune }}</div><div ng-if="ll.locale.website !== null"><a href="http://{{ ll.locale.website }}" target="_blank">{{ ll.locale.website }}</a></div></div></div></div>');
$templateCache.put('app/pages/locale/locale.listino.html','<div class="listino"><div class="linea" ng-repeat="linea in vm.linee" id="linea-{{linea.id}}"><div class="linea-title">{{ linea | languageSwitch:\'descrizioneIt\':\'descrizioneEn\' }}<div ng-if="linea.descrizioneEstesaIt" class="linea-subtitle">{{ linea | languageSwitch:\'descrizioneEstesaIt\':\'descrizioneEstesaEn\' }}</div></div><!-- <div class="linea-subtitle">\n\t\t\t{{ linea | languageSwitch:\'descrizioneEstesaIt\':\'descrizioneEstesaEn\' }}\n\t\t</div> --><div class="linea-contents"><div class="prodotto" ng-repeat="prodotto in linea.prodottos | orderBy:\'sortOrder\'"><div ng-show="prodotto.visibile" class="prodotto-main"><!-- <div class="prodotto-id">\n\t\t\t\t\t\t{{ prodotto.id }}.\n\t\t\t\t\t</div> --><div class="prodotto-descrizione">{{ prodotto | languageSwitch:\'descrizioneIt\':\'descrizioneEn\' }} <span ng-repeat="attributo in prodotto.attributos"><img class="attributo-icon" ng-src="{{SERVER_URL}}/static/images/{{ attributo.imageUrl }}" uib-tooltip="{{attributo | languageSwitch: \'descrizioneIt\' : \'descrizioneEn\'}}" tooltip-append-to-body="true"></span><div class="prodotto-descrizione-estesa">{{ prodotto | languageSwitch:\'descrizioneEstesaIt\':\'descrizioneEstesaEn\' }}</div></div><div class="prodotto-prezzo">{{ vm.getPrezzoProdotto(prodotto) | currency:\'\u20AC\' }}</div><div class="prodotto-aggiunta"><button type="button" class="btn btn-round btn-primary" ng-click="vm.aggiungiProdotto(prodotto)"><span class="glyphicon glyphicon-plus"></span></button></div></div><div class="prodotto-menu" ng-if="prodotto.menus && prodotto.menus.length"><div class="scelta-menu col-xs-12 col-lg-4 col-md-6" ng-repeat="scelta in prodotto.menus | orderBy:\'sortOrder\'" ng-class="{ \'has-error\': vm.showMenuError === prodotto.id && !scelta.opzionale && !vm.scelteMenu[ scelta.id ] }"><label for="menu-{{ prodotto.id }}-{{ scelta.id }}" class="control-label">{{ scelta | languageSwitch:\'descrizioneIt\':\'descrizioneEn\' }}</label><select class="form-control" ng-model="vm.scelteMenu[ scelta.id ]" ng-change="vm.onSceltaMenuChanged(scelta)"><option><option ng-repeat="prodotto in scelta.prodottoAssociatoes" value="{{ prodotto.id }}">{{ prodotto | languageSwitch:\'descrizioneIt\':\'descrizioneEn\' }}</option></select></div></div><div class="alert alert-danger alert-sm alert-bottom" ng-if="vm.showMenuError === prodotto.id"><span data-translate="theFoodApp.carrello.required-menu-choices-error">Il tuo carrello \xE8 attualmente vuoto.</span></div></div></div></div><!--<div class="visible-xs" style="margin-top:30px;margin-bottom:10px;text-align:center">\n\t\t<button class="btn btn-primary" ui-sref="carrello" ng-disabled="vm.getImportoCarrello() <= 0">\n\t\t\t<span class="glyphicon glyphicon-shopping-cart"></span>\n\t\t\t&nbsp;\n\t\t\t<strong>{{ vm.getImportoCarrello() | currency }}</strong>\n\t\t</button>\n\t</div>--></div>');
$templateCache.put('app/pages/selezione-indirizzo/selezione-indirizzo.html','<div class="text-center selezione-indirizzo"><jhi-alert></jhi-alert><!-- <ng-include src="\'/static/pages/note.html\'" /> --><div class="panel panel-default indirizzo-new"><!-- Indirizo manuale --><div class="panel-heading consegna-domicilio-label" data-translate="theFoodApp.selezione-indirizzo.type-address"></div><!-- <h2 data-translate="theFoodApp.selezione-indirizzo.note"></h2> --><ng-include src="vm.getNotePage()"></ng-include><div class="panel-body" ui-view="new"></div></div><div class="panel panel-default" ng-if="vm.showAddressBook"><!-- Rubrica--><div class="panel-heading" data-translate="theFoodApp.selezione-indirizzo.select-address"></div><div class="panel-body" ui-view="rubrica"></div></div><!-- <div class="panel panel-default">\n\t\t<div class="panel-heading takeaway-panel-heading">{{"theFoodApp.selezione-indirizzo.take-away-title" | translateEnv}}</div>\n\t\t<div class="panel-body" ui-view="takeaway"></div>\n\t</div> --></div><div class="panel panel-default marketing-panel"><ng-include src="vm.getInfoCommerciali()"></ng-include></div>');
$templateCache.put('app/pages/selezione-indirizzo/selezione-indirizzo.new.html','<form role="form" name="indirizzoForm" class="form selezione-indirizzo-new" novalidate show-validation><div ng-if="!vm.validAddress || !vm.selectedAddress" class="alert alert-warning" data-translate="theFoodApp.selezione-indirizzo.error.invalid-address"></div><div ng-if="!vm.validZone" class="alert alert-warning" data-translate="theFoodApp.selezione-indirizzo.error.invalid-zone"></div><div class="row text-left" ng-class="{\'has-error\': !vm.validAddress || !vm.selectedAddress}"><div class="form-group col-lg-4 col-md-4"><label class="control-label" data-translate="theFoodApp.selezione-indirizzo.address" for="field_indirizzo">Indirizzo</label><input type="text" class="form-control" name="indirizzo" id="field_indirizzo" ng-model="vm.strada" strada required typeahead-on-select="vm.onAddressSelected($item)" placeholder="{{\'theFoodApp.selezione-indirizzo.address-placeholder\' | translate}}"></div><div class="form-group col-lg-2 col-md-4"><label class="control-label" data-translate="theFoodApp.selezione-indirizzo.number" for="field_civico">Civico</label><input enter-key-press="vm.searchZona(vm.strada,vm.civico)" type="text" class="form-control" name="civico" id="field_civico" ng-model="vm.civico" civico required></div><div class="form-group col-lg-3 col-md-4"><button type="submit" class="search-btn elementor-button-primary lg" ng-click="vm.searchZona(vm.strada,vm.civico)">{{"theFoodApp.selezione-indirizzo.search-new" | translateEnv}}</button></div><div class="form-group col-lg-3 col-md-12"><button type="button" ui-sref="takeaway" class="search-btn elementor-button-primary lg">{{"theFoodApp.selezione-indirizzo.take-away" | translateEnv}}</button></div></div><div class="row text-left"><div class="has-error col-md-12"><span ng-if="!vm.selectedAddress && vm.strada" class="help-block error-block" data-translate="theFoodApp.selezione-indirizzo.error.street-not-selected">Prego selezionare un indirizzo da quelli disponibili.</span> <span ng-if="indirizzoForm.indirizzo.$invalid && (indirizzoForm.indirizzo.$dirty || indirizzoForm.$submitted) && !vm.strada" class="help-block error-block" data-translate="theFoodApp.selezione-indirizzo.error.empty-street">Prego indicare un indirizzo per la consegna.</span> <span ng-if="indirizzoForm.civico.$invalid && (indirizzoForm.civico.$dirty || indirizzoForm.$submitted)" class="help-block error-block" data-translate="theFoodApp.selezione-indirizzo.error.invalid-number">Prego inserire un numero civico valido.</span></div></div></form>');
$templateCache.put('app/pages/selezione-indirizzo/selezione-indirizzo.rubrica.html','<div><div ng-if="!vm.validZone" class="alert alert-warning" data-translate="theFoodApp.selezione-indirizzo.error.invalid-zone"></div><div class="list-group max-height-address-book"><a class="list-group-item" ng-repeat="indirizzo in vm.addressBook" ng-click="vm.selezionaIndirizzo( indirizzo )">{{ vm.getDescrizione(indirizzo) }}</a></div></div>');
$templateCache.put('app/pages/selezione-indirizzo/selezione-indirizzo.takeaway.html','<!-- <button type="button" ui-sref="takeaway" class="btn btn-primary takeaway-btn word-break">{{"theFoodApp.selezione-indirizzo.take-away" | translateEnv}}</button> --> <button type="button" ui-sref="takeaway" class="btn btn-primary search-btn word-break">{{"theFoodApp.selezione-indirizzo.take-away" | translateEnv}}</button>');
$templateCache.put('app/pages/promozioni/promozioni.full.html','<div class="promozioni-full"><a ui-sref="^">&lt; Modifica il tuo ordine</a><div class="row text-center"><span class="h3">{{\'theFoodApp.promozioni.titolo\' | translate}}</span></div><div class="row text-center promozioni-list" ng-repeat="promozione in vm.promozioni"><span ng-if="!promozione.promozioneApp">{{promozione | languageSwitch: \'nomePromozioneIt\':\'nomePromozioneEn\'}}</span><br><span ng-if="!promozione.promozioneApp">{{promozione | languageSwitch: \'descrizioneIt\':\'descrizioneEn\'}}</span><hr></div></div>');
$templateCache.put('app/pages/payment/payment-cancel.html','<h4 data-translate="payments.payments-cancel.title">Payment aborted by user</h4>');
$templateCache.put('app/pages/payment/payment-error.html','<h4 data-translate="payments.payments-error.title">Payment error</h4>');
$templateCache.put('app/pages/payment/payment-ok.html','<div class="payment-result-container"><!--<jhi-alert-error></jhi-alert-error>--><div class="col-sm-12"><div class="alert alert-success"><h3 data-translate="payments.payments-ok.title">Payment successfully made</h3><div ng-if="vm.ordine.ritiroAlLocale"><h4 data-translate="payments.payments-ok.takeaway"></h4><div class="row"><div class="col-sm-12">{{vm.locale.insegna.insegna}} - {{vm.locale.indirizzo}}, {{vm.locale.civico}} {{vm.locale.comune}}</div><div class="col-sm-12">{{"payments.payments-ok.orario-consegna" | translate}}: {{vm.getOrariConsegna(vm.ordine.orarioConsegna, vm.locale)}}</div><div class="col-sm-12">{{"payments.payments-ok.data-consegna" | translate}}: {{vm.dataOrdine | date:\'shortDate\'}}</div></div></div><div ng-if="!vm.ordine.ritiroAlLocale"><h4 data-translate="payments.payments-ok.consegna"></h4><div class="row"><div class="col-sm-12">{{vm.indirizzo.indirizzoAsText}} {{vm.indirizzo.strada.descrizioneComune}}</div><div class="col-sm-12">{{"payments.payments-ok.orario-consegna" | translate}}: {{vm.getOrariConsegna(vm.ordine.orarioConsegna, vm.locale)}}</div><div class="col-sm-12">{{"payments.payments-ok.data-consegna" | translate}}: {{vm.dataOrdine | date:\'shortDate\'}}</div></div></div></div></div><div class="col-sm-12 col-md-8"><div class="panel"><div class="panel-body"><div class="row"><div class="col-sm-4" data-translate="payments.payments-ok.issuer"></div><div class="col-sm-6">{{vm.pagamento.issuer}}</div></div><div class="row"><div class="col-sm-4" data-translate="payments.payments-ok.data-ora-transazione"></div><div class="col-sm-6">{{vm.dataOraTransazione | date:\'shortDate\'}} {{vm.dataOraTransazione | date:\'shortTime\'}}</div></div><div class="row"><div class="col-sm-4" data-translate="payments.payments-ok.transaction-id"></div><div class="col-sm-6">{{vm.pagamento.transactionId}}</div></div><div class="row"><div class="col-sm-4" data-translate="payments.payments-ok.ordine-id"></div><div class="col-sm-6">{{vm.ordine.id}}</div></div><div class="row"><div class="col-sm-4" data-translate="payments.payments-ok.data-ordine"></div><div class="col-sm-6">{{vm.dataOrdine | date:\'shortDate\'}}</div></div></div></div></div><div class="col-sm-12 col-md-4"><div class="panel"><div class="panel-body"><div class="row"><div class="col-xs-6 col-sm-4" data-translate="payments.payments-ok.importo-ordine"></div><div class="col-xs-6">{{vm.ordine.importoOrdine | currency:\'\u20AC\'}}</div></div><div class="row"><div class="col-xs-6 col-sm-4" data-translate="payments.payments-ok.importo-spedizione"></div><div class="col-xs-6">{{vm.ordine.importoSpedizione | currency:\'\u20AC\'}}</div></div><div class="row"><div class="col-xs-6 col-sm-4" data-translate="payments.payments-ok.importo-totale"></div><div class="col-xs-6">{{vm.ordine.importoOrdine + vm.ordine.importoSpedizione | currency:\'\u20AC\'}}</div></div></div></div></div><pre>\n\n\t\t{{vm.pagamento | json}}\n\t</pre></div>');
$templateCache.put('app/pages/selezione-locale/locale.directive.html','<div class="locale-info"><div class="locale-address text-xs-center text-sm-center"><a ui-sref="locale({ t: vm.isTakeaway ? vm.locale.id : undefined, i: vm.locale.insegna.id })" class="linked">{{ vm.locale.indirizzo }}, {{vm.locale.civico}}{{vm.locale.rosso ? (\'theFoodApp.locale.civicoRosso\' | translate) : \'\' }} - {{ vm.locale.comune }}</a></div><div class="informazioni-apertura-collapse"><span ng-click="vm.mostraInfoApertura = !vm.mostraInfoApertura" data-translate="{{\'theFoodApp.locale.infoApertura\'| translate}}">Orari e informazioni</span></div><div uib-collapse="!vm.mostraInfoApertura"><table class="table locale-info-table"><thead><tr><th></th><th>{{\'theFoodApp.locale.calendario\' | translate}}</th><th>{{\'theFoodApp.locale.attesa\' | translate}}</th><th ng-if="!vm.isTakeaway">{{\'theFoodApp.locale.costoConsegna\' | translate}}</th></tr></thead><tbody><tr><th>{{\'theFoodApp.locale.pranzo\' | translate}}</th><td ng-if="!vm.pranzoApre">{{\'theFoodApp.locale.chiuso\' | translate}}</td><td ng-if="vm.pranzoApre" class="nowrap">{{ vm.pranzoApre }} - {{ vm.locale.calendarios[0].pranzoChiude }}</td><td class="nowrap"><span ng-if="vm.locale.attesaPrnz !== null">{{ vm.locale.attesaPrnz }} {{ \'minuti\' | translate }}</span></td><td ng-if="!vm.isTakeaway"><span ng-if="vm.locale.insegna.costoConsegnaPranzo !== null">{{vm.locale.insegna.costoConsegnaPranzo | currency: \'\u20AC\'}}</span></td></tr><tr><th>{{\'theFoodApp.locale.cena\' | translate}}</th><td ng-if="!vm.cenaApre">{{\'theFoodApp.locale.chiuso\' | translate}}</td><td ng-if="vm.cenaApre" class="nowrap">{{ vm.cenaApre }} - {{ vm.locale.calendarios[0].cenaChiude }}</td><td class="nowrap"><span ng-if="vm.locale.attesaCena !== null">{{ vm.locale.attesaCena }} {{ \'minuti\' | translate }}</span></td><td ng-if="!vm.isTakeaway"><span ng-if="vm.locale.insegna.costoConsegnaCena !== null">{{vm.locale.insegna.costoConsegnaCena | currency: \'\u20AC\'}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/selezione-locale/selezione-locale.html','<div class="alert alert-warning" ng-show="vm.insegne.length === 0" style="margin-bottom:0">Nessun locale trovato per i parametri specificati.</div><div ng-repeat="insegna in vm.insegne track by insegna.id" class="row insegna"><div class="insegna-logo"><div class="image-tag-container"><div ng-if="!vm.isTakeaway && insegna.tipoConsegna === \'T\'" class="chi-consegna"><img ng-src="{{SERVER_URL}}/static/images/ConsegnaTheFood.png" class="img-responsive"></div><div class="insegna-img"><img ng-src="{{SERVER_URL}}/static/images/insegne/{{ insegna.id }}.jpg" class="img-responsive" ng-click="vm.onInsegnaClicked(insegna)"></div></div></div><div class="insegna-description"><div class="row"><div class="insegna-info"><div class="apertura-locale" ng-if="insegna.locales.length == 1"><p class="text-center {{ vm.informazioniAperturaOdierna(insegna.locales[0]).stileAperturaLocale }}"><span class="apertura-locale-descrizione">{{ vm.informazioniAperturaOdierna(insegna.locales[0]).descrizioneAperturaLocale | translate }}</span> <span ng-show="vm.mostraStringaProssimaConsegnaUtile(insegna.locales[0])">- {{ \'theFoodApp.locale.primaConsegnaUtile\' | translate }} {{ vm.informazioniAperturaOdierna(insegna.locales[0]).orarioPrimaConsegna }} </span><span ng-show="vm.mostraGiornoProssimaConsegna(insegna.locales[0])">{{\'theFoodApp.locale.di\' | translate}} {{vm.informazioniAperturaOdierna(insegna.locales[0]).giornoProssimaConsegna | translate}} </span><!-- <span ng-show="vm.nessunaDataDisponibile(insegna.locales[0])">\n\t\t\t\t\t\t\t- {{\'theFoodApp.locale.nessunaDataDisponibile\' | translate}}\n\t\t\t\t\t\t</span> --></p></div><div class="insegna-title linked text-xs-center text-sm-center"><a ng-click="vm.onInsegnaClicked(insegna)">{{ insegna.insegna }}</a></div><div ng-if="insegna.locales.length == 1" class="insegna-single"><!-- Selezione del locale per insegne con singolo locale --><locale data="insegna.locales[0]" is-takeaway="vm.isTakeaway"></locale></div><div ng-if="insegna.locales.length > 1" class="insegna-multiple"><div class="text-xs-center text-sm-center collapse-button"><!-- Selezione del locale per insegne con molteplici locali --> <a role="button" ng-click="vm.collapsed[ insegna.id ] = !vm.collapsed[ insegna.id ]" data-translate="theFoodApp.locale.moltepliciLocaliDisponibili">Molteplici locali disponibili</a></div><div class="collapsed-items" uib-collapse="!vm.collapsed[ insegna.id ]"><div class="locali-multipli" ng-repeat="locale in insegna.locales"><div class="apertura-locale"><p class="text-center {{ vm.informazioniAperturaOdierna(locale).stileAperturaLocale }}"><span class="apertura-locale-descrizione">{{ vm.informazioniAperturaOdierna(locale).descrizioneAperturaLocale | translate }}</span> <span ng-show="vm.informazioniAperturaOdierna(locale).prossimaConsegnaUtile">- {{ \'theFoodApp.locale.primaConsegnaUtile\' | translate }} {{ vm.informazioniAperturaOdierna(locale).orarioPrimaConsegna }}</span></p></div><locale data="locale" is-takeaway="vm.isTakeaway"></locale></div></div></div></div><div class="insegna-tipologie tipologie-locale-wrapper"><h4 data-translate="theFoodApp.locale.cucina">Cucina:</h4><ul class="list tipologie-locale-container clearfix"><li ng-repeat="tipologia in insegna.tipologiaLocales" class="tipologia-locale">{{ tipologia | languageSwitch:\'descrizioneIta\':\'descrizioneEng\' }}</li></ul></div></div></div></div>');
$templateCache.put('app/pages/storico-ordini/storico-ordini.html','<div ng-cloak class="container-fluid storico"><div class="go-back">&lt; <a ui-sref="landing" data-translate="theFoodApp.storico-ordini.homepage">&lt; Modifica indirizzo</a></div><div class="row text-center"><span class="h2">{{\'theFoodApp.storico-ordini.title-page\' | translate}}</span></div><hr><div class="row" ng-repeat="ordine in vm.storicoOrdini"><!-- TESTATA ORDINE --><div class="row testata-ordine"><div class="col-md-2 insegna-logo"><div class="insegna-img"><img ng-src="{{SERVER_URL}}/static/images/insegne/{{ ordine.locale.insegnaId }}.jpg" class="img-responsive" ng-click="vm.vediDettaglio[$index] = !vm.vediDettaglio[$index]"></div></div><div class="col-md-4 descrizione-locale">{{ordine.locale.insegna}}<br>{{ordine.locale.indirizzo}}, {{ordine.locale.civico}}{{ordine.locale.rosso ? (\'theFoodApp.locale.civicoRosso\' | translate) : \'\' }}<br>{{ordine.dettaglioOrdine.locale.comune}}</div><div class="col-md-4 descrizione-ordine">{{\'theFoodApp.storico.testata.data-ordine\' | translate}}: {{ordine.ordine.dataPagamento | date:\'dd/MM/yyyy\'}}<br>{{\'theFoodApp.storico.testata.data-consegna\' | translate}}: {{ordine.ordine.dataConsegna | date:\'dd/MM/yyyy\'}}<br>{{\'theFoodApp.storico.testata.importo-ordine\' | translate}}: {{ordine.ordine.importoOrdineSenzaSconti | currency: \'\u20AC\'}}<br><div ng-if="vm.hasSconto(ordine.ordine) > 0">{{\'theFoodApp.storico.testata.sconto\' | translate}}: -{{vm.getScontoTotale(ordine.ordine) | currency: \'\u20AC\'}}<br></div><div ng-if=" ordine.ordine.creditoUtilizzato">{{\'theFoodApp.storico.testata.credito-utilizzato\' | translate}}: {{ordine.ordine.creditoUtilizzato | currency: \'\u20AC\'}}<br></div><div ng-if=" ordine.ordine.codiceCoupon">{{\'theFoodApp.storico.testata.codice-coupon\' | translate}}: {{ordine.ordine.codiceCoupon}}<br></div>{{\'theFoodApp.storico.testata.importo-spedizione\' | translate}}: {{ordine.ordine.importoSpedizione | currency: \'\u20AC\'}}<br>{{\'theFoodApp.storico.testata.totale\' | translate}}: {{vm.getTotale(ordine.ordine) | currency: \'\u20AC\'}}</div><div class="col-md-2 btn-vedi-ordine"><button class="btn btn-primary" ng-click="vm.vediDettaglio[$index] = !vm.vediDettaglio[$index]">{{\'theFoodApp.storico.testata.vedi-ordine\' | translate}}</button></div></div><!-- DETTAGLIO ORDINE --><div class="row dettaglio-ordine" uib-collapse="!vm.vediDettaglio[$index]"><div class="col-md-10"><div class="titolo-dettaglio">{{\'theFoodApp.storico.dettaglio.ordine\' | translate}} <span ng-if="vm.isTakeaway(vm.storicoOrdini[$index].ordine)">{{\'theFoodApp.storico.dettaglio.takeaway\' | translate}} </span>{{\'theFoodApp.storico.dettaglio.effettuato-via\' | translate}} {{vm.storicoOrdini[$index].ordine.device}} <span ng-if="!vm.isTakeaway(vm.storicoOrdini[$index].ordine)">{{\'theFoodApp.storico.dettaglio.spedito-in\' | translate}} {{vm.getIndirizzoCliente(vm.storicoOrdini[$index].cliente)}}</span></div><ul class="text-sm-center"><dd ng-repeat="riga in vm.storicoOrdini[$index].ordine.righeOrdine"><span ng-show="vm.showCaret(riga)" class="caret-the-food" ng-class="{\'caret-the-food-up\':vm.vediDettaglioRiga[$parent.$index][$index]}" ng-click="vm.vediDettaglioRiga[$parent.$index][$index] = !vm.vediDettaglioRiga[$parent.$index][$index]"></span><!--&nbsp;--> <span ng-click="vm.vediDettaglioRiga[$parent.$index][$index] = !vm.vediDettaglioRiga[$parent.$index][$index]">{{ riga.prodotto | languageSwitch:\'descrizioneIt\':\'descrizioneEn\' }}, {{vm.getPrezzo(riga.prodotto, vm.storicoOrdini[$parent.$index].ordine) | currency: \'\u20AC\'}} </span>&nbsp; <button ng-show="riga.dettaglioVariantes && riga.dettaglioVariantes.length > 0" title="{{ \'theFoodApp.storico.dettaglio.varianti\' | translate}}" type="button" class="btn btn-primary btn-xs" ng-click="vm.vediDettaglioRiga[$parent.$index][$index] = !vm.vediDettaglioRiga[$parent.$index][$index]"><span ng-show="!vm.vediDettaglioRiga[$parent.$index][$index]" class="glyphicon glyphicon-plus"></span> <span ng-show="vm.vediDettaglioRiga[$parent.$index][$index]" class="glyphicon glyphicon-minus"></span></button><!-- AGGIUNTE E VARIANTI SUI PRODOTTI --><div uib-collapse="!vm.vediDettaglioRiga[$parent.$index][$index]"><!-- PRODOTTO MENU --><ul ng-if="riga.dettaglioMenus && riga.dettaglioMenus.length > 0"><dd class="riga-prodotto" ng-repeat="item in riga.dettaglioMenus">{{item.prodotto | languageSwitch:\'descrizioneIt\':\'descrizioneEn\' }}<!-- AGGIUNTE --><ul ng-if="item.aggiuntas && item.aggiuntas.length > 0"><dt class="text-uppercase">{{\'theFoodApp.storico.dettaglio.aggiunte\' | translate}}</dt><dd class="riga-aggiunta" ng-repeat="aggiunta in item.aggiuntas">{{aggiunta | languageSwitch:\'descrizioneIt\':\'descrizioneEn\' }}, {{vm.getPrezzo(aggiunta, vm.storicoOrdini[$parent.$index].ordine) | currency: \'\u20AC\'}}</dd></ul><!-- VARIANTI --><ul ng-if="item.dettaglioVariantes && item.dettaglioVariantes.length > 0"><dt class="text-uppercase">{{\'theFoodApp.storico.dettaglio.varianti\' | translate}}</dt><dd class="riga-variante" ng-repeat="variante in item.dettaglioVariantes">{{variante | languageSwitch:\'tipoVarianteIt\':\'tipoVarianteEn\' }}: {{variante | languageSwitch:\'descrizioneIt\':\'descrizioneEn\' }}, {{variante.prezzo | currency: \'\u20AC\'}}</dd></ul></dd></ul><!-- PRODOTTO SINGOLO - AGGIUNTE --><ul class="text-sm-center" ng-if="riga.aggiuntas && riga.aggiuntas.length > 0"><dt class="text-uppercase">{{\'theFoodApp.storico.dettaglio.aggiunte\' | translate}}</dt><dd class="riga-aggiunta" ng-repeat="aggiunta in riga.aggiuntas">{{aggiunta | languageSwitch:\'descrizioneIt\':\'descrizioneEn\' }}, {{vm.getPrezzo(aggiunta, vm.storicoOrdini[$parent.$index].ordine) | currency: \'\u20AC\'}}</dd></ul><!-- PRODOTTO SINGOLO - VARIANTI --><ul class="text-sm-center" ng-if="riga.dettaglioVariantes && riga.dettaglioVariantes.length > 0"><dt class="text-uppercase">{{\'theFoodApp.storico.dettaglio.varianti\' | translate}}</dt><dd class="riga-variante" ng-repeat="variante in riga.dettaglioVariantes">{{variante | languageSwitch:\'tipoVarianteIt\':\'tipoVarianteEn\' }}: {{variante | languageSwitch:\'descrizioneIt\':\'descrizioneEn\' }}, {{variante.prezzo | currency: \'\u20AC\'}}</dd></ul></div><div class="promo-articoli-container" ng-if="riga.scontoPromoziones && riga.scontoPromoziones.length > 0"><span ng-repeat-start="promozione in riga.scontoPromoziones">{{ promozione | languageSwitch:\'messaggioIt\':\'messaggioEn\' }}: -{{ promozione.valoreSconto | currency: \'\u20AC\'}} </span><span ng-repeat-end><br></span></div></dd></ul><!-- PROMOZIONI TESTATA --><ul class="promo-testata-container" ng-if="vm.storicoOrdini[$index].ordine.scontoPromoziones && vm.storicoOrdini[$index].ordine.scontoPromoziones.length > 0"><dd ng-repeat="promozione in vm.storicoOrdini[$index].ordine.scontoPromoziones"><span>{{ promozione | languageSwitch:\'messaggioIt\':\'messaggioEn\' }}: -{{ promozione.valoreSconto | currency: \'\u20AC\'}}</span></dd></ul><div class="text-xs-center text-sm-center"><!-- TODO Bottone da abilitare per il riacquisto dell\'ordine --> <button type="button" class="btn btn-primary" ng-click="vm.riacquista(vm.storicoOrdini[$index])">{{\'theFoodApp.storico.dettaglio.riacquista\' | translate}}</button></div></div></div><hr></div><!-- PAGINATION --><div class="text-center pagination-thefood" ng-if="vm.totalItems > vm.itemsPerPage"><uib-pagination class="pagination pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="\n    vm.page" ng-change="vm.transition()" boundary-link-numbers="true"></uib-pagination></div></div>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" data-translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p data-translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p data-translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p data-translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div></div><div class="col-md-10 col-md-offset-1"><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="row"><div class="form-group col-md-6"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required ng-model-options="{ debounce: 250 }"><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div></div><div class="form-group col-md-6"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div></div><div class="row text-center" style="margin:10px 0"><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="row text-center"><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.finish.form.button">Register</button></div></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" data-translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists"><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p data-translate="reset.request.messages.info">Enter the e-mail address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success == \'OK\'"><p data-translate="reset.request.messages.success">Check your e-mails for details on how to reset your password.</p><a ui-sref="landing" data-translate="go.home">Clicca qui per tornare alla home.</a></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="text-center"><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.request.form.button">Reset</button></div></form></div></div></div>');
$templateCache.put('app/account/social/directive/social.html','<form ng-click="saveState()" action="{{ providerURL }}" method="POST"><button type="submit" class="btn btn-block jh-btn-social jh-btn-{{ provider }}"><span data-translate="social.btnLabel" translate-values="{ label: label }">Sign in with {{ label }}</span></button> <input name="scope" type="hidden" value="{{\xA0providerSetting }}"> <input name="_csrf" type="hidden" value="{{\xA0csrf }}"></form>');
$templateCache.put('app/pages/concludi-acquisto/indirizzi/indirizzi-rubrica-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myIndirizzoLabel" data-translate="theFoodApp.concludi.indirizzi-rubrica.title">Select an address from your addressbook</h4></div><div class="modal-body"><div class="row"><div class="list-group text-center lista-indirizzi"><a class="list-group-item close-address-book" ng-click="vm.clear()" data-translate="theFoodApp.concludi.indirizzi-rubrica.no-grazie">No grazie</a></div><div class="list-group text-center lista-indirizzi"><a class="list-group-item" ng-repeat="indirizzo in vm.indirizziRubrica" ng-click="vm.selezionaIndirizzo(indirizzo)">{{indirizzo.nomeSulCampanello}}<br>{{ indirizzo.strada.descrizioneComune }} - {{ indirizzo.strada.descrizione }} {{ indirizzo.civico }}</a></div></div></div><!-- <div class="modal-footer">\n\t<button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\n\t\t<span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="theFoodApp.concludi.indirizzi-rubrica.no-grazie">No grazie</span>\n\t</button>\n</div> -->');
$templateCache.put('app/pages/concludi-acquisto/payments/payments.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="theFoodApp.concludi.payments.title">Payments</h4></div><div class="modal-body"><div class="payments-container"><div ng-if="vm.useCredit === true" class="rimanenza-div"><span class="rimanenza-text" data-translate="theFoodApp.concludi.payments.rimanenza-text">Rimanenza dell\'ordine da pagare </span><span class="rimanenza">{{vm.totalWithUseCredit | currency:\'\u20AC\' }}</span></div><div class="payment-img-container" ng-repeat="payment in vm.payments"><div class="payment-img"><img ng-src="{{payment.imgUrl}}" alt="{{payment.imgAlt}}" ng-click="vm.selectIssuer(payment.issuer)"></div><div class="payment-img-label"><label ng-click="vm.selectIssuer(payment.issuer)">{{payment.imgAlt}}</label></div></div></div></div>');
$templateCache.put('app/pages/cliente/indirizzo/indirizzo-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.indirizzo.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="theFoodApp.cliente.indirizzi.deletequestion" translate-values="{id: \'{{vm.indirizzo.id}}\'}">Are you sure you want to delete this Indirizzo?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/pages/cliente/indirizzo/indirizzo-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myIndirizzoLabel" data-translate="theFoodApp.cliente.indirizzi.createOrEditLabel">Create or edit a Indirizzo</h4></div><div class="modal-body"><!-- <jhi-alert-error></jhi-alert-error> --><!-- \t\t<div class="form-group" ng-show="vm.indirizzo.id"> --><!-- \t\t\t<label for="id" data-translate="global.field.id">ID</label> <input --><!-- \t\t\t\ttype="text" class="form-control" id="id" name="id" --><!-- \t\t\t\tng-model="vm.indirizzo.id" readonly /> --><!-- \t\t</div> --><div class="row"><div class="form-group col-sm-3"><label class="control-label" data-translate="theFoodApp.indirizzo.tipoIndirizzo" for="field_tipoIndirizzo">Tipo Indirizzo</label><span>*</span><select ng-if="vm.getLocale() == \'it\'" class="form-control" id="field_tipoIndirizzo" name="tipoIndirizzo" ng-model="vm.indirizzo.tipoIndirizzo" ng-options="tipoIndirizzo as tipoIndirizzo.descrizioneIta for tipoIndirizzo in vm.tipoindirizzos track by tipoIndirizzo.id" required></select><select ng-if="vm.getLocale() != \'it\'" class="form-control" id="field_tipoIndirizzo" name="tipoIndirizzo" ng-model="vm.indirizzo.tipoIndirizzo" ng-options="tipoIndirizzo as tipoIndirizzo.descrizioneEng for tipoIndirizzo in vm.tipoindirizzos track by tipoIndirizzo.id" required></select><div ng-show="editForm.tipoIndirizzo.$dirty && editForm.tipoIndirizzo.$invalid"><p class="help-block" ng-show="editForm.tipoIndirizzo.$error.required" data-translate="entity.validation.required">Your surname is required.</p></div></div><div class="form-group col-sm-9"><label class="control-label" data-translate="theFoodApp.indirizzo.nomeSulCampanello" for="field_nomeSulCampanello">Nome Sul Campanello</label><span>*</span> <input type="text" class="form-control" name="nomeSulCampanello" id="field_nomeSulCampanello" ng-model="vm.indirizzo.nomeSulCampanello" autocomplete="name" required><div ng-show="editForm.nomeSulCampanello.$dirty && editForm.nomeSulCampanello.$invalid"><p class="help-block" ng-show="editForm.nomeSulCampanello.$error.required" data-translate="entity.validation.required">Your surname is required.</p></div></div></div><div class="row"><div class="form-group col-sm-8" ng-class="{\'has-error\': !vm.selectedAddress}"><label class="control-label" data-translate="theFoodApp.indirizzo.detail.title" for="field_indirizzo">Indirizzo</label><span>*</span> <input type="text" class="form-control" name="indirizzo" id="field_indirizzo" ng-model="vm.indirizzo.strada" strada required autocomplete="off" typeahead-on-select="vm.onAddressSelected($item)" required><div ng-show="!vm.selectedAddress || (editForm.indirizzo.$invalid  && editForm.indirizzo.$dirty)"><p class="help-block" ng-show="editForm.indirizzo.$error.required" data-translate="entity.validation.required">Questo campo \xE8 obbligatorio</p><p class="help-block" ng-show="!vm.selectedAddress" data-translate="theFoodApp.indirizzo.error.street-not-selected"></p></div></div><div class="form-group col-sm-4"><label class="control-label" data-translate="theFoodApp.indirizzo.civico" for="field_civico">Civico</label><span>*</span> <input type="text" class="form-control" name="civico" id="field_civico" ng-model="vm.indirizzo.civico" civico required autocomplete="off" required><div ng-show="editForm.civico.$invalid  && editForm.civico.$dirty"><p class="help-block" ng-show="editForm.civico.$error.required" data-translate="entity.validation.required">Questo campo \xE8 obbligatorio</p><p class="help-block" ng-show="editForm.civico.$error.pattern" data-translate="theFoodApp.indirizzo.error.civico">Civico non valido</p></div></div></div><!-- \t\t<div class="form-group"> --><!-- \t\t\t<label class="control-label" --><!-- \t\t\t\tdata-translate="theFoodApp.cliente.indirizzi.tipoCivico" --><!-- \t\t\t\tfor="field_tipoCivico">Tipo Civico</label> <input type="text" --><!-- \t\t\t\tclass="form-control" name="tipoCivico" id="field_tipoCivico" --><!-- \t\t\t\tng-model="vm.indirizzo.tipoCivico" /> --><!-- \t\t</div> --><div class="row"><div class="form-group col-sm-6"><label class="control-label" data-translate="theFoodApp.indirizzo.telefono" for="field_telefono">Telefono</label><span>*</span> <input type="text" class="form-control" name="telefono" id="field_telefono" ng-model="vm.indirizzo.telefono" autocomplete="tel" aria-describedby="basic-addon1" telefono required uib-popover="{{\'theFoodApp.indirizzo.informativa\' | translate}}" data-popover-title="{{\'theFoodApp.indirizzo.informativa-title\' | translate}}" data-popover-placement="top" data-popover-append-to-body="true" data-popover-trigger="focus"><div ng-show="editForm.telefono.$invalid  && editForm.telefono.$dirty"><p class="help-block" ng-show="editForm.telefono.$error.required" data-translate="entity.validation.required">Questo campo \xE8 obbligatorio</p><p class="help-block" ng-show="editForm.telefono.$error.pattern" data-translate="theFoodApp.indirizzo.error.tel">Incorrect Number</p></div></div><div class="form-group col-sm-6"><label class="control-label" data-translate="theFoodApp.indirizzo.telefono2" for="field_telefono2">Telefono 2</label><input type="text" class="form-control" name="telefono2" id="field_telefono2" ng-model="vm.indirizzo.telefono2" autocomplete="off"></div></div><div class="row"><div class="form-group col-sm-4"><label class="control-label" data-translate="theFoodApp.indirizzo.piano" for="field_piano">Piano</label><span>*</span> <input type="text" class="form-control" name="piano" id="field_piano" ng-model="vm.indirizzo.piano" autocomplete="off" required><div ng-show="editForm.piano.$invalidv && editForm.piano.$dirty"><p class="help-block" ng-show="editForm.piano.$error.required" data-translate="entity.validation.required">Questo campo \xE8 obbligatorio</p></div></div><div class="form-group col-sm-4"><label class="control-label" data-translate="theFoodApp.indirizzo.scala" for="field_scala">Scala</label><input type="text" class="form-control" name="scala" id="field_scala" ng-model="vm.indirizzo.scala" autocomplete="off"></div><div class="form-group col-sm-4"><label class="control-label" data-translate="theFoodApp.indirizzo.interno" for="field_interno">Interno</label><input type="text" class="form-control" name="interno" id="field_interno" ng-model="vm.indirizzo.interno" autocomplete="off"></div></div><div class="form-group"><label class="control-label" data-translate="theFoodApp.indirizzo.note" for="field_note">Note</label><input type="text" class="form-control" name="note" id="field_note" ng-model="vm.indirizzo.note" autocomplete="off"></div><div uib-collapse="!vm.showInformativa"><span class="glyphicon glyphicon-question-sign white"></span> {{\'theFoodApp.indirizzo.informativa\' | translate}}</div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/pages/cliente/dati-fatturazione/dati-fatturazione-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.datiFatturazione.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="theFoodApp.cliente.datiFatturazione.deletequestion" translate-values="{id: \'{{vm.datiFatturazione.id}}\'}">Are you sure you want to delete this Dati Fatturazione?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/pages/cliente/dati-fatturazione/dati-fatturazione-detail.html','<div><h2><span data-translate="theFoodApp.datiFatturazione.detail.title">Dati Fatturazione</span> {{vm.datiFatturazione.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="theFoodApp.datiFatturazione.ragioneSociale">Ragione Sociale</span></dt><dd><span>{{vm.datiFatturazione.ragioneSociale}}</span></dd><dt><span data-translate="theFoodApp.datiFatturazione.ragioneSociale2">Ragione Sociale 2</span></dt><dd><span>{{vm.datiFatturazione.ragioneSociale2}}</span></dd><dt><span data-translate="theFoodApp.datiFatturazione.pIva">P Iva</span></dt><dd><span>{{vm.datiFatturazione.pIva}}</span></dd><dt><span data-translate="theFoodApp.datiFatturazione.codFisc">Cod Fisc</span></dt><dd><span>{{vm.datiFatturazione.codFisc}}</span></dd><dt><span data-translate="theFoodApp.datiFatturazione.indirizzo">Indirizzo</span></dt><dd><span>{{vm.datiFatturazione.indirizzo}}</span></dd><dt><span data-translate="theFoodApp.datiFatturazione.citta">Citta</span></dt><dd><span>{{vm.datiFatturazione.citta}}</span></dd><dt><span data-translate="theFoodApp.datiFatturazione.provincia">Provincia</span></dt><dd><span>{{vm.datiFatturazione.provincia}}</span></dd><dt><span data-translate="theFoodApp.datiFatturazione.cap">Cap</span></dt><dd><span>{{vm.datiFatturazione.cap}}</span></dd><dt><span data-translate="theFoodApp.datiFatturazione.telefono">Telefono</span></dt><dd><span>{{vm.datiFatturazione.telefono}}</span></dd><dt><span data-translate="theFoodApp.datiFatturazione.pec">Pec</span></dt><dd><span>{{vm.datiFatturazione.pec}}</span></dd><dt><span data-translate="theFoodApp.datiFatturazione.sdi">Sdi</span></dt><dd><span>{{vm.datiFatturazione.sdi}}</span></dd><dt><span data-translate="theFoodApp.datiFatturazione.cliente">Cliente</span></dt><dd><a ui-sref="cliente-detail({id:vm.datiFatturazione.clienteId})">{{vm.datiFatturazione.clienteId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="dati-fatturazione-detail.edit({id:vm.datiFatturazione.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/pages/cliente/dati-fatturazione/dati-fatturazione-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDatiFatturazioneLabel" data-translate="theFoodApp.cliente.datiFatturazione.createOrEditLabel">Create or edit a Dati Fatturazione</h4></div><div class="modal-body modal-body-fatturazione"><jhi-alert-error></jhi-alert-error><!--         <div class="form-group" ng-show="vm.datiFatturazione.id"> --><!--             <label for="id" data-translate="global.field.id">ID</label> --><!--             <input type="text" class="form-control" id="id" name="id" --><!--                     ng-model="vm.datiFatturazione.id" readonly /> --><!--         </div> --><div class="row"><div class="form-group col-sm-6"><label class="control-label" data-translate="theFoodApp.datiFatturazione.ragioneSociale" for="field_ragioneSociale">Ragione Sociale</label><span>*</span> <input type="text" class="form-control" name="ragioneSociale" id="field_ragioneSociale" ng-model="vm.datiFatturazione.ragioneSociale" required><div ng-show="editForm.ragioneSociale.$invalid && editForm.ragioneSociale.$dirty"><p class="help-block" ng-show="editForm.ragioneSociale.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group col-sm-6"><label class="control-label" data-translate="theFoodApp.datiFatturazione.ragioneSociale2" for="field_ragioneSociale2">Ragione Sociale 2</label><input type="text" class="form-control" name="ragioneSociale2" id="field_ragioneSociale2" ng-model="vm.datiFatturazione.ragioneSociale2"><div ng-show="editForm.ragioneSociale2.$invalid && editForm.ragioneSociale2.$dirty"><p class="help-block" ng-show="editForm.ragioneSociale2.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="row"><div class="form-group col-sm-4"><label class="control-label" data-translate="theFoodApp.datiFatturazione.pIva" for="field_pIva">P Iva</label><span>*</span> <input type="text" class="form-control" name="pIva" id="field_pIva" ng-model="vm.datiFatturazione.pIva" required partita-iva><div ng-show="editForm.pIva.$invalid && editForm.pIva.$dirty"><p class="help-block" ng-show="editForm.pIva.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div ng-show="editForm.pIva.$invalid && editForm.pIva.$dirty"><p class="help-block" ng-show="editForm.pIva.$error.partitaIva" data-translate="entity.validation.partitaIva">This field is required.</p></div></div><div class="form-group col-sm-4"><label class="control-label" data-translate="theFoodApp.datiFatturazione.codFisc" for="field_codFisc">Cod Fisc</label><span>*</span> <input type="text" class="form-control" name="codFisc" id="field_codFisc" ng-model="vm.datiFatturazione.codFisc" required codice-fiscale-partita-iva><div ng-show="editForm.codFisc.$invalid && editForm.codFisc.$dirty"><p class="help-block" ng-show="editForm.codFisc.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div ng-show="editForm.codFisc.$invalid && editForm.codFisc.$dirty"><p class="help-block" ng-show="editForm.codFisc.$error.codiceFiscale " data-translate="entity.validation.codiceFiscale">This field is required.</p></div></div><div class="form-group col-sm-4"><label class="control-label" data-translate="theFoodApp.datiFatturazione.telefono" for="field_telefono">Telefono</label><input type="text" class="form-control" name="telefono" id="field_telefono" ng-model="vm.datiFatturazione.telefono" telefono><div ng-show="editForm.telefono.$invalid && editForm.telefono.$dirty"><p class="help-block" ng-show="editForm.telefono.$error" data-translate="theFoodApp.datiFatturazione.error.invalidTel">Incorrect Number</p></div></div></div><div class="row"><div class="form-group col-sm-12"><label class="control-label" data-translate="theFoodApp.datiFatturazione.indirizzo" for="field_indirizzo">Indirizzo</label><span>*</span> <input type="text" class="form-control" name="indirizzo" id="field_indirizzo" ng-model="vm.datiFatturazione.indirizzo" required><div ng-show="editForm.indirizzo.$invalid && editForm.indirizzo.$dirty"><p class="help-block" ng-show="editForm.indirizzo.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="row"><div class="form-group col-sm-6"><label class="control-label" data-translate="theFoodApp.datiFatturazione.citta" for="field_citta">Citta</label><span>*</span> <input type="text" class="form-control" name="citta" id="field_citta" ng-model="vm.datiFatturazione.citta" required><div ng-show="editForm.citta.$invalid && editForm.citta.$dirty"><p class="help-block" ng-show="editForm.citta.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group col-sm-4"><label class="control-label" data-translate="theFoodApp.datiFatturazione.provincia" for="field_provincia">Provincia</label><span>*</span><select class="form-control" id="field_provincia" name="provincia" ng-model="vm.datiFatturazione.provincia" ng-options="provincia.id as provincia.descrizione for provincia in vm.province" required></select><div ng-show="editForm.provincia.$invalid && editForm.provincia.$dirty"><p class="help-block" ng-show="editForm.provincia.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group col-sm-2"><label class="control-label" data-translate="theFoodApp.datiFatturazione.cap" for="field_cap">Cap</label><span>*</span> <input type="text" class="form-control" name="cap" id="field_cap" ng-model="vm.datiFatturazione.cap" ng-pattern="vm.cap" required><div ng-show="editForm.cap.$invalid && editForm.cap.$dirty"><p class="help-block" ng-show="editForm.cap.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.cap.$error.pattern" data-translate="theFoodApp.datiFatturazione.error.invalidCap">Invalid Cap</p></div></div></div><div class="row"><div ng-if="!vm.datiFatturazione.sdi" class="form-group col-sm-6"><label class="control-label" data-translate="theFoodApp.datiFatturazione.pec" for="field_pec">Pec</label><span>*</span> <input type="email" class="form-control" name="pec" id="field_pec" ng-model="vm.datiFatturazione.pec" autocomplete="email" required><div ng-show="editForm.pec.$invalid && editForm.pec.$dirty"><p class="help-block" ng-show="editForm.pec.$error.required" data-translate="theFoodApp.datiFatturazione.error.invalidPec">This field is required.</p></div></div><div ng-if="vm.datiFatturazione.sdi" class="form-group col-sm-6"><label class="control-label" data-translate="theFoodApp.datiFatturazione.pec" for="field_pec">Pec</label><input type="email" class="form-control" name="pec" id="field_pec" ng-model="vm.datiFatturazione.pec" autocomplete="email"><div ng-show="editForm.pec.$invalid && editForm.pec.$dirty"><p class="help-block" ng-show="editForm.pec.$error.required" data-translate="theFoodApp.datiFatturazione.error.invalidPec">This field is required.</p></div></div><div ng-if="!vm.datiFatturazione.pec" class="form-group col-sm-6"><label class="control-label" data-translate="theFoodApp.datiFatturazione.sdi" for="field_sdi">Sdi</label><span>*</span> <input type="text" class="form-control" name="sdi" id="field_sdi" ng-model="vm.datiFatturazione.sdi" maxlength="7" required><div ng-show="editForm.sdi.$invalid && editForm.sdi.$dirty"><p class="help-block" ng-show="editForm.sdi.$error.required" data-translate="theFoodApp.datiFatturazione.error.invalidSdi">This field is required.</p></div></div><div ng-if="vm.datiFatturazione.pec" class="form-group col-sm-6"><label class="control-label" data-translate="theFoodApp.datiFatturazione.sdi" for="field_sdi">Sdi</label><input type="text" class="form-control" name="sdi" id="field_sdi" ng-model="vm.datiFatturazione.sdi" maxlength="7"><div ng-show="editForm.sdi.$invalid && editForm.sdi.$dirty"><p class="help-block" ng-show="editForm.sdi.$error.required" data-translate="theFoodApp.datiFatturazione.error.invalidSdi">This field is required.</p></div></div></div><div class="row"><div ng-show="(!vm.datiFatturazione.pec && !vm.datiFatturazione.sdi) || (editForm.sdi.$invalid || editForm.sdi.$dirty) || (editForm.pec.$invalid || editForm.pec.$dirty)"><p class="help-block" ng-show="!vm.datiFatturazione.pec && !vm.datiFatturazione.sdi" data-translate="theFoodApp.datiFatturazione.error.invalidPecSdi">Pec or sdi is required</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/pages/cliente/dati-fatturazione/dati-fatturaziones.html','<div><h2 data-translate="theFoodApp.datiFatturazione.home.title">Dati Fatturaziones</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="dati-fatturazione.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" data-translate="theFoodApp.datiFatturazione.home.createLabel">Create new Dati Fatturazione</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'theFoodApp.datiFatturazione.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="theFoodApp.datiFatturazione.ragioneSociale">Ragione Sociale</span></th><th><span data-translate="theFoodApp.datiFatturazione.ragioneSociale2">Ragione Sociale 2</span></th><th><span data-translate="theFoodApp.datiFatturazione.pIva">P Iva</span></th><th><span data-translate="theFoodApp.datiFatturazione.codFisc">Cod Fisc</span></th><th><span data-translate="theFoodApp.datiFatturazione.indirizzo">Indirizzo</span></th><th><span data-translate="theFoodApp.datiFatturazione.citta">Citta</span></th><th><span data-translate="theFoodApp.datiFatturazione.provincia">Provincia</span></th><th><span data-translate="theFoodApp.datiFatturazione.cap">Cap</span></th><th><span data-translate="theFoodApp.datiFatturazione.telefono">Telefono</span></th><th><span data-translate="theFoodApp.datiFatturazione.pec">Pec</span></th><th><span data-translate="theFoodApp.datiFatturazione.sid">Sdi</span></th><th><span data-translate="theFoodApp.datiFatturazione.cliente">Cliente</span></th><th></th></tr></thead><tbody><tr ng-repeat="datiFatturazione in vm.datiFatturaziones track by datiFatturazione.id"><td><a ui-sref="dati-fatturazione-detail({id:datiFatturazione.id})">{{datiFatturazione.id}}</a></td><td>{{datiFatturazione.ragioneSociale}}</td><td>{{datiFatturazione.ragioneSociale2}}</td><td>{{datiFatturazione.pIva}}</td><td>{{datiFatturazione.codFisc}}</td><td>{{datiFatturazione.indirizzo}}</td><td>{{datiFatturazione.citta}}</td><td>{{datiFatturazione.provincia}}</td><td>{{datiFatturazione.cap}}</td><td>{{datiFatturazione.telefono}}</td><td>{{datiFatturazione.pec}}</td><td>{{datiFatturazione.sdi}}</td><td><a ui-sref="cliente-detail({id:datiFatturazione.clienteId})">{{datiFatturazione.clienteId}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="dati-fatturazione-detail({id:datiFatturazione.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="dati-fatturazione.edit({id:datiFatturazione.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="dati-fatturazione.delete({id:datiFatturazione.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/selezione-indirizzo/modal-update-app/modal-update-app.html','<div class="download-app text-center"><div class="banner-white-space">&nbsp;</div><img class="logo-style" src="{{ SERVER_URL }}/static/images/runnerpizza_logo_alta_risoluzione.png"><!-- <div class="banner-text" data-translate="global.banner.ordinaOnLine">ordina online</div> --><!-- <div class="banner-text" data-translate="global.banner.oppureChiama">oppure chiama 055 6812477</div> --><div class="banner-white-space">&nbsp;</div><div class="bottom-elements"><div class="banner-text" data-translate="global.version.content"></div><div class="banner-white-space">&nbsp;</div><div><button class="scarica" ng-click="vm.downloadApp()" data-translate="global.banner.scarica">SCARICA</button></div><div class="banner-white-space">&nbsp;</div></div></div>');
$templateCache.put('app/pages/selezione-locale/consegna/consegna-list.html','<div class="selezione-locale consegna consegna-list"><div class="go-back">&lt; <a ui-sref="selezione-indirizzo" data-translate="theFoodApp.selezione-locale.modificaIndirizzo">&lt; Modifica indirizzo</a></div><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 filters-container"><h4 class="tipologie-collapse" data-translate="theFoodApp.selezione-locale.tipologie" ng-click="vm.mostraTipologie = !vm.mostraTipologie || vm.isScreenLargeEnough()">Tipologie locali</h4><div class="tipologie-container" uib-collapse="vm.mostraTipologie"><div class="tipologia row" ng-repeat="tipologia in vm.tipologieLocali"><input type="checkbox" id="tipologia-{{$id}}" class="checkbox" ng-checked="tipologia.selected" ng-click="vm.toggleTipologiaLocale($event, tipologia)"><label for="tipologia-{{$id}}">{{ tipologia | languageSwitch:\'descrizioneIta\':\'descrizioneEng\' }} ({{ tipologia.count }})</label></div></div></div><div class="col-md-9 results-container"><h4 data-translate="theFoodApp.selezione-locale.insegne-consegna" translate-values="{ via: vm.indirizzoCercato }">Locali individuati per via ...</h4><div class="insegne-container" id="primo-locale"><div ui-view="insegne"></div></div></div></div></div>');
$templateCache.put('app/pages/selezione-locale/takeaway/takeaway-list.html','<div class="go-back">&lt; <a ui-sref="selezione-indirizzo" data-translate="theFoodApp.selezione-locale.indietro">&lt; Modifica indirizzo</a></div><div class="selezione-locale takeaway takeaway-list"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 filters-container"><h4 class="comuni-collapse" ng-click="vm.mostraComuni = !vm.mostraComuni || vm.isScreenLargeEnough()" data-translate="theFoodApp.selezione-locale.comuni">Comuni</h4><div class="comuni-container" uib-collapse="vm.mostraComuni"><div class="comune row" ng-repeat="comune in vm.comuni"><a ui-sref=".( { comune:comune.id } )" ng-click="vm.selectComune(comune.id)" class="comune" ng-class="{ \'selected\': vm.selectedComune === comune.id }">{{ comune.descrizione }} ({{ comune.count }})</a><ul ng-if="vm.selectedComune === comune.id && vm.tipologieLocali.length > 0" ng-hide="vm.loadingTipologie" class="comune-tipologie list"><li class="tipologia" ng-repeat="tipologia in vm.tipologieLocali"><input type="checkbox" id="tipologia-{{$id}}" class="checkbox" ng-checked="tipologia.selected" ng-click="vm.toggleTipologiaLocale($event, tipologia)"><label for="tipologia-{{$id}}">{{ tipologia | languageSwitch:\'descrizioneIta\':\'descrizioneEng\' }} ({{ tipologia.count }})</label></li></ul></div></div></div><div class="col-md-9 results-container"><h4 data-translate="theFoodApp.selezione-locale.insegne-takeaway">Locali disponibili <span ng-if="vm.descrizioneSelectedComune">{{\'theFoodApp.selezione-locale.insegne-takeaway-in-comune\'|translate}} {{vm.descrizioneSelectedComune.descrizione}}</span></h4><div class="insegne-container"><div ui-view="insegne"></div></div></div></div></div>');}]);})();